/*! bxs-vue-ui v4.0.1 */
import Vue from 'vue';
import BScroll from 'better-scroll';
import TimeStamp from 'time-stamp';
import scrollIntoView from 'scroll-into-view-if-needed';
import AsyncValidator from 'async-validator';

var fails = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var toString = {}.toString;

var classofRaw = function (it) {
  return toString.call(it).slice(8, -1);
};

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classofRaw(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings



var toIndexedObject = function (it) {
  return indexedObject(requireObjectCoercible(it));
};

var iterators = {};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, basedir, module) {
	return module = {
		path: basedir,
		exports: {},
		require: function (path, base) {
			return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
		}
	}, fn(module, module.exports), module.exports;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global_1 =
  // eslint-disable-next-line no-undef
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func
  Function('return this')();

var isPure = true;

// Thank's IE8 for his funny defineProperty
var descriptors = !fails(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

var isObject = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var document$1 = global_1.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document$1) && isObject(document$1.createElement);

var documentCreateElement = function (it) {
  return EXISTS ? document$1.createElement(it) : {};
};

// Thank's IE8 for his funny defineProperty
var ie8DomDefine = !descriptors && !fails(function () {
  return Object.defineProperty(documentCreateElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var anObject = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var toPrimitive = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
var f = descriptors ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (ie8DomDefine) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var objectDefineProperty = {
	f: f
};

var createPropertyDescriptor = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var createNonEnumerableProperty = descriptors ? function (object, key, value) {
  return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var setGlobal = function (key, value) {
  try {
    createNonEnumerableProperty(global_1, key, value);
  } catch (error) {
    global_1[key] = value;
  } return value;
};

var SHARED = '__core-js_shared__';
var store = global_1[SHARED] || setGlobal(SHARED, {});

var sharedStore = store;

var shared = createCommonjsModule(function (module) {
(module.exports = function (key, value) {
  return sharedStore[key] || (sharedStore[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.4.5',
  mode:  'pure' ,
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});
});

var functionToString = Function.toString;

var inspectSource = shared('inspectSource', function (it) {
  return functionToString.call(it);
});

var WeakMap = global_1.WeakMap;

var nativeWeakMap = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));

var hasOwnProperty = {}.hasOwnProperty;

var has = function (it, key) {
  return hasOwnProperty.call(it, key);
};

var id = 0;
var postfix = Math.random();

var uid = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};

var keys = shared('keys');

var sharedKey = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys = {};

var WeakMap$1 = global_1.WeakMap;
var set, get, has$1;

var enforce = function (it) {
  return has$1(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (nativeWeakMap) {
  var store$1 = new WeakMap$1();
  var wmget = store$1.get;
  var wmhas = store$1.has;
  var wmset = store$1.set;
  set = function (it, metadata) {
    wmset.call(store$1, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store$1, it) || {};
  };
  has$1 = function (it) {
    return wmhas.call(store$1, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return has(it, STATE) ? it[STATE] : {};
  };
  has$1 = function (it) {
    return has(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has$1,
  enforce: enforce,
  getterFor: getterFor
};

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
var f$1 = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;

var objectPropertyIsEnumerable = {
	f: f$1
};

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
var f$2 = descriptors ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (ie8DomDefine) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!objectPropertyIsEnumerable.f.call(O, P), O[P]);
};

var objectGetOwnPropertyDescriptor = {
	f: f$2
};

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

var isForced_1 = isForced;

var path = {};

var aFunction = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};

// optional / simple context binding
var bindContext = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;






var wrapConstructor = function (NativeConstructor) {
  var Wrapper = function (a, b, c) {
    if (this instanceof NativeConstructor) {
      switch (arguments.length) {
        case 0: return new NativeConstructor();
        case 1: return new NativeConstructor(a);
        case 2: return new NativeConstructor(a, b);
      } return new NativeConstructor(a, b, c);
    } return NativeConstructor.apply(this, arguments);
  };
  Wrapper.prototype = NativeConstructor.prototype;
  return Wrapper;
};

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var PROTO = options.proto;

  var nativeSource = GLOBAL ? global_1 : STATIC ? global_1[TARGET] : (global_1[TARGET] || {}).prototype;

  var target = GLOBAL ? path : path[TARGET] || (path[TARGET] = {});
  var targetPrototype = target.prototype;

  var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
  var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;

  for (key in source) {
    FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contains in native
    USE_NATIVE = !FORCED && nativeSource && has(nativeSource, key);

    targetProperty = target[key];

    if (USE_NATIVE) if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor$1(nativeSource, key);
      nativeProperty = descriptor && descriptor.value;
    } else nativeProperty = nativeSource[key];

    // export native or implementation
    sourceProperty = (USE_NATIVE && nativeProperty) ? nativeProperty : source[key];

    if (USE_NATIVE && typeof targetProperty === typeof sourceProperty) continue;

    // bind timers to global for call from export context
    if (options.bind && USE_NATIVE) resultProperty = bindContext(sourceProperty, global_1);
    // wrap global constructors for prevent changs in this version
    else if (options.wrap && USE_NATIVE) resultProperty = wrapConstructor(sourceProperty);
    // make static versions for prototype methods
    else if (PROTO && typeof sourceProperty == 'function') resultProperty = bindContext(Function.call, sourceProperty);
    // default case
    else resultProperty = sourceProperty;

    // add a flag to not completely full polyfills
    if (options.sham || (sourceProperty && sourceProperty.sham) || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(resultProperty, 'sham', true);
    }

    target[key] = resultProperty;

    if (PROTO) {
      VIRTUAL_PROTOTYPE = TARGET + 'Prototype';
      if (!has(path, VIRTUAL_PROTOTYPE)) {
        createNonEnumerableProperty(path, VIRTUAL_PROTOTYPE, {});
      }
      // export virtual prototype methods
      path[VIRTUAL_PROTOTYPE][key] = sourceProperty;
      // export real prototype methods
      if (options.real && targetPrototype && !targetPrototype[key]) {
        createNonEnumerableProperty(targetPrototype, key, sourceProperty);
      }
    }
  }
};

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
var toObject = function (argument) {
  return Object(requireObjectCoercible(argument));
};

var correctPrototypeGetter = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.getprototypeof
var objectGetPrototypeOf = correctPrototypeGetter ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};

var nativeSymbol = !!Object.getOwnPropertySymbols && !fails(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});

var useSymbolAsUid = nativeSymbol
  // eslint-disable-next-line no-undef
  && !Symbol.sham
  // eslint-disable-next-line no-undef
  && typeof Symbol() == 'symbol';

var WellKnownSymbolsStore = shared('wks');
var Symbol$1 = global_1.Symbol;
var createWellKnownSymbol = useSymbolAsUid ? Symbol$1 : uid;

var wellKnownSymbol = function (name) {
  if (!has(WellKnownSymbolsStore, name)) {
    if (nativeSymbol && has(Symbol$1, name)) WellKnownSymbolsStore[name] = Symbol$1[name];
    else WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = objectGetPrototypeOf(objectGetPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

if (IteratorPrototype == undefined) IteratorPrototype = {};

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
var toInteger = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
var toLength = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var max = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

var indexOf = arrayIncludes.indexOf;


var objectKeysInternal = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
var objectKeys = Object.keys || function keys(O) {
  return objectKeysInternal(O, enumBugKeys);
};

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
var objectDefineProperties = descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) objectDefineProperty.f(O, key = keys[index++], Properties[key]);
  return O;
};

var aFunction$1 = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

var getBuiltIn = function (namespace, method) {
  return arguments.length < 2 ? aFunction$1(path[namespace]) || aFunction$1(global_1[namespace])
    : path[namespace] && path[namespace][method] || global_1[namespace] && global_1[namespace][method];
};

var html = getBuiltIn('document', 'documentElement');

var IE_PROTO$1 = sharedKey('IE_PROTO');

var PROTOTYPE = 'prototype';
var Empty = function () { /* empty */ };

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var length = enumBugKeys.length;
  var lt = '<';
  var script = 'script';
  var gt = '>';
  var js = 'java' + script + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  iframe.src = String(js);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + script + gt + 'document.F=Object' + lt + '/' + script + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (length--) delete createDict[PROTOTYPE][enumBugKeys[length]];
  return createDict();
};

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = createDict();
  return Properties === undefined ? result : objectDefineProperties(result, Properties);
};

hiddenKeys[IE_PROTO$1] = true;

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG$1 = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof = toStringTagSupport ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG$1)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};

// `Object.prototype.toString` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
var objectToString = toStringTagSupport ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};

var defineProperty = objectDefineProperty.f;





var TO_STRING_TAG$2 = wellKnownSymbol('toStringTag');

var setToStringTag = function (it, TAG, STATIC, SET_METHOD) {
  if (it) {
    var target = STATIC ? it : it.prototype;
    if (!has(target, TO_STRING_TAG$2)) {
      defineProperty(target, TO_STRING_TAG$2, { configurable: true, value: TAG });
    }
    if (SET_METHOD && !toStringTagSupport) {
      createNonEnumerableProperty(target, 'toString', objectToString);
    }
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;





var returnThis = function () { return this; };

var createIteratorConstructor = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = objectCreate(IteratorPrototype$1, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};

var aPossiblePrototype = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var redefine = function (target, key, value, options) {
  if (options && options.enumerable) target[key] = value;
  else createNonEnumerableProperty(target, key, value);
};

var IteratorPrototype$2 = iteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS$1 = iteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$1 = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis$1 = function () { return this; };

var defineIterator = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS$1 && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$1]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS$1 && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = objectGetPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype$2 !== Object.prototype && CurrentIteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      iterators[TO_STRING_TAG] = returnThis$1;
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if (( FORCED) && IterablePrototype[ITERATOR$1] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR$1, defaultIterator);
  }
  iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else _export({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = internalState.set;
var getInternalState = internalState.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.github.io/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.github.io/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.github.io/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.github.io/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
// https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
iterators.Arguments = iterators.Array;

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

var TO_STRING_TAG$3 = wellKnownSymbol('toStringTag');

for (var COLLECTION_NAME in domIterables) {
  var Collection = global_1[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype && !CollectionPrototype[TO_STRING_TAG$3]) {
    createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG$3, COLLECTION_NAME);
  }
  iterators[COLLECTION_NAME] = iterators.Array;
}

// `IsArray` abstract operation
// https://tc39.github.io/ecma262/#sec-isarray
var isArray = Array.isArray || function isArray(arg) {
  return classofRaw(arg) == 'Array';
};

var SPECIES = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.github.io/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation
var createMethod$1 = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = indexedObject(O);
    var boundFunction = bindContext(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else if (IS_EVERY) return false;  // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

var arrayIteration = {
  // `Array.prototype.forEach` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
  forEach: createMethod$1(0),
  // `Array.prototype.map` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.map
  map: createMethod$1(1),
  // `Array.prototype.filter` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.filter
  filter: createMethod$1(2),
  // `Array.prototype.some` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.some
  some: createMethod$1(3),
  // `Array.prototype.every` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.every
  every: createMethod$1(4),
  // `Array.prototype.find` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.find
  find: createMethod$1(5),
  // `Array.prototype.findIndex` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod$1(6)
};

var sloppyArrayMethod = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !method || !fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal
    method.call(null, argument || function () { throw 1; }, 1);
  });
};

var $forEach = arrayIteration.forEach;


// `Array.prototype.forEach` method implementation
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
var arrayForEach = sloppyArrayMethod('forEach') ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
} : [].forEach;

// `Array.prototype.forEach` method
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
_export({ target: 'Array', proto: true, forced: [].forEach != arrayForEach }, {
  forEach: arrayForEach
});

var entryVirtual = function (CONSTRUCTOR) {
  return path[CONSTRUCTOR + 'Prototype'];
};

var forEach = entryVirtual('Array').forEach;

var forEach$1 = forEach;

var ArrayPrototype = Array.prototype;

var DOMIterables = {
  DOMTokenList: true,
  NodeList: true
};

var forEach_1 = function (it) {
  var own = it.forEach;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.forEach)
    // eslint-disable-next-line no-prototype-builtins
    || DOMIterables.hasOwnProperty(classof(it)) ? forEach$1 : own;
};

var forEach$2 = forEach_1;

var check$1 = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global_1$1 =
  // eslint-disable-next-line no-undef
  check$1(typeof globalThis == 'object' && globalThis) ||
  check$1(typeof window == 'object' && window) ||
  check$1(typeof self == 'object' && self) ||
  check$1(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func
  Function('return this')();

var fails$1 = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

// Thank's IE8 for his funny defineProperty
var descriptors$1 = !fails$1(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

var isObject$1 = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var document$2 = global_1$1.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$1(document$2) && isObject$1(document$2.createElement);

var documentCreateElement$1 = function (it) {
  return EXISTS$1 ? document$2.createElement(it) : {};
};

// Thank's IE8 for his funny defineProperty
var ie8DomDefine$1 = !descriptors$1 && !fails$1(function () {
  return Object.defineProperty(documentCreateElement$1('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var anObject$1 = function (it) {
  if (!isObject$1(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var toPrimitive$1 = function (input, PREFERRED_STRING) {
  if (!isObject$1(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject$1(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject$1(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject$1(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var nativeDefineProperty$1 = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
var f$3 = descriptors$1 ? nativeDefineProperty$1 : function defineProperty(O, P, Attributes) {
  anObject$1(O);
  P = toPrimitive$1(P, true);
  anObject$1(Attributes);
  if (ie8DomDefine$1) try {
    return nativeDefineProperty$1(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var objectDefineProperty$1 = {
	f: f$3
};

var createPropertyDescriptor$1 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var createNonEnumerableProperty$1 = descriptors$1 ? function (object, key, value) {
  return objectDefineProperty$1.f(object, key, createPropertyDescriptor$1(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var hasOwnProperty$1 = {}.hasOwnProperty;

var has$2 = function (it, key) {
  return hasOwnProperty$1.call(it, key);
};

var setGlobal$1 = function (key, value) {
  try {
    createNonEnumerableProperty$1(global_1$1, key, value);
  } catch (error) {
    global_1$1[key] = value;
  } return value;
};

var isPure$1 = false;

var SHARED$1 = '__core-js_shared__';
var store$2 = global_1$1[SHARED$1] || setGlobal$1(SHARED$1, {});

var sharedStore$1 = store$2;

var shared$1 = createCommonjsModule(function (module) {
(module.exports = function (key, value) {
  return sharedStore$1[key] || (sharedStore$1[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.4.5',
  mode:  'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});
});

var functionToString$1 = Function.toString;

var inspectSource$1 = shared$1('inspectSource', function (it) {
  return functionToString$1.call(it);
});

var WeakMap$2 = global_1$1.WeakMap;

var nativeWeakMap$1 = typeof WeakMap$2 === 'function' && /native code/.test(inspectSource$1(WeakMap$2));

var id$1 = 0;
var postfix$1 = Math.random();

var uid$1 = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id$1 + postfix$1).toString(36);
};

var keys$1 = shared$1('keys');

var sharedKey$1 = function (key) {
  return keys$1[key] || (keys$1[key] = uid$1(key));
};

var hiddenKeys$1 = {};

var WeakMap$3 = global_1$1.WeakMap;
var set$1, get$1, has$3;

var enforce$1 = function (it) {
  return has$3(it) ? get$1(it) : set$1(it, {});
};

var getterFor$1 = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$1(it) || (state = get$1(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (nativeWeakMap$1) {
  var store$3 = new WeakMap$3();
  var wmget$1 = store$3.get;
  var wmhas$1 = store$3.has;
  var wmset$1 = store$3.set;
  set$1 = function (it, metadata) {
    wmset$1.call(store$3, it, metadata);
    return metadata;
  };
  get$1 = function (it) {
    return wmget$1.call(store$3, it) || {};
  };
  has$3 = function (it) {
    return wmhas$1.call(store$3, it);
  };
} else {
  var STATE$1 = sharedKey$1('state');
  hiddenKeys$1[STATE$1] = true;
  set$1 = function (it, metadata) {
    createNonEnumerableProperty$1(it, STATE$1, metadata);
    return metadata;
  };
  get$1 = function (it) {
    return has$2(it, STATE$1) ? it[STATE$1] : {};
  };
  has$3 = function (it) {
    return has$2(it, STATE$1);
  };
}

var internalState$1 = {
  set: set$1,
  get: get$1,
  has: has$3,
  enforce: enforce$1,
  getterFor: getterFor$1
};

var redefine$1 = createCommonjsModule(function (module) {
var getInternalState = internalState$1.get;
var enforceInternalState = internalState$1.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has$2(value, 'name')) createNonEnumerableProperty$1(value, 'name', key);
    enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
  }
  if (O === global_1$1) {
    if (simple) O[key] = value;
    else setGlobal$1(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty$1(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource$1(this);
});
});

var DatePrototype = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var nativeDateToString = DatePrototype[TO_STRING];
var getTime = DatePrototype.getTime;

// `Date.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-date.prototype.tostring
if (new Date(NaN) + '' != INVALID_DATE) {
  redefine$1(DatePrototype, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? nativeDateToString.call(this) : INVALID_DATE;
  });
}

var defineProperty$1 = objectDefineProperty$1.f;

var FunctionPrototype = Function.prototype;
var FunctionPrototypeToString = FunctionPrototype.toString;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// Function instances `.name` property
// https://tc39.github.io/ecma262/#sec-function-instances-name
if (descriptors$1 && !(NAME in FunctionPrototype)) {
  defineProperty$1(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return FunctionPrototypeToString.call(this).match(nameRE)[1];
      } catch (error) {
        return '';
      }
    }
  });
}

var replacement$1 = /#|\.prototype\./;

var isForced$1 = function (feature, detection) {
  var value = data$1[normalize$1(feature)];
  return value == POLYFILL$1 ? true
    : value == NATIVE$1 ? false
    : typeof detection == 'function' ? fails$1(detection)
    : !!detection;
};

var normalize$1 = isForced$1.normalize = function (string) {
  return String(string).replace(replacement$1, '.').toLowerCase();
};

var data$1 = isForced$1.data = {};
var NATIVE$1 = isForced$1.NATIVE = 'N';
var POLYFILL$1 = isForced$1.POLYFILL = 'P';

var isForced_1$1 = isForced$1;

var toString$1 = {}.toString;

var classofRaw$1 = function (it) {
  return toString$1.call(it).slice(8, -1);
};

var aPossiblePrototype$1 = function (it) {
  if (!isObject$1(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var objectSetPrototypeOf$1 = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject$1(O);
    aPossiblePrototype$1(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

// makes subclassing work correct for wrapped built-ins
var inheritIfRequired = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    objectSetPrototypeOf$1 &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    typeof (NewTarget = dummy.constructor) == 'function' &&
    NewTarget !== Wrapper &&
    isObject$1(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) objectSetPrototypeOf$1($this, NewTargetPrototype);
  return $this;
};

var split$1 = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject$1 = fails$1(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classofRaw$1(it) == 'String' ? split$1.call(it, '') : Object(it);
} : Object;

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$1 = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings



var toIndexedObject$1 = function (it) {
  return indexedObject$1(requireObjectCoercible$1(it));
};

var ceil$1 = Math.ceil;
var floor$1 = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
var toInteger$1 = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor$1 : ceil$1)(argument);
};

var min$2 = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
var toLength$1 = function (argument) {
  return argument > 0 ? min$2(toInteger$1(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var max$1 = Math.max;
var min$3 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toInteger$1(index);
  return integer < 0 ? max$1(integer + length, 0) : min$3(integer, length);
};

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$2 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$1($this);
    var length = toLength$1(O.length);
    var index = toAbsoluteIndex$1(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes$1 = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod$2(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$2(false)
};

var indexOf$1 = arrayIncludes$1.indexOf;


var objectKeysInternal$1 = function (object, names) {
  var O = toIndexedObject$1(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has$2(hiddenKeys$1, key) && has$2(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has$2(O, key = names[i++])) {
    ~indexOf$1(result, key) || result.push(key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$1 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
var objectKeys$1 = Object.keys || function keys(O) {
  return objectKeysInternal$1(O, enumBugKeys$1);
};

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
var objectDefineProperties$1 = descriptors$1 ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$1(O);
  var keys = objectKeys$1(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) objectDefineProperty$1.f(O, key = keys[index++], Properties[key]);
  return O;
};

var path$1 = global_1$1;

var aFunction$2 = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

var getBuiltIn$1 = function (namespace, method) {
  return arguments.length < 2 ? aFunction$2(path$1[namespace]) || aFunction$2(global_1$1[namespace])
    : path$1[namespace] && path$1[namespace][method] || global_1$1[namespace] && global_1$1[namespace][method];
};

var html$1 = getBuiltIn$1('document', 'documentElement');

var IE_PROTO$2 = sharedKey$1('IE_PROTO');

var PROTOTYPE$1 = 'prototype';
var Empty$1 = function () { /* empty */ };

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict$1 = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var length = enumBugKeys$1.length;
  var lt = '<';
  var script = 'script';
  var gt = '>';
  var js = 'java' + script + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html$1.appendChild(iframe);
  iframe.src = String(js);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + script + gt + 'document.F=Object' + lt + '/' + script + gt);
  iframeDocument.close();
  createDict$1 = iframeDocument.F;
  while (length--) delete createDict$1[PROTOTYPE$1][enumBugKeys$1[length]];
  return createDict$1();
};

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
var objectCreate$1 = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty$1[PROTOTYPE$1] = anObject$1(O);
    result = new Empty$1();
    Empty$1[PROTOTYPE$1] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$2] = O;
  } else result = createDict$1();
  return Properties === undefined ? result : objectDefineProperties$1(result, Properties);
};

hiddenKeys$1[IE_PROTO$2] = true;

var hiddenKeys$2 = enumBugKeys$1.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertynames
var f$4 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return objectKeysInternal$1(O, hiddenKeys$2);
};

var objectGetOwnPropertyNames = {
	f: f$4
};

var nativePropertyIsEnumerable$1 = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG$1 = getOwnPropertyDescriptor$2 && !nativePropertyIsEnumerable$1.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
var f$5 = NASHORN_BUG$1 ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$2(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable$1;

var objectPropertyIsEnumerable$1 = {
	f: f$5
};

var nativeGetOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
var f$6 = descriptors$1 ? nativeGetOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$1(O);
  P = toPrimitive$1(P, true);
  if (ie8DomDefine$1) try {
    return nativeGetOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (has$2(O, P)) return createPropertyDescriptor$1(!objectPropertyIsEnumerable$1.f.call(O, P), O[P]);
};

var objectGetOwnPropertyDescriptor$1 = {
	f: f$6
};

// a string of all valid unicode whitespaces
// eslint-disable-next-line max-len
var whitespaces = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod$3 = function (TYPE) {
  return function ($this) {
    var string = String(requireObjectCoercible$1($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimstart
  start: createMethod$3(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimend
  end: createMethod$3(2),
  // `String.prototype.trim` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.trim
  trim: createMethod$3(3)
};

var getOwnPropertyNames = objectGetOwnPropertyNames.f;
var getOwnPropertyDescriptor$3 = objectGetOwnPropertyDescriptor$1.f;
var defineProperty$2 = objectDefineProperty$1.f;
var trim = stringTrim.trim;

var NUMBER = 'Number';
var NativeNumber = global_1$1[NUMBER];
var NumberPrototype = NativeNumber.prototype;

// Opera ~12 has broken Object#toString
var BROKEN_CLASSOF = classofRaw$1(objectCreate$1(NumberPrototype)) == NUMBER;

// `ToNumber` abstract operation
// https://tc39.github.io/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive$1(argument, false);
  var first, third, radix, maxCode, digits, length, index, code;
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = it.charCodeAt(0);
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = it.slice(2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = digits.charCodeAt(index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.github.io/ecma262/#sec-number-constructor
if (isForced_1$1(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var dummy = this;
    return dummy instanceof NumberWrapper
      // check on 1..constructor(foo) case
      && (BROKEN_CLASSOF ? fails$1(function () { NumberPrototype.valueOf.call(dummy); }) : classofRaw$1(dummy) != NUMBER)
        ? inheritIfRequired(new NativeNumber(toNumber(it)), dummy, NumberWrapper) : toNumber(it);
  };
  for (var keys$2 = descriptors$1 ? getOwnPropertyNames(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys$2.length > j; j++) {
    if (has$2(NativeNumber, key = keys$2[j]) && !has$2(NumberWrapper, key)) {
      defineProperty$2(NumberWrapper, key, getOwnPropertyDescriptor$3(NativeNumber, key));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  redefine$1(global_1$1, NUMBER, NumberWrapper);
}

var nativeSymbol$1 = !!Object.getOwnPropertySymbols && !fails$1(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});

var useSymbolAsUid$1 = nativeSymbol$1
  // eslint-disable-next-line no-undef
  && !Symbol.sham
  // eslint-disable-next-line no-undef
  && typeof Symbol() == 'symbol';

var WellKnownSymbolsStore$1 = shared$1('wks');
var Symbol$2 = global_1$1.Symbol;
var createWellKnownSymbol$1 = useSymbolAsUid$1 ? Symbol$2 : uid$1;

var wellKnownSymbol$1 = function (name) {
  if (!has$2(WellKnownSymbolsStore$1, name)) {
    if (nativeSymbol$1 && has$2(Symbol$2, name)) WellKnownSymbolsStore$1[name] = Symbol$2[name];
    else WellKnownSymbolsStore$1[name] = createWellKnownSymbol$1('Symbol.' + name);
  } return WellKnownSymbolsStore$1[name];
};

var TO_STRING_TAG$4 = wellKnownSymbol$1('toStringTag');
var test$1 = {};

test$1[TO_STRING_TAG$4] = 'z';

var toStringTagSupport$1 = String(test$1) === '[object z]';

var TO_STRING_TAG$5 = wellKnownSymbol$1('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS$1 = classofRaw$1(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet$1 = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$1 = toStringTagSupport$1 ? classofRaw$1 : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet$1(O = Object(it), TO_STRING_TAG$5)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS$1 ? classofRaw$1(O)
    // ES3 arguments fallback
    : (result = classofRaw$1(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};

// `Object.prototype.toString` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
var objectToString$1 = toStringTagSupport$1 ? {}.toString : function toString() {
  return '[object ' + classof$1(this) + ']';
};

// `Object.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
if (!toStringTagSupport$1) {
  redefine$1(Object.prototype, 'toString', objectToString$1, { unsafe: true });
}

// `RegExp.prototype.flags` getter implementation
// https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags = function () {
  var that = anObject$1(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

var TO_STRING$1 = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING$1];

var NOT_GENERIC = fails$1(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = nativeToString.name != TO_STRING$1;

// `RegExp.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine$1(RegExp.prototype, TO_STRING$1, function toString() {
    var R = anObject$1(this);
    var p = String(R.source);
    var rf = R.flags;
    var f = String(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype) ? regexpFlags.call(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}

// a string of all valid unicode whitespaces
// eslint-disable-next-line max-len
var whitespaces$1 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var whitespace$1 = '[' + whitespaces$1 + ']';
var ltrim$1 = RegExp('^' + whitespace$1 + whitespace$1 + '*');
var rtrim$1 = RegExp(whitespace$1 + whitespace$1 + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod$4 = function (TYPE) {
  return function ($this) {
    var string = String(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim$1, '');
    if (TYPE & 2) string = string.replace(rtrim$1, '');
    return string;
  };
};

var stringTrim$1 = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimstart
  start: createMethod$4(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimend
  end: createMethod$4(2),
  // `String.prototype.trim` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.trim
  trim: createMethod$4(3)
};

var trim$1 = stringTrim$1.trim;


var nativeParseInt = global_1.parseInt;
var hex = /^[+-]?0[Xx]/;
var FORCED = nativeParseInt(whitespaces$1 + '08') !== 8 || nativeParseInt(whitespaces$1 + '0x16') !== 22;

// `parseInt` method
// https://tc39.github.io/ecma262/#sec-parseint-string-radix
var _parseInt = FORCED ? function parseInt(string, radix) {
  var S = trim$1(String(string));
  return nativeParseInt(S, (radix >>> 0) || (hex.test(S) ? 16 : 10));
} : nativeParseInt;

// `parseInt` method
// https://tc39.github.io/ecma262/#sec-parseint-string-radix
_export({ global: true, forced: parseInt != _parseInt }, {
  parseInt: _parseInt
});

var _parseInt$1 = path.parseInt;

var _parseInt$2 = _parseInt$1;

var _parseInt$3 = _parseInt$2;

var userAgent = getBuiltIn('navigator', 'userAgent') || '';

var process = global_1.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

var v8Version = version && +version;

var SPECIES$1 = wellKnownSymbol('species');

var arrayMethodHasSpeciesSupport = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return v8Version >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES$1] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};

var $map = arrayIteration.map;



var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');
// FF49- issue
var USES_TO_LENGTH = HAS_SPECIES_SUPPORT && !fails(function () {
  [].map.call({ length: -1, 0: 1 }, function (it) { throw it; });
});

// `Array.prototype.map` method
// https://tc39.github.io/ecma262/#sec-array.prototype.map
// with adding support of @@species
_export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var map = entryVirtual('Array').map;

var ArrayPrototype$1 = Array.prototype;

var map_1 = function (it) {
  var own = it.map;
  return it === ArrayPrototype$1 || (it instanceof Array && own === ArrayPrototype$1.map) ? map : own;
};

var map$1 = map_1;

var map$2 = map$1;

var $indexOf = arrayIncludes.indexOf;


var nativeIndexOf = [].indexOf;

var NEGATIVE_ZERO = !!nativeIndexOf && 1 / [1].indexOf(1, -0) < 0;
var SLOPPY_METHOD = sloppyArrayMethod('indexOf');

// `Array.prototype.indexOf` method
// https://tc39.github.io/ecma262/#sec-array.prototype.indexof
_export({ target: 'Array', proto: true, forced: NEGATIVE_ZERO || SLOPPY_METHOD }, {
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? nativeIndexOf.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var indexOf$2 = entryVirtual('Array').indexOf;

var ArrayPrototype$2 = Array.prototype;

var indexOf_1 = function (it) {
  var own = it.indexOf;
  return it === ArrayPrototype$2 || (it instanceof Array && own === ArrayPrototype$2.indexOf) ? indexOf$2 : own;
};

var indexOf$3 = indexOf_1;

var indexOf$4 = indexOf$3;

var createProperty = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) objectDefineProperty.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};

var SPECIES$2 = wellKnownSymbol('species');
var nativeSlice = [].slice;
var max$2 = Math.max;

// `Array.prototype.slice` method
// https://tc39.github.io/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
_export({ target: 'Array', proto: true, forced: !arrayMethodHasSpeciesSupport('slice') }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = toLength(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES$2];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max$2(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});

var slice = entryVirtual('Array').slice;

var ArrayPrototype$3 = Array.prototype;

var slice_1 = function (it) {
  var own = it.slice;
  return it === ArrayPrototype$3 || (it instanceof Array && own === ArrayPrototype$3.slice) ? slice : own;
};

var slice$1 = slice_1;

var slice$2 = slice$1;

// `Array.isArray` method
// https://tc39.github.io/ecma262/#sec-array.isarray
_export({ target: 'Array', stat: true }, {
  isArray: isArray
});

var isArray$1 = path.Array.isArray;

var isArray$2 = isArray$1;

var isArray$3 = isArray$2;

var $find = arrayIteration.find;


var FIND = 'find';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.github.io/ecma262/#sec-array.prototype.find
_export({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var find = entryVirtual('Array').find;

var ArrayPrototype$4 = Array.prototype;

var find_1 = function (it) {
  var own = it.find;
  return it === ArrayPrototype$4 || (it instanceof Array && own === ArrayPrototype$4.find) ? find : own;
};

var find$1 = find_1;

var find$2 = find$1;

var f$7 = Object.getOwnPropertySymbols;

var objectGetOwnPropertySymbols = {
	f: f$7
};

// all object keys, includes non-enumerable and symbols
var ownKeys = getBuiltIn$1('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = objectGetOwnPropertyNames.f(anObject$1(it));
  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};

var copyConstructorProperties = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = objectDefineProperty$1.f;
  var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor$1.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has$2(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};

var getOwnPropertyDescriptor$4 = objectGetOwnPropertyDescriptor$1.f;






/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
var _export$1 = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global_1$1;
  } else if (STATIC) {
    target = global_1$1[TARGET] || setGlobal$1(TARGET, {});
  } else {
    target = (global_1$1[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor$4(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced_1$1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$1(sourceProperty, 'sham', true);
    }
    // extend global
    redefine$1(target, key, sourceProperty, options);
  }
};

var sloppyArrayMethod$1 = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !method || !fails$1(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal
    method.call(null, argument || function () { throw 1; }, 1);
  });
};

var nativeJoin = [].join;

var ES3_STRINGS = indexedObject$1 != Object;
var SLOPPY_METHOD$1 = sloppyArrayMethod$1('join', ',');

// `Array.prototype.join` method
// https://tc39.github.io/ecma262/#sec-array.prototype.join
_export$1({ target: 'Array', proto: true, forced: ES3_STRINGS || SLOPPY_METHOD$1 }, {
  join: function join(separator) {
    return nativeJoin.call(toIndexedObject$1(this), separator === undefined ? ',' : separator);
  }
});

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

var regexpExec = patchedExec;

_export$1({ target: 'RegExp', proto: true, forced: /./.exec !== regexpExec }, {
  exec: regexpExec
});

var SPECIES$3 = wellKnownSymbol$1('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails$1(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails$1(function () {
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

var fixRegexpWellKnownSymbolLogic = function (KEY, length, exec, sham) {
  var SYMBOL = wellKnownSymbol$1(KEY);

  var DELEGATES_TO_SYMBOL = !fails$1(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$1(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES$3] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      if (regexp.exec === regexpExec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    });
    var stringMethod = methods[0];
    var regexMethod = methods[1];

    redefine$1(String.prototype, KEY, stringMethod);
    redefine$1(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return regexMethod.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return regexMethod.call(string, this); }
    );
    if (sham) createNonEnumerableProperty$1(RegExp.prototype[SYMBOL], 'sham', true);
  }
};

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
var toObject$1 = function (argument) {
  return Object(requireObjectCoercible$1(argument));
};

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod$5 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible$1($this));
    var position = toInteger$1(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$5(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$5(true)
};

var charAt = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
var advanceStringIndex = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};

// `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }

  if (classofRaw$1(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec.call(R, S);
};

var max$3 = Math.max;
var min$4 = Math.min;
var floor$2 = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
fixRegexpWellKnownSymbolLogic('replace', 2, function (REPLACE, nativeReplace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible$1(this);
      var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
      return replacer !== undefined
        ? replacer.call(searchValue, O, replaceValue)
        : nativeReplace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative(nativeReplace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject$1(regexp);
      var S = String(this);

      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regexpExecAbstract(rx, S);
        if (result === null) break;

        results.push(result);
        if (!global) break;

        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength$1(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = String(result[0]);
        var position = max$3(min$4(toInteger$1(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

  // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject$1(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return nativeReplace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor$2(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});

var MATCH = wellKnownSymbol$1('match');

// `IsRegExp` abstract operation
// https://tc39.github.io/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject$1(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classofRaw$1(it) == 'RegExp');
};

var aFunction$3 = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};

var SPECIES$4 = wellKnownSymbol$1('species');

// `SpeciesConstructor` abstract operation
// https://tc39.github.io/ecma262/#sec-speciesconstructor
var speciesConstructor = function (O, defaultConstructor) {
  var C = anObject$1(O).constructor;
  var S;
  return C === undefined || (S = anObject$1(C)[SPECIES$4]) == undefined ? defaultConstructor : aFunction$3(S);
};

var arrayPush = [].push;
var min$5 = Math.min;
var MAX_UINT32 = 0xFFFFFFFF;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails$1(function () { return !RegExp(MAX_UINT32, 'y'); });

// @@split logic
fixRegexpWellKnownSymbolLogic('split', 2, function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(requireObjectCoercible$1(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegexp(separator)) {
        return nativeSplit.call(string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) arrayPush.apply(output, match.slice(1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output.length > lim ? output.slice(0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : nativeSplit.call(this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible$1(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== nativeSplit);
      if (res.done) return res.value;

      var rx = anObject$1(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return regexpExecAbstract(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = regexpExecAbstract(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = min$5(toLength$1(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
}, !SUPPORTS_Y);

var max$4 = Math.max;
var min$6 = Math.min;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded';

// `Array.prototype.splice` method
// https://tc39.github.io/ecma262/#sec-array.prototype.splice
// with adding support of @@species
_export({ target: 'Array', proto: true, forced: !arrayMethodHasSpeciesSupport('splice') }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = toLength(O.length);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min$6(max$4(toInteger(deleteCount), 0), len - actualStart);
    }
    if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) {
      throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
    }
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    O.length = len - actualDeleteCount + insertCount;
    return A;
  }
});

var splice = entryVirtual('Array').splice;

var ArrayPrototype$5 = Array.prototype;

var splice_1 = function (it) {
  var own = it.splice;
  return it === ArrayPrototype$5 || (it instanceof Array && own === ArrayPrototype$5.splice) ? splice : own;
};

var splice$1 = splice_1;

var splice$2 = splice$1;

var propertyIsEnumerable = objectPropertyIsEnumerable.f;

// `Object.{ entries, values }` methods implementation
var createMethod$6 = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!descriptors || propertyIsEnumerable.call(O, key)) {
        result.push(TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

var objectToArray = {
  // `Object.entries` method
  // https://tc39.github.io/ecma262/#sec-object.entries
  entries: createMethod$6(true),
  // `Object.values` method
  // https://tc39.github.io/ecma262/#sec-object.values
  values: createMethod$6(false)
};

var $values = objectToArray.values;

// `Object.values` method
// https://tc39.github.io/ecma262/#sec-object.values
_export({ target: 'Object', stat: true }, {
  values: function values(O) {
    return $values(O);
  }
});

var values = path.Object.values;

var values$1 = values;

var values$2 = values$1;

var themePropsDefault = {
  'default-page': {
    empty: {
      image: '//media.winbaoxian.com/autoUpload/common/error-empty_71d507cd6a90807.png',
      text: '什么都没有'
    },
    message: {
      image: '//media.winbaoxian.com/autoUpload/common/error-message_9b45ca72412df4b.png',
      text: '没有消息'
    },
    activity: {
      image: '//media.winbaoxian.com/autoUpload/common/error-activity_d6fd3d38e6cda2b.png',
      text: '没有活动'
    },
    search: {
      image: '//media.winbaoxian.com/autoUpload/common/error-search_05ae4e97a2d63b3.png',
      text: '没有搜索结果'
    },
    comment: {
      image: '//media.winbaoxian.com/autoUpload/common/error-comment_40b84b4a78811f2.png',
      text: '没有评论'
    },
    collect: {
      image: '//media.winbaoxian.com/autoUpload/common/error-collect_c718dfd03a76400.png',
      text: '没有收藏'
    },
    address: {
      image: '//media.winbaoxian.com/autoUpload/common/error-address_cd82052533577c9.png',
      text: '没有地址'
    },
    redpack: {
      image: '//media.winbaoxian.com/autoUpload/common/error-redpack_44e982d000216fb.png',
      text: '没有奖励券'
    },
    network: {
      image: '//media.winbaoxian.com/autoUpload/common/error-network_3fb1d4ef31a65e1.png',
      text: '网络异常'
    },
    loaded: {
      image: '//media.winbaoxian.com/autoUpload/common/error-loaded_51196385d445198.png',
      text: '加载失败'
    },
    upgrade: {
      image: '//media.winbaoxian.com/autoUpload/common/error-upgrade_a35b243ef7e6ef9.png',
      text: '服务器升级中'
    }
  },
  'uploader-list': {
    file: 'https://media.winbaoxian.com/autoUpload/common/uploader-singel-default-bg_50cf43edbe0abde.png',
    // 文件
    id_emb: 'https://media.winbaoxian.com/autoUpload/common/ID_font2x_51a64f467a9867a.png',
    // 身份证国徽面
    id_face: 'https://media.winbaoxian.com/autoUpload/common/ID_back2x_c6d5c06307df180.png',
    // 身份证人脸面
    deposit_book: 'https://media.winbaoxian.com/autoUpload/common/deposit_book2x_1d1d8b33735a6ab.png',
    // 存折信息面
    bank_card_front: 'https://media.winbaoxian.com/autoUpload/common/bankcard_front2x_7e9530f90c8818d.png',
    // 银行卡正面
    bank_card_back: 'https://media.winbaoxian.com/autoUpload/common/bankcard_back2x_4554d73a0f5d328.png',
    // 银行卡方面
    hand_file: 'https://media.winbaoxian.com/autoUpload/common/hand-held_file2x_423f58337781646.png',
    // 手持文件
    hand_id_emb: 'https://media.winbaoxian.com/autoUpload/common/hand-held_ID_font2x_d93b14c97b4dbce.png',
    // 手持身份证国徽面
    hand_id_face: 'https://media.winbaoxian.com/autoUpload/common/hand-held_ID_back2x_ce50244bd7573c4.png' // 手持身份证人脸面

  }
};

var uploaderPresetBgImgUrl = 'https://res.wyins.net/autoUpload/common/uploader_bg_camera_4d9849153102b23.png';
var themePropsBroker = {
  'default-page': {
    empty: {
      image: '//res.wyins.net/autoUpload/common/emptystatus_72884a7621331d1.png',
      text: '什么都没有'
    },
    message: {
      image: '//res.wyins.net/autoUpload/common/emptystatus_72884a7621331d1.png',
      text: '没有消息'
    },
    activity: {
      image: '//res.wyins.net/autoUpload/common/emptystatus_72884a7621331d1.png',
      text: '没有活动'
    },
    search: {
      image: '//res.wyins.net/autoUpload/common/emptystatus_72884a7621331d1.png',
      text: '没有搜索结果'
    },
    comment: {
      image: '//res.wyins.net/autoUpload/common/emptystatus_72884a7621331d1.png',
      text: '没有评论'
    },
    collect: {
      image: '//res.wyins.net/autoUpload/common/emptystatus_72884a7621331d1.png',
      text: '没有收藏'
    },
    address: {
      image: '//res.wyins.net/autoUpload/common/emptystatus_72884a7621331d1.png',
      text: '没有地址'
    },
    redpack: {
      image: '//res.wyins.net/autoUpload/common/emptystatus_72884a7621331d1.png',
      text: '没有奖励券'
    },
    network: {
      image: '//res.wyins.net/autoUpload/common/emptystatus_72884a7621331d1.png',
      text: '网络异常'
    },
    loaded: {
      image: '//res.wyins.net/autoUpload/common/emptystatus_72884a7621331d1.png',
      text: '加载失败'
    },
    upgrade: {
      image: '//res.wyins.net/autoUpload/common/emptystatus_72884a7621331d1.png',
      text: '服务器升级中'
    }
  },
  'uploader-list': {
    file: uploaderPresetBgImgUrl,
    // 文件
    id_emb: uploaderPresetBgImgUrl,
    // 身份证国徽面
    id_face: uploaderPresetBgImgUrl,
    // 身份证人脸面
    deposit_book: uploaderPresetBgImgUrl,
    // 存折信息面
    bank_card_front: uploaderPresetBgImgUrl,
    // 银行卡正面
    bank_card_back: uploaderPresetBgImgUrl,
    // 银行卡方面
    hand_file: uploaderPresetBgImgUrl,
    // 手持文件
    hand_id_emb: uploaderPresetBgImgUrl,
    // 手持身份证国徽面
    hand_id_face: uploaderPresetBgImgUrl // 手持身份证人脸面

  }
};

var _context;
var ENUM_THEME_VARS = {
  default: {
    themeProps: themePropsDefault
  },
  broker: {
    themeProps: themePropsBroker,
    className: 'theme-broker'
  }
};

var THEME_CLASS_NAMES = map$2(_context = values$2(ENUM_THEME_VARS)).call(_context, function (item) {
  return item.className;
});

function addClass(classNames, className) {
  if (className && indexOf$4(classNames).call(classNames, className) === -1) {
    classNames.push(className);
  }
}

function removeClass(classNames, className) {
  var index = indexOf$4(classNames).call(classNames, className);

  if (className && index > -1) {
    splice$2(classNames).call(classNames, index, 1);
  }
}

var globalThemeInstance = new Vue({
  data: {
    theme: 'default'
  }
});
var ThemeSwitcher = {
  setTheme: function setTheme(theme) {
    if (theme === void 0) {
      theme = 'default';
    }

    globalThemeInstance.theme = theme;
    var el = document.body;
    var classNames = el.className.split(' ');

    forEach$2(THEME_CLASS_NAMES).call(THEME_CLASS_NAMES, function (themeClass) {
      removeClass(classNames, themeClass);
    });

    addClass(classNames, ENUM_THEME_VARS[theme].className); // eslint-disable-next-line no-param-reassign

    el.className = classNames.join(' ');
  },
  getTheme: function getTheme() {
    return globalThemeInstance.theme;
  },
  getThemeProps: function getThemeProps(theme) {
    var themeName = theme || globalThemeInstance.theme;
    return ENUM_THEME_VARS[themeName].themeProps || {};
  },
  // 供Vue.use使用
  install: function install(vueGlobal) {
    vueGlobal.mixin({
      computed: {
        $themeProps: function $themeProps() {
          return ENUM_THEME_VARS[globalThemeInstance.theme] ? ENUM_THEME_VARS[globalThemeInstance.theme].themeProps : {};
        },
        $myThemeProps: function $myThemeProps() {
          var themeProps = this.$themeProps;
          /* eslint no-underscore-dangle: ["error", { "allow": ["_componentTag"] }] */

          var componentDefName = this.$options._componentTag || this.$options.name || '';
          var componentKey = componentDefName.replace('bxs-', '');
          return themeProps && themeProps[componentKey] || {};
        }
      }
    }); // eslint-disable-next-line no-param-reassign

    vueGlobal.prototype.$setTheme = this.setTheme; // eslint-disable-next-line no-param-reassign

    vueGlobal.prototype.$getTheme = this.getTheme;
    window.themeUtil = this;
  }
};

Vue.use(ThemeSwitcher);

var install = function install(vueGlobal) {
  vueGlobal.component(this.name, this);
};

function basicCreate(sfc) {
  /* eslint no-param-reassign: ["error", { "props": false }] */
  sfc.name = "bxs-" + sfc.name;
  sfc.install = sfc.install || install;
  return sfc;
}

function create (sfc) {
  return basicCreate(sfc);
}

var SPECIES$5 = wellKnownSymbol$1('species');

var setSpecies = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn$1(CONSTRUCTOR_NAME);
  var defineProperty = objectDefineProperty$1.f;

  if (descriptors$1 && Constructor && !Constructor[SPECIES$5]) {
    defineProperty(Constructor, SPECIES$5, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var defineProperty$3 = objectDefineProperty$1.f;
var getOwnPropertyNames$1 = objectGetOwnPropertyNames.f;







var MATCH$1 = wellKnownSymbol$1('match');
var NativeRegExp = global_1$1.RegExp;
var RegExpPrototype$1 = NativeRegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var FORCED$1 = descriptors$1 && isForced_1$1('RegExp', (!CORRECT_NEW || fails$1(function () {
  re2[MATCH$1] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || NativeRegExp(re1, 'i') != '/a/i';
})));

// `RegExp` constructor
// https://tc39.github.io/ecma262/#sec-regexp-constructor
if (FORCED$1) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = this instanceof RegExpWrapper;
    var patternIsRegExp = isRegexp(pattern);
    var flagsAreUndefined = flags === undefined;
    return !thisIsRegExp && patternIsRegExp && pattern.constructor === RegExpWrapper && flagsAreUndefined ? pattern
      : inheritIfRequired(CORRECT_NEW
        ? new NativeRegExp(patternIsRegExp && !flagsAreUndefined ? pattern.source : pattern, flags)
        : NativeRegExp((patternIsRegExp = pattern instanceof RegExpWrapper)
          ? pattern.source
          : pattern, patternIsRegExp && flagsAreUndefined ? regexpFlags.call(pattern) : flags)
      , thisIsRegExp ? this : RegExpPrototype$1, RegExpWrapper);
  };
  var proxy = function (key) {
    key in RegExpWrapper || defineProperty$3(RegExpWrapper, key, {
      configurable: true,
      get: function () { return NativeRegExp[key]; },
      set: function (it) { NativeRegExp[key] = it; }
    });
  };
  var keys$3 = getOwnPropertyNames$1(NativeRegExp);
  var index = 0;
  while (keys$3.length > index) proxy(keys$3[index++]);
  RegExpPrototype$1.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype$1;
  redefine$1(global_1$1, 'RegExp', RegExpWrapper);
}

// https://tc39.github.io/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');

function hasClass(ele, cls) {
  return new RegExp("\\b" + cls + "\\b").test(ele.getAttribute('class') || '');
}

function addClass$1(ele, cls) {
  if (!hasClass(ele, cls)) {
    ele.setAttribute('class', ele.getAttribute('class') + " " + cls);
  }
}
function removeClass$1(ele, cls) {
  if (hasClass(ele, cls)) {
    ele.setAttribute('class', ele.getAttribute('class').replace(new RegExp("\\b" + cls + "\\b"), ''));
  }
}
function getContainer(appendTo) {
  var $container = null;

  if (typeof appendTo === 'string') {
    $container = document.querySelector(appendTo);
  } else if (typeof appendTo === 'object' && appendTo.nodeType === Node.ELEMENT_NODE) {
    $container = appendTo;
  }

  return $container || document.body;
}

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod$7 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte$1 = {
  // `String.prototype.codePointAt` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$7(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$7(true)
};

var charAt$1 = stringMultibyte$1.charAt;



var STRING_ITERATOR = 'String Iterator';
var setInternalState$1 = internalState.set;
var getInternalState$1 = internalState.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState$1(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState$1(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt$1(string, index);
  state.index += point.length;
  return { value: point, done: false };
});

var nativePromiseConstructor = global_1.Promise;

var redefineAll = function (target, src, options) {
  for (var key in src) {
    if (options && options.unsafe && target[key]) target[key] = src[key];
    else redefine(target, key, src[key], options);
  } return target;
};

var SPECIES$6 = wellKnownSymbol('species');

var setSpecies$1 = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = objectDefineProperty.f;

  if (descriptors && Constructor && !Constructor[SPECIES$6]) {
    defineProperty(Constructor, SPECIES$6, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var anInstance = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};

var ITERATOR$2 = wellKnownSymbol('iterator');
var ArrayPrototype$6 = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod = function (it) {
  return it !== undefined && (iterators.Array === it || ArrayPrototype$6[ITERATOR$2] === it);
};

var ITERATOR$3 = wellKnownSymbol('iterator');

var getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR$3]
    || it['@@iterator']
    || iterators[classof(it)];
};

// call something on iterator step with safe closing on error
var callWithSafeIterationClosing = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (error) {
    var returnMethod = iterator['return'];
    if (returnMethod !== undefined) anObject(returnMethod.call(iterator));
    throw error;
  }
};

var iterate_1 = createCommonjsModule(function (module) {
var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var iterate = module.exports = function (iterable, fn, that, AS_ENTRIES, IS_ITERATOR) {
  var boundFunction = bindContext(fn, that, AS_ENTRIES ? 2 : 1);
  var iterator, iterFn, index, length, result, next, step;

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = toLength(iterable.length); length > index; index++) {
        result = AS_ENTRIES
          ? boundFunction(anObject(step = iterable[index])[0], step[1])
          : boundFunction(iterable[index]);
        if (result && result instanceof Result) return result;
      } return new Result(false);
    }
    iterator = iterFn.call(iterable);
  }

  next = iterator.next;
  while (!(step = next.call(iterator)).done) {
    result = callWithSafeIterationClosing(iterator, boundFunction, step.value, AS_ENTRIES);
    if (typeof result == 'object' && result && result instanceof Result) return result;
  } return new Result(false);
};

iterate.stop = function (result) {
  return new Result(true, result);
};
});

var ITERATOR$4 = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR$4] = function () {
    return this;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$4] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var SPECIES$7 = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.github.io/ecma262/#sec-speciesconstructor
var speciesConstructor$1 = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES$7]) == undefined ? defaultConstructor : aFunction(S);
};

var isIos = /(iphone|ipod|ipad).*applewebkit/i.test(userAgent);

var location = global_1.location;
var set$2 = global_1.setImmediate;
var clear = global_1.clearImmediate;
var process$1 = global_1.process;
var MessageChannel = global_1.MessageChannel;
var Dispatch = global_1.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;

var run = function (id) {
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global_1.postMessage(id + '', location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set$2 || !clear) {
  set$2 = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (classofRaw(process$1) == 'process') {
    defer = function (id) {
      process$1.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !isIos) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bindContext(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global_1.addEventListener && typeof postMessage == 'function' && !global_1.importScripts && !fails(post)) {
    defer = post;
    global_1.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in documentCreateElement('script')) {
    defer = function (id) {
      html.appendChild(documentCreateElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task = {
  set: set$2,
  clear: clear
};

var getOwnPropertyDescriptor$5 = objectGetOwnPropertyDescriptor.f;

var macrotask = task.set;


var MutationObserver$1 = global_1.MutationObserver || global_1.WebKitMutationObserver;
var process$2 = global_1.process;
var Promise = global_1.Promise;
var IS_NODE = classofRaw(process$2) == 'process';
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor$5(global_1, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process$2.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (IS_NODE) {
    notify = function () {
      process$2.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  } else if (MutationObserver$1 && !isIos) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver$1(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    then = promise.then;
    notify = function () {
      then.call(promise, flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global_1, flush);
    };
  }
}

var microtask = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify();
  } last = task;
};

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
};

// 25.4.1.5 NewPromiseCapability(C)
var f$8 = function (C) {
  return new PromiseCapability(C);
};

var newPromiseCapability = {
	f: f$8
};

var promiseResolve = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var hostReportErrors = function (a, b) {
  var console = global_1.console;
  if (console && console.error) {
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  }
};

var perform = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var task$1 = task.set;










var SPECIES$8 = wellKnownSymbol('species');
var PROMISE = 'Promise';
var getInternalState$2 = internalState.get;
var setInternalState$2 = internalState.set;
var getInternalPromiseState = internalState.getterFor(PROMISE);
var PromiseConstructor = nativePromiseConstructor;
var TypeError$1 = global_1.TypeError;
var document$3 = global_1.document;
var process$3 = global_1.process;
var $fetch = getBuiltIn('fetch');
var newPromiseCapability$1 = newPromiseCapability.f;
var newGenericPromiseCapability = newPromiseCapability$1;
var IS_NODE$1 = classofRaw(process$3) == 'process';
var DISPATCH_EVENT = !!(document$3 && document$3.createEvent && global_1.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var Internal, OwnPromiseCapability, PromiseWrapper;

var FORCED$2 = isForced_1(PROMISE, function () {
  var GLOBAL_CORE_JS_PROMISE = inspectSource(PromiseConstructor) !== String(PromiseConstructor);
  if (!GLOBAL_CORE_JS_PROMISE) {
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (v8Version === 66) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    if (!IS_NODE$1 && typeof PromiseRejectionEvent != 'function') return true;
  }
  // We need Promise#finally in the pure version for preventing prototype pollution
  if ( !PromiseConstructor.prototype['finally']) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (v8Version >= 51 && /native code/.test(PromiseConstructor)) return false;
  // Detect correctness of subclassing with @@species support
  var promise = PromiseConstructor.resolve(1);
  var FakePromise = function (exec) {
    exec(function () { /* empty */ }, function () { /* empty */ });
  };
  var constructor = promise.constructor = {};
  constructor[SPECIES$8] = FakePromise;
  return !(promise.then(function () { /* empty */ }) instanceof FakePromise);
});

var INCORRECT_ITERATION = FORCED$2 || !checkCorrectnessOfIteration(function (iterable) {
  PromiseConstructor.all(iterable)['catch'](function () { /* empty */ });
});

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};

var notify$1 = function (promise, state, isReject) {
  if (state.notified) return;
  state.notified = true;
  var chain = state.reactions;
  microtask(function () {
    var value = state.value;
    var ok = state.state == FULFILLED;
    var index = 0;
    // variable length - can't use forEach
    while (chain.length > index) {
      var reaction = chain[index++];
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (state.rejection === UNHANDLED) onHandleUnhandled(promise, state);
            state.rejection = HANDLED;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // can throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError$1('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
      }
    }
    state.reactions = [];
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(promise, state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$3.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global_1.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (handler = global_1['on' + name]) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (promise, state) {
  task$1.call(global_1, function () {
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE$1) {
          process$3.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE$1 || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (promise, state) {
  task$1.call(global_1, function () {
    if (IS_NODE$1) {
      process$3.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, promise, state, unwrap) {
  return function (value) {
    fn(promise, state, value, unwrap);
  };
};

var internalReject = function (promise, state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify$1(promise, state, true);
};

var internalResolve = function (promise, state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (promise === value) throw TypeError$1("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          then.call(value,
            bind(internalResolve, promise, wrapper, state),
            bind(internalReject, promise, wrapper, state)
          );
        } catch (error) {
          internalReject(promise, wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify$1(promise, state, false);
    }
  } catch (error) {
    internalReject(promise, { done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED$2) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromiseConstructor, PROMISE);
    aFunction(executor);
    Internal.call(this);
    var state = getInternalState$2(this);
    try {
      executor(bind(internalResolve, this, state), bind(internalReject, this, state));
    } catch (error) {
      internalReject(this, state, error);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    setInternalState$2(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: [],
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };
  Internal.prototype = redefineAll(PromiseConstructor.prototype, {
    // `Promise.prototype.then` method
    // https://tc39.github.io/ecma262/#sec-promise.prototype.then
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState(this);
      var reaction = newPromiseCapability$1(speciesConstructor$1(this, PromiseConstructor));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = IS_NODE$1 ? process$3.domain : undefined;
      state.parent = true;
      state.reactions.push(reaction);
      if (state.state != PENDING) notify$1(this, state, false);
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.github.io/ecma262/#sec-promise.prototype.catch
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalState$2(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, promise, state);
    this.reject = bind(internalReject, promise, state);
  };
  newPromiseCapability.f = newPromiseCapability$1 = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

_export({ global: true, wrap: true, forced: FORCED$2 }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies$1(PROMISE);

PromiseWrapper = getBuiltIn(PROMISE);

// statics
_export({ target: PROMISE, stat: true, forced: FORCED$2 }, {
  // `Promise.reject` method
  // https://tc39.github.io/ecma262/#sec-promise.reject
  reject: function reject(r) {
    var capability = newPromiseCapability$1(this);
    capability.reject.call(undefined, r);
    return capability.promise;
  }
});

_export({ target: PROMISE, stat: true, forced: isPure  }, {
  // `Promise.resolve` method
  // https://tc39.github.io/ecma262/#sec-promise.resolve
  resolve: function resolve(x) {
    return promiseResolve( this === PromiseWrapper ? PromiseConstructor : this, x);
  }
});

_export({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
  // `Promise.all` method
  // https://tc39.github.io/ecma262/#sec-promise.all
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability$1(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate_1(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        $promiseResolve.call(C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  },
  // `Promise.race` method
  // https://tc39.github.io/ecma262/#sec-promise.race
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability$1(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction(C.resolve);
      iterate_1(iterable, function (promise) {
        $promiseResolve.call(C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

// `Promise.allSettled` method
// https://github.com/tc39/proposal-promise-allSettled
_export({ target: 'Promise', stat: true }, {
  allSettled: function allSettled(iterable) {
    var C = this;
    var capability = newPromiseCapability.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aFunction(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate_1(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        promiseResolve.call(C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'fulfilled', value: value };
          --remaining || resolve(values);
        }, function (e) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'rejected', reason: e };
          --remaining || resolve(values);
        });
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var NON_GENERIC = !!nativePromiseConstructor && fails(function () {
  nativePromiseConstructor.prototype['finally'].call({ then: function () { /* empty */ } }, function () { /* empty */ });
});

// `Promise.prototype.finally` method
// https://tc39.github.io/ecma262/#sec-promise.prototype.finally
_export({ target: 'Promise', proto: true, real: true, forced: NON_GENERIC }, {
  'finally': function (onFinally) {
    var C = speciesConstructor$1(this, getBuiltIn('Promise'));
    var isFunction = typeof onFinally == 'function';
    return this.then(
      isFunction ? function (x) {
        return promiseResolve(C, onFinally()).then(function () { return x; });
      } : onFinally,
      isFunction ? function (e) {
        return promiseResolve(C, onFinally()).then(function () { throw e; });
      } : onFinally
    );
  }
});

var promise$1 = path.Promise;

var promise$2 = promise$1;

var promise$3 = promise$2;

/**
 * @param {Function} checkSyncFn 检测方法-只能返回 true or false
 * @param {number} heartTime 心跳间隔
 * @param {number} timeout 超时时间, 默认 1000
 */
function heartCheck(checkSyncFn, heartTime, timeout) {
  if (heartTime === void 0) {
    heartTime = 500;
  }

  if (timeout === void 0) {
    timeout = 30000;
  }

  return new promise$3(function (resolve, reject) {
    if (checkSyncFn()) {
      resolve();
      return;
    }

    var startTime = new Date().getTime();
    var intervalId = window.setInterval(function () {
      if (checkSyncFn()) {
        window.clearInterval(intervalId);
        resolve();
      } else if (new Date().getTime() - startTime >= timeout) {
        window.clearInterval(intervalId);
        reject(new Error("timeout - " + timeout + ": \u7528\u65F6 " + (new Date().getTime() - startTime)));
      }
    }, heartTime);
  });
}
function assert(condition, msg) {
  if (!condition) throw new Error("[bxs-ui-vue] " + msg);
} // 跳转到升级保险师的H5页面

function updateApp() {
  if (window) {
    window.location.href = 'https://app.winbaoxian.com/view/update-app/';
  }
}
function randomString(len) {
  var length = len || 32;
  var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
  var maxPos = chars.length;
  var pwd = '';

  for (var i = 0; i < length; i += 1) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos));
  }

  return pwd;
}
function generateFileName() {
  return new Date().getTime() + "_" + randomString(15);
}

var f$9 = Object.getOwnPropertySymbols;

var objectGetOwnPropertySymbols$1 = {
	f: f$9
};

var nativeAssign = Object.assign;
var defineProperty$4 = Object.defineProperty;

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
var objectAssign = !nativeAssign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (descriptors && nativeAssign({ b: 1 }, nativeAssign(defineProperty$4({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$4(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return nativeAssign({}, A)[symbol] != 7 || objectKeys(nativeAssign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = objectGetOwnPropertySymbols$1.f;
  var propertyIsEnumerable = objectPropertyIsEnumerable.f;
  while (argumentsLength > index) {
    var S = indexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!descriptors || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : nativeAssign;

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
_export({ target: 'Object', stat: true, forced: Object.assign !== objectAssign }, {
  assign: objectAssign
});

var assign = path.Object.assign;

var assign$1 = assign;

var assign$2 = assign$1;

function _extends() {
  _extends = assign$2 || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var trim$2 = stringTrim$1.trim;


var nativeParseFloat = global_1.parseFloat;
var FORCED$3 = 1 / nativeParseFloat(whitespaces$1 + '-0') !== -Infinity;

// `parseFloat` method
// https://tc39.github.io/ecma262/#sec-parsefloat-string
var _parseFloat = FORCED$3 ? function parseFloat(string) {
  var trimmedString = trim$2(String(string));
  var result = nativeParseFloat(trimmedString);
  return result === 0 && trimmedString.charAt(0) == '-' ? -0 : result;
} : nativeParseFloat;

// `parseFloat` method
// https://tc39.github.io/ecma262/#sec-parsefloat-string
_export({ global: true, forced: parseFloat != _parseFloat }, {
  parseFloat: _parseFloat
});

var _parseFloat$1 = path.parseFloat;

var _parseFloat$2 = _parseFloat$1;

var _parseFloat$3 = _parseFloat$2;

var FAILS_ON_PRIMITIVES = fails(function () { objectKeys(1); });

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
_export({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return objectKeys(toObject(it));
  }
});

var keys$4 = path.Object.keys;

var keys$5 = keys$4;

var keys$6 = keys$5;

var context = {
  zIndex: 700,
  // 浮层信息堆栈
  stack: [],

  // 取最顶层浮层信息
  get top() {
    return this.stack[this.stack.length - 1] || {};
  }

};

var $filter = arrayIteration.filter;



var HAS_SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport('filter');
// Edge 14- issue
var USES_TO_LENGTH$1 = HAS_SPECIES_SUPPORT$1 && !fails(function () {
  [].filter.call({ length: -1, 0: 1 }, function (it) { throw it; });
});

// `Array.prototype.filter` method
// https://tc39.github.io/ecma262/#sec-array.prototype.filter
// with adding support of @@species
_export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$1 || !USES_TO_LENGTH$1 }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var filter = entryVirtual('Array').filter;

var ArrayPrototype$7 = Array.prototype;

var filter_1 = function (it) {
  var own = it.filter;
  return it === ArrayPrototype$7 || (it instanceof Array && own === ArrayPrototype$7.filter) ? filter : own;
};

var filter$1 = filter_1;

var filter$2 = filter$1;

var $some = arrayIteration.some;


// `Array.prototype.some` method
// https://tc39.github.io/ecma262/#sec-array.prototype.some
_export({ target: 'Array', proto: true, forced: sloppyArrayMethod('some') }, {
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var some = entryVirtual('Array').some;

var ArrayPrototype$8 = Array.prototype;

var some_1 = function (it) {
  var own = it.some;
  return it === ArrayPrototype$8 || (it instanceof Array && own === ArrayPrototype$8.some) ? some : own;
};

var some$1 = some_1;

var some$2 = some$1;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script = {
  name: 'overlay',
  props: {
    visible: Boolean,
    zIndex: {
      type: Number,
      default: 700
    }
  },
  computed: {
    style: function style() {
      return {
        zIndex: this.zIndex
      };
    }
  }
};

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER$1 = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = v8Version >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED$4 = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.github.io/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
_export({ target: 'Array', proto: true, forced: FORCED$4 }, {
  concat: function concat(arg) { // eslint-disable-line no-unused-vars
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = toLength(E.length);
        if (n + len > MAX_SAFE_INTEGER$1) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER$1) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});

var concat = entryVirtual('Array').concat;

var ArrayPrototype$9 = Array.prototype;

var concat_1 = function (it) {
  var own = it.concat;
  return it === ArrayPrototype$9 || (it instanceof Array && own === ArrayPrototype$9.concat) ? concat : own;
};

var concat$1 = concat_1;

var concat$2 = concat$1;

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var _context;

      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? concat$2(_context = []).call(_context, existing, hook) : [hook];
    }
  }

  return script;
}

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('transition', {
    attrs: {
      "enter-active-class": "bx-animate-fade-in",
      "leave-active-class": "bx-animate-fade-out"
    },
    on: {
      "afterEnter": function afterEnter($event) {
        _vm.$emit('after-enter', $event);
      },
      "afterLeave": function afterLeave($event) {
        _vm.$emit('after-leave', $event);
      },
      "leaveCancelled": function leaveCancelled($event) {
        _vm.$emit('leave-cancelled', $event);
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible,
      expression: "visible"
    }],
    staticClass: "bx-overlay",
    style: _vm.style,
    on: {
      "click": function click($event) {
        _vm.$emit('click', $event);
      },
      "touchmove": function touchmove($event) {
        _vm.$emit('touchmove', $event);
      }
    }
  })]);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

var manager = {
  open: function open(vm, config) {
    var _context;

    if (!some$2(_context = context.stack).call(_context, function (item) {
      return item.vm === vm;
    })) {
      var el = vm.$el;
      var target = el && el.parentNode ? el.parentNode : document.body;
      context.stack.push({
        vm: vm,
        config: config,
        target: target
      });
      this.update();
    }
  },
  close: function close(vm) {
    var stack = context.stack;

    if (stack.length) {
      if (context.top.vm === vm) {
        stack.pop();
        context.zIndex -= 2;
        this.update(true);
      } else {
        context.stack = filter$2(stack).call(stack, function (item) {
          return item.vm !== vm;
        });
      }
    }
  },
  update: function update(isClose) {
    if (isClose === void 0) {
      isClose = false;
    }

    var overlay = context.overlay;

    if (!overlay) {
      overlay = new (Vue.extend(__vue_component__))({
        el: document.createElement('div')
      });
      overlay.$on('click', this.onClick);
      overlay.$on('touchmove', this.onTouchMove); // 为了解决在iPhone 11手机上，animationEnd首次触发后，再也不触发，无法稳定复现，但是几率很高
      // 经测试，在iPhone 11上，同时存在两个「transition」组件，会产生这个问题

      overlay.$on('after-enter', this.afterEnter);
      overlay.$on('after-leave', this.afterLeaveOrCancelled); // 在遮罩层leaving过程中，可能会因为重新enter导致动画被cancelled
      // 为了保证「openAfter」与「closeAfter」调用同步

      overlay.$on('leave-cancelled', this.afterLeaveOrCancelled);
      context.overlay = overlay;
    }

    if (isClose) {
      overlay.visible = false;
    }

    var _context$top = context.top,
        config = _context$top.config,
        target = _context$top.target;

    if (target) {
      target.appendChild(overlay.$el);

      _extends(overlay, config, {
        visible: true
      });
    }
  },
  onClick: function onClick() {
    var vm = context.top.vm;

    if (vm && vm.closeOnClickOverlay) {
      vm.$emit('input', false);
      vm.$emit('overlayClose');
    }
  },
  onTouchMove: function onTouchMove(e) {
    e.preventDefault();
    e.stopPropagation();
  },
  afterEnter: function afterEnter() {
    var vm = context.top.vm;

    if (vm) {
      // 记录当前活动的浮层
      context.activeVm = vm;
      vm.openAfter();
    }
  },
  afterLeaveOrCancelled: function afterLeaveOrCancelled() {
    var activeVm = context.activeVm;

    if (activeVm) {
      activeVm.closeAfter();
      context.activeVm = null;
    }
  }
};

var _context$1;

var ua = navigator.userAgent;
var env = {
  isAndroid: /Android/i.test(ua),
  isIos: /(iPhone|iPad|iPod)/i.test(ua),
  supportTouch: function isSupportTouch() {
    return !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch);
  }()
};

var DEVICE_VIEWPORT_SPECS = map$2(_context$1 = [[375, 812, 3], // iPhone X, 11 Pro,
[414, 896, 2], // iPhone XR, 11,
[414, 896, 3], // iPhone XS Max, 11 Pro Max,
[390, 844, 3], // iPhone 12, 12 Pro,
[428, 926, 3] // iPhone 12 Pro Max,
]).call(_context$1, function (it) {
  return it.join(',');
});

var isAfterIphoneX = function isAfterIphoneX() {
  var _context2;

  if (!/iphone/gi.test(ua)) {
    return false;
  }

  var _window$screen = window.screen,
      width = _window$screen.width,
      height = _window$screen.height;

  var demensions = concat$2(_context2 = width > height ? [height, width] : [width, height]).call(_context2, window.devicePixelRatio);

  return indexOf$4(DEVICE_VIEWPORT_SPECS).call(DEVICE_VIEWPORT_SPECS, demensions.join(',')) !== -1;
};
function addXSupport() {
  var $viewport = document.querySelector('meta[name=viewport]');

  if (!$viewport || !isAfterIphoneX()) {
    return false;
  }

  var content = $viewport.getAttribute('content');

  if (indexOf$4(content).call(content, 'viewport-fit') !== -1) {
    return false;
  }

  content += ',viewport-fit=cover';
  $viewport.setAttribute('content', content);
  return true;
}

var patchBlock = {
  node: null,
  windowHeight: null,
  getWindowHeight: function getWindowHeight() {
    if (!this.windowHeight) {
      this.windowHeight = window.outerHeight;
    }

    return this.windowHeight;
  },
  createAndAppendBody: function createAndAppendBody(height) {
    if (!this.node) {
      var div = document.createElement('div');
      div.style.width = '100%';
      div.style.height = height + "px";
      this.node = div;
      document.body.append(this.node);
    }
  },
  update: function update(height) {
    if (!this.node) {
      this.createAndAppendBody(height);
    } else {
      this.node.style.height = height + "px";
    }
  },
  reset: function reset() {
    if (this.node) {
      this.node.style.height = 0;
    }
  },
  remove: function remove() {
    if (this.node) {
      document.body.removeChild(this.node);
      this.node = null;
    }
  }
};

var getRemainHeight = function getRemainHeight() {
  var windowHeight = patchBlock.getWindowHeight();
  var bodyHeight = document.body.clientHeight;
  return {
    remainHeight: windowHeight - bodyHeight,
    // bodyHeight与windowHeight相等时，也会出现该bug，因此+1强制body超出window
    computedHeight: windowHeight - bodyHeight + 1
  };
};

var SafeAreaPatch = {
  // 自动探测viewport-fit，并添加
  addXSupport: addXSupport,
  // 判断是否是iphoneX之后的机型
  isAfterIphoneX: isAfterIphoneX,
  // 添加安全区域补丁
  create: function create() {
    if (isAfterIphoneX()) {
      addXSupport();
      this.update();
    }
  },
  // 更新安全区域补丁
  update: function update() {
    if (isAfterIphoneX()) {
      // 重置node高度，以正确计算内容是否满一屏
      patchBlock.reset();
      Vue.nextTick(function () {
        var _getRemainHeight = getRemainHeight(),
            remainHeight = _getRemainHeight.remainHeight,
            computedHeight = _getRemainHeight.computedHeight;

        if (remainHeight > 0) {
          patchBlock.update(computedHeight);
        }
      });
    }
  },
  // 移除安全区域补丁
  remove: function remove() {
    patchBlock.remove();
  },
  // 供Vue.use使用
  install: function install(vueGlobal) {
    /* eslint no-param-reassign: ["error", { "props": false }] */
    vueGlobal.prototype.$safeAreaPatch = this;
  }
};

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
_export({ target: 'Object', stat: true, forced: !descriptors, sham: !descriptors }, {
  defineProperty: objectDefineProperty.f
});

var defineProperty_1 = createCommonjsModule(function (module) {
var Object = path.Object;

var defineProperty = module.exports = function defineProperty(it, key, desc) {
  return Object.defineProperty(it, key, desc);
};

if (Object.defineProperty.sham) defineProperty.sham = true;
});

var defineProperty$5 = defineProperty_1;

var defineProperty$6 = defineProperty$5;

var passiveSupported = false;

try {
  var options = defineProperty$6({}, 'passive', {
    get: function get() {
      passiveSupported = true;
      return passiveSupported;
    }
  });

  window.addEventListener('test', null, options);
} catch (err) {
  passiveSupported = false;
} // 添加事件


function addEvent(target, event, handler, passive) {
  if (passive === void 0) {
    passive = false;
  }

  target.addEventListener(event, handler, passiveSupported ? {
    capture: false,
    passive: passive
  } : false);
} // 移除事件

function removeEvent(target, event, handler) {
  target.removeEventListener(event, handler);
}

/**
 * 弹出层统一管理mixin
 * tips: 内部的props、data、watch、methods可能会因为与调用者同名而导致不触发（mixin局限）
 */
var MODAL_OPEN_CLASS = 'bx-overlay-open';
var Popup = {
  props: {
    // 和emit('input')配合
    value: Boolean,
    // 遮罩背景是否显示
    overlay: {
      type: Boolean,
      default: true
    },
    // 点击遮罩是否关闭
    closeOnClickOverlay: {
      type: Boolean,
      default: true
    },
    // 禁止document滚动
    lockScroll: {
      type: Boolean,
      default: false
    },
    // 防止滚动穿透，页面会有轻微闪动
    preventScrollThrough: {
      type: Boolean,
      default: false
    },
    // 是否兼容iphoneX，解决在app内不满一屏情况下的bug，废弃，改为补丁的方式
    supportIphoneX: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      // 记住打开overlay时 body 的位置
      scrollTop: 0,
      // Vue挂载的节点
      appNode: null
    };
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler(val) {
        var _this = this;

        if (!this.$el) {
          this.$nextTick(function () {
            return _this[val ? 'open' : 'close']();
          });
        } else {
          this[val ? 'open' : 'close']();
        }
      }
    },
    overlay: function overlay() {
      if (this.value) {
        this.renderOverlay();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.close();
  },
  deactivated: function deactivated() {
    this.close();
  },
  methods: {
    open: function open() {
      if (this.opened) {
        return false;
      }

      this.openBefore();
      this.renderOverlay();
      this.opened = true;
      return this.opened;
    },
    openBefore: function openBefore() {
      // 禁止滚动，在弹出层无需滚动时使用
      if (this.lockScroll) {
        addEvent(document, 'touchmove', this.onTouchMove);
      }
    },
    openAfter: function openAfter() {
      // 防止滚动穿透
      if (this.preventScrollThrough) {
        this.scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;

        if (!this.appNode) {
          this.appNode = this.findRootElement(this.$el);
        }

        this.appNode.classList.add(MODAL_OPEN_CLASS);
        this.appNode.style.top = -1 * this.scrollTop + "px"; // 增加了「MODAL_OPEN_CLASS」导致Body高度变化，因此需要更新安全区域补丁

        SafeAreaPatch.update();
      }
    },
    close: function close() {
      if (!this.opened) {
        return false;
      }

      this.closeBefore();
      manager.close(this);
      this.opened = false;
      return this.opened;
    },
    closeBefore: function closeBefore() {
      if (this.lockScroll) {
        removeEvent(document, 'touchmove', this.onTouchMove);
      }
    },
    // 透明遮罩动画结束后，调用
    closeAfter: function closeAfter() {
      if (this.preventScrollThrough) {
        if (this.appNode) {
          this.appNode.classList.remove(MODAL_OPEN_CLASS);
          this.appNode.style.top = null;
          window.scrollTo(0, this.scrollTop);
        } // 移除了「MODAL_OPEN_CLASS」导致Body高度变化，因此需要更新安全区域补丁


        SafeAreaPatch.update();
      }
    },
    renderOverlay: function renderOverlay() {
      var _this2 = this;

      if (this.overlay) {
        context.zIndex += 1;
        manager.open(this, {
          zIndex: context.zIndex
        });
      } else {
        manager.close(this);
      }

      this.$nextTick(function () {
        context.zIndex += 1;
        _this2.$el.style.zIndex = context.zIndex;
      });
    },
    onTouchMove: function onTouchMove(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    // 查找Vue挂载的节点
    findRootElement: function findRootElement($el) {
      var $rootNode = $el;

      while ($rootNode.parentNode && $rootNode.parentNode.tagName !== 'BODY') {
        $rootNode = $rootNode.parentNode;
      }

      if ($rootNode.parentNode && $el === $rootNode) {
        $rootNode = $rootNode.parentNode;
      }

      return $rootNode;
    }
  }
};

//
var script$1 = create({
  name: 'icon',
  props: {
    name: String,
    color: String,
    size: String,
    prefix: {
      type: String,
      default: 'bx-icon'
    }
  },
  computed: {
    style: function style() {
      var appearance = {};

      if (this.color) {
        appearance.color = this.color;
      }

      if (this.size) {
        appearance.fontSize = this.size;
      }

      return appearance;
    }
  }
});

var __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('i', {
    class: [_vm.prefix, _vm.prefix + "-" + _vm.name],
    style: _vm.style
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$1 = [];
/* style */

var __vue_inject_styles__$1 = undefined;
/* scoped */

var __vue_scope_id__$1 = undefined;
/* module identifier */

var __vue_module_identifier__$1 = undefined;
/* functional template */

var __vue_is_functional_template__$1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1 =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, undefined, undefined, undefined);

var _components;
var MAX_HEIGHT_RATE = 0.9,
    MIN_HEIGHT_RATE = 0.44;
var ENUM_HEIGHT_PRESET = {
  small: '44%',
  middle: '77%',
  large: '90%',
  full: '100%'
};

function getPercentVaule(rawVal) {
  var _context;

  var percentStr = rawVal;

  if (rawVal && indexOf$4(_context = keys$6(ENUM_HEIGHT_PRESET)).call(_context, rawVal) >= 0) {
    percentStr = ENUM_HEIGHT_PRESET[rawVal];
  }

  if (/^\d*(\.\d+)?%$/.test(percentStr)) {
    var percentVal = _parseFloat$3(percentStr);

    return percentVal <= 100 && percentVal >= 0 ? percentVal : null;
  }

  return null;
}

function getValueInRange(val, min, max) {
  return Math.max(Math.min(val, max), min);
}

var script$2 = create({
  name: 'bottom-sheets',
  mixins: [Popup],
  props: {
    // 半屏浮层的固定高度
    height: {
      type: [Number, String],
      default: null,
      validator: function validator(val) {
        return getPercentVaule(val) !== null || /^\d*(\.\d+)?$/.test(val);
      }
    },
    // 是否使用better-scroll
    useBScroll: {
      type: Boolean,
      default: false
    },
    // 是否隐藏浮层顶部栏
    hideHeader: {
      type: Boolean,
      default: false
    },
    // 是否隐藏浮层底部栏
    hideFooter: {
      type: Boolean,
      default: false
    },
    // 顶部栏标题
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    transitionListeners: function transitionListeners() {
      var existEvents = {
        appear: this.enter,
        enter: this.enter,
        'after-enter': this.afterEnter
      };
      return _extends({}, this.listenersEmit(['appear', 'before-enter', 'enter', 'after-enter', 'enter-cancelled', 'leave', 'after-leave', 'leave-cancelled'], existEvents));
    }
  },
  methods: {
    // 关闭浮层
    closePopup: function closePopup() {
      this.$emit('input', false);
    },
    // 设置正文内容的位置
    setContentPosition: function setContentPosition() {
      var $header = this.$refs.header;
      var $footer = this.$refs.footer;
      this.headerHeight = 0;

      if ($header) {
        this.headerHeight = $header.clientHeight;
        this.wrapper.style.top = $header.clientHeight + "px";
      }

      if ($footer) {
        this.wrapper.style.bottom = $footer.clientHeight + "px";
      }
    },
    setLayerHeight: function setLayerHeight() {
      var $scroll = this.wrapper.children[0];
      var layerHeight = $scroll.clientHeight + this.headerHeight; // 以防在怪异渲染模式document.documentElement.clientHeight下，可能为0
      // https://developer.mozilla.org/zh-CN/docs/Web/HTML/Quirks_Mode_and_Standards_Mode

      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      var displayHeight;

      if (this.height) {
        // 指定高度，传入枚举值或百分比时，在 prop validator 处已保证范围在 0-100%。
        var percentVal = getPercentVaule(this.height);
        displayHeight = percentVal !== null ? percentVal * viewportHeight / 100 : getValueInRange(this.height, 0, viewportHeight);
      } else {
        // 设置浮层的高度
        displayHeight = getValueInRange(layerHeight, viewportHeight * MIN_HEIGHT_RATE, viewportHeight * MAX_HEIGHT_RATE);
      }

      this.layer.style.height = _parseInt$3(displayHeight, 10) + "px";
    },
    initPopup: function initPopup() {
      this.layer = this.$refs.layer;
      this.wrapper = this.$refs.content;

      if (this.layer) {
        this.setContentPosition();
        this.setLayerHeight();
        this.$emit('domReady', this.$refs);
      }
    },
    // 动画enter回调
    enter: function enter() {
      this.initPopup();
    },
    // 动画after-enter回调
    afterEnter: function afterEnter() {
      // TODO: （#83）无视滚动区域是否超出父容器，一律初始化 BSCroll，用以支持浮层打开情况下内容动态变动的情形
      // 仅确定提供 BSCroll 实例，使用者仍需在内容变动后自行调用 scroll.refresh()
      // 因 BSCroll 只关心默认 slot 的内容，header 和 footer slot 中的内容变动暂无法支持
      // 后期可能需要更周到处理
      if (this.useBScroll) {
        // eslint-disable-next-line
        var scroll = new BScroll(this.wrapper);
        this.$emit('bscroll', scroll);
      }
    },
    // 给事件添加 $emit
    listenersEmit: function listenersEmit(eventNames, existEvents) {
      var _this = this;

      var listeners = {};

      forEach$2(eventNames).call(eventNames, function (name) {
        var eventFunc = existEvents[name];

        listeners[name] = function (el) {
          if (eventFunc) {
            eventFunc.call(_this, el);
          }

          _this.$emit(name, el);
        };
      });

      return listeners;
    }
  },
  components: (_components = {}, _components[__vue_component__$1.name] = __vue_component__$1, _components)
});

/* script */
var __vue_script__$2 = script$2;
/* template */

var __vue_render__$2 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('transition', _vm._g({
    attrs: {
      "name": "bx-animate-slide"
    }
  }, _vm.transitionListeners), [_vm.value ? _c('div', {
    ref: "layer",
    staticClass: "bx-sheets-layer"
  }, [!_vm.hideHeader ? _c('div', {
    ref: "header",
    staticClass: "bx-sheets-header"
  }, [_vm._t("header", [_c('div', {
    staticClass: "bx-sheets-header-inner"
  }, [_c('div', {
    staticClass: "bx-sheets-title"
  }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n          ")]), _c('div', {
    staticClass: "bx-sheets-close",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('bxs-icon', {
    attrs: {
      "name": "close"
    }
  })], 1)])])], 2) : _vm._e(), _c('div', {
    ref: "content",
    staticClass: "bx-sheets-content",
    class: !_vm.useBScroll && 'bx-sheets-content--scroll'
  }, [_c('div', {
    ref: "scroll",
    staticClass: "bx-sheets-scroll"
  }, [_vm._t("default")], 2)]), !_vm.hideFooter ? _c('div', {
    ref: "footer",
    staticClass: "bx-sheets-footer"
  }, [_vm._t("footer")], 2) : _vm._e()]) : _vm._e()]);
};

var __vue_staticRenderFns__$2 = [];
/* style */

var __vue_inject_styles__$2 = undefined;
/* scoped */

var __vue_scope_id__$2 = undefined;
/* module identifier */

var __vue_module_identifier__$2 = undefined;
/* functional template */

var __vue_is_functional_template__$2 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$2 =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, undefined, undefined, undefined);

var _components$1;
var script$3 = create({
  name: 'area',
  props: {
    keyName: {
      type: String,
      default: 'code'
    },
    valueName: {
      type: String,
      default: 'name'
    },
    areaData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    areaSelect: {
      type: [String, Number],
      default: ''
    },
    title: {
      type: String,
      default: '选择地区'
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      tabActive: 1,
      provinceCode: '',
      provinceName: '',
      cityCode: '',
      cityName: '',
      countyCode: '',
      countyName: '',
      provinceList: [],
      cityList: [],
      countyList: [],
      $content: null,
      finish: false
    };
  },
  computed: {
    isShow: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit('input', val);
      }
    },
    tabType: function tabType() {
      var map = {
        1: 'province',
        2: 'city',
        3: 'county'
      };
      return map[this.tabActive] || 'province';
    },
    currentList: function currentList() {
      return this[this.tabType + "List"] || this.provinceList;
    },
    currentCode: function currentCode() {
      return this[this.tabType + "Code"] || this.provinceCode;
    }
  },
  watch: {
    isShow: function isShow(val) {
      if (val) {
        this.init();
      }
    }
  },
  methods: {
    close: function close() {
      this.isShow = false;
    },
    init: function init() {
      this.provinceList = this.areaData.provinceList || [];

      if (this.areaSelect) {
        this.setValues();
      } else {
        this.reset();
      }
    },
    findItemByCode: function findItemByCode(data, code) {
      var vm = this;
      return find$2(data).call(data, function (item) {
        return vm.equals(item[vm.keyName], code);
      });
    },
    isArrayAndHasValue: function isArrayAndHasValue(list) {
      return isArray$3(list) && list.length;
    },
    setValues: function setValues() {
      var vm = this;
      var defaultCode = vm.areaSelect.toString();

      var proCode = slice$2(defaultCode).call(defaultCode, 0, 2);

      var cityCode = slice$2(defaultCode).call(defaultCode, 0, 4);

      var _vm$areaData = vm.areaData,
          provinceList = _vm$areaData.provinceList,
          cityList = _vm$areaData.cityList,
          countyList = _vm$areaData.countyList;

      if (proCode && vm.isArrayAndHasValue(provinceList)) {
        var provinceItem = this.findItemByCode(provinceList, proCode + "0000");
        var cityItem = vm.isArrayAndHasValue(cityList) && this.findItemByCode(cityList, cityCode + "00");
        var countyItem = vm.isArrayAndHasValue(countyList) && this.findItemByCode(countyList, vm.areaSelect);

        if (!provinceItem) {
          this.reset();
          return;
        }

        vm.selectAreaCode(1, provinceItem[vm.keyName], provinceItem[vm.valueName]);

        if (slice$2(defaultCode).call(defaultCode, 2, 6) !== '0000' && cityCode) {
          vm.selectAreaCode(2, cityItem[vm.keyName], cityItem[vm.valueName]);

          if (slice$2(defaultCode).call(defaultCode, 4, 6) !== '00') {
            if (countyItem) {
              vm.selectAreaCode(3, countyItem[vm.keyName], countyItem[vm.valueName]);
            } else {
              this.reset();
            }
          }
        }

        vm.scroll();
      } else {
        this.reset();
      }
    },
    reset: function reset() {
      this.tabActive = 1;
      this.provinceCode = '';
      this.provinceName = '';
      this.cityCode = '';
      this.cityName = '';
      this.countyCode = '';
      this.countyName = '';
    },
    scroll: function scroll() {
      var _context,
          _context2,
          _this = this;

      var indexItem = indexOf$4(_context = map$2(_context2 = this.currentList).call(_context2, function (item) {
        return item[_this.keyName];
      })).call(_context, this.currentCode);

      this.$nextTick(function () {
        if (indexItem) {
          var areaItems = _this.$refs.areaItem || [];

          if (areaItems.length) {
            var areaItem = areaItems[0].offsetHeight;

            _this.resetTop((indexItem - 2) * areaItem);
          }
        } else {
          _this.resetTop();
        }
      });
    },
    switchTab: function switchTab(activeTab) {
      this.tabActive = activeTab;
      this.scroll();
    },
    domReady: function domReady(dom) {
      this.$content = dom.content;
    },
    resetTop: function resetTop(y) {
      var _this2 = this;

      if (y === void 0) {
        y = 0;
      }

      this.$nextTick(function () {
        if (_this2.$content) {
          _this2.$content.scrollTop = y;
        }
      });
    },
    equals: function equals(num1, num2) {
      return _parseInt$3(num1, 10) === _parseInt$3(num2, 10);
    },
    selectAreaCode: function selectAreaCode(activeTab, code, name) {
      var _this3 = this;

      var type = this.tabType;
      var _this$areaData = this.areaData,
          cityList = _this$areaData.cityList,
          countyList = _this$areaData.countyList;
      this.finish = false;

      if (this[type + "Code"] !== code) {
        this.countyCode = '';
        this.countyName = '';
        this[type + "Code"] = code;
        this[type + "Name"] = name;
      }

      if (type === 'province' && this.isArrayAndHasValue(cityList)) {
        this.cityCode = '';
        this.cityName = '';
        this.cityList = [];

        forEach$2(cityList).call(cityList, function (city) {
          if (_this3.equals(city.parentId, code)) {
            _this3.cityList.push(city);
          }
        });

        if (!this.cityList.length) {
          this.finish = true;
        }
      } else if (type === 'city' && this.isArrayAndHasValue(countyList)) {
        this.countyList = [];

        forEach$2(countyList).call(countyList, function (county) {
          if (_this3.equals(county.parentId, code)) {
            _this3.countyList.push(county);
          }
        });

        if (!this.countyList.length) {
          this.finish = true;
        }
      } else {
        this.finish = true;
      }

      if (!this.finish) {
        this.tabActive = activeTab < 3 ? activeTab + 1 : 3;
        this.resetTop();
      }
    },
    confirm: function confirm() {
      if (!this.finish) {
        return;
      }

      this.$emit('confirm', {
        provinceCode: this.provinceCode,
        provinceName: this.provinceName,
        cityCode: this.cityCode,
        cityName: this.cityName,
        countyCode: this.countyCode,
        countyName: this.countyName
      });
      this.isShow = false;
    }
  },
  components: (_components$1 = {}, _components$1[__vue_component__$2.name] = __vue_component__$2, _components$1)
});

/* script */
var __vue_script__$3 = script$3;
/* template */

var __vue_render__$3 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('bxs-bottom-sheets', {
    attrs: {
      "title": "选择地区",
      "height": 375,
      "prevent-scroll-through": true,
      "use-b-scroll": false
    },
    on: {
      "close": _vm.close,
      "domReady": _vm.domReady
    },
    model: {
      value: _vm.isShow,
      callback: function callback($$v) {
        _vm.isShow = $$v;
      },
      expression: "isShow"
    }
  }, [_c('div', {
    staticClass: "bx-area-header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('div', {
    staticClass: "bx-area-title"
  }, [_c('div', {
    staticClass: "bx-area-cancel",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n        取消\n      ")]), _c('div', [_vm._v(_vm._s(_vm.title))]), _c('div', {
    staticClass: "bx-area-confirm",
    class: {
      'bx-area-confirm--primary': _vm.finish
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("\n        确定\n      ")])]), _c('div', {
    staticClass: "bx-area-tabs bx-hairline--bottom"
  }, [_c('div', {
    staticClass: "bx-area-tab",
    class: {
      'bx-area-active': _vm.tabActive === 1
    },
    on: {
      "click": function click($event) {
        _vm.switchTab(1);
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.provinceName || '请选择') + "\n      ")]), _vm.provinceName && _vm.cityList.length ? _c('div', {
    staticClass: "bx-area-tab",
    class: {
      'bx-area-active': _vm.tabActive === 2
    },
    on: {
      "click": function click($event) {
        _vm.switchTab(2);
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.cityName || '请选择') + "\n      ")]) : _vm._e(), _vm.cityName && _vm.countyList.length ? _c('div', {
    staticClass: "bx-area-tab",
    class: {
      'bx-area-active': _vm.tabActive === 3
    },
    on: {
      "click": function click($event) {
        _vm.switchTab(3);
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.countyName || '请选择') + "\n      ")]) : _vm._e()])]), _c('div', {
    ref: "areaContainer",
    staticClass: "bx-area-container"
  }, [_c('ul', {
    staticClass: "bx-area-items"
  }, _vm._l(_vm.currentList, function (item) {
    return _c('li', {
      key: item[_vm.keyName],
      ref: "areaItem",
      refInFor: true,
      staticClass: "bx-area-item",
      class: {
        'bx-area-active': item[_vm.keyName] === _vm.currentCode
      },
      on: {
        "click": function click($event) {
          _vm.selectAreaCode(_vm.tabActive, item[_vm.keyName], item[_vm.valueName]);
        }
      }
    }, [_vm._v("\n        " + _vm._s(item[_vm.valueName]) + "\n      ")]);
  }))])]);
};

var __vue_staticRenderFns__$3 = [];
/* style */

var __vue_inject_styles__$3 = undefined;
/* scoped */

var __vue_scope_id__$3 = undefined;
/* module identifier */

var __vue_module_identifier__$3 = undefined;
/* functional template */

var __vue_is_functional_template__$3 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$3 =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, undefined, undefined, undefined);

var script$4 = create({
  name: 'badge',
  props: {
    // 显示文本，空时为小红点
    text: {
      type: String,
      default: ''
    },
    // 红点类型，圆形：cricle/标签：label
    type: {
      type: String,
      default: 'circle'
    },
    // 宽度值
    width: {
      type: Number,
      default: null
    },
    // 是否有描边
    outline: {
      type: Boolean,
      default: false
    },
    // 是否是角标
    subscript: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      // 是否是小红点
      isDot: this.text === '',
      isAndroid: env.isAndroid,
      className: '',
      styleObject: {}
    };
  },
  created: function created() {
    // 设置css类
    var classArr = [];

    if (this.isDot) {
      classArr.push('bx-badge-dot');
    } else if (this.type === 'label') {
      classArr.push('bx-badge-label');
    } else {
      classArr.push('bx-badge-circle');

      var number = _parseInt$3(this.text, 10);

      if (number >= 0 && number <= 9) {
        classArr.push('bx-badge-number');
      }
    }

    if (this.isAndroid) {
      classArr.push('bx-badge--android');
    }

    if (this.outline) {
      classArr.push('bx-badge--outline');
    }

    if (this.subscript) {
      classArr.push('bx-badge--subscript');

      if (!this.isDot && this.type === 'label') {
        classArr.push('bx-badge-label--subscript');
      }
    }

    this.className = classArr.join(' '); // 设置固定宽度

    if (this.width) {
      this.styleObject.width = this.width + "px";
      this.styleObject.paddingLeft = 0;
      this.styleObject.paddingRight = 0;
    }
  }
});

/* script */
var __vue_script__$4 = script$4;
/* template */

var __vue_render__$4 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "bx-badge",
    class: _vm.className,
    style: _vm.styleObject
  }, [_vm._v("\n  " + _vm._s(_vm.text) + "\n")]);
};

var __vue_staticRenderFns__$4 = [];
/* style */

var __vue_inject_styles__$4 = undefined;
/* scoped */

var __vue_scope_id__$4 = undefined;
/* module identifier */

var __vue_module_identifier__$4 = undefined;
/* functional template */

var __vue_is_functional_template__$4 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$4 =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, undefined, undefined, undefined);

var onlyValues = function onlyValues(values) {
  return function (str) {
    return indexOf$4(values).call(values, str) !== -1;
  };
};

var script$5 = create({
  name: 'button',
  props: {
    plain: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    nativeType: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'primary',
      validator: onlyValues(['primary', 'minor', 'assist'])
    },
    size: {
      type: String,
      default: 'normal',
      validator: onlyValues(['large', 'middle', 'normal', 'small', 'mini'])
    }
  },
  computed: {
    className: function className() {
      var classArr = [];
      classArr.push("bx-button--" + this.type);
      classArr.push("bx-button--" + this.size);

      if (this.plain) {
        classArr.push('bx-button--plain');
      }

      if (this.disabled) {
        classArr.push('bx-button--disabled');
      }

      return classArr.join(' ');
    }
  },
  methods: {
    onClick: function onClick(event) {
      if (!this.loading && !this.disabled) {
        this.$emit('click', event);
      }
    }
  }
});

/* script */
var __vue_script__$5 = script$5;
/* template */

var __vue_render__$5 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('button', {
    tag: "component",
    staticClass: "bx-button",
    class: _vm.className,
    attrs: {
      "type": _vm.nativeType,
      "disabled": _vm.disabled,
      "ontouchstart": !_vm.disabled
    },
    on: {
      "click": _vm.onClick
    }
  }, [_c('span', [_vm._t("default")], 2)]);
};

var __vue_staticRenderFns__$5 = [];
/* style */

var __vue_inject_styles__$5 = undefined;
/* scoped */

var __vue_scope_id__$5 = undefined;
/* module identifier */

var __vue_module_identifier__$5 = undefined;
/* functional template */

var __vue_is_functional_template__$5 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$5 =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, undefined, undefined, undefined);

function timeFormatter(formatter, time) {
  return TimeStamp(formatter, time);
}

var _components$2;
var script$6 = create({
  name: 'cell',
  props: {
    // 列表项的主、副标题
    title: {
      type: String,
      required: true
    },
    titleOneLine: {
      type: Boolean,
      default: true
    },
    subtitle: {
      type: String,
      default: ''
    },
    subtitleOneLine: {
      type: Boolean,
      default: false
    },
    // 列表项的右上角文案
    value: {
      type: String | Date,
      // eslint-disable-line no-bitwise
      default: ''
    },
    valueFormatter: {
      type: String,
      default: 'YYYY-MM-DD HH:mm:ss'
    },
    // 图标设置
    icon: {
      type: String,
      default: ''
    },
    iconPrefix: {
      type: String,
      default: 'bx-icon'
    },
    iconColor: {
      type: String,
      default: ''
    },
    iconSize: {
      type: String,
      default: ''
    },
    // 图片 url
    logo: {
      type: String,
      default: ''
    },
    // 是否展示右侧箭头
    isLink: {
      type: Boolean,
      default: false
    },
    // 小红点数字
    //    false=不显示, true=显示但无数字
    //    数字=显示小红点且显示数字
    // isLink 为true时显示在右侧, 否则显示在左侧图标或图片右上角
    badge: {
      type: Boolean | Number,
      // eslint-disable-line no-bitwise
      default: false
    },
    // 图片是否显示在右侧
    logoRight: {
      type: Boolean,
      default: false
    }
  },
  components: (_components$2 = {}, _components$2[__vue_component__$1.name] = __vue_component__$1, _components$2[__vue_component__$4.name] = __vue_component__$4, _components$2),
  methods: {
    cellRightClickHandler: function cellRightClickHandler() {
      this.$emit('click-right');
    },
    cellClickHandler: function cellClickHandler() {
      this.$emit('click');
    }
  },
  computed: {
    shouldHide: function shouldHide() {
      var _context;

      // moreThreshold 为 0、或点击过查看更多时, 即可确定须展示全部
      if (this.$parent.showAllCell || this.$parent.moreThreshold === 0) return false;

      var siblingCells = filter$2(_context = this.$parent.$children).call(_context, function (x) {
        return x.$options.name === 'bxs-cell';
      });

      var cellIdx = indexOf$4(siblingCells).call(siblingCells, this);

      return cellIdx >= this.$parent.moreThreshold;
    },
    cellClass: function cellClass() {
      return {
        'bx-cell--multi-line': this.subtitle || this.$slots.subtitle,
        'bx-cell-logo-left': this.logo && !this.logoRight || this.icon,
        'bx-cell-logo-right': this.logo && this.logoRight,
        'bx-cell--hide': this.shouldHide
      };
    },
    valueOrTime: function valueOrTime() {
      if (typeof this.value === 'object' && this.value instanceof Date) {
        if (this.valueFormatter) {
          return timeFormatter(this.valueFormatter, this.value);
        }
      }

      return this.value;
    }
  }
});

/* script */
var __vue_script__$6 = script$6;
/* template */

var __vue_render__$6 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "bx-cell",
    class: _vm.cellClass,
    on: {
      "click": _vm.cellClickHandler
    }
  }, [_vm.logo && !_vm.logoRight || _vm.icon ? _c('div', {
    staticClass: "bx-cell-left"
  }, [_c('div', {
    staticClass: "bx-cell-image-wrapper"
  }, [_vm.logo && !_vm.icon ? _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.logo
    }
  }) : _vm._e(), _vm.icon ? _c('bxs-icon', {
    attrs: {
      "name": _vm.icon,
      "color": _vm.iconColor,
      "size": _vm.iconSize,
      "prefix": _vm.iconPrefix
    }
  }) : _vm._e(), _vm.badge === true && !_vm.isLink ? _c('bxs-badge', {
    attrs: {
      "subscript": true
    }
  }) : _vm._e(), typeof _vm.badge === 'string' && !_vm.isLink ? _c('bxs-badge', {
    attrs: {
      "text": _vm.badge,
      "width": 18,
      "subscript": true
    }
  }) : _vm._e()], 1)]) : _vm._e(), _c('div', {
    staticClass: "bx-cell-center-right"
  }, [_c('div', {
    staticClass: "bx-cell-center"
  }, [_c('div', {
    staticClass: "bx-cell-title-line"
  }, [_c('span', {
    staticClass: "bx-cell-title",
    class: {
      'bx-cell--one-line': _vm.titleOneLine
    }
  }, [_vm._v("\n          " + _vm._s(_vm.title) + "\n        ")]), this.subtitle && this.valueOrTime ? _c('span', {
    staticClass: "bx-cell-title-desc"
  }, [_vm._v(_vm._s(_vm.valueOrTime))]) : _vm._e()]), _vm.subtitle || _vm.$slots.subtitle ? _c('span', {
    staticClass: "bx-cell-subtitle",
    class: {
      'bx-cell--one-line': _vm.subtitleOneLine
    }
  }, [_vm._t("subtitle", [_c('span', [_vm._v(_vm._s(_vm.subtitle))])])], 2) : _vm._e()]), !_vm.subtitle && !_vm.$slots.subtitle ? _c('div', {
    staticClass: "bx-cell-right"
  }, [_c('span', {
    staticClass: "bx-cell-right-click-span",
    on: {
      "click": _vm.cellRightClickHandler
    }
  }), _vm.value ? _c('span', {
    staticClass: "bx-cell-right-value"
  }, [_vm._v(_vm._s(_vm.value))]) : _vm._e(), _vm.badge === true && _vm.isLink ? _c('bxs-badge') : _vm._e(), typeof _vm.badge === 'string' && _vm.isLink ? _c('bxs-badge', {
    attrs: {
      "text": _vm.badge,
      "width": 18
    }
  }) : _vm._e(), _vm.isLink ? _c('bxs-icon', {
    attrs: {
      "name": "arrow-right"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm.logo && _vm.logoRight ? _c('div', {
    staticClass: "bx-cell-right-logo"
  }, [_vm.logo && !_vm.icon ? _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.logo
    }
  }) : _vm._e()]) : _vm._e()])]);
};

var __vue_staticRenderFns__$6 = [];
/* style */

var __vue_inject_styles__$6 = undefined;
/* scoped */

var __vue_scope_id__$6 = undefined;
/* module identifier */

var __vue_module_identifier__$6 = undefined;
/* functional template */

var __vue_is_functional_template__$6 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$6 =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$6, __vue_script__$6, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, undefined, undefined, undefined);

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
var forcedStringTrimMethod = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces$1[METHOD_NAME]() || non[METHOD_NAME]() != non || whitespaces$1[METHOD_NAME].name !== METHOD_NAME;
  });
};

var $trim = stringTrim$1.trim;


// `String.prototype.trim` method
// https://tc39.github.io/ecma262/#sec-string.prototype.trim
_export({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});

var trim$3 = entryVirtual('String').trim;

var StringPrototype = String.prototype;

var trim_1 = function (it) {
  var own = it.trim;
  return typeof it === 'string' || it === StringPrototype
    || (it instanceof String && own === StringPrototype.trim) ? trim$3 : own;
};

var trim$4 = trim_1;

var trim$5 = trim$4;

var script$7 = create({
  name: 'cell-group',
  props: {
    // 分组标题
    title: {
      type: String,
      default: ''
    },
    // 分组右上角文案, eg: '更多'
    linkText: {
      type: String,
      default: ''
    },
    // 是否展示右侧箭头并开启点击反馈
    isLink: {
      type: Boolean,
      default: false
    },
    // 点击后跳转的url (有值则 click 事件不会被触发)
    linkUrl: {
      type: String,
      default: ''
    },
    // isLink=true 且 linkUrl 有值时生效, true 代表替换浏览器历史
    replace: {
      type: Boolean,
      default: false
    },
    // 展示《查看更多》的列表阀值(正整数)
    //    0 代表永不展示《查看更多》
    //    2 代表超过两个时展示《查看更多》
    moreThreshold: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        var _context;

        return val >= 0 && indexOf$4(_context = String(val)).call(_context, '.') === -1;
      }
    },
    // 底部《查看更多》的文案
    moreText: {
      type: String,
      default: '查看更多'
    }
  },
  data: function data() {
    return {
      showAllCell: false
    };
  },
  created: function created() {
    this.validDefaultSlots();
  },
  methods: {
    validDefaultSlots: function validDefaultSlots() {
      var _context2;

      if (some$2(_context2 = this.$slots.default).call(_context2, function (slot) {
        var _context3;

        return slot.componentOptions && slot.componentOptions.tag !== 'bxs-cell' || !slot.componentOptions && slot.tag || slot.tag === undefined && trim$5(_context3 = slot.text).call(_context3) !== '';
      })) {
        throw new Error('bxs-cell-group 组件的默认 slot 中支持 bxs-cell 组件');
      }
    },
    clickHandler: function clickHandler() {
      if (this.linkUrl) {
        if (this.replace) {
          window.location.replace(this.linkUrl);
        } else {
          window.location.href = this.linkUrl;
        }
      } else {
        this.$emit('click');
      }
    }
  }
});

/* script */
var __vue_script__$7 = script$7;
/* template */

var __vue_render__$7 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "bx-cell-group"
  }, [_vm.title ? _c('div', {
    staticClass: "bx-cell-group-title-line bx-hairline--bottom"
  }, [_c('span', {
    staticClass: "bx-cell-group-title"
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]), _vm.isLink || _vm.linkText || _vm.$slots.right ? _c('span', {
    staticClass: "bx-cell-group-link",
    on: {
      "click": _vm.clickHandler
    }
  }, [_vm._t("right", [_c('span', {
    staticClass: "bx-cell-group-link-btn"
  }), _vm.linkText ? _c('span', {
    staticClass: "bx-cell-group-link-text"
  }, [_vm._v("\n          " + _vm._s(_vm.linkText) + "\n        ")]) : _vm._e(), _vm.isLink ? _c('bxs-icon', {
    staticClass: "bx-cell-group-link-icon",
    attrs: {
      "name": "arrow-right"
    }
  }) : _vm._e()])], 2) : _vm._e()]) : _vm._e(), _c('div', {
    staticClass: "bx-cell-group-cells"
  }, [_vm._t("default")], 2), _vm.moreThreshold > 0 && !_vm.showAllCell ? _c('div', {
    staticClass: "bx-cell-group-more-line bx-hairline--top",
    on: {
      "click": function click($event) {
        _vm.showAllCell = true;
      }
    }
  }, [_c('span', {
    staticClass: "bx-cell-group-more-text"
  }, [_vm._v("\n      " + _vm._s(_vm.moreText) + "\n    ")]), _c('bxs-icon', {
    staticClass: "bx-cell-group-more-icon",
    attrs: {
      "name": "arrow-down"
    }
  })], 1) : _vm._e()]);
};

var __vue_staticRenderFns__$7 = [];
/* style */

var __vue_inject_styles__$7 = undefined;
/* scoped */

var __vue_scope_id__$7 = undefined;
/* module identifier */

var __vue_module_identifier__$7 = undefined;
/* functional template */

var __vue_is_functional_template__$7 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$7 =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$7,
  staticRenderFns: __vue_staticRenderFns__$7
}, __vue_inject_styles__$7, __vue_script__$7, __vue_scope_id__$7, __vue_is_functional_template__$7, __vue_module_identifier__$7, false, undefined, undefined, undefined);

var _components$3;

var onlyValues$1 = function onlyValues(values) {
  return function (str) {
    return indexOf$4(values).call(values, str) !== -1;
  };
};

var script$8 = create({
  name: 'checkbox',
  components: (_components$3 = {}, _components$3[__vue_component__$1.name] = __vue_component__$1, _components$3),
  props: {
    name: null,
    shape: {
      type: String,
      default: 'round',
      validator: onlyValues$1(['round', 'square'])
    },
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    checkedColor: String
  },
  data: function data() {
    return {
      parent: null
    };
  },
  computed: {
    checked: {
      get: function get() {
        var _context;

        return this.parent ? indexOf$4(_context = this.parent.value).call(_context, this.name) !== -1 : this.value;
      },
      set: function set(val) {
        if (this.isDisabled) {
          return;
        }

        if (this.parent) {
          this.setParentValue(val);
        } else {
          this.$emit('input', val);
        }
      }
    },
    isDisabled: function isDisabled() {
      return this.parent ? this.parent.disabled || this.disabled : this.disabled;
    },
    iconStyle: function iconStyle() {
      var checkedColor = this.checkedColor,
          checked = this.checked;

      if (checkedColor && checked) {
        return {
          borderColor: checkedColor,
          backgroundColor: checkedColor
        };
      }

      return {};
    }
  },
  watch: {
    value: function value(val) {
      this.$emit('change', val);
    }
  },
  created: function created() {
    this.findParent('bxs-checkbox-group');
  },
  methods: {
    toggle: function toggle() {
      this.checked = !this.checked;
    },
    setParentValue: function setParentValue(val) {
      var _context2;

      var parent = this.parent;

      var value = slice$2(_context2 = parent.value).call(_context2);

      if (val) {
        if (parent.max && value.length >= parent.max) {
          return;
        }

        if (indexOf$4(value).call(value, this.name) === -1) {
          value.push(this.name);
          parent.$emit('input', value);
        }
      } else {
        var index = indexOf$4(value).call(value, this.name);

        if (index !== -1) {
          splice$2(value).call(value, index, 1);

          parent.$emit('input', value);
        }
      }
    },
    findParent: function findParent(name) {
      var parent = this.$parent;

      while (parent) {
        if (parent.$options.name === name) {
          this.parent = parent;
          break;
        }

        parent = parent.$parent;
      }
    }
  }
});

/* script */
var __vue_script__$8 = script$8;
/* template */

var __vue_render__$8 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "bx-checkbox"
  }, [_c('div', {
    class: ['bx-checkbox-icon', "bx-checkbox-" + _vm.shape, {
      'bx-checkbox-checked': _vm.checked
    }, {
      'bx-checkbox-disabled': _vm.isDisabled
    }],
    on: {
      "click": _vm.toggle
    }
  }, [_vm._t("icon", [_c('bxs-icon', {
    style: _vm.iconStyle,
    attrs: {
      "name": "check",
      "size": "12px"
    }
  })], {
    checked: _vm.checked
  })], 2), _vm.$slots.default ? _c('span', {
    class: ['bx-checkbox-label', {
      'bx-checkbox-disabled': _vm.isDisabled
    }],
    on: {
      "click": _vm.toggle
    }
  }, [_vm._t("default")], 2) : _vm._e()]);
};

var __vue_staticRenderFns__$8 = [];
/* style */

var __vue_inject_styles__$8 = undefined;
/* scoped */

var __vue_scope_id__$8 = undefined;
/* module identifier */

var __vue_module_identifier__$8 = undefined;
/* functional template */

var __vue_is_functional_template__$8 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$8 =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$8,
  staticRenderFns: __vue_staticRenderFns__$8
}, __vue_inject_styles__$8, __vue_script__$8, __vue_scope_id__$8, __vue_is_functional_template__$8, __vue_module_identifier__$8, false, undefined, undefined, undefined);

var Emitter = {
  methods: {
    dispatch: function dispatch(componentName, eventName, params) {
      var parent = this.$parent || this.$root;
      var name = parent.$options.name;

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;

        if (parent) {
          name = parent.$options.name;
        }
      }

      if (parent) {
        var _parent, _context;

        (_parent = parent).$emit.apply(_parent, concat$2(_context = [eventName]).call(_context, params));
      }
    }
  }
};

var script$9 = create({
  name: 'checkbox-group',
  mixins: [Emitter],
  props: {
    value: Array,
    max: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: function value(val) {
      this.$emit('change', val);
      this.dispatch('bxs-form-item', 'form.item.reset');
    }
  }
});

/* script */
var __vue_script__$9 = script$9;
/* template */

var __vue_render__$9 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "bx-checkbox-group"
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$9 = [];
/* style */

var __vue_inject_styles__$9 = undefined;
/* scoped */

var __vue_scope_id__$9 = undefined;
/* module identifier */

var __vue_module_identifier__$9 = undefined;
/* functional template */

var __vue_is_functional_template__$9 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$9 =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$9,
  staticRenderFns: __vue_staticRenderFns__$9
}, __vue_inject_styles__$9, __vue_script__$9, __vue_scope_id__$9, __vue_is_functional_template__$9, __vue_module_identifier__$9, false, undefined, undefined, undefined);

var $includes = arrayIncludes.includes;


// `Array.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-array.prototype.includes
_export({ target: 'Array', proto: true }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var includes = entryVirtual('Array').includes;

var MATCH$2 = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.github.io/ecma262/#sec-isregexp
var isRegexp$1 = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH$2]) !== undefined ? !!isRegExp : classofRaw(it) == 'RegExp');
};

var notARegexp = function (it) {
  if (isRegexp$1(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};

var MATCH$3 = wellKnownSymbol('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (e) {
    try {
      regexp[MATCH$3] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (f) { /* empty */ }
  } return false;
};

// `String.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-string.prototype.includes
_export({ target: 'String', proto: true, forced: !correctIsRegexpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~String(requireObjectCoercible(this))
      .indexOf(notARegexp(searchString), arguments.length > 1 ? arguments[1] : undefined);
  }
});

var includes$1 = entryVirtual('String').includes;

var ArrayPrototype$a = Array.prototype;
var StringPrototype$1 = String.prototype;

var includes$2 = function (it) {
  var own = it.includes;
  if (it === ArrayPrototype$a || (it instanceof Array && own === ArrayPrototype$a.includes)) return includes;
  if (typeof it === 'string' || it === StringPrototype$1 || (it instanceof String && own === StringPrototype$1.includes)) {
    return includes$1;
  } return own;
};

var includes$3 = includes$2;

var includes$4 = includes$3;

var _components$4;
var LABEL_THRESHOLD = 5,
    ICON_LINK_NAME = 'arrow-right';
var script$a = create({
  name: 'input',
  // 组件的根元素不继承特性，配合$attrs使用
  // 不会影响 style 和 class 的绑定
  inheritAttrs: false,
  mixins: [Emitter],
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      default: ''
    },
    clearable: {
      type: Boolean,
      default: true
    },
    // 暂时无用
    error: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ''
    },
    // 是否显示右侧右箭头
    isLink: {
      type: Boolean,
      default: false
    },
    rightIcon: [String, Object],
    iconColor: {
      type: String,
      default: '#CCC'
    },
    iconSize: {
      type: String,
      default: '18px'
    },
    inputAlign: {
      type: String,
      default: '',
      validator: function validator(value) {
        var _context;

        return includes$4(_context = ['', 'bx-center', 'bx-right', 'center', 'right']).call(_context, value);
      }
    },
    autosize: {
      type: [Boolean, Object],
      default: false
    },
    // 是否显示剩余字数统计
    showWordLimit: {
      type: Boolean,
      default: false
    },
    // 开始进行剩余字数统计阈值
    wordLimitThreshold: {
      type: [Number, String],
      default: 50
    }
  },
  data: function data() {
    return {
      isFocus: false
    };
  },
  mounted: function mounted() {
    this.resizeArea();
  },
  watch: {
    currentValue: function currentValue() {
      this.$nextTick(this.resizeArea);
    }
  },
  computed: {
    currentValue: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    },
    inputAlignClass: function inputAlignClass() {
      var _context2, _context3;

      var alignClass = ''; // bx-center 和 bx-right 是为了兼容旧版本

      if (includes$4(_context2 = ['bx-center', 'center']).call(_context2, this.inputAlign)) {
        alignClass = 'bx-input-center';
      }

      if (includes$4(_context3 = ['bx-right', 'right']).call(_context3, this.inputAlign)) {
        alignClass = 'bx-input-right';
      }

      return alignClass;
    },
    hasRightIcon: function hasRightIcon() {
      return this.rightIconAttr && !!this.rightIconAttr.name;
    },
    rightIconAttr: function rightIconAttr() {
      var color = this.iconColor,
          size = this.iconSize,
          isLink = this.isLink,
          rightIcon = this.rightIcon;
      var name = isLink && ICON_LINK_NAME || typeof rightIcon === 'string' && rightIcon;

      if (name) {
        return {
          name: name,
          color: color,
          size: size
        };
      }

      if (rightIcon && typeof rightIcon === 'object') {
        return _extends({
          color: color,
          size: size
        }, rightIcon);
      }

      return {};
    },
    // label 文案是否超过阈值LABEL_THRESHOLD=5
    isLabelMoreThanThreshold: function isLabelMoreThanThreshold() {
      return this.label.length >= LABEL_THRESHOLD;
    },
    // 是否显示剩余字数统计
    showTextareaWordLimit: function showTextareaWordLimit() {
      var maxLength = this.$attrs.maxlength;
      return this.showWordLimit && maxLength > 0 && this.remainingWords <= this.wordLimitThreshold;
    },
    // 剩余字数
    remainingWords: function remainingWords() {
      var maxLength = this.$attrs.maxlength;
      var currentLength = this.currentValue.length;

      if (currentLength >= maxLength) {
        currentLength = maxLength;
      }

      return maxLength - currentLength;
    },
    // 属性透传
    inputAttrs: function inputAttrs() {
      return _extends({}, this.$attrs, {
        value: this.currentValue
      });
    },
    // 事件透传
    inputListeners: function inputListeners() {
      var vm = this;
      return _extends({}, this.$listeners, {
        // 与 属性value 合并成v-model语法
        input: function input(event) {
          var value = event.target.value;
          var _vm$$attrs = vm.$attrs,
              type = _vm$$attrs.type,
              maxlength = _vm$$attrs.maxlength; // 解决number类型maxlength不生效问题

          if (type === 'number' && maxlength) {
            value = slice$2(value).call(value, 0, maxlength);
          }

          vm.$emit('input', trim$5(value).call(value));
        },
        focus: this.onFocus,
        blur: this.onBlur,
        change: this.onChange
      });
    },
    // 是否显示清除图标
    isShowClearIcon: function isShowClearIcon() {
      return this.currentValue && this.isFocus && this.clearable;
    },
    hasExtraSlot: function hasExtraSlot() {
      return this.$slots.extra;
    }
  },
  methods: {
    getRootScrollTop: function getRootScrollTop() {
      return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    },
    resizeArea: function resizeArea() {
      var input = this.$refs.input;
      var autosize = this.autosize,
          $attrs = this.$attrs;

      if (!($attrs.type === 'textarea' && autosize)) {
        return;
      }

      input.style.height = 'auto';
      var height = input.scrollHeight;

      if (!(typeof autosize === 'object')) {
        if (height) {
          input.style.height = height + "px";
        }

        return;
      }

      var minHeight = autosize.minHeight,
          maxHeight = autosize.maxHeight;

      if (maxHeight) {
        height = Math.min(height, maxHeight);
      }

      if (minHeight) {
        height = Math.max(height, minHeight);
      }

      input.style.height = height + "px";
    },
    onFocus: function onFocus(event) {
      this.isFocus = true;
      this.$emit('focus', event);
      this.dispatch('bxs-form-item', 'form.item.reset'); // ios手机，input元素加readonly属性
      // 点击后会有光标出现在框中，且会有不完整输入键盘出现

      var input = this.$refs.input;

      if (this.isReadonly(this.$attrs) && input) {
        input.blur();
      }
    },
    onBlur: function onBlur(event) {
      this.isFocus = false;
      this.$emit('blur', event);

      if (!this.isReadonly(this.$attrs)) {
        this.dispatch('bxs-form-item', 'form.item.validate');
      }

      if (env.isIos) {
        window.scrollTo(0, this.getRootScrollTop());
      }
    },
    onChange: function onChange(event) {
      this.$emit('change', event);
      this.dispatch('bxs-form-item', 'form.item.validate');
    },
    clearInput: function clearInput() {
      this.currentValue = '';
      this.$emit('clear');
    },
    clickIcon: function clickIcon() {
      this.$emit('click-icon');
    },
    isReadonly: function isReadonly(attrs) {
      if ({}.hasOwnProperty.call(attrs, 'readonly') && attrs.readonly !== false && attrs.readonly !== null && attrs.readonly !== undefined) {
        return true;
      }

      return false;
    }
  },
  components: (_components$4 = {}, _components$4[__vue_component__$1.name] = __vue_component__$1, _components$4)
});

/* script */
var __vue_script__$a = script$a;
/* template */

var __vue_render__$a = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "bx-input",
    class: {
      'bx-input--textarea': _vm.inputAttrs.type === 'textarea',
      'bx-input--center': _vm.$slots.button,
      'bx-input--link': _vm.isLink
    }
  }, [_c('div', {
    staticClass: "bx-input-inner"
  }, [_vm.label ? _c('div', {
    staticClass: "bx-input-label",
    class: _vm.isLabelMoreThanThreshold && 'bx-input-label--lg'
  }, [_c('span', [_vm._v(_vm._s(_vm.label))])]) : _vm._e(), _c('div', {
    staticClass: "bx-input-value"
  }, [_c('div', {
    staticClass: "bx-input-body"
  }, [_vm.inputAttrs.type === 'textarea' ? _c('div', {
    staticClass: "bx-input-textarea"
  }, [_c('textarea', _vm._g(_vm._b({
    ref: "input",
    staticClass: "bx-input-control",
    class: [_vm.inputAlignClass],
    attrs: {
      "rows": "1"
    }
  }, 'textarea', _vm.inputAttrs, false), _vm.inputListeners)), _vm.showTextareaWordLimit ? _c('div', {
    staticClass: "bx-input-textarea--limit"
  }, [_vm._v("\n            " + _vm._s(_vm.remainingWords) + "\n          ")]) : _vm._e()]) : _c('input', _vm._g(_vm._b({
    ref: "input",
    staticClass: "bx-input-control",
    class: [_vm.inputAlignClass]
  }, 'input', _vm.inputAttrs, false), _vm.inputListeners)), _vm.isShowClearIcon ? _c('div', {
    staticClass: "bx-input-icon",
    class: _vm.isShowClearIcon && _vm.hasRightIcon && 'bx-input-icon--withPadding',
    on: {
      "touchstart": function touchstart($event) {
        $event.preventDefault();
        return _vm.clearInput($event);
      }
    }
  }, [_c('bxs-icon', {
    staticClass: "bx-input-icon--clearable",
    attrs: {
      "name": "close-solid"
    }
  })], 1) : _vm._e(), _vm.hasRightIcon ? _c('div', {
    staticClass: "bx-input-icon",
    class: _vm.isShowClearIcon && 'bx-input-icon--withoutPadding',
    on: {
      "touchstart": function touchstart($event) {
        $event.preventDefault();
        return _vm.clickIcon($event);
      }
    }
  }, [_c('bxs-icon', _vm._b({}, 'bxs-icon', _vm.rightIconAttr, false))], 1) : _vm._e(), _vm._t("button")], 2), _vm.hasExtraSlot ? _c('div', {
    staticClass: "bx-input-extra"
  }, [_vm._t("extra")], 2) : _vm._e()])]), _vm.errorMessage ? _c('div', {
    staticClass: "bx-input-error"
  }, [_vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n  ")]) : _vm._e()]);
};

var __vue_staticRenderFns__$a = [];
/* style */

var __vue_inject_styles__$a = undefined;
/* scoped */

var __vue_scope_id__$a = undefined;
/* module identifier */

var __vue_module_identifier__$a = undefined;
/* functional template */

var __vue_is_functional_template__$a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$a =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$a,
  staticRenderFns: __vue_staticRenderFns__$a
}, __vue_inject_styles__$a, __vue_script__$a, __vue_scope_id__$a, __vue_is_functional_template__$a, __vue_module_identifier__$a, false, undefined, undefined, undefined);

var _components$5;
var _window = window,
    appBridge = _window.appBridge;
var script$b = create({
  name: 'crm-input',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    iconColor: {
      type: String,
      default: '#FF6722'
    },
    iconSize: {
      type: String,
      default: '24px'
    },
    label: {
      type: String,
      default: '姓名'
    },
    placeholder: {
      type: String,
      default: '请输入姓名'
    },
    clearable: {
      type: Boolean,
      default: true
    },
    error: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ''
    }
  },
  computed: {
    currentValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    clickIcon: function clickIcon() {
      var self = this;
      assert(appBridge, 'crm-input requires appBridge');

      if (appBridge && appBridge.checkAppFeature('CRM_IMPORT')) {
        appBridge.importContact('recipient');
        appBridge.onContactImport(function (contactInfo) {
          self.$emit('crmInfo', contactInfo);
        });
      } else {
        updateApp();
      }
    },
    onFocus: function onFocus(event) {
      this.$emit('focus', event);
    },
    onBlur: function onBlur(event) {
      this.$emit('blur', event);
    }
  },
  components: (_components$5 = {}, _components$5[__vue_component__$a.name] = __vue_component__$a, _components$5)
});

var __vue_script__$b = script$b;
/* template */

var __vue_render__$b = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('bxs-input', {
    attrs: {
      "label": _vm.label,
      "placeholder": _vm.placeholder,
      "clearable": _vm.clearable,
      "right-icon": "contact",
      "error": _vm.error,
      "error-message": _vm.errorMessage,
      "icon-size": _vm.iconSize,
      "icon-color": _vm.iconColor
    },
    on: {
      "click-icon": _vm.clickIcon,
      "focu": _vm.onFocus,
      "blur": _vm.onBlur
    },
    model: {
      value: _vm.currentValue,
      callback: function callback($$v) {
        _vm.currentValue = typeof $$v === 'string' ? trim$5($$v).call($$v) : $$v;
      },
      expression: "currentValue"
    }
  });
};

var __vue_staticRenderFns__$b = [];
/* style */

var __vue_inject_styles__$b = undefined;
/* scoped */

var __vue_scope_id__$b = undefined;
/* module identifier */

var __vue_module_identifier__$b = undefined;
/* functional template */

var __vue_is_functional_template__$b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$b =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$b,
  staticRenderFns: __vue_staticRenderFns__$b
}, __vue_inject_styles__$b, __vue_script__$b, __vue_scope_id__$b, __vue_is_functional_template__$b, __vue_module_identifier__$b, false, undefined, undefined, undefined);

// `Number.isNaN` method
// https://tc39.github.io/ecma262/#sec-number.isnan
_export({ target: 'Number', stat: true }, {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});

var isNan = path.Number.isNaN;

var isNan$1 = isNan;

var isNan$2 = isNan$1;

var values$3 = entryVirtual('Array').values;

var values$4 = values$3;

var ArrayPrototype$b = Array.prototype;

var DOMIterables$1 = {
  DOMTokenList: true,
  NodeList: true
};

var values_1 = function (it) {
  var own = it.values;
  return it === ArrayPrototype$b || (it instanceof Array && own === ArrayPrototype$b.values)
    // eslint-disable-next-line no-prototype-builtins
    || DOMIterables$1.hasOwnProperty(classof(it)) ? values$4 : own;
};

var values$5 = values_1;

var $stringify = getBuiltIn('JSON', 'stringify');
var re = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;

var fix = function (match, offset, string) {
  var prev = string.charAt(offset - 1);
  var next = string.charAt(offset + 1);
  if ((low.test(match) && !hi.test(next)) || (hi.test(match) && !low.test(prev))) {
    return '\\u' + match.charCodeAt(0).toString(16);
  } return match;
};

var FORCED$5 = fails(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
    || $stringify('\uDEAD') !== '"\\udead"';
});

if ($stringify) {
  // https://github.com/tc39/proposal-well-formed-stringify
  _export({ target: 'JSON', stat: true, forced: FORCED$5 }, {
    // eslint-disable-next-line no-unused-vars
    stringify: function stringify(it, replacer, space) {
      var result = $stringify.apply(null, arguments);
      return typeof result == 'string' ? result.replace(re, fix) : result;
    }
  });
}

if (!path.JSON) path.JSON = { stringify: JSON.stringify };

// eslint-disable-next-line no-unused-vars
var stringify = function stringify(it, replacer, space) {
  return path.JSON.stringify.apply(null, arguments);
};

var stringify$1 = stringify;

var stringify$2 = stringify$1;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
function range(num, min, max) {
  return Math.min(Math.max(num, min), max);
}

var DEFAULT_DURATION = 200;
var script$c = {
  name: 'picker-item',
  props: {
    values: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    defaultIndex: {
      type: Number,
      default: 0
    },
    itemCount: {
      type: Number,
      default: 7
    },
    valueKey: {
      type: String,
      default: 'text'
    },
    className: {
      type: String,
      default: ''
    }
  },
  components: {},
  data: function data() {
    return {
      pickerTranslateY: 0,
      pickerState: {
        data: values$5(this),
        selectedId: null,
        index: 0,
        startPos: null,
        translateY: 0,
        startTranslateY: 0,
        dragging: true
      },
      options: JSON.parse(stringify$2(values$5(this))),
      currentIndex: this.defaultIndex,
      // 当前选择项
      startY: 0,
      offset: 0,
      duration: 0,
      startOffset: 0,
      isTouchInline: false,
      itemHeight: 30,
      itemSelectHeight: 40,
      innerStyle: {},
      innerSelectStyle: {}
    };
  },
  watch: {
    defaultIndex: function defaultIndex() {
      this.setOptionIndex(this.defaultIndex);
    },
    values: function values(n) {
      if (n) {
        this.options = JSON.parse(stringify$2(n));
      }
    }
  },
  computed: {
    pickerStyle: function pickerStyle() {
      return {
        height: this.itemHeight * (this.itemCount - 1) + this.itemSelectHeight + "px"
      };
    },
    count: function count() {
      return this.options.length;
    },
    baseOffset: function baseOffset() {
      return this.itemHeight * (this.itemCount - 1) / 2;
    },
    wrapperStyle: function wrapperStyle() {
      return {
        transition: this.duration + "ms",
        '-webkit-transition': this.duration + "ms",
        '-moz-transition': this.duration + "ms",
        '-o-transition': this.duration + "ms",
        transform: "translate3d(0, " + (this.offset + this.baseOffset) + "px, 0)",
        '-ms-transform': "translate3d(0, " + (this.offset + this.baseOffset) + "px, 0)",
        '-webkit-transform': "translate3d(0, " + (this.offset + this.baseOffset) + "px, 0)",
        '-o-transform': "translate3d(0, " + (this.offset + this.baseOffset) + "px, 0)",
        '-moz-transform': "translate3d(0, " + (this.offset + this.baseOffset) + "px, 0)",
        lineHeight: this.itemHeight + "px"
      };
    }
  },
  methods: {
    onTouchStart: function onTouchStart(event) {
      this.startY = event.touches[0].clientY;
      this.startOffset = this.offset;
      this.duration = 0;
      this.isTouchInline = false;
    },
    onTouchMove: function onTouchMove(event) {
      var deltaY = event.touches[0].clientY - this.startY;
      this.isTouchInline = true;
      this.offset = range(this.startOffset + deltaY, -((this.count - 1) * this.itemHeight + this.itemSelectHeight), this.itemHeight);
    },
    onTouchEnd: function onTouchEnd() {
      if (this.offset !== this.startOffset) {
        this.duration = DEFAULT_DURATION;
        var index = range(Math.round(-this.offset / this.itemHeight), 0, this.count - 1);
        this.setOptionIndex(index, true);
      }

      this.isTouchInline = false;
    },
    isDisabled: function isDisabled(option) {
      return this.isObject(option) && option.disabled;
    },
    isObject: function isObject(value) {
      var type = typeof value;
      return value != null && (type === 'object' || type === 'function');
    },
    setOptionIndex: function setOptionIndex(index, userAction) {
      if (index < this.options.length) {
        if (index !== this.currentIndex) {
          this.currentIndex = index;

          if (userAction) {
            this.$emit('change', index);
          }
        }
      } else if (index !== this.currentIndex) {
        this.currentIndex = this.options.length - 1;

        if (userAction) {
          this.$emit('change', this.currentIndex);
        }
      }

      this.offset = -this.currentIndex * this.itemHeight;
    },
    getOptionText: function getOptionText(option) {
      return this.isObject(option) && this.valueKey in option ? option[this.valueKey] : option;
    },
    setValue: function setValue(value) {
      var options = this.options;

      for (var i = 0; i < options.length; i += 1) {
        if (this.getOptionText(options[i]) === value) {
          return this.setOptionIndex(i, true);
        }
      }

      return this.setOptionIndex(0, true);
    },
    getValue: function getValue() {
      return this.options[this.currentIndex];
    }
  },
  created: function created() {
    if (this.$parent && this.$parent.children) {
      this.$parent.children.push(this);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      if (_this.$refs.bxPickerLi) {
        _this.itemHeight = _this.$refs.bxPickerLi[0].offsetHeight;
      }

      if (_this.$refs.bxPickerLiSelect) {
        _this.itemSelectHeight = _this.$refs.bxPickerLiSelect[0].offsetHeight;
      }

      _this.setOptionIndex(_this.currentIndex);

      _this.$set(_this.innerStyle, 'height', _this.itemHeight + "px");

      _this.$set(_this.innerSelectStyle, 'height', _this.itemSelectHeight + "px");
    });
  },
  destroyed: function destroyed() {
    var children = this.$parent.children;

    if (children) {
      splice$2(children).call(children, indexOf$4(children).call(children, this), 1);
    }
  }
};

/* script */
var __vue_script__$c = script$c;
/* template */

var __vue_render__$c = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: ['bx-picker-well', _vm.className],
    style: _vm.pickerStyle,
    on: {
      "touchstart": _vm.onTouchStart,
      "touchmove": function touchmove($event) {
        $event.preventDefault();
        return _vm.onTouchMove($event);
      },
      "touchend": _vm.onTouchEnd,
      "touchcancel": _vm.onTouchEnd
    }
  }, [_c('ul', {
    ref: "bxPickerUl",
    staticClass: "bx-picker-scroll",
    style: _vm.wrapperStyle
  }, _vm._l(_vm.options, function (item, index) {
    return _c('li', {
      key: index,
      ref: index === _vm.currentIndex ? 'bxPickerLiSelect' : 'bxPickerLi',
      refInFor: true,
      class: ['bx-picker-item', {
        'disabled': _vm.isDisabled(item)
      }, {
        'selected': index === _vm.currentIndex
      }],
      style: [{
        opacity: _vm.isTouchInline ? 0.5 : 1 - Math.abs(index - _vm.currentIndex) * 0.3
      }, index === _vm.currentIndex ? _vm.innerSelectStyle : _vm.innerStyle],
      on: {
        "click": function click($event) {
          _vm.setOptionIndex(index, true);
        }
      }
    }, [_vm._v("\n      " + _vm._s(typeof item === 'object' && item[_vm.valueKey] ? item[_vm.valueKey] : item) + "\n    ")]);
  }))]);
};

var __vue_staticRenderFns__$c = [];
/* style */

var __vue_inject_styles__$c = undefined;
/* scoped */

var __vue_scope_id__$c = undefined;
/* module identifier */

var __vue_module_identifier__$c = undefined;
/* functional template */

var __vue_is_functional_template__$c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$c =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$c,
  staticRenderFns: __vue_staticRenderFns__$c
}, __vue_inject_styles__$c, __vue_script__$c, __vue_scope_id__$c, __vue_is_functional_template__$c, __vue_module_identifier__$c, false, undefined, undefined, undefined);

var _components$6;
var script$d = create({
  name: 'picker',
  props: {
    title: {
      // 选择展示标题
      type: String,
      default: ''
    },
    valueKey: {
      // 传递对象显示的值
      type: String,
      default: 'text'
    },
    pickerData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showToolbar: {
      type: Boolean,
      default: false
    },
    value: Array
  },
  components: (_components$6 = {}, _components$6[__vue_component__$c.name] = __vue_component__$c, _components$6),
  data: function data() {
    return {
      children: []
    };
  },
  computed: {
    pickerDataType: function pickerDataType() {
      return !!(this.pickerData.length && !values$5(this.pickerData[0]));
    },
    pickerDataList: function pickerDataList() {
      return this.pickerData.length && !values$5(this.pickerData[0]) ? [this.pickerData] : this.pickerData;
    }
  },
  watch: {
    pickerData: function pickerData() {
      this.setColumns();
    }
  },
  methods: {
    setColumns: function setColumns() {
      var _this = this;

      var columnsItem = this.pickerDataType ? [{
        values: this.pickerData
      }] : this.pickerData;

      forEach$2(columnsItem).call(columnsItem, function (columnValue, index) {
        _this.setColumnValues(index, JSON.parse(stringify$2(values$5(columnValue))));
      });
    },
    onChange: function onChange(columnIndex) {
      if (this.pickerDataType) {
        this.$emit('change', this, this.getColumnValue(0), this.getColumnIndex(0));
      } else {
        this.$emit('change', this, this.getValues(), columnIndex, this.getIndexes());
      }

      this.$emit('input', this.getValues());
    },
    cancel: function cancel() {
      this.$emit('cancel', false);
    },
    confirm: function confirm() {
      if (this.pickerDataType) {
        this.$emit('confirm', this, this.getColumnValue(0), this.getColumnIndex(0));
      } else {
        this.$emit('confirm', this, this.getValues(), this.getIndexes());
      }
    },
    getColumnValue: function getColumnValue(index) {
      var column = this.getColumn(index);
      return column && column.getValue();
    },
    setColumnValue: function setColumnValue(index, value) {
      var column = this.getColumn(index);

      if (column) {
        return column.setValue(value);
      }

      return false;
    },
    getColumn: function getColumn(index) {
      return this.children[index];
    },
    getColumnIndex: function getColumnIndex(columnIndex) {
      return (this.getColumn(columnIndex) || {}).currentIndex;
    },
    setColumnIndex: function setColumnIndex(columnIndex, optionIndex) {
      var column = this.getColumn(columnIndex);

      if (column) {
        return column.setOptionIndex(optionIndex, true);
      }

      return false;
    },
    getColumnValues: function getColumnValues(index) {
      return (this.children[index] || {}).options;
    },
    setColumnValues: function setColumnValues(index, options) {
      var column = this.children[index];

      if (column && stringify$2(column.options) !== stringify$2(options)) {
        column.options = options;
        column.setOptionIndex(0, true);
      }
    },
    getValues: function getValues() {
      var _context;

      return map$2(_context = this.children).call(_context, function (child) {
        return child.getValue();
      });
    },
    setValues: function setValues(values) {
      var _this2 = this;

      forEach$2(values).call(values, function (value, index) {
        _this2.setColumnValue(index, value);
      });
    },
    getIndexes: function getIndexes() {
      var _context2;

      return map$2(_context2 = this.children).call(_context2, function (child) {
        return child.currentIndex;
      });
    },
    setIndexes: function setIndexes(indexes) {
      var _this3 = this;

      forEach$2(indexes).call(indexes, function (optionIndex, columnIndex) {
        _this3.setColumnIndex(columnIndex, optionIndex);
      });
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    this.$nextTick(function () {
      if (_this4.value && _this4.value.length) {
        _this4.setValues(_this4.value);
      }
    });
  }
});

var __vue_script__$d = script$d;
/* template */

var __vue_render__$d = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "bx-picker"
  }, [_c('transition', {
    attrs: {
      "name": "bx-picker"
    }
  }, [_c('div', {
    staticClass: "bx-picker-body"
  }, [_vm.showToolbar ? _c('div', {
    staticClass: "bx-picker-header bx-hairline--bottom"
  }, [_c('p', {
    staticClass: "bx-picker-cancel",
    on: {
      "click": function click($event) {
        _vm.cancel();
      }
    }
  }, [_vm._v("\n          取消\n        ")]), _c('p', {
    staticClass: "bx-picker-title"
  }, [_vm._v("\n          " + _vm._s(_vm.title) + "\n        ")]), _c('p', {
    staticClass: "bx-picker-sure",
    on: {
      "click": function click($event) {
        _vm.confirm();
      }
    }
  }, [_vm._v("\n          确定\n        ")])]) : _vm._e(), _c('div', {
    staticClass: "bx-picker-content"
  }, [_c('div', {
    ref: "pickerWrapper",
    staticClass: "bx-picker-wrapper"
  }, _vm._l(_vm.pickerDataList, function (data, index) {
    return _c('picker-item', {
      key: index,
      attrs: {
        "values": _vm.pickerDataType ? data : values$5(data),
        "class-name": data.className,
        "default-index": data.defaultIndex,
        "value-key": _vm.valueKey
      },
      on: {
        "change": function change($event) {
          _vm.onChange(index);
        }
      }
    });
  })), _c('div', {
    staticClass: "bx-picker-center-highlight"
  })]), _c('div', {
    staticClass: "bx-picker-footer"
  })])])], 1);
};

var __vue_staticRenderFns__$d = [];
/* style */

var __vue_inject_styles__$d = undefined;
/* scoped */

var __vue_scope_id__$d = undefined;
/* module identifier */

var __vue_module_identifier__$d = undefined;
/* functional template */

var __vue_is_functional_template__$d = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$d =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$d,
  staticRenderFns: __vue_staticRenderFns__$d
}, __vue_inject_styles__$d, __vue_script__$d, __vue_scope_id__$d, __vue_is_functional_template__$d, __vue_module_identifier__$d, false, undefined, undefined, undefined);

var _components$7;

function range$1(num, min, max) {
  return Math.min(Math.max(num, min), max);
}

var currentYear = new Date().getFullYear();

var isValidDate = function isValidDate(date) {
  return Object.prototype.toString.call(date) === '[object Date]' && !isNan$2(date.getTime());
};

var isValidType = function isValidType(type) {
  var _context;

  return indexOf$4(_context = ['datetime', 'date', 'time', 'year-month']).call(_context, type) !== -1;
};

var script$e = create({
  name: 'datetime-picker',
  components: (_components$7 = {}, _components$7[__vue_component__$d.name] = __vue_component__$d, _components$7),
  props: {
    value: [Date, String],
    title: String,
    type: {
      type: String,
      default: 'datetime',
      validator: isValidType
    },
    formatter: {
      type: [Function, String],
      default: function _default(type, value) {
        return value;
      }
    },
    minDate: {
      type: Date,
      default: function _default() {
        return new Date(currentYear - 10, 0, 1);
      },
      validator: isValidDate
    },
    maxDate: {
      type: Date,
      default: function _default() {
        return new Date(currentYear + 10, 11, 31);
      },
      validator: isValidDate
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    minMinute: {
      type: Number,
      default: 0
    },
    maxMinute: {
      type: Number,
      default: 59
    },
    minSecond: {
      type: Number,
      default: 0
    },
    maxSecond: {
      type: Number,
      default: 59
    }
  },
  data: function data() {
    return {
      innerValue: this.correctValue(this.value)
    };
  },
  watch: {
    value: function value(val) {
      var v = this.correctValue(val);
      var isEqual = this.type === 'time' ? v === this.innerValue : v.valueOf() === this.innerValue.valueOf();
      if (!isEqual) this.innerValue = v;
    },
    innerValue: function innerValue(val) {
      this.$emit('input', val);
    },
    columns: function columns() {
      this.updateColumnValue(this.innerValue);
    }
  },
  computed: {
    ranges: function ranges() {
      if (this.type === 'time') {
        return [{
          type: 'hour',
          range: [this.minHour, this.maxHour]
        }, {
          type: 'minute',
          range: [this.minMinute, this.maxMinute]
        }, {
          type: 'second',
          range: [this.minSecond, this.maxSecond]
        }];
      }

      var _this$getBoundary = this.getBoundary('max', this.innerValue),
          maxYear = _this$getBoundary.maxYear,
          maxDate = _this$getBoundary.maxDate,
          maxMonth = _this$getBoundary.maxMonth,
          maxHour = _this$getBoundary.maxHour,
          maxMinute = _this$getBoundary.maxMinute,
          maxSecond = _this$getBoundary.maxSecond;

      var _this$getBoundary2 = this.getBoundary('min', this.innerValue),
          minYear = _this$getBoundary2.minYear,
          minDate = _this$getBoundary2.minDate,
          minMonth = _this$getBoundary2.minMonth,
          minHour = _this$getBoundary2.minHour,
          minMinute = _this$getBoundary2.minMinute,
          minSecond = _this$getBoundary2.minSecond;

      var result = [{
        type: 'year',
        range: [minYear, maxYear]
      }, {
        type: 'month',
        range: [minMonth, maxMonth]
      }, {
        type: 'day',
        range: [minDate, maxDate]
      }, {
        type: 'hour',
        range: [minHour, maxHour]
      }, {
        type: 'minute',
        range: [minMinute, maxMinute]
      }, {
        type: 'second',
        range: [minSecond, maxSecond]
      }];
      if (this.type === 'date') splice$2(result).call(result, 3, 3);
      if (this.type === 'year-month') splice$2(result).call(result, 2, 4);
      return result;
    },
    columns: function columns() {
      var _context2,
          _this = this;

      var results = map$2(_context2 = this.ranges).call(_context2, function (item) {
        var rg = item.range;
        var tp = item.type;

        var values = _this.times(rg[1] - rg[0] + 1, function (index) {
          var value = rg[0] + index;
          value = value < 10 ? "0" + value : "" + value;
          return _this.iFormatter(tp, value);
        });

        return {
          values: values
        };
      });

      return results;
    }
  },
  methods: {
    pad: function pad(val) {
      var _context3;

      return slice$2(_context3 = "00" + val).call(_context3, -2);
    },
    iFormatter: function iFormatter(type, value) {
      return this.ranges.length > 3 ? value : this.formatter(type, value);
    },
    correctValue: function correctValue(value) {
      var val = value;
      var isDateType = this.type !== 'time';

      if (isDateType && !isValidDate(val)) {
        val = this.minDate;
      } else if (!val) {
        var minHour = this.minHour;
        val = (minHour > 9 ? minHour : "0" + minHour) + ":00:00";
      } // time type


      if (!isDateType) {
        var _val$split = val.split(':'),
            hour = _val$split[0],
            minute = _val$split[1],
            second = _val$split[2];

        hour = this.pad(range$1(hour, this.minHour, this.maxHour));
        minute = this.pad(range$1(minute, this.minMinute, this.maxMinute));
        second = this.pad(range$1(second, this.minSecond, this.maxSecond));
        return hour + ":" + minute + ":" + second;
      } // date type


      val = range$1(val, this.minDate, this.maxDate);
      return new Date(val);
    },
    times: function times(n, iteratee) {
      var index = 0;
      var result = [];
      result.length = Math.max(n, result.length);

      while (index < n) {
        result[index] = iteratee(index);
        index += 1;
      }

      return result;
    },
    getBoundary: function getBoundary(type, value) {
      var _ref;

      var boundary = this[type + "Date"];
      var year = boundary.getFullYear();
      var month = 1;
      var date = 1;
      var hour = 0;
      var minute = 0;
      var second = 0;

      if (type === 'max') {
        month = 12;
        date = this.getMonthEndDay(value.getFullYear(), value.getMonth() + 1);
        hour = 23;
        minute = 59;
        second = 59;
      }

      if (value.getFullYear() === year) {
        month = boundary.getMonth() + 1;

        if (value.getMonth() + 1 === month) {
          date = boundary.getDate();

          if (value.getDate() === date) {
            hour = boundary.getHours();

            if (value.getHours() === hour) {
              minute = boundary.getMinutes();

              if (value.getMinutes() === minute) {
                second = boundary.getSeconds();
              }
            }
          }
        }
      }

      return _ref = {}, _ref[type + "Year"] = year, _ref[type + "Month"] = month, _ref[type + "Date"] = date, _ref[type + "Hour"] = hour, _ref[type + "Minute"] = minute, _ref[type + "Second"] = second, _ref;
    },
    getTrueValue: function getTrueValue(formattedValue) {
      var fv = formattedValue;
      if (!fv) return null;

      while (isNan$2(_parseInt$3(fv, 10))) {
        fv = slice$2(fv).call(fv, 1);
      }

      return _parseInt$3(fv, 10);
    },
    getMonthEndDay: function getMonthEndDay(year, month) {
      return 32 - new Date(year, month - 1, 32).getDate();
    },
    onConfirm: function onConfirm() {
      this.$emit('confirm', this.innerValue);
    },
    onCancel: function onCancel() {
      this.$emit('cancel');
    },
    onChange: function onChange(picker) {
      var _this2 = this;

      var values = picker.getValues();
      var value = null;

      if (this.type === 'time') {
        value = values.join(':');
      } else {
        var year = this.getTrueValue(values[0]);
        var month = this.getTrueValue(values[1]);
        var maxDate = this.getMonthEndDay(year, month);
        var date = this.getTrueValue(values[2]);

        if (this.type === 'year-month') {
          date = 1;
        }

        date = date > maxDate ? maxDate : date;
        var hour = 0;
        var minute = 0;
        var second = 0;

        if (this.type === 'datetime') {
          hour = this.getTrueValue(values[3]);
          minute = this.getTrueValue(values[4]);
          second = this.getTrueValue(values[5]);
        }

        value = new Date(year, month - 1, date, hour, minute, second);
      }

      value = this.correctValue(value);
      this.innerValue = value;
      this.$nextTick(function () {
        _this2.$nextTick(function () {
          _this2.$emit('change', value);
        });
      });
    },
    updateColumnValue: function updateColumnValue(value) {
      var _this3 = this;

      var values = [];
      var iFormatter = this.iFormatter,
          pad = this.pad;

      if (this.type === 'time') {
        var currentValue = value.split(':');
        values = [iFormatter('hour', currentValue[0]), iFormatter('minute', currentValue[1]), iFormatter('second', currentValue[2])];
      } else {
        values = [iFormatter('year', "" + value.getFullYear()), iFormatter('month', pad(value.getMonth() + 1)), iFormatter('day', pad(value.getDate()))];

        if (this.type === 'datetime') {
          values.push(iFormatter('hour', pad(value.getHours())), iFormatter('minute', pad(value.getMinutes())), iFormatter('second', pad(value.getSeconds())));
        }

        if (this.type === 'year-month') {
          values = slice$2(values).call(values, 0, 2);
        }
      }

      this.$nextTick(function () {
        if (_this3.$refs.picker) {
          _this3.$refs.picker.setValues(values);
        }
      });
    }
  },
  mounted: function mounted() {
    this.updateColumnValue(this.innerValue);
  }
});

/* script */
var __vue_script__$e = script$e;
/* template */

var __vue_render__$e = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('bxs-picker', {
    ref: "picker",
    attrs: {
      "picker-data": _vm.columns
    },
    on: {
      "change": _vm.onChange
    }
  });
};

var __vue_staticRenderFns__$e = [];
/* style */

var __vue_inject_styles__$e = undefined;
/* scoped */

var __vue_scope_id__$e = undefined;
/* module identifier */

var __vue_module_identifier__$e = undefined;
/* functional template */

var __vue_is_functional_template__$e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$e =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$e,
  staticRenderFns: __vue_staticRenderFns__$e
}, __vue_inject_styles__$e, __vue_script__$e, __vue_scope_id__$e, __vue_is_functional_template__$e, __vue_module_identifier__$e, false, undefined, undefined, undefined);

var _components$8;
var currentYear$1 = new Date().getFullYear();

var isValidDate$1 = function isValidDate(date) {
  return Object.prototype.toString.call(date) === '[object Date]' && !isNan$2(date.getTime());
};

var isValidType$1 = function isValidType(type) {
  var _context;

  return indexOf$4(_context = ['datetime', 'date', 'time', 'year-month']).call(_context, type) !== -1;
};

var script$f = create({
  name: 'pop-datetime-picker',
  props: {
    value: [Date, String],
    title: String,
    type: {
      type: String,
      default: 'datetime',
      validator: isValidType$1
    },
    formatter: {
      type: [Function, String],
      default: function _default(type, value) {
        return value;
      }
    },
    minDate: {
      type: Date,
      default: function _default() {
        return new Date(currentYear$1 - 10, 0, 1);
      },
      validator: isValidDate$1
    },
    maxDate: {
      type: Date,
      default: function _default() {
        return new Date(currentYear$1 + 10, 11, 31);
      },
      validator: isValidDate$1
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    minMinute: {
      type: Number,
      default: 0
    },
    maxMinute: {
      type: Number,
      default: 59
    },
    minSecond: {
      type: Number,
      default: 0
    },
    maxSecond: {
      type: Number,
      default: 59
    },
    confirmButtonColor: String
  },
  data: function data() {
    return {
      isShow: false,
      innerValue: ''
    };
  },
  computed: {},
  methods: {
    onConfirm: function onConfirm() {
      this.isShow = false;
      this.$emit('confirm', this.innerValue);
    },
    onCancel: function onCancel() {
      this.isShow = false;
      this.$emit('cancel');
    },
    onChange: function onChange(value) {
      this.$emit('change', value);
    }
  },
  watch: {
    value: function value(val) {
      this.innerValue = val;
    }
  },
  components: (_components$8 = {}, _components$8[__vue_component__$2.name] = __vue_component__$2, _components$8)
});

/* script */
var __vue_script__$f = script$f;
/* template */

var __vue_render__$f = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('bxs-bottom-sheets', {
    attrs: {
      "prevent-scroll-through": true
    },
    on: {
      "after-leave": function afterLeave($event) {
        _vm.$emit('after-leave');
      }
    },
    model: {
      value: _vm.isShow,
      callback: function callback($$v) {
        _vm.isShow = $$v;
      },
      expression: "isShow"
    }
  }, [_c('div', {
    staticClass: "bx-picker-sheets-header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('div', {
    staticClass: "bx-picker-header bx-hairline--bottom"
  }, [_c('p', {
    staticClass: "bx-picker-cancel",
    on: {
      "click": function click($event) {
        _vm.onCancel();
      }
    }
  }, [_vm._v("\n        取消\n      ")]), _c('p', {
    staticClass: "bx-picker-title"
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]), _c('p', {
    staticClass: "bx-picker-sure",
    style: {
      color: _vm.confirmButtonColor
    },
    on: {
      "click": function click($event) {
        _vm.onConfirm();
      }
    }
  }, [_vm._v("\n        确定\n      ")])])]), _c('bxs-datetime-picker', {
    ref: "datetimePicker",
    attrs: {
      "type": _vm.type,
      "min-date": _vm.minDate,
      "max-date": _vm.maxDate,
      "max-hour": _vm.maxHour,
      "min-hour": _vm.minHour,
      "max-minite": _vm.maxMinute,
      "min-minite": _vm.minHour,
      "max-second": _vm.maxSecond,
      "min-second": _vm.minSecond,
      "formatter": _vm.formatter
    },
    on: {
      "change": _vm.onChange
    },
    model: {
      value: _vm.innerValue,
      callback: function callback($$v) {
        _vm.innerValue = $$v;
      },
      expression: "innerValue"
    }
  })], 1);
};

var __vue_staticRenderFns__$f = [];
/* style */

var __vue_inject_styles__$f = undefined;
/* scoped */

var __vue_scope_id__$f = undefined;
/* module identifier */

var __vue_module_identifier__$f = undefined;
/* functional template */

var __vue_is_functional_template__$f = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$f =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$f,
  staticRenderFns: __vue_staticRenderFns__$f
}, __vue_inject_styles__$f, __vue_script__$f, __vue_scope_id__$f, __vue_is_functional_template__$f, __vue_module_identifier__$f, false, undefined, undefined, undefined);

function isObj(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}

var defaultOptions = {
  title: '选择日期',
  type: 'date',
  cancel: function cancel() {},
  confirm: function confirm() {},
  change: function change() {}
};

var currentOptions = _extends({}, defaultOptions);

var instance = {};

function createInstance(appendTo) {
  var datePicker = new (Vue.extend(__vue_component__$f))({
    el: document.createElement('div')
  });
  getContainer(appendTo).appendChild(datePicker.$el);
  instance = datePicker;
  return instance;
}

function destroy() {
  if (keys$6(instance).length === 0) return;
  instance.isShow = false;
  instance.$on('after-leave', function () {
    return instance.$destroy();
  });
}

function functionCheck(target, targetStr, callback) {
  if (typeof target === 'function') {
    callback();
  } else {
    console.error("type check failed for \"" + targetStr + "\"  Expected Function!");
  }
}

function DatePicker(options) {
  if (options === void 0) {
    options = {};
  }

  var datePicker = createInstance(options.appendTo);

  if (!isObj(options)) {
    console.error('type check failed for "options". Expected Object!');
  } else {
    var opt = _extends({}, currentOptions, {}, options);

    _extends(datePicker, opt);

    datePicker.isShow = true;
    datePicker.$on('cancel', function () {
      functionCheck(opt.cancel, 'cancel', function () {
        opt.cancel();
        destroy();
      });
    });
    datePicker.$on('confirm', function (innerValue) {
      functionCheck(opt.confirm, 'confirm', function () {
        opt.confirm(innerValue);
        destroy();
      });
    });
    datePicker.$on('change', function (picker) {
      functionCheck(opt.change, 'change', function () {
        opt.change(picker);
      });
    });
    return datePicker;
  }
}

DatePicker.close = function () {
  destroy();
};
/**
 * TODO:经过create.js的封装，组件都会有默认的install方法，Vue.use的作用就是全局注册该组件。
 * 外层注册DatePickerView是为了在组件内全局注册，从而使pop-datetime-picker可以引入。install函数内使用传入的全局对象注册，从而使得宿主环境可以直接标签式引入组件。
 * 疑问： DatePickerView组件只在pop-datetime-picker组件内局部引用的时候，会无法注册。待解决！

*/
// 组件全局注册datetime-picker


Vue.use(__vue_component__$e);

DatePicker.install = function (vueGlobal) {
  /* eslint no-param-reassign: ["error", { "props": false }] */
  // 宿主环境注册datetime-picker
  vueGlobal.use(__vue_component__$e);
  vueGlobal.prototype.$datetime = DatePicker;
};

var ENUM_TYPES = ThemeSwitcher.getThemeProps()['default-page'] || {};
var ENUM_TYPES_KEYS = keys$6(ENUM_TYPES);

var script$g = create({
  name: 'default-page',
  props: {
    // 是否是局部布局
    inline: {
      type: Boolean,
      default: true
    },
    // 是否是更大的
    large: {
      type: Boolean,
      default: false
    },
    // 局部显示是否自适应
    responsive: {
      type: Boolean,
      default: true
    },
    // 错误类型
    type: {
      type: String,
      default: 'empty',
      validator: function validator(type) {
        return indexOf$4(ENUM_TYPES_KEYS).call(ENUM_TYPES_KEYS, type) !== -1;
      }
    },
    // 错误图片
    image: {
      type: String,
      default: ''
    },
    imageClass: {
      type: String,
      default: ''
    },
    // 错误文案
    text: {
      type: String,
      default: ''
    },
    // 行动按钮文案
    label: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      visible: true,
      innerStyle: {},
      action: null
    };
  },
  computed: {
    preset: function preset() {
      var myThemeProps = this.$myThemeProps;
      return myThemeProps[this.type] || myThemeProps.empty || {};
    },
    imgData: function imgData() {
      return this.image || this.preset.image;
    },
    txtData: function txtData() {
      return this.text || this.preset.text;
    }
  },
  methods: {
    // 触发行动按钮事件
    handleAction: function handleAction() {
      if (this.action) {
        this.action();
      }

      this.$emit('action');
    },
    // 计算页面还留多少空白高度
    calculateBlank: function calculateBlank() {
      var self = this;
      return new promise$3(function (resolve, reject) {
        // 图片loaded后再计算高度
        var $img = self && self.$refs && self.$refs.defaultpageImage;

        if (!$img) {
          reject();
          return;
        }

        $img.onload = function () {
          var blankHeight = 0; // 查看body是否存在留白

          blankHeight = window.innerHeight - document.body.clientHeight;

          if (blankHeight > 0) {
            resolve(blankHeight);
          } // 若body发现没有留白，再查找body下的第一个元素，查看是否存在留白


          var firstElement = document.body.firstElementChild; // 第一个元素不是div，则不再处理

          if (firstElement.nodeName !== 'DIV') {
            resolve(0);
          }

          blankHeight = window.innerHeight - firstElement.clientHeight;

          if (blankHeight > 0) {
            resolve(blankHeight);
          } // 未有留白统一返回0


          resolve(0);
        };

        $img.onerror = function () {
          resolve(0);
        };
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.inline && this.responsive) {
      this.$nextTick(function () {
        // 动态取paddingBottom的值
        var paddingBottom = window.getComputedStyle(_this.$el.childNodes[0]).paddingBottom.replace('px', '');
        paddingBottom = _parseInt$3(paddingBottom, 10);

        _this.calculateBlank().then(function (height) {
          paddingBottom += height;

          _this.$set(_this.innerStyle, 'paddingBottom', paddingBottom + "px");
        });
      });
    }
  }
});

/* script */
var __vue_script__$g = script$g;
/* template */

var __vue_render__$g = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.visible ? _c('div', {
    class: {
      'bx-defaultpage-inline': _vm.inline,
      'bx-defaultpage-fixed': !_vm.inline,
      'bx-defaultpage-large': _vm.large
    }
  }, [_c('div', {
    staticClass: "bx-defaultpage-inner",
    style: _vm.innerStyle
  }, [_c('div', {
    staticClass: "bx-defaultpage-image",
    class: _vm.imageClass
  }, [_c('img', {
    ref: "defaultpageImage",
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.imgData
    }
  })]), _c('div', {
    staticClass: "bx-defaultpage-text",
    domProps: {
      "innerHTML": _vm._s(_vm.txtData)
    }
  }), _vm.label ? _c('div', {
    staticClass: "bx-defaultpage-group"
  }, [_c('a', {
    staticClass: "bx-defaultpage-btn",
    on: {
      "click": _vm.handleAction
    }
  }, [_vm._v(_vm._s(_vm.label))])]) : _vm._e()])]) : _vm._e();
};

var __vue_staticRenderFns__$g = [];
/* style */

var __vue_inject_styles__$g = undefined;
/* scoped */

var __vue_scope_id__$g = undefined;
/* module identifier */

var __vue_module_identifier__$g = undefined;
/* functional template */

var __vue_is_functional_template__$g = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$g =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$g,
  staticRenderFns: __vue_staticRenderFns__$g
}, __vue_inject_styles__$g, __vue_script__$g, __vue_scope_id__$g, __vue_is_functional_template__$g, __vue_module_identifier__$g, false, undefined, undefined, undefined);

var defaultOptions$1 = {
  inline: false,
  large: true
};
var DefaultPageConstructor = Vue.extend(__vue_component__$g);
var instance$1 = null;

var getInstance = function getInstance() {
  return new DefaultPageConstructor({
    el: document.createElement('div')
  });
};

var DefaultPage = function DefaultPage(options) {
  if (options === void 0) {
    options = {};
  }

  instance$1 = getInstance();

  _extends(instance$1, defaultOptions$1, options);

  document.body.appendChild(instance$1.$el);
};
/* eslint-disable no-param-reassign */


forEach$2(ENUM_TYPES_KEYS).call(ENUM_TYPES_KEYS, function (key) {
  DefaultPage[key] = function (options) {
    if (options === void 0) {
      options = {};
    }

    if (typeof options === 'string') {
      options = {
        text: options
      };
    }

    var defaults = {
      type: key
    };
    options = _extends({}, defaults, options); // eslint-disable-next-line

    new DefaultPage(options);
  };
});
/* eslint-enable no-param-reassign */


DefaultPage.view = __vue_component__$g;

DefaultPage.remove = function () {
  if (instance$1) {
    instance$1.visible = false;
  }
};

DefaultPage.hide = function () {
  if (instance$1) {
    instance$1.visible = false;
  }
};

DefaultPage.install = function (vueGlobal) {
  vueGlobal.use(__vue_component__$g);
  /* eslint no-param-reassign: ["Error", { "props": false }] */

  vueGlobal.prototype.$defaultPage = DefaultPage;
};

var nativePromiseConstructor$1 = global_1$1.Promise;

var redefineAll$1 = function (target, src, options) {
  for (var key in src) redefine$1(target, key, src[key], options);
  return target;
};

var defineProperty$7 = objectDefineProperty$1.f;



var TO_STRING_TAG$6 = wellKnownSymbol$1('toStringTag');

var setToStringTag$1 = function (it, TAG, STATIC) {
  if (it && !has$2(it = STATIC ? it : it.prototype, TO_STRING_TAG$6)) {
    defineProperty$7(it, TO_STRING_TAG$6, { configurable: true, value: TAG });
  }
};

var anInstance$1 = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};

var iterators$1 = {};

var ITERATOR$5 = wellKnownSymbol$1('iterator');
var ArrayPrototype$c = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod$1 = function (it) {
  return it !== undefined && (iterators$1.Array === it || ArrayPrototype$c[ITERATOR$5] === it);
};

// optional / simple context binding
var bindContext$1 = function (fn, that, length) {
  aFunction$3(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var ITERATOR$6 = wellKnownSymbol$1('iterator');

var getIteratorMethod$1 = function (it) {
  if (it != undefined) return it[ITERATOR$6]
    || it['@@iterator']
    || iterators$1[classof$1(it)];
};

// call something on iterator step with safe closing on error
var callWithSafeIterationClosing$1 = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject$1(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (error) {
    var returnMethod = iterator['return'];
    if (returnMethod !== undefined) anObject$1(returnMethod.call(iterator));
    throw error;
  }
};

var iterate_1$1 = createCommonjsModule(function (module) {
var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var iterate = module.exports = function (iterable, fn, that, AS_ENTRIES, IS_ITERATOR) {
  var boundFunction = bindContext$1(fn, that, AS_ENTRIES ? 2 : 1);
  var iterator, iterFn, index, length, result, next, step;

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod$1(iterable);
    if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod$1(iterFn)) {
      for (index = 0, length = toLength$1(iterable.length); length > index; index++) {
        result = AS_ENTRIES
          ? boundFunction(anObject$1(step = iterable[index])[0], step[1])
          : boundFunction(iterable[index]);
        if (result && result instanceof Result) return result;
      } return new Result(false);
    }
    iterator = iterFn.call(iterable);
  }

  next = iterator.next;
  while (!(step = next.call(iterator)).done) {
    result = callWithSafeIterationClosing$1(iterator, boundFunction, step.value, AS_ENTRIES);
    if (typeof result == 'object' && result && result instanceof Result) return result;
  } return new Result(false);
};

iterate.stop = function (result) {
  return new Result(true, result);
};
});

var ITERATOR$7 = wellKnownSymbol$1('iterator');
var SAFE_CLOSING$1 = false;

try {
  var called$1 = 0;
  var iteratorWithReturn$1 = {
    next: function () {
      return { done: !!called$1++ };
    },
    'return': function () {
      SAFE_CLOSING$1 = true;
    }
  };
  iteratorWithReturn$1[ITERATOR$7] = function () {
    return this;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(iteratorWithReturn$1, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration$1 = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING$1) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$7] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var userAgent$1 = getBuiltIn$1('navigator', 'userAgent') || '';

var isIos$1 = /(iphone|ipod|ipad).*applewebkit/i.test(userAgent$1);

var location$1 = global_1$1.location;
var set$3 = global_1$1.setImmediate;
var clear$1 = global_1$1.clearImmediate;
var process$4 = global_1$1.process;
var MessageChannel$1 = global_1$1.MessageChannel;
var Dispatch$1 = global_1$1.Dispatch;
var counter$1 = 0;
var queue$1 = {};
var ONREADYSTATECHANGE$1 = 'onreadystatechange';
var defer$1, channel$1, port$1;

var run$1 = function (id) {
  // eslint-disable-next-line no-prototype-builtins
  if (queue$1.hasOwnProperty(id)) {
    var fn = queue$1[id];
    delete queue$1[id];
    fn();
  }
};

var runner$1 = function (id) {
  return function () {
    run$1(id);
  };
};

var listener$1 = function (event) {
  run$1(event.data);
};

var post$1 = function (id) {
  // old engines have not location.origin
  global_1$1.postMessage(id + '', location$1.protocol + '//' + location$1.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set$3 || !clear$1) {
  set$3 = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue$1[++counter$1] = function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(undefined, args);
    };
    defer$1(counter$1);
    return counter$1;
  };
  clear$1 = function clearImmediate(id) {
    delete queue$1[id];
  };
  // Node.js 0.8-
  if (classofRaw$1(process$4) == 'process') {
    defer$1 = function (id) {
      process$4.nextTick(runner$1(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch$1 && Dispatch$1.now) {
    defer$1 = function (id) {
      Dispatch$1.now(runner$1(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel$1 && !isIos$1) {
    channel$1 = new MessageChannel$1();
    port$1 = channel$1.port2;
    channel$1.port1.onmessage = listener$1;
    defer$1 = bindContext$1(port$1.postMessage, port$1, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global_1$1.addEventListener && typeof postMessage == 'function' && !global_1$1.importScripts && !fails$1(post$1)) {
    defer$1 = post$1;
    global_1$1.addEventListener('message', listener$1, false);
  // IE8-
  } else if (ONREADYSTATECHANGE$1 in documentCreateElement$1('script')) {
    defer$1 = function (id) {
      html$1.appendChild(documentCreateElement$1('script'))[ONREADYSTATECHANGE$1] = function () {
        html$1.removeChild(this);
        run$1(id);
      };
    };
  // Rest old browsers
  } else {
    defer$1 = function (id) {
      setTimeout(runner$1(id), 0);
    };
  }
}

var task$2 = {
  set: set$3,
  clear: clear$1
};

var getOwnPropertyDescriptor$6 = objectGetOwnPropertyDescriptor$1.f;

var macrotask$1 = task$2.set;


var MutationObserver$2 = global_1$1.MutationObserver || global_1$1.WebKitMutationObserver;
var process$5 = global_1$1.process;
var Promise$1 = global_1$1.Promise;
var IS_NODE$2 = classofRaw$1(process$5) == 'process';
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor$1 = getOwnPropertyDescriptor$6(global_1$1, 'queueMicrotask');
var queueMicrotask$1 = queueMicrotaskDescriptor$1 && queueMicrotaskDescriptor$1.value;

var flush$1, head$1, last$1, notify$2, toggle$1, node$1, promise$4, then$1;

// modern engines have queueMicrotask method
if (!queueMicrotask$1) {
  flush$1 = function () {
    var parent, fn;
    if (IS_NODE$2 && (parent = process$5.domain)) parent.exit();
    while (head$1) {
      fn = head$1.fn;
      head$1 = head$1.next;
      try {
        fn();
      } catch (error) {
        if (head$1) notify$2();
        else last$1 = undefined;
        throw error;
      }
    } last$1 = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (IS_NODE$2) {
    notify$2 = function () {
      process$5.nextTick(flush$1);
    };
  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  } else if (MutationObserver$2 && !isIos$1) {
    toggle$1 = true;
    node$1 = document.createTextNode('');
    new MutationObserver$2(flush$1).observe(node$1, { characterData: true });
    notify$2 = function () {
      node$1.data = toggle$1 = !toggle$1;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise$4 = Promise$1.resolve(undefined);
    then$1 = promise$4.then;
    notify$2 = function () {
      then$1.call(promise$4, flush$1);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify$2 = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask$1.call(global_1$1, flush$1);
    };
  }
}

var microtask$1 = queueMicrotask$1 || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last$1) last$1.next = task;
  if (!head$1) {
    head$1 = task;
    notify$2();
  } last$1 = task;
};

var PromiseCapability$1 = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction$3(resolve);
  this.reject = aFunction$3(reject);
};

// 25.4.1.5 NewPromiseCapability(C)
var f$a = function (C) {
  return new PromiseCapability$1(C);
};

var newPromiseCapability$2 = {
	f: f$a
};

var promiseResolve$1 = function (C, x) {
  anObject$1(C);
  if (isObject$1(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability$2.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var hostReportErrors$1 = function (a, b) {
  var console = global_1$1.console;
  if (console && console.error) {
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  }
};

var perform$1 = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var process$6 = global_1$1.process;
var versions$1 = process$6 && process$6.versions;
var v8$1 = versions$1 && versions$1.v8;
var match$1, version$1;

if (v8$1) {
  match$1 = v8$1.split('.');
  version$1 = match$1[0] + match$1[1];
} else if (userAgent$1) {
  match$1 = userAgent$1.match(/Edge\/(\d+)/);
  if (!match$1 || match$1[1] >= 74) {
    match$1 = userAgent$1.match(/Chrome\/(\d+)/);
    if (match$1) version$1 = match$1[1];
  }
}

var v8Version$1 = version$1 && +version$1;

var task$3 = task$2.set;










var SPECIES$9 = wellKnownSymbol$1('species');
var PROMISE$1 = 'Promise';
var getInternalState$3 = internalState$1.get;
var setInternalState$3 = internalState$1.set;
var getInternalPromiseState$1 = internalState$1.getterFor(PROMISE$1);
var PromiseConstructor$1 = nativePromiseConstructor$1;
var TypeError$2 = global_1$1.TypeError;
var document$4 = global_1$1.document;
var process$7 = global_1$1.process;
var $fetch$1 = getBuiltIn$1('fetch');
var newPromiseCapability$3 = newPromiseCapability$2.f;
var newGenericPromiseCapability$1 = newPromiseCapability$3;
var IS_NODE$3 = classofRaw$1(process$7) == 'process';
var DISPATCH_EVENT$1 = !!(document$4 && document$4.createEvent && global_1$1.dispatchEvent);
var UNHANDLED_REJECTION$1 = 'unhandledrejection';
var REJECTION_HANDLED$1 = 'rejectionhandled';
var PENDING$1 = 0;
var FULFILLED$1 = 1;
var REJECTED$1 = 2;
var HANDLED$1 = 1;
var UNHANDLED$1 = 2;
var Internal$1, OwnPromiseCapability$1, PromiseWrapper$1, nativeThen;

var FORCED$6 = isForced_1$1(PROMISE$1, function () {
  var GLOBAL_CORE_JS_PROMISE = inspectSource$1(PromiseConstructor$1) !== String(PromiseConstructor$1);
  if (!GLOBAL_CORE_JS_PROMISE) {
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (v8Version$1 === 66) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    if (!IS_NODE$3 && typeof PromiseRejectionEvent != 'function') return true;
  }
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (v8Version$1 >= 51 && /native code/.test(PromiseConstructor$1)) return false;
  // Detect correctness of subclassing with @@species support
  var promise = PromiseConstructor$1.resolve(1);
  var FakePromise = function (exec) {
    exec(function () { /* empty */ }, function () { /* empty */ });
  };
  var constructor = promise.constructor = {};
  constructor[SPECIES$9] = FakePromise;
  return !(promise.then(function () { /* empty */ }) instanceof FakePromise);
});

var INCORRECT_ITERATION$1 = FORCED$6 || !checkCorrectnessOfIteration$1(function (iterable) {
  PromiseConstructor$1.all(iterable)['catch'](function () { /* empty */ });
});

// helpers
var isThenable$1 = function (it) {
  var then;
  return isObject$1(it) && typeof (then = it.then) == 'function' ? then : false;
};

var notify$3 = function (promise, state, isReject) {
  if (state.notified) return;
  state.notified = true;
  var chain = state.reactions;
  microtask$1(function () {
    var value = state.value;
    var ok = state.state == FULFILLED$1;
    var index = 0;
    // variable length - can't use forEach
    while (chain.length > index) {
      var reaction = chain[index++];
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (state.rejection === UNHANDLED$1) onHandleUnhandled$1(promise, state);
            state.rejection = HANDLED$1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // can throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError$2('Promise-chain cycle'));
          } else if (then = isThenable$1(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
      }
    }
    state.reactions = [];
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled$1(promise, state);
  });
};

var dispatchEvent$1 = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT$1) {
    event = document$4.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global_1$1.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (handler = global_1$1['on' + name]) handler(event);
  else if (name === UNHANDLED_REJECTION$1) hostReportErrors$1('Unhandled promise rejection', reason);
};

var onUnhandled$1 = function (promise, state) {
  task$3.call(global_1$1, function () {
    var value = state.value;
    var IS_UNHANDLED = isUnhandled$1(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform$1(function () {
        if (IS_NODE$3) {
          process$7.emit('unhandledRejection', value, promise);
        } else dispatchEvent$1(UNHANDLED_REJECTION$1, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE$3 || isUnhandled$1(state) ? UNHANDLED$1 : HANDLED$1;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled$1 = function (state) {
  return state.rejection !== HANDLED$1 && !state.parent;
};

var onHandleUnhandled$1 = function (promise, state) {
  task$3.call(global_1$1, function () {
    if (IS_NODE$3) {
      process$7.emit('rejectionHandled', promise);
    } else dispatchEvent$1(REJECTION_HANDLED$1, promise, state.value);
  });
};

var bind$1 = function (fn, promise, state, unwrap) {
  return function (value) {
    fn(promise, state, value, unwrap);
  };
};

var internalReject$1 = function (promise, state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED$1;
  notify$3(promise, state, true);
};

var internalResolve$1 = function (promise, state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (promise === value) throw TypeError$2("Promise can't be resolved itself");
    var then = isThenable$1(value);
    if (then) {
      microtask$1(function () {
        var wrapper = { done: false };
        try {
          then.call(value,
            bind$1(internalResolve$1, promise, wrapper, state),
            bind$1(internalReject$1, promise, wrapper, state)
          );
        } catch (error) {
          internalReject$1(promise, wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED$1;
      notify$3(promise, state, false);
    }
  } catch (error) {
    internalReject$1(promise, { done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED$6) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor$1 = function Promise(executor) {
    anInstance$1(this, PromiseConstructor$1, PROMISE$1);
    aFunction$3(executor);
    Internal$1.call(this);
    var state = getInternalState$3(this);
    try {
      executor(bind$1(internalResolve$1, this, state), bind$1(internalReject$1, this, state));
    } catch (error) {
      internalReject$1(this, state, error);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal$1 = function Promise(executor) {
    setInternalState$3(this, {
      type: PROMISE$1,
      done: false,
      notified: false,
      parent: false,
      reactions: [],
      rejection: false,
      state: PENDING$1,
      value: undefined
    });
  };
  Internal$1.prototype = redefineAll$1(PromiseConstructor$1.prototype, {
    // `Promise.prototype.then` method
    // https://tc39.github.io/ecma262/#sec-promise.prototype.then
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState$1(this);
      var reaction = newPromiseCapability$3(speciesConstructor(this, PromiseConstructor$1));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = IS_NODE$3 ? process$7.domain : undefined;
      state.parent = true;
      state.reactions.push(reaction);
      if (state.state != PENDING$1) notify$3(this, state, false);
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.github.io/ecma262/#sec-promise.prototype.catch
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability$1 = function () {
    var promise = new Internal$1();
    var state = getInternalState$3(promise);
    this.promise = promise;
    this.resolve = bind$1(internalResolve$1, promise, state);
    this.reject = bind$1(internalReject$1, promise, state);
  };
  newPromiseCapability$2.f = newPromiseCapability$3 = function (C) {
    return C === PromiseConstructor$1 || C === PromiseWrapper$1
      ? new OwnPromiseCapability$1(C)
      : newGenericPromiseCapability$1(C);
  };

  if ( typeof nativePromiseConstructor$1 == 'function') {
    nativeThen = nativePromiseConstructor$1.prototype.then;

    // wrap native Promise#then for native async functions
    redefine$1(nativePromiseConstructor$1.prototype, 'then', function then(onFulfilled, onRejected) {
      var that = this;
      return new PromiseConstructor$1(function (resolve, reject) {
        nativeThen.call(that, resolve, reject);
      }).then(onFulfilled, onRejected);
    // https://github.com/zloirock/core-js/issues/640
    }, { unsafe: true });

    // wrap fetch result
    if (typeof $fetch$1 == 'function') _export$1({ global: true, enumerable: true, forced: true }, {
      // eslint-disable-next-line no-unused-vars
      fetch: function fetch(input /* , init */) {
        return promiseResolve$1(PromiseConstructor$1, $fetch$1.apply(global_1$1, arguments));
      }
    });
  }
}

_export$1({ global: true, wrap: true, forced: FORCED$6 }, {
  Promise: PromiseConstructor$1
});

setToStringTag$1(PromiseConstructor$1, PROMISE$1, false);
setSpecies(PROMISE$1);

PromiseWrapper$1 = getBuiltIn$1(PROMISE$1);

// statics
_export$1({ target: PROMISE$1, stat: true, forced: FORCED$6 }, {
  // `Promise.reject` method
  // https://tc39.github.io/ecma262/#sec-promise.reject
  reject: function reject(r) {
    var capability = newPromiseCapability$3(this);
    capability.reject.call(undefined, r);
    return capability.promise;
  }
});

_export$1({ target: PROMISE$1, stat: true, forced:  FORCED$6 }, {
  // `Promise.resolve` method
  // https://tc39.github.io/ecma262/#sec-promise.resolve
  resolve: function resolve(x) {
    return promiseResolve$1( this, x);
  }
});

_export$1({ target: PROMISE$1, stat: true, forced: INCORRECT_ITERATION$1 }, {
  // `Promise.all` method
  // https://tc39.github.io/ecma262/#sec-promise.all
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability$3(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform$1(function () {
      var $promiseResolve = aFunction$3(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate_1$1(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        $promiseResolve.call(C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  },
  // `Promise.race` method
  // https://tc39.github.io/ecma262/#sec-promise.race
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability$3(C);
    var reject = capability.reject;
    var result = perform$1(function () {
      var $promiseResolve = aFunction$3(C.resolve);
      iterate_1$1(iterable, function (promise) {
        $promiseResolve.call(C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod$8 = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aFunction(callbackfn);
    var O = toObject(that);
    var self = indexedObject(O);
    var length = toLength(O.length);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.reduce
  left: createMethod$8(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.reduceright
  right: createMethod$8(true)
};

var $reduce = arrayReduce.left;


// `Array.prototype.reduce` method
// https://tc39.github.io/ecma262/#sec-array.prototype.reduce
_export({ target: 'Array', proto: true, forced: sloppyArrayMethod('reduce') }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var reduce = entryVirtual('Array').reduce;

var ArrayPrototype$d = Array.prototype;

var reduce_1 = function (it) {
  var own = it.reduce;
  return it === ArrayPrototype$d || (it instanceof Array && own === ArrayPrototype$d.reduce) ? reduce : own;
};

var reduce$1 = reduce_1;

var reduce$2 = reduce$1;

var promiseSequential = function promiseSequential(promises) {
  if (!isArray$3(promises)) {
    throw new Error('First argument need to be an array of Promises');
  }

  return new promise$3(function (resolve, reject) {
    var count = 0;
    var results = [];

    var iterateeFunc = function iterateeFunc(previousPromise, currentPromise) {
      return previousPromise.then(function (result) {
        if (count++ !== 0) results = concat$2(results).call(results, result);
        return currentPromise(result, results, count);
      }).catch(function (err) {
        return reject(err);
      });
    };

    promises = concat$2(promises).call(promises, function () {
      return promise$3.resolve();
    });

    reduce$2(promises).call(promises, iterateeFunc, promise$3.resolve(false)).then(function (res) {
      resolve(results);
    });
  });
};

var slice$3 = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check

var wrap = function (scheduler) {
  return function (handler, timeout /* , ...arguments */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice$3.call(arguments, 2) : undefined;
    return scheduler(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof handler == 'function' ? handler : Function(handler)).apply(this, args);
    } : handler, timeout);
  };
};

// ie9- setTimeout & setInterval additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
_export({ global: true, bind: true, forced: MSIE }, {
  // `setTimeout` method
  // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
  setTimeout: wrap(global_1.setTimeout),
  // `setInterval` method
  // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
  setInterval: wrap(global_1.setInterval)
});

var setTimeout$1 = path.setTimeout;

var setTimeout$2 = setTimeout$1;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$2(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$2;

/** Detect free variable `global` from Node.js. */

var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */

var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root = _freeGlobal || freeSelf || Function('return this')();
var _root = root;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */

var now = function now() {
  return _root.Date.now();
};

var now_1 = now;

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */

function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}

  return index;
}

var _trimmedEndIndex = trimmedEndIndex;

/** Used to match leading whitespace. */

var reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */

function baseTrim(string) {
  return string ? slice$2(string).call(string, 0, _trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
}

var _baseTrim = baseTrim;

var f$b = wellKnownSymbol$1;

var wrappedWellKnownSymbol = {
	f: f$b
};

var defineProperty$8 = objectDefineProperty$1.f;

var defineWellKnownSymbol = function (NAME) {
  var Symbol = path$1.Symbol || (path$1.Symbol = {});
  if (!has$2(Symbol, NAME)) defineProperty$8(Symbol, NAME, {
    value: wrappedWellKnownSymbol.f(NAME)
  });
};

// `Symbol.toStringTag` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.tostringtag
defineWellKnownSymbol('toStringTag');

// JSON[@@toStringTag] property
// https://tc39.github.io/ecma262/#sec-json-@@tostringtag
setToStringTag$1(global_1$1.JSON, 'JSON', true);

// Math[@@toStringTag] property
// https://tc39.github.io/ecma262/#sec-math-@@tostringtag
setToStringTag$1(Math, 'Math', true);

/** Built-in value references. */

var Symbol$3 = _root.Symbol;
var _Symbol = Symbol$3;

/** Used for built-in method references. */

var objectProto = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$2 = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString = objectProto.toString;
/** Built-in value references. */

var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */

function getRawTag(value) {
  var isOwn = hasOwnProperty$2.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);

  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }

  return result;
}

var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString$1 = objectProto$1.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */

function objectToString$2(value) {
  return nativeObjectToString$1.call(value);
}

var _objectToString = objectToString$2;

/** `Object#toString` result references. */

var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';
/** Built-in value references. */

var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */

function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }

  return symToStringTag$1 && symToStringTag$1 in Object(value) ? _getRawTag(value) : _objectToString(value);
}

var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike;

/** `Object#toString` result references. */

var symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */

function isSymbol(value) {
  return typeof value == 'symbol' || isObjectLike_1(value) && _baseGetTag(value) == symbolTag;
}

var isSymbol_1 = isSymbol;

/** Used as references for various `Number` constants. */

var NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */

var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */

var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */

var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */

var freeParseInt = _parseInt$3;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */

function toNumber$1(value) {
  if (typeof value == 'number') {
    return value;
  }

  if (isSymbol_1(value)) {
    return NAN;
  }

  if (isObject_1(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject_1(other) ? other + '' : other;
  }

  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }

  value = _baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(slice$2(value).call(value, 2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

var toNumber_1 = toNumber$1;

/** Error message constants. */

var FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeMax = Math.max,
    nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */

function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }

  wait = toNumber_1(wait) || 0;

  if (isObject_1(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber_1(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;
    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time; // Start the timer for the trailing edge.

    timerId = setTimeout$2(timerExpired, wait); // Invoke the leading edge.

    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime; // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.

    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }

  function timerExpired() {
    var time = now_1();

    if (shouldInvoke(time)) {
      return trailingEdge(time);
    } // Restart the timer.


    timerId = setTimeout$2(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined; // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.

    if (trailing && lastArgs) {
      return invokeFunc(time);
    }

    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }

    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now_1());
  }

  function debounced() {
    var time = now_1(),
        isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }

      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout$2(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }

    if (timerId === undefined) {
      timerId = setTimeout$2(timerExpired, wait);
    }

    return result;
  }

  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

var debounce_1 = debounce;

var _components$9;
var script$h = create({
  name: 'toast',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  components: (_components$9 = {}, _components$9[__vue_component__$1.name] = __vue_component__$1, _components$9)
});

/* script */
var __vue_script__$h = script$h;
/* template */

var __vue_render__$h = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('transition', {
    attrs: {
      "name": "bx-animate-fade"
    }
  }, [_vm.visible ? _c('div', {
    staticClass: "bx-toast"
  }, [_c('div', {
    staticClass: "bx-toast-inner",
    class: _vm.icon && 'bx-toast-block'
  }, [_vm.icon ? _c('bxs-icon', {
    staticClass: "bx-toast-icon",
    attrs: {
      "name": _vm.icon
    }
  }) : _vm._e(), _c('span', {
    staticClass: "bx-toast-text"
  }, [_vm._v("\n        " + _vm._s(_vm.message) + "\n      ")])], 1)]) : _vm._e()]);
};

var __vue_staticRenderFns__$h = [];
/* style */

var __vue_inject_styles__$h = undefined;
/* scoped */

var __vue_scope_id__$h = undefined;
/* module identifier */

var __vue_module_identifier__$h = undefined;
/* functional template */

var __vue_is_functional_template__$h = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$h =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$h,
  staticRenderFns: __vue_staticRenderFns__$h
}, __vue_inject_styles__$h, __vue_script__$h, __vue_scope_id__$h, __vue_is_functional_template__$h, __vue_module_identifier__$h, false, undefined, undefined, undefined);

var _context$2;
var ToastConstructor = Vue.extend(__vue_component__$h);
var theInstance;

var getInstance$1 = function getInstance() {
  if (!theInstance) {
    theInstance = new ToastConstructor({
      el: document.createElement('div')
    });
  }

  return theInstance;
};

var appendDom = function appendDom(el) {
  if (!el.parentNode) {
    document.body.appendChild(el);
  }
};

var removeDom = function removeDom(event) {
  if (event.target.parentNode) {
    event.target.parentNode.removeChild(event.target);
  }
};

ToastConstructor.prototype.close = function close() {
  this.visible = false;
  this.$el.addEventListener('transitionend', removeDom);
};

function Toast(options) {
  if (options === void 0) {
    options = {};
  }

  var duration = options.duration || 2000;
  var instance = getInstance$1();
  clearTimeout(instance.timer);
  instance.$el.removeEventListener('transitionend', removeDom);
  instance.message = typeof options === 'string' ? options : options.message;
  instance.type = options.type || '';
  instance.icon = options.icon || '';

  if (!instance.icon) {
    switch (instance.type) {
      case 'success':
        instance.icon = 'check-plain';
        break;

      case 'fail':
        instance.icon = 'close-plain';
        break;

      case 'warning':
        instance.icon = 'warning-plain';
        break;

      default:
        instance.icon = '';
    }
  }

  appendDom(instance.$el);
  Vue.nextTick(function () {
    instance.visible = true;

    if (duration) {
      instance.timer = setTimeout$2(function () {
        instance.close();
      }, duration);
    }
  });
  return instance;
}

forEach$2(_context$2 = ['success', 'fail', 'warning']).call(_context$2, function (method) {
  Toast[method] = function (options) {
    if (options === void 0) {
      options = {};
    }

    var opt = {
      type: method
    };

    if (typeof options === 'string') {
      opt.message = options;
    } else {
      opt = _extends(opt, options);
    }

    Toast(opt);
  };
});

Toast.install = function (vueGlobal) {
  /* eslint no-param-reassign: ["error", { "props": false }] */
  vueGlobal.use(__vue_component__$h);
  vueGlobal.prototype.$toast = Toast;
};

var script$i = create({
  name: 'form',
  provide: function provide() {
    return {
      bxsForm: this
    };
  },
  props: {
    model: Object,
    rules: Object,
    // 可选，是否显示校验错误信息
    showMessage: {
      type: Boolean,
      default: true
    },
    // 可选，是否自动定位至错误项
    autoPositionError: {
      type: Boolean,
      default: true
    },
    // 可选，是否自动显示Toast提示
    autoShowToast: {
      type: Boolean,
      default: true
    },
    // 可选，默认Toast提示文案
    toastMessage: {
      type: String,
      default: '请完善填写内容'
    },
    // 可选，是否忽略最后一项的分割线
    ignoreLastLine: {
      type: Boolean,
      default: true
    },
    // 可选，是否所有内容垂直对齐
    isContentVerticalAlignment: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      fields: []
    };
  },
  watch: {
    isContentVerticalAlignment: {
      handler: function handler() {
        this.$nextTick(this.reCalculateLabelWidth);
      } // immediate: true, // #131 fix。初始化时 label 宽度重算由 'form.addField' 触发，此处无必要。

    }
  },
  created: function created() {
    var _this = this;

    var debouncedWidthCalc = debounce_1(this.reCalculateLabelWidth, 60);
    this.$on('form.addField', function (field) {
      _this.fields.push(field); // Fix #131, 异步 push field 后触发重算


      _this.$nextTick(debouncedWidthCalc);
    });
    this.$on('form.removeField', function (field) {
      var _context;

      _this.fields = filter$2(_context = _this.fields).call(_context, function (it) {
        return it !== field;
      }); // Fix #131, 异步 push field 后触发重算

      _this.$nextTick(debouncedWidthCalc);
    });
  },
  methods: {
    getFieldByProp: function getFieldByProp(prop) {
      var _context2;

      var fields = filter$2(_context2 = this.fields).call(_context2, function (field) {
        return field.prop === prop;
      });

      if (fields && fields.length > 0) {
        return fields[0];
      }

      return {};
    },
    validate: function validate(prop) {
      var _this2 = this;

      if (prop) {
        var field = this.getFieldByProp(prop);
        return field.validate();
      }

      return new promise$3(function (resolve, reject) {
        var _context3;

        promiseSequential(map$2(_context3 = _this2.fields).call(_context3, function (field) {
          return function () {
            return field.validate();
          };
        })).then(function () {
          resolve();
        }).catch(function (_ref) {
          var errors = _ref.errors;

          if (_this2.autoPositionError) {
            _this2.readyPositionErrorField(errors[0].field);
          }

          if (_this2.autoShowToast) {
            Toast(_this2.toastMessage);
          }

          reject(errors);
        });
      });
    },
    // 支持多个Form表单定位
    readyPositionErrorField: function readyPositionErrorField(prop) {
      var _this3 = this;

      if (!Vue.bxsFormErrorFields) {
        Vue.bxsFormErrorFields = [];
      }

      Vue.bxsFormErrorFields.push(prop); // 增加macroTask(setTimeout)，保证在microTask(PromiseSequential)后执行

      window.setTimeout(function () {
        _this3.autoPositionErrorField(Vue.bxsFormErrorFields[0]);

        Vue.bxsFormErrorFields = [];
      });
    },
    // 自动定位到错误项
    autoPositionErrorField: function autoPositionErrorField(prop) {
      var _this$getFieldByProp = this.getFieldByProp(prop),
          $el = _this$getFieldByProp.$el;

      if ($el) {
        scrollIntoView($el, {
          behavior: function behavior(actions) {
            var canSmoothScroll = 'scrollBehavior' in document.body.style;

            forEach$2(actions).call(actions, function (_ref2) {
              var el = _ref2.el,
                  top = _ref2.top,
                  left = _ref2.left;

              if (el.scroll && canSmoothScroll) {
                el.scroll({
                  top: top,
                  left: left,
                  behavior: 'smooth'
                });
              } else if (window.scrollTo && el.tagName === 'HTML') {
                window.scrollTo(left, top);
              } else {
                el.scrollTop = top;
                el.scrollLeft = left;
              }
            });
          },
          scrollMode: 'if-needed'
        });
      }
    },
    // 重新计算每一项label的宽度
    reCalculateLabelWidth: function reCalculateLabelWidth() {
      var _context5;

      var isVerticalAlignmentForced = false;

      if (this.isContentVerticalAlignment) {
        var _context4;

        var fields = filter$2(_context4 = this.fields).call(_context4, function (field) {
          return field.isLabelMoreThanThreshold;
        });

        isVerticalAlignmentForced = fields.length > 0;
      }
      /* eslint no-param-reassign: ["error", { "props": false }] */


      forEach$2(_context5 = this.fields).call(_context5, function (field) {
        field.isVerticalAlignmentForced = isVerticalAlignmentForced;
      });
    },
    resetFields: function resetFields(prop) {
      if (prop) {
        var field = this.getFieldByProp(prop);
        field.resetField();
      } else {
        var _context6;

        forEach$2(_context6 = this.fields).call(_context6, function (field) {
          field.resetField();
        });
      }
    }
  }
});

/* script */
var __vue_script__$i = script$i;
/* template */

var __vue_render__$i = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('form', {
    staticClass: "bx-form",
    class: _vm.ignoreLastLine && 'bx-form--ignoredline'
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$i = [];
/* style */

var __vue_inject_styles__$i = undefined;
/* scoped */

var __vue_scope_id__$i = undefined;
/* module identifier */

var __vue_module_identifier__$i = undefined;
/* functional template */

var __vue_is_functional_template__$i = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$i =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$i,
  staticRenderFns: __vue_staticRenderFns__$i
}, __vue_inject_styles__$i, __vue_script__$i, __vue_scope_id__$i, __vue_is_functional_template__$i, __vue_module_identifier__$i, false, undefined, undefined, undefined);

/* eslint-disable */
// 暂时简单自行实现，等待函数库完成再切换
// 内置的校验类型可查看 https://github.com/yiminghe/async-validator#type
var buildInType = {
  email: function email(value) {
    return /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test(value);
  },
  mobile: function mobile(value) {
    return /^1(3|4|5|6|7|8|9)\d{9}$/.test(value);
  },
  bank: function bank(value) {
    return /^([1-9]{1})(\d{14}|\d{18})$/.test(value);
  },
  idCard: function idCard(value) {
    return /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(value);
  }
};

var LABEL_THRESHOLD$1 = 5;

var onlyValues$2 = function onlyValues(values) {
  return function (str) {
    return indexOf$4(values).call(values, str) !== -1;
  };
};

var getPositionResult = function getPositionResult(value, type) {
  return value ? "bx-form-item__" + type + "--" + value : '';
};

var script$j = create({
  name: 'form-item',
  provide: function provide() {
    return {
      bxsFormItem: this
    };
  },
  inject: {
    bxsForm: {
      default: ''
    }
  },
  props: {
    prop: String,
    label: String,
    labelPosition: {
      type: String,
      default: 'left',
      validator: onlyValues$2(['top', 'bottom', 'left', 'right', 'middle'])
    },
    contentPosition: {
      type: String,
      default: 'left',
      validator: onlyValues$2(['top', 'bottom', 'left', 'right', 'middle'])
    },
    required: [Boolean, String],
    rules: [Object, Array],
    showMessage: {
      type: Boolean,
      default: undefined
    },
    ignoreValidate: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      validateMessage: '',
      // 是否强制垂直对齐
      isVerticalAlignmentForced: false
    };
  },
  computed: {
    form: function form() {
      return this.bxsForm;
    },
    // label 文案是否超过阈值LABEL_THRESHOLD=5
    isLabelMoreThanThreshold: function isLabelMoreThanThreshold() {
      return !!this.$slots.label || this.label && this.label.length >= LABEL_THRESHOLD$1;
    },
    // 根据 labelPosition 计算class
    labelPositionClass: function labelPositionClass() {
      return getPositionResult(this.labelPosition, 'label');
    },
    // 根据 contentPosition 计算class
    contentPositionClass: function contentPositionClass() {
      return getPositionResult(this.contentPosition, 'content');
    },
    // 是否显示校验错误信息，覆盖form中的showMessage
    isShowErrorMessage: function isShowErrorMessage() {
      if (this.showMessage === undefined || this.showMessage === null) {
        return this.form.showMessage;
      }

      return this.showMessage;
    }
  },
  mounted: function mounted() {
    if (this.prop) {
      this.form.$emit('form.addField', this); // 可通过inject自行实现逻辑触发

      this.$on('form.item.validate', this.onValidate);
      this.$on('form.item.reset', this.onResetField);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.form.$emit('form.removeField', this);
  },
  methods: {
    // 获取表单域上的所有规则，包括form上的rules，form-item上的rules和required
    getRules: function getRules() {
      var _context, _context2, _context3;

      var formRules = this.form.rules[this.prop] || [];
      var selfRules = this.rules || [];
      var requiredRule = this.getRequiredRule();
      return concat$2(_context = concat$2(_context2 = concat$2(_context3 = []).call(_context3, formRules)).call(_context2, selfRules)).call(_context, requiredRule);
    },
    getRequiredRule: function getRequiredRule() {
      if (this.required !== undefined && this.required !== null) {
        var requiredRule = {};
        requiredRule.required = !!this.required;

        if (typeof this.required === 'string') {
          requiredRule.message = this.required;
        }

        return requiredRule;
      }

      return [];
    },
    // 获取内置类型校验规则
    getBuildInRule: function getBuildInRule(rules) {
      var formItemRules = rules;
      return map$2(formItemRules).call(formItemRules, function (rule) {
        if (rule.type && !rule.validator && buildInType[rule.type]) {
          /* eslint no-param-reassign: ["error", { "props": false }] */
          rule.validator = function (_rule, value) {
            return buildInType[rule.type](value);
          };
        }

        return rule;
      });
    },
    validate: function validate() {
      var _this = this;

      if (this.ignoreValidate) {
        return promise$3.resolve();
      }

      var rules = this.getRules(); // 没有设置规则的项，直接跳过

      if (rules.length === 0) {
        return promise$3.resolve();
      }

      var descriptor = {};
      rules = this.getBuildInRule(rules);
      descriptor[this.prop] = rules;
      var validator = new AsyncValidator(descriptor, {
        // 当验证到第一个错误时，立刻回调，不再执行之后的验证
        first: true
      });
      var source = {};
      source[this.prop] = this.form.model[this.prop];
      var promise = validator.validate(source);
      promise.then(function () {
        _this.resetField();
      }).catch(function (_ref) {
        var errors = _ref.errors;

        if (errors) {
          // 通知input，信息反馈
          _this.validateMessage = errors[0].message;
        }
      });
      return promise;
    },
    resetField: function resetField() {
      this.validateMessage = '';
    },
    onResetField: function onResetField() {
      this.resetField();
    },
    onValidate: function onValidate() {
      this.validate();
    }
  }
});

/* script */
var __vue_script__$j = script$j;
/* template */

var __vue_render__$j = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "bx-form-item",
    class: [_vm.labelPositionClass, _vm.contentPositionClass]
  }, [_c('div', {
    staticClass: "bx-form-item__inner"
  }, [_vm.$slots.label || _vm.label ? _c('div', {
    staticClass: "bx-form-item__label",
    class: (_vm.isLabelMoreThanThreshold || _vm.isVerticalAlignmentForced) && 'bx-form-item__labbx--lg'
  }, [_vm._t("label", [_vm._v("\n        " + _vm._s(_vm.label) + "\n      ")])], 2) : _vm._e(), _c('div', {
    staticClass: "bx-form-item__content"
  }, [_vm._t("default")], 2)]), _vm.isShowErrorMessage && _vm.validateMessage ? _c('div', {
    staticClass: "bx-form-item__error"
  }, [_vm._v("\n    " + _vm._s(_vm.validateMessage) + "\n  ")]) : _vm._e()]);
};

var __vue_staticRenderFns__$j = [];
/* style */

var __vue_inject_styles__$j = undefined;
/* scoped */

var __vue_scope_id__$j = undefined;
/* module identifier */

var __vue_module_identifier__$j = undefined;
/* functional template */

var __vue_is_functional_template__$j = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$j =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$j,
  staticRenderFns: __vue_staticRenderFns__$j
}, __vue_inject_styles__$j, __vue_script__$j, __vue_scope_id__$j, __vue_is_functional_template__$j, __vue_module_identifier__$j, false, undefined, undefined, undefined);

//
var script$k = create({
  name: 'load-more',
  props: {
    // 是否还有更多
    hasMore: {
      type: Boolean,
      default: true
    },
    // 是否在加载中
    isLoading: {
      type: Boolean,
      default: false
    },
    // 是否出错
    isError: {
      type: Boolean,
      default: false
    }
  }
});

/* script */
var __vue_script__$k = script$k;
/* template */

var __vue_render__$k = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('div', {
    staticClass: "bx-load"
  }, [_vm.hasMore && !_vm.isLoading && !_vm.isError ? _c('div', {
    staticClass: "bx-load-text"
  }, [_vm._v("\n      上拉加载更多\n    ")]) : _vm._e(), _vm.isLoading ? _c('div', {
    staticClass: "bx-load-text"
  }, [_vm._v("\n      加载中...\n    ")]) : _vm._e(), !_vm.hasMore ? _c('div', {
    staticClass: "bx-load-text"
  }, [_vm._v("\n      没有更多了\n    ")]) : _vm._e(), !_vm.isLoading && _vm.isError ? _c('div', {
    staticClass: "bx-load-text"
  }, [_vm._v("\n      加载失败，请上拉重试\n    ")]) : _vm._e()])]);
};

var __vue_staticRenderFns__$k = [];
/* style */

var __vue_inject_styles__$k = undefined;
/* scoped */

var __vue_scope_id__$k = undefined;
/* module identifier */

var __vue_module_identifier__$k = undefined;
/* functional template */

var __vue_is_functional_template__$k = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$k =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$k,
  staticRenderFns: __vue_staticRenderFns__$k
}, __vue_inject_styles__$k, __vue_script__$k, __vue_scope_id__$k, __vue_is_functional_template__$k, __vue_module_identifier__$k, false, undefined, undefined, undefined);

var script$l = create({
  name: 'loading',
  props: {
    size: {
      type: String,
      default: '19px'
    }
  },
  computed: {
    style: function style() {
      var size = this.size;
      var sizeValue;

      if (isNan$2(Number(size))) {
        sizeValue = size;
      } else {
        sizeValue = size + "px";
      }

      return {
        width: sizeValue,
        height: sizeValue
      };
    }
  }
});

/* script */
var __vue_script__$l = script$l;
/* template */

var __vue_render__$l = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "bx-loading",
    style: _vm.style
  }, [_c('span', {
    staticClass: "bx-loading-spinner"
  }, _vm._l(12, function (n) {
    return _c('i', {
      key: n,
      staticClass: "bx-loading-wire"
    });
  }))]);
};

var __vue_staticRenderFns__$l = [];
/* style */

var __vue_inject_styles__$l = undefined;
/* scoped */

var __vue_scope_id__$l = undefined;
/* module identifier */

var __vue_module_identifier__$l = undefined;
/* functional template */

var __vue_is_functional_template__$l = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$l =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$l,
  staticRenderFns: __vue_staticRenderFns__$l
}, __vue_inject_styles__$l, __vue_script__$l, __vue_scope_id__$l, __vue_is_functional_template__$l, __vue_module_identifier__$l, false, undefined, undefined, undefined);

var $every = arrayIteration.every;


// `Array.prototype.every` method
// https://tc39.github.io/ecma262/#sec-array.prototype.every
_export({ target: 'Array', proto: true, forced: sloppyArrayMethod('every') }, {
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var every = entryVirtual('Array').every;

var ArrayPrototype$e = Array.prototype;

var every_1 = function (it) {
  var own = it.every;
  return it === ArrayPrototype$e || (it instanceof Array && own === ArrayPrototype$e.every) ? every : own;
};

var every$1 = every_1;

var every$2 = every$1;

var _components$a;

var getName = function getName(value) {
  return value.substring(0, indexOf$4(value).call(value, '@'));
};

var getSuffix = function getSuffix(value) {
  return value.substring(indexOf$4(value).call(value, '@'));
};

var script$m = create({
  name: 'mail-input',
  filters: {
    filterEmailValue: function filterEmailValue(email) {
      if (indexOf$4(email).call(email, '@') > -1) {
        return getName(email);
      }

      return email;
    }
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    emailArr: {
      type: Array,
      default: function _default() {
        return ['@qq.com', '@163.com', '@126.com', '@139.com'];
      },
      validator: function validator(emails) {
        return every$2(emails).call(emails, function (email) {
          return typeof email === 'string' && /^@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(email);
        });
      }
    }
  },
  data: function data() {
    var _context;

    return {
      hintShow: false,
      isFocus: false,
      suffixList: concat$2(_context = []).call(_context, this.emailArr)
    };
  },
  computed: {
    currentValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit('input', val);
      }
    },
    showPopperHint: function showPopperHint() {
      return this.hintShow && this.isFocus && this.suffixList.length;
    }
  },
  watch: {
    currentValue: function currentValue(val) {
      var _context2, _context3;

      if (!val) {
        this.hintShow = false;
        return;
      }

      this.hintShow = true;
      var suffix = getSuffix(val);
      this.suffixList = indexOf$4(val).call(val, '@') > -1 ? filter$2(_context2 = this.emailArr).call(_context2, function (item) {
        return includes$4(item).call(item, suffix) && item.length > suffix.length;
      }) : concat$2(_context3 = []).call(_context3, this.emailArr);
    }
  },
  methods: {
    emitEvent: function emitEvent(eventName, args) {
      this.$emit(eventName, args);
    },
    clickItem: function clickItem(data) {
      var _context4;

      var index = indexOf$4(_context4 = this.currentValue).call(_context4, '@');

      var html = index > -1 ? getName(this.currentValue) + data : this.currentValue + data;
      this.currentValue = html;
      this.emitEvent('select', html);
      this.hintShow = false;
    },
    onFocus: function onFocus(event) {
      this.isFocus = true;
      this.emitEvent('focus', event);
    },
    onBlur: function onBlur(event) {
      this.isFocus = false;
      this.hintShow = false;
      this.emitEvent('blur', event);
    }
  },
  components: (_components$a = {}, _components$a[__vue_component__$a.name] = __vue_component__$a, _components$a)
});

var __vue_script__$m = script$m;
/* template */

var __vue_render__$m = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "bx-mail-input"
  }, [_c('bxs-input', _vm._b({
    ref: "input",
    on: {
      "focus": _vm.onFocus,
      "blur": _vm.onBlur,
      "clear": function clear($event) {
        _vm.emitEvent('clear');
      },
      "click-icon": function clickIcon($event) {
        _vm.emitEvent('click-icon');
      }
    },
    model: {
      value: _vm.currentValue,
      callback: function callback($$v) {
        _vm.currentValue = typeof $$v === 'string' ? trim$5($$v).call($$v) : $$v;
      },
      expression: "currentValue"
    }
  }, 'bxs-input', _vm.$attrs, false), [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showPopperHint,
      expression: "showPopperHint"
    }],
    ref: "popperHint",
    staticClass: "bx-popper-hint bx-hairline--surround",
    attrs: {
      "slot": "extra"
    },
    slot: "extra"
  }, [_c('div', {
    staticClass: "bx-popper-hint--wrap"
  }, [_c('div', {
    staticClass: "bx-popper-hint--left"
  }, _vm._l(_vm.suffixList, function (item, index) {
    return _c('div', {
      key: 'popper_' + index,
      staticClass: "bx-popper-hint-list bx-hairline--bottom",
      on: {
        "touchstart": function touchstart($event) {
          $event.preventDefault();

          _vm.clickItem(item);
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm._f("filterEmailValue")(_vm.value)) + "\n          ")]);
  })), _c('div', {
    staticClass: "bx-popper-hint--right"
  }, _vm._l(_vm.suffixList, function (item, index) {
    return _c('div', {
      key: 'popper_' + index,
      staticClass: "bx-popper-hint-list bx-hairline--bottom",
      on: {
        "touchstart": function touchstart($event) {
          $event.preventDefault();

          _vm.clickItem(item);
        }
      }
    }, [_vm._v("\n            " + _vm._s(item) + "\n          ")]);
  }))])])])], 1);
};

var __vue_staticRenderFns__$m = [];
/* style */

var __vue_inject_styles__$m = undefined;
/* scoped */

var __vue_scope_id__$m = undefined;
/* module identifier */

var __vue_module_identifier__$m = undefined;
/* functional template */

var __vue_is_functional_template__$m = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$m =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$m,
  staticRenderFns: __vue_staticRenderFns__$m
}, __vue_inject_styles__$m, __vue_script__$m, __vue_scope_id__$m, __vue_is_functional_template__$m, __vue_module_identifier__$m, false, undefined, undefined, undefined);

var onlyValues$3 = function onlyValues(values) {
  return function (str) {
    return indexOf$4(values).call(values, str) !== -1;
  };
};

var script$n = create({
  name: 'message-box',
  mixins: [Popup],
  props: {
    title: String,
    message: String,
    tips: String,
    className: [String, Object, Array],
    messageAlign: {
      type: String,
      default: 'center',
      validator: onlyValues$3(['left', 'right', 'center', 'justify'])
    },
    cancelButtonText: {
      type: String,
      default: '取消'
    },
    confirmButtonText: {
      type: String,
      default: '确定'
    },
    cancelButtonColor: {
      type: String,
      default: ''
    },
    confirmButtonColor: {
      type: String,
      default: ''
    },
    showCancel: {
      type: Boolean,
      default: true
    },
    showConfirm: {
      type: Boolean,
      default: true
    },
    closeOnClickOverlay: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    cancelButtonStyle: function cancelButtonStyle() {
      var style = {};

      if (this.cancelButtonColor) {
        style.color = this.cancelButtonColor;
      }

      return style;
    },
    confirmButtonStyle: function confirmButtonStyle() {
      var style = {};

      if (this.confirmButtonColor) {
        style.color = this.confirmButtonColor;
      }

      return style;
    }
  },
  methods: {
    handleAction: function handleAction(action) {
      var _this = this;

      this.$emit('before-close', action, function (state) {
        if (state !== false) {
          _this.closeModal(action);
        }
      });

      if (this.callback) {
        this.callback(action);
      }
    },
    closeModal: function closeModal(action) {
      this.$emit('input', false);
      this.$emit(action);
    }
  }
});

/* script */
var __vue_script__$n = script$n;
/* template */

var __vue_render__$n = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('transition', {
    attrs: {
      "name": "bx-animate-fade"
    }
  }, [_vm.value ? _c('div', {
    staticClass: "bx-modal",
    class: _vm.className
  }, [_c('div', {
    staticClass: "bx-modal-body"
  }, [_vm.title ? _c('div', {
    staticClass: "bx-modal-title"
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]) : _vm._e(), _vm._t("default", [_c('div', {
    staticClass: "bx-modal-content"
  }, [_c('div', {
    staticClass: "bx-modal-message",
    style: {
      'text-align': _vm.messageAlign
    },
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  }), _vm.tips ? _c('div', {
    staticClass: "bx-modal-tips"
  }, [_vm._v("\n            " + _vm._s(_vm.tips) + "\n          ")]) : _vm._e()])])], 2), _c('div', {
    staticClass: "bx-modal-footer bx-hairline--top"
  }, [_vm.showCancel ? _c('a', {
    staticClass: "bx-modal-btn bx-hairline--left",
    style: _vm.cancelButtonStyle,
    on: {
      "click": function click($event) {
        _vm.handleAction('cancel');
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.cancelButtonText) + "\n      ")]) : _vm._e(), _vm.showConfirm ? _c('a', {
    staticClass: "bx-modal-btn bx-modal-btn--highlight bx-hairline--left",
    style: _vm.confirmButtonStyle,
    on: {
      "click": function click($event) {
        _vm.handleAction('confirm');
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.confirmButtonText) + "\n      ")]) : _vm._e()])]) : _vm._e()]);
};

var __vue_staticRenderFns__$n = [];
/* style */

var __vue_inject_styles__$n = undefined;
/* scoped */

var __vue_scope_id__$n = undefined;
/* module identifier */

var __vue_module_identifier__$n = undefined;
/* functional template */

var __vue_is_functional_template__$n = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$n =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$n,
  staticRenderFns: __vue_staticRenderFns__$n
}, __vue_inject_styles__$n, __vue_script__$n, __vue_scope_id__$n, __vue_is_functional_template__$n, __vue_module_identifier__$n, false, undefined, undefined, undefined);

var defaults = {
  title: '',
  tips: '',
  message: '',
  className: '',
  type: 'dialog',
  messageAlign: 'center',
  cancelButtonText: '取消',
  confirmButtonText: '确定',
  cancelButtonColor: '',
  confirmButtonColor: '',
  showCancel: true,
  showConfirm: true,
  lockScroll: true,
  closeOnClickOverlay: false
};
var MessageBoxConstructor = Vue.extend(__vue_component__$n);
var currentMsg;
var instance$2;
var msgQueue = [];
/* eslint-disable no-use-before-define */

var defaultCallback = function defaultCallback(action) {
  if (currentMsg) {
    var _currentMsg = currentMsg,
        callback = _currentMsg.callback;

    if (typeof callback === 'function') {
      callback(action);
    }

    if (currentMsg.resolve) {
      var type = currentMsg.options.type;

      if (type === 'dialog') {
        currentMsg[action === 'confirm' ? 'resolve' : 'reject'](action);
      } else {
        currentMsg.resolve(action);
      }
    }

    MessageBox.close();
  }
};

var initInstance = function initInstance() {
  instance$2 = new MessageBoxConstructor({
    el: document.createElement('div')
  });
  instance$2.$on('input', function (value) {
    instance$2.value = value;
  });
  instance$2.callback = defaultCallback;
}; // 显示消息队列里的第一个消息


var showNextMsg = function showNextMsg() {
  if (!instance$2) {
    initInstance();
  }

  if (!instance$2.value) {
    if (msgQueue.length > 0) {
      currentMsg = msgQueue.shift();
      var _currentMsg2 = currentMsg,
          options = _currentMsg2.options;
      instance$2 = _extends(instance$2, options);

      if (options.callback === undefined) {
        instance$2.callback = defaultCallback;
      }

      document.body.appendChild(instance$2.$el);
      instance$2.value = true;
    }
  }
};
/* eslint-disable no-param-reassign */

/* eslint-disable prefer-rest-params */

/* eslint-disable prefer-destructuring */


var MessageBox = function MessageBox(options, callback) {
  if (typeof options === 'string') {
    options = {
      message: options
    };
  }

  if (options.callback && !callback) {
    callback = options.callback;
  }

  if (typeof promise$3 !== 'undefined') {
    return new promise$3(function (resolve, reject) {
      // eslint-disable-line
      msgQueue.push({
        options: _extends({}, defaults, MessageBox.defaults || {}, options),
        callback: callback,
        resolve: resolve,
        reject: reject
      });
      showNextMsg();
    });
  }

  msgQueue.push({
    options: _extends({}, defaults, MessageBox.defaults || {}, options),
    callback: callback
  });
  showNextMsg();
  return instance$2;
};

MessageBox.setDefaults = function (newDefaults) {
  MessageBox.defaults = newDefaults;
};

MessageBox.alert = function (message, title, tips, options) {
  if (typeof message === 'object') {
    options = message;
    message = '';
  }

  if (typeof title === 'object') {
    options = title;
    title = '';
  }

  if (typeof tips === 'object') {
    options = tips;
    tips = '';
  }

  return MessageBox(_extends({
    title: title,
    message: message,
    tips: tips,
    type: 'alert',
    showCancel: true,
    showConfirm: false,
    cancelButtonText: '知道了'
  }, options));
};

MessageBox.dialog = function (message, title, tips, options) {
  if (typeof message === 'object') {
    options = message;
    message = '';
  }

  if (typeof title === 'object') {
    options = title;
    title = '';
  }

  if (typeof tips === 'object') {
    options = tips;
    tips = '';
  }

  return MessageBox(_extends({
    title: title,
    message: message,
    tips: tips,
    type: 'dialog',
    showCancel: true,
    showConfirm: true
  }, options));
};

MessageBox.close = function () {
  if (!instance$2) return;
  instance$2.value = false;
  msgQueue = [];
  currentMsg = null;
};

MessageBox.install = function (vueGlobal) {
  vueGlobal.use(__vue_component__$n);
  vueGlobal.prototype.$messagebox = MessageBox;
};

var _components$b;
var script$o = create({
  name: 'pop-picker',
  props: {},
  data: function data() {
    return {
      isShow: false,
      title: '',
      showToolbar: true,
      pickerData: [],
      defaultValue: '',
      value: '',
      findValue: '',
      index: '',
      indexs: '',
      pickerObj: {},
      valueKey: 'text',
      isChange: false
    };
  },
  computed: {},
  methods: {
    cancel: function cancel() {
      this.isShow = false;
      this.$emit('cancel', false);
    },
    confirm: function confirm(pickerObj, value, index, indexs) {
      this.isShow = false;
      this.pickerObj = pickerObj;
      this.findValue = value;
      this.index = index;
      this.indexs = indexs;
      this.$emit('confirm', this.pickerObj, this.findValue, this.index, this.indexs);
    },
    sure: function sure() {
      if (!this.isChange) {
        this.$refs.bxsPicker.confirm();
        return;
      }

      this.isShow = false;
      this.$emit('confirm', this.pickerObj, this.findValue, this.index, this.indexs);
    },
    change: function change(pickerObj, value, index, indexs) {
      this.isChange = true;
      this.pickerObj = pickerObj;
      this.findValue = value;
      this.index = index;
      this.indexs = indexs;
      this.$emit('change', pickerObj, value, index, indexs);
    }
  },
  watch: {
    value: function value(n) {
      this.$emit('input', n);
    }
  },
  components: (_components$b = {}, _components$b[__vue_component__$d.name] = __vue_component__$d, _components$b[__vue_component__$2.name] = __vue_component__$2, _components$b)
});

/* script */
var __vue_script__$o = script$o;
/* template */

var __vue_render__$o = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('bxs-bottom-sheets', {
    attrs: {
      "prevent-scroll-through": true
    },
    on: {
      "after-leave": function afterLeave($event) {
        _vm.$emit('after-leave');
      }
    },
    model: {
      value: _vm.isShow,
      callback: function callback($$v) {
        _vm.isShow = $$v;
      },
      expression: "isShow"
    }
  }, [_c('div', {
    staticClass: "bx-picker-sheets-header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm.showToolbar ? _c('div', {
    staticClass: "bx-picker-header bx-hairline--bottom"
  }, [_c('p', {
    staticClass: "bx-picker-cancel",
    on: {
      "click": function click($event) {
        _vm.cancel();
      }
    }
  }, [_vm._v("\n        取消\n      ")]), _c('p', {
    staticClass: "bx-picker-title"
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]), _c('p', {
    staticClass: "bx-picker-sure",
    on: {
      "click": function click($event) {
        _vm.sure();
      }
    }
  }, [_vm._v("\n        确定\n      ")])]) : _vm._e()]), _c('bxs-picker', {
    ref: "bxsPicker",
    attrs: {
      "picker-data": _vm.pickerData,
      "value": _vm.defaultValue,
      "value-key": _vm.valueKey
    },
    on: {
      "change": _vm.change,
      "confirm": _vm.confirm
    }
  })], 1);
};

var __vue_staticRenderFns__$o = [];
/* style */

var __vue_inject_styles__$o = undefined;
/* scoped */

var __vue_scope_id__$o = undefined;
/* module identifier */

var __vue_module_identifier__$o = undefined;
/* functional template */

var __vue_is_functional_template__$o = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$o =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$o,
  staticRenderFns: __vue_staticRenderFns__$o
}, __vue_inject_styles__$o, __vue_script__$o, __vue_scope_id__$o, __vue_is_functional_template__$o, __vue_module_identifier__$o, false, undefined, undefined, undefined);

var PickerConstructor = Vue.extend(__vue_component__$o);
var instance$3;

var getAnInstance = function getAnInstance() {
  return new PickerConstructor({
    el: document.createElement('div')
  });
};

var getMerge = function getMerge(target, src) {
  var _context;

  var result = _extends({}, target);

  forEach$2(_context = keys$6(target)).call(_context, function (key) {
    if (Object.prototype.hasOwnProperty.call(target, key) && src[key]) {
      result[key] = src[key];
    }
  });

  return result;
};

function Picker(options) {
  instance$3 = getAnInstance();
  var opt = {
    value: [''],
    title: '',
    defaultValue: [''],
    valueKey: 'text',
    pickerData: [],
    callback: function callback() {},
    isShow: false,
    showToolbar: true,
    index: 0
  };
  opt = getMerge(opt, _extends({}, options));

  _extends(instance$3, _extends({}, opt));

  instance$3.$on('confirm', function (picker, value, index, indexs) {
    if (typeof options.callback === 'function') {
      options.callback({
        type: 'confirm',
        picker: picker,
        value: value,
        index: index,
        indexs: indexs
      });
    }

    instance$3.$on('after-leave', function () {
      return instance$3.$destroy();
    });
  });
  instance$3.$on('change', function (picker, value, index) {
    if (typeof options.callback === 'function') {
      options.callback({
        type: 'change',
        picker: picker,
        value: value,
        index: index
      });
    }
  });
  instance$3.$on('input', function (value) {
    instance$3.value = value;
  });

  if (typeof options === 'string') {
    instance$3.title = options;
  }

  getContainer(options.appendTo).appendChild(instance$3.$el);
  instance$3.isShow = false;
  Vue.nextTick(function () {
    instance$3.isShow = true;
    instance$3.showToolbar = true;

    if (options.pickerData) {
      instance$3.index = options.index ? options.index : 0;
      instance$3.defaultValue = options.defaultValue ? options.defaultValue : [options.pickerData[instance$3.index]];
    }
  });
  return instance$3;
}

Picker.install = function (vueGlobal) {
  var vueGlobalObj = vueGlobal;
  vueGlobalObj.use(__vue_component__$d);
  vueGlobalObj.use(__vue_component__$o);
  vueGlobalObj.prototype.$picker = Picker;
};

var onlyValues$4 = function onlyValues(values) {
  return function (str) {
    return indexOf$4(values).call(values, str) !== -1;
  };
};

var script$p = create({
  name: 'popup',
  mixins: [Popup],
  props: {
    position: {
      type: String,
      default: 'middle',
      validator: onlyValues$4(['top', 'left', 'bottom', 'right', 'middle'])
    },
    transition: String
  },
  computed: {
    currentTransition: function currentTransition() {
      var transitionName = this.transition;

      if (!transitionName) {
        transitionName = this.position === 'middle' ? 'bx-animate-fade' : "bx-popup-slide--" + this.position;
      }

      return transitionName;
    },
    currentClass: function currentClass() {
      return "bx-popup--" + this.position;
    }
  }
});

/* script */
var __vue_script__$p = script$p;
/* template */

var __vue_render__$p = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('transition', {
    attrs: {
      "name": _vm.currentTransition
    }
  }, [_vm.value ? _c('div', {
    staticClass: "bx-popup",
    class: _vm.currentClass
  }, [_vm._t("default")], 2) : _vm._e()]);
};

var __vue_staticRenderFns__$p = [];
/* style */

var __vue_inject_styles__$p = undefined;
/* scoped */

var __vue_scope_id__$p = undefined;
/* module identifier */

var __vue_module_identifier__$p = undefined;
/* functional template */

var __vue_is_functional_template__$p = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$p =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$p,
  staticRenderFns: __vue_staticRenderFns__$p
}, __vue_inject_styles__$p, __vue_script__$p, __vue_scope_id__$p, __vue_is_functional_template__$p, __vue_module_identifier__$p, false, undefined, undefined, undefined);

// `thisNumberValue` abstract operation
// https://tc39.github.io/ecma262/#sec-thisnumbervalue
var thisNumberValue = function (value) {
  if (typeof value != 'number' && classofRaw$1(value) != 'Number') {
    throw TypeError('Incorrect invocation');
  }
  return +value;
};

// `String.prototype.repeat` method implementation
// https://tc39.github.io/ecma262/#sec-string.prototype.repeat
var stringRepeat = ''.repeat || function repeat(count) {
  var str = String(requireObjectCoercible$1(this));
  var result = '';
  var n = toInteger$1(count);
  if (n < 0 || n == Infinity) throw RangeError('Wrong number of repetitions');
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
  return result;
};

var nativeToFixed = 1.0.toFixed;
var floor$3 = Math.floor;

var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};

var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

var FORCED$7 = nativeToFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !fails$1(function () {
  // V8 ~ Android 4.3-
  nativeToFixed.call({});
});

// `Number.prototype.toFixed` method
// https://tc39.github.io/ecma262/#sec-number.prototype.tofixed
_export$1({ target: 'Number', proto: true, forced: FORCED$7 }, {
  // eslint-disable-next-line max-statements
  toFixed: function toFixed(fractionDigits) {
    var number = thisNumberValue(this);
    var fractDigits = toInteger$1(fractionDigits);
    var data = [0, 0, 0, 0, 0, 0];
    var sign = '';
    var result = '0';
    var e, z, j, k;

    var multiply = function (n, c) {
      var index = -1;
      var c2 = c;
      while (++index < 6) {
        c2 += n * data[index];
        data[index] = c2 % 1e7;
        c2 = floor$3(c2 / 1e7);
      }
    };

    var divide = function (n) {
      var index = 6;
      var c = 0;
      while (--index >= 0) {
        c += data[index];
        data[index] = floor$3(c / n);
        c = (c % n) * 1e7;
      }
    };

    var dataToString = function () {
      var index = 6;
      var s = '';
      while (--index >= 0) {
        if (s !== '' || index === 0 || data[index] !== 0) {
          var t = String(data[index]);
          s = s === '' ? t : s + stringRepeat.call('0', 7 - t.length) + t;
        }
      } return s;
    };

    if (fractDigits < 0 || fractDigits > 20) throw RangeError('Incorrect fraction digits');
    // eslint-disable-next-line no-self-compare
    if (number != number) return 'NaN';
    if (number <= -1e21 || number >= 1e21) return String(number);
    if (number < 0) {
      sign = '-';
      number = -number;
    }
    if (number > 1e-21) {
      e = log(number * pow(2, 69, 1)) - 69;
      z = e < 0 ? number * pow(2, -e, 1) : number / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = fractDigits;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        result = dataToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        result = dataToString() + stringRepeat.call('0', fractDigits);
      }
    }
    if (fractDigits > 0) {
      k = result.length;
      result = sign + (k <= fractDigits
        ? '0.' + stringRepeat.call('0', fractDigits - k) + result
        : result.slice(0, k - fractDigits) + '.' + result.slice(k - fractDigits));
    } else {
      result = sign + result;
    } return result;
  }
});

var quot = /"/g;

// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
// https://tc39.github.io/ecma262/#sec-createhtml
var createHtml = function (string, tag, attribute, value) {
  var S = String(requireObjectCoercible$1(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
var forcedStringHtmlMethod = function (METHOD_NAME) {
  return fails$1(function () {
    var test = ''[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
};

// `String.prototype.fontsize` method
// https://tc39.github.io/ecma262/#sec-string.prototype.fontsize
_export$1({ target: 'String', proto: true, forced: forcedStringHtmlMethod('fontsize') }, {
  fontsize: function fontsize(size) {
    return createHtml(this, 'font', 'size', size);
  }
});

var script$q = create({
  name: 'price',
  props: {
    // 价格数额
    price: {
      default: '0'
    },
    // 价格后缀单位
    suffix: {
      type: String,
      default: '元'
    },
    // 价格类型，默认1:1
    type: {
      type: String,
      default: 'normal'
    },
    // 是否精确到小数点后两位显示
    precise: {
      type: Boolean,
      default: true
    },
    // 价格前缀
    prefix: {
      type: String,
      default: ''
    },
    // 字体大小
    fontsize: {
      type: String,
      default: '20'
    },
    // 颜色
    color: {
      type: String,
      default: ''
    },
    // 删除线
    deleted: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    priceText: function priceText() {
      var val = _parseFloat$3(this.price) || 0;
      return this.toFixed(val);
    },
    priceTextFront: function priceTextFront() {
      return this.prefix + this.priceText.split('.')[0];
    },
    priceTextEnd: function priceTextEnd() {
      var val = this.precise ? "." + (this.priceText.split('.')[1] || '00') : '';
      return val + this.suffix;
    },
    fontStyle: function fontStyle() {
      var size = isNan$2(Number(this.fontsize)) ? this.fontsize : this.fontsize + "px";
      var color = this.deleted ? '' : this.color;
      return {
        'font-size': size,
        color: color
      };
    },
    frontFontStyle: function frontFontStyle() {
      if (this.type === 'big') {
        var size = _parseFloat$3(this.fontsize) * 2;
        var fontsize = isNan$2(Number(this.fontsize)) ? size + this.fontsize.replace(/[0-9.]/g, '') : this.fontsize * 2 + "px";
        return {
          'font-size': fontsize
        };
      }

      return '';
    }
  },
  methods: {
    toFixed: function toFixed(value, decimal) {
      if (decimal === void 0) {
        decimal = 2;
      }

      // 四舍五入
      var symbol = value < 0 ? -1 : 1;
      /* eslint-disable */

      var times = Math.pow(10, decimal);
      /* eslint-enable */

      var des = symbol * value * times + 0.5;
      des = symbol * _parseInt$3(des, 10) / times;
      des = des.toFixed(decimal);
      return des;
    }
  }
});

/* script */
var __vue_script__$q = script$q;
/* template */

var __vue_render__$q = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: ['bx-price', {
      'bx-price--deleted': _vm.deleted
    }],
    style: _vm.fontStyle
  }, [_c('span', {
    style: _vm.frontFontStyle
  }, [_vm._v(_vm._s(_vm.priceTextFront))]), _c('span', [_vm._v(_vm._s(_vm.priceTextEnd))])]);
};

var __vue_staticRenderFns__$q = [];
/* style */

var __vue_inject_styles__$q = undefined;
/* scoped */

var __vue_scope_id__$q = undefined;
/* module identifier */

var __vue_module_identifier__$q = undefined;
/* functional template */

var __vue_is_functional_template__$q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$q =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$q,
  staticRenderFns: __vue_staticRenderFns__$q
}, __vue_inject_styles__$q, __vue_script__$q, __vue_scope_id__$q, __vue_is_functional_template__$q, __vue_module_identifier__$q, false, undefined, undefined, undefined);

// `SameValue` abstract operation
// https://tc39.github.io/ecma262/#sec-samevalue
var sameValue = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

// @@search logic
fixRegexpWellKnownSymbolLogic('search', 1, function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible$1(this);
      var searcher = regexp == undefined ? undefined : regexp[SEARCH];
      return searcher !== undefined ? searcher.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative(nativeSearch, regexp, this);
      if (res.done) return res.value;

      var rx = anObject$1(regexp);
      var S = String(this);

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regexpExecAbstract(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});

var _components$c;
var script$r = create({
  name: 'search',
  props: {
    placeholder: {
      type: String,
      default: '请输入搜索关键字'
    },
    showAction: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    background: {
      type: String,
      default: '#f2f2f2'
    },
    history: {
      type: String
    },
    value: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      attachModuleShow: false,
      historyList: null,
      vl: ''
    };
  },
  components: (_components$c = {}, _components$c[__vue_component__$1.name] = __vue_component__$1, _components$c),
  watch: {
    value: function value(a) {
      if (typeof a !== 'undefined') {
        this.vl = a;
      }
    }
  },
  computed: {
    listeners: function listeners() {
      var _context;

      var self = this;

      var listeners = _extends({}, this.$listeners, {
        keypress: self.keypress,
        input: self.input,
        clear: self.clear,
        focus: self.focus
      });

      var searchListeners = {};

      forEach$2(_context = keys$6(listeners)).call(_context, function (attr) {
        searchListeners[attr] = function (ev) {
          if (self[attr] && typeof self[attr] === 'function') {
            self[attr](ev);
          } else {
            self.doFn(attr);
          }
        };
      });

      return self.disabled ? {} : searchListeners;
    },
    attachModuleDeploy: function attachModuleDeploy() {
      return typeof this.history !== 'undefined';
    },
    historyTag: function historyTag() {
      return this.history ? this.history : 'common';
    }
  },
  methods: {
    doFn: function doFn(str, v) {
      if (this.disabled) {
        return;
      }

      if (v) {
        this.$emit(str, v);
      } else {
        this.$emit(str);
      }
    },
    clear: function clear() {
      this.vl = this.disabled ? this.vl : '';
      this.doFn('clear');
    },
    search: function search() {
      this.doFn('search');
      this.close();
      if (this.attachModuleDeploy) this.addHistory();
    },
    goSearch: function goSearch(str) {
      this.vl = str;
      this.input();
      this.search();
    },
    cancel: function cancel() {
      this.vl = this.disabled ? this.vl : '';
      this.doFn('cancel');
      this.close();
    },
    focus: function focus() {
      var self = this;

      if (!this.attachModuleShow) {
        this.doFn('open');
      }

      if (this.attachModuleDeploy) {
        this.attachModuleShow = true;
        this.getHistoryLocal(true);
        this.$nextTick(function () {
          self.$refs.attachModule.focus();
        });
      }
    },
    input: function input() {
      this.doFn('input', this.vl);
    },
    keypress: function keypress(event) {
      if (event && (event.keyCode === 13 || event.code === 'Enter') && !this.disabled) {
        event.preventDefault();
        this.search();
      }

      this.doFn('keypress', event);
    },
    getHistoryLocal: function getHistoryLocal(b) {
      var self = this;
      var type = self.historyTag;
      var historyLocal;

      try {
        historyLocal = JSON.parse(window.localStorage.bxsSearchHis);
        historyLocal = typeof historyLocal !== 'object' ? {} : historyLocal;
      } catch (e) {
        historyLocal = {};
      }

      if (b) {
        if (historyLocal[type] && historyLocal[type] instanceof Array) {
          self.historyList = historyLocal[type];
        } else {
          self.historyList = [];
        }
      }

      return historyLocal;
    },
    close: function close() {
      if (this.attachModuleShow) {
        this.attachModuleShow = false;
        this.doFn('close');
      }
    },
    addHistory: function addHistory(b) {
      var _context2;

      if (b) {
        this.close();
      }

      if (!trim$5(_context2 = this.vl).call(_context2)) {
        return;
      }

      var historyLocal = this.getHistoryLocal();
      var type = this.historyTag;
      var arr = historyLocal[type] ? historyLocal[type] : [];
      arr = arr instanceof Array ? arr : [];
      arr.unshift(this.vl);
      arr = splice$2(arr).call(arr, 0, 4);
      this.historyList = arr;
      historyLocal[type] = arr;
      window.localStorage.bxsSearchHis = stringify$2(historyLocal);
    },
    clearHistory: function clearHistory(n) {
      var history = this.historyList;

      if (typeof n !== 'undefined' && history[n]) {
        splice$2(history).call(history, n, 1);
      } else if (typeof n === 'undefined') {
        this.historyList = null;
      }

      var historyLocal = this.getHistoryLocal();
      var type = this.historyTag;
      historyLocal[type] = this.historyList && this.historyList.length ? this.historyList : null;
      window.localStorage.bxsSearchHis = stringify$2(historyLocal);
    }
  },
  created: function created() {
    this.vl = this.value;
  }
});

var __vue_script__$r = script$r;
/* template */

var __vue_render__$r = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('section', [_c('section', {
    staticClass: "bx-search"
  }, [_c('div', {
    class: ['bx-search-box', _vm.showAction ? 'bx-search-box--with-action' : ''],
    style: "background:" + _vm.background
  }, [_c('p', {
    staticClass: "bx-search-icon",
    on: {
      "click": _vm.search
    }
  }, [_c('bxs-icon', {
    attrs: {
      "name": "search",
      "size": "18px"
    }
  })], 1), _c('p', {
    staticClass: "bx-search-form"
  }, [_c('input', _vm._g({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.vl,
      expression: "vl"
    }],
    staticClass: "bx-search-input",
    attrs: {
      "disabled": _vm.disabled,
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.vl
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) {
          return;
        }

        _vm.vl = $event.target.value;
      }
    }
  }, _vm.listeners))]), !!_vm.vl ? _c('p', {
    staticClass: "bx-search-clear",
    on: {
      "click": _vm.clear
    }
  }, [_c('bxs-icon', {
    attrs: {
      "name": "close-solid",
      "size": "18px"
    }
  })], 1) : _vm._e()]), _vm.showAction ? _c('div', {
    staticClass: "bx-search-action"
  }, [_vm._t("action", [_c('div', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("\n          取消\n        ")])], {
    addHistory: _vm.addHistory
  })], 2) : _vm._e()]), _vm.attachModuleShow ? _c('div', {
    staticClass: "bx-search-suggestion-overlay"
  }, [_c('section', {
    staticClass: "bx-search"
  }, [_c('div', {
    class: ['bx-search-box', _vm.showAction ? 'bx-search-box--with-action' : ''],
    style: "background:" + _vm.background
  }, [_c('p', {
    staticClass: "bx-search-icon",
    on: {
      "click": _vm.search
    }
  }, [_c('bxs-icon', {
    attrs: {
      "name": "search",
      "size": "18px"
    }
  })], 1), _c('p', {
    staticClass: "bx-search-form"
  }, [_c('input', _vm._g({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.vl,
      expression: "vl"
    }],
    ref: "attachModule",
    staticClass: "bx-search-input",
    attrs: {
      "disabled": _vm.disabled,
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.vl
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) {
          return;
        }

        _vm.vl = $event.target.value;
      }
    }
  }, _vm.listeners))]), !!_vm.vl ? _c('p', {
    staticClass: "bx-search-clear",
    on: {
      "click": _vm.clear
    }
  }, [_c('bxs-icon', {
    attrs: {
      "name": "close-solid",
      "size": "18px"
    }
  })], 1) : _vm._e()]), _vm.showAction ? _c('div', {
    staticClass: "bx-search-action"
  }, [_vm._t("action", [_c('div', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("\n            取消\n          ")])], {
    addHistory: _vm.addHistory
  })], 2) : _vm._e()]), _vm.historyList && _vm.historyList.length ? _c('div', {
    staticClass: "bx-search-block"
  }, [_c('p', {
    staticClass: "bx-search-block-title"
  }, [_vm._v("\n        搜索历史\n      ")]), _c('ul', {
    staticClass: "bx-search-history"
  }, _vm._l(_vm.historyList, function (item, index) {
    return _c('li', {
      key: index,
      staticClass: "bx-search-history-one"
    }, [_c('bxs-icon', {
      attrs: {
        "name": "clock"
      }
    }), _c('em', {
      staticClass: "bx-search-history-text",
      on: {
        "click": function click($event) {
          _vm.goSearch(item);
        }
      }
    }, [_vm._v("\n            " + _vm._s(item) + "\n          ")]), _c('p', {
      staticClass: "bx-search-history-close",
      on: {
        "click": function click($event) {
          _vm.clearHistory(index);
        }
      }
    }, [_c('bxs-icon', {
      attrs: {
        "name": "close"
      }
    })], 1)], 1);
  })), _c('p', {
    staticClass: "bx-search-history-clear",
    on: {
      "click": function click($event) {
        _vm.clearHistory();
      }
    }
  }, [_vm._v("\n        清除搜索历史\n      ")])]) : _vm._e()]) : _vm._e()]);
};

var __vue_staticRenderFns__$r = [];
/* style */

var __vue_inject_styles__$r = undefined;
/* scoped */

var __vue_scope_id__$r = undefined;
/* module identifier */

var __vue_module_identifier__$r = undefined;
/* functional template */

var __vue_is_functional_template__$r = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$r =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$r,
  staticRenderFns: __vue_staticRenderFns__$r
}, __vue_inject_styles__$r, __vue_script__$r, __vue_scope_id__$r, __vue_is_functional_template__$r, __vue_module_identifier__$r, false, undefined, undefined, undefined);

var defaultRequestParams = {
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 15000,
  withCredentials: true,
  async: true,
  params: undefined,
  method: 'GET'
};
function requestAjax(url, config) {
  return new promise$3(function (resolve, reject) {
    var params = _extends({}, defaultRequestParams, config);

    var xhr = new XMLHttpRequest();
    xhr.timeout = params.timeout;
    if (params.withCredentials) xhr.withCredentials = true;
    xhr.open(params.method, url, params.async);

    if (typeof params.headers === 'object' && params.headers !== null) {
      var _context;

      forEach$2(_context = keys$6(params.headers)).call(_context, function (key) {
        xhr.setRequestHeader(key, params.headers[key]);
      });
    }

    xhr.onerror = function (event) {
      return reject(event);
    };

    xhr.onabort = function (event) {
      return reject(event);
    };

    xhr.ontimeout = function (event) {
      return reject(event);
    };

    xhr.onload = function (e) {
      if (e.currentTarget.status === 200) {
        try {
          var res = JSON.parse(xhr.responseText);
          if (res.success || +res.code === 200) resolve(res);
          reject(new Error(res.msg || res.info || res.message || '请求出错, 请重试'));
        } catch (error) {
          reject(error);
        }
      } else {
        reject(e);
      }
    };

    xhr.send(params.params || null);
  });
}

var _components$d;

function asyncColumnsParamsValidator(ov) {
  var postParams = ov.postParams,
      urlParams = ov.urlParams; // 校验 postParams 和 urlParams

  return postParams && postParams.productId && urlParams && urlParams.userUuid;
}

var script$s = create({
  name: 'profession-list',
  components: (_components$d = {}, _components$d[__vue_component__$r.name] = __vue_component__$r, _components$d[DefaultPage.view.name] = DefaultPage.view, _components$d[__vue_component__$1.name] = __vue_component__$1, _components$d),
  mixins: [Popup],
  data: function data() {
    return {
      totalLevels: 1,
      // 判断数据层级，共有几层筛选逻辑，默认1层
      isLeafLevel: false,
      // 最后一层
      isComplaint: false,
      // 是否符合
      selected: [],
      // 历史选择项
      // 当前项信息
      currSelect: {},
      // 当前选择项
      professionType: '',
      // 当前职业类别
      professionObj: null,
      // 当前项列表值
      // 搜索相关项
      isShowSearch: false,
      // 搜索开关
      searchValue: '',
      // 搜索key
      searchs: [],
      // 搜索数据源
      menuList: [{
        des: '一级'
      }],
      // tab数据
      digit: ['一级', '二级', '三级', '四级', '五级', '六级', '七级', '八级', '九级', '十级'],
      // 转大写字典
      listStyle: '',
      searchListStyle: '',
      parentId: '',
      // asyncColumns 为true时使用，标识职业类别的父级id
      professionList: [],
      // template中渲染的职业列表集合，兼容同步和异步数据设置的中间变量
      baseDevUrl: 'https://insurance2a-api.wyins.net.cn/api/product/data/getProfession?',
      baseProUrl: 'https://insurance2a-api.wyins.net/api/product/data/getProfession?',
      isDevelop: null
    };
  },
  props: {
    // 当前数据结构取职业类型的字段key - 预留字段
    // professTypeKey: {
    //   type: String,
    //   default: 'val',
    // },
    asyncColumnsParams: {
      type: Object,
      validator: asyncColumnsParamsValidator
    },
    // 检索key
    childrenKeyName: {
      type: String,
      default: 'children'
    },
    // 职业列表集
    columns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 初始化值
    initialSelection: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    // 校验函数
    verifyProfess: {
      type: Function,
      default: function _default() {
        return true;
      }
    },
    // 只读属性
    readonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    selectedStr: function selectedStr() {
      var str = '';

      if (this.asyncColumns && this.selected && this.selected.length) {
        var _context;

        str = reduce$2(_context = this.selected).call(_context, function (preVal, currVal, idx) {
          return "" + preVal + (currVal.name && idx > 0 ? '-' : '') + currVal.name;
        }, '');
      } else {
        var _context2;

        str = reduce$2(_context2 = this.selected).call(_context2, function (preVal, currVal, idx) {
          return "" + preVal + (currVal.des && idx > 0 ? '-' : '') + currVal.des;
        }, '');
      }

      return str;
    },
    asyncColumns: function asyncColumns() {
      return !!this.asyncColumnsParams;
    }
  },
  created: function created() {
    this.setIsDevelop();
  },
  methods: {
    setIsDevelop: function setIsDevelop() {
      if (window.location.port) {
        this.isDevelop = true;
      } else {
        this.isDevelop = false;
      }

      if (this.asyncColumnsParams && (this.asyncColumnsParams.isDev === true || this.asyncColumnsParams.isDev === false)) {
        this.isDevelop = this.asyncColumnsParams.isDev;
      }
    },
    getUrl: function getUrl() {
      var _context3,
          _this = this;

      var baseUrl = this.isDevelop ? this.baseDevUrl : this.baseProUrl;

      forEach$2(_context3 = keys$6(this.asyncColumnsParams.urlParams)).call(_context3, function (key) {
        baseUrl += key + "=" + _this.asyncColumnsParams.urlParams[key] + "&";
      });

      return slice$2(baseUrl).call(baseUrl, 0, baseUrl.length - 1);
    },
    getPostParams: function getPostParams() {
      return JSON.parse(stringify$2(this.asyncColumnsParams.postParams));
    },
    // 格式化数据
    formatColumn: function formatColumn(data) {
      if (!data || data.length === 0) {
        return [];
      }

      return map$2(data).call(data, function (item) {
        if (item.category) {
          return _extends({}, item, {
            des: item.name,
            val: item.category
          });
        }

        return _extends({}, item, {
          des: item.name
        });
      });
    },
    // 异步获取职业
    getProfession: function getProfession() {
      var _this2 = this;

      var url = this.getUrl();
      var params = this.getPostParams(); // 检索下级

      if (this.parentId && !this.searchValue) {
        params.parentId = this.parentId;
      } // 检索关键字


      if (this.searchValue) {
        params.searchKey = this.searchValue;
      }

      var config = {
        method: 'POST',
        params: stringify$2(params)
      };
      return requestAjax(url, config).then(function (response) {
        return response && _this2.formatColumn(response.data);
      }).catch(function (error) {
        _this2.$toast('职业类别数据获取失败');

        console.log('职业类别请求API报错:', error);
      });
    },
    // 动态样式计算
    calculateListStyle: function calculateListStyle() {
      if (this.$refs.bxContainerHead) this.listStyle = {
        height: window.innerHeight - this.$refs.bxContainerHead.offsetHeight + "px"
      };
    },
    // 选择层级
    onClickMenu: function onClickMenu(idx) {
      var vm = this;

      if (vm.selected.length > idx) {
        vm.isLeafLevel = false;
        vm.isComplaint = false;

        if (vm.selected.length !== vm.menuList.length) {
          var _context4;

          vm.selected = slice$2(_context4 = vm.selected).call(_context4, 0, idx + 1 - vm.totalLevels);
        } else {
          var _context5;

          vm.selected = slice$2(_context5 = vm.selected).call(_context5, 0, idx - vm.totalLevels);
        }

        vm.professionObj = vm.selected.length > 0 ? vm.selected[vm.selected.length - 1][vm.childrenKeyName] : vm.professionList;
      }
    },
    // 职业选择功能实现
    professionChoose: function professionChoose(val) {
      var vm = this;
      vm.currSelect = val;
      vm.professionAddSelected(val);

      if (!val.code) {
        if (vm.asyncColumns) {
          vm.parentId = val.id;
          vm.getProfession().then(function (res) {
            vm.$set(vm.currSelect, vm.childrenKeyName, res);
            vm.professionObj = res;
          });
        } else {
          vm.professionObj = val[vm.childrenKeyName];
        }
      } else if (vm.verifyProfess(vm.currSelect)) {
        // 最后一级职业-符合条件
        vm.isLeafLevel = true;
        vm.isComplaint = true;
        vm.professionType = vm.asyncColumns ? val.category : val.val;

        if (!vm.readonly) {
          vm.$emit('select', vm.selected[vm.selected.length - 1]);
          vm.closeMe();
        }
      } else {
        // 最后一级职业-不符合条件
        vm.isLeafLevel = true;
        vm.isComplaint = false;
        vm.professionType = vm.asyncColumns ? val.category : val.val;
      }
    },
    professionAddSelected: function professionAddSelected(val) {
      var _context6;

      var vm = this;

      if (this.asyncColumns) {
        if (!vm.selected.length) {
          vm.selected.push(val);
        } else {
          var lastItem = vm.selected[vm.selected.length - 1];

          if (lastItem.category) {
            vm.selected.pop();
            vm.selected.push(val);
          } else {
            vm.selected.push(val);
          }
        }

        return;
      } // selected为0，或者 selected最后一项子项不包含当前项


      if (!vm.selected.length || vm.selected.length < vm.totalLevels && some$2(_context6 = vm.selected[vm.selected.length - 1][vm.childrenKeyName]).call(_context6, function (item) {
        return item.des === val.des;
      })) {
        vm.selected.push(val);
      } else {
        vm.selected.pop();
        vm.selected.push(val);
      }
    },
    back: function back() {
      var vm = this;
      vm.isLeafLevel = false;

      if (vm.selected && vm.selected.length && vm.selected.length > 0) {
        vm.selected.pop();
        vm.professionObj = vm.selected.length > 0 ? vm.selected[vm.selected.length - 1][vm.childrenKeyName] : vm.professionList;
      } else {
        vm.closeMe();
      }
    },
    closeMe: function closeMe() {
      this.$emit('input', false);
    },
    enter: function enter() {
      var _this3 = this;

      if (this.asyncColumns) {
        this.getProfession().then(function (res) {
          _this3.professionList = res;
          _this3.totalLevels = 1;
          _this3.professionObj = _this3.professionList;
        });
      } else {
        this.professionList = this.columns;
        this.totalLevels = 1;
        var targetObj = this.professionList;

        while (targetObj[0] && targetObj[0][this.childrenKeyName] && typeof targetObj[0][this.childrenKeyName] === 'object') {
          this.totalLevels += 1;

          if (targetObj[0] && targetObj[0][this.childrenKeyName]) {
            targetObj = targetObj[0][this.childrenKeyName];
          }
        }

        if (this.initialSelection && this.initPreProfession(this.initialSelection)) {
          // 存在默认值
          this.professionObj = this.selected[this.selected.length - 2][this.childrenKeyName];
        } else {
          // 初始化
          this.professionObj = this.professionList;
        }
      }

      this.calculateListStyle();
    },
    beforeLeave: function beforeLeave() {
      var vm = this;
      vm.isLeafLevel = false;
      vm.isComplaint = false;
      vm.selected = [];
      vm.professionType = '';

      if (this.asyncColumns) {
        this.parentId = '';
      }
    },
    // 搜索功能实现
    enterSearchPage: function enterSearchPage() {
      if (!this.searchListStyle && this.$refs.bxSearchBar) {
        this.searchListStyle = {
          height: window.innerHeight - this.$refs.bxSearchBar.offsetHeight + "px"
        };
      }
    },
    searchShow: function searchShow() {
      this.isShowSearch = true;
    },
    getAllNames: function getAllNames(item, arr) {
      if (!item.parent) {
        arr.unshift(item);
        return arr;
      }

      arr.unshift(item);
      return this.getAllNames(item.parent, arr);
    },
    search: function search() {
      var _this4 = this;

      var vm = this;

      if (this.asyncColumns) {
        this.getProfession().then(function (res) {
          vm.searchs = [];

          forEach$2(res).call(res, function (item) {
            var _context7;

            var temp = {};
            temp.des = item.name;
            temp.code = item.code;
            temp.val = item.category;
            temp.category = item.category;

            var oa = map$2(_context7 = _this4.getAllNames(item, [])).call(_context7, function (it) {
              return it.name;
            });

            temp.name = oa.join('-');

            if (vm.verifyProfess(temp)) {
              temp.flag = 1;
            } else {
              temp.flag = 0;
            }

            vm.searchs.push(temp);
          });
        });
      } else {
        vm.searchs = [];
        var result = vm.treeTranArray(vm.professionList, '', []);

        forEach$2(result).call(result, function (item) {
          var _context8;

          if (indexOf$4(_context8 = item.des).call(_context8, vm.searchValue) !== -1) {
            var temp = {};
            var desArr = item.des.split('-');
            temp.des = desArr[desArr.length - 1];
            temp.code = item.code;
            temp.val = item.val;
            temp.name = item.des;

            if (vm.verifyProfess(temp)) {
              temp.flag = 1;
            } else {
              temp.flag = 0;
            }

            vm.searchs.push(temp);
          }
        });
      }
    },
    searchCancel: function searchCancel() {
      this.isShowSearch = false;
      this.searchClear();
    },
    searchClear: function searchClear() {
      this.searchs = [];
      this.searchValue = '';
    },
    searchAndChooseItem: function searchAndChooseItem(params) {
      var vm = this;
      var temp = params;

      if (params.flag) {
        temp.val = _parseFloat$3(params.val);
        vm.$emit('select', temp);

        if (!vm.readonly) {
          vm.closeMe();
          vm.searchCancel();
        } else {
          vm.$toast('符合投保条件');
        }
      } else {
        vm.$toast('该职业不符合投保条件');
      }
    },
    // 数据处理
    initPreProfession: function initPreProfession(profess) {
      var vm = this;
      var result = vm.findProfessionByCode(vm.professionList, profess.code, profess.des, profess.val);
      vm.selected = result ? result.nodes : [];

      if (!vm.selected.length) {
        vm.$toast('暂无该职业或职业类别有误');
        return false;
      }

      vm.currSelect = vm.selected[vm.selected.length - 1];
      vm.isLeafLevel = true;
      vm.professionType = vm.currSelect.val;

      if (vm.verifyProfess(vm.currSelect)) {
        vm.isComplaint = true;
      } else {
        vm.isComplaint = false;
      }

      return true;
    },
    treeTranArray: function treeTranArray(list, des, params) {
      var vm = this;
      var res = params;

      for (var index = 0; index < list.length; index += 1) {
        var item = list[index];

        if (item[vm.childrenKeyName]) {
          var tempDes = des + "-" + item.des;
          vm.treeTranArray(item[vm.childrenKeyName], tempDes, res);
        } else {
          var _tempDes = des + "-" + item.des;

          res.push(_extends({}, item, {
            des: slice$2(_tempDes).call(_tempDes, 1)
          }));
        }
      }

      return res;
    },
    findProfessionByCode: function findProfessionByCode(list, code, des, val, params) {
      var vm = this;

      for (var index = 0; index < list.length; index += 1) {
        var item = list[index];
        var data = JSON.parse(stringify$2(params || {
          nodes: []
        }));

        if (String(item.code) === String(code) && item.des === des && item.val === val) {
          data.nodes.push(item);
          return data;
        }

        if (item[vm.childrenKeyName]) {
          data.nodes.push(item);
          var result = vm.findProfessionByCode(item[vm.childrenKeyName], code, des, val, data);

          if (result) {
            return result;
          }
        } else {
          data = null;
        }
      }

      return null;
    }
  },
  watch: {
    selected: function selected(val) {
      this.menuList = JSON.parse(stringify$2(val));

      if (this.asyncColumns) {
        if (val && val.length) {
          var lastItem = val[val.length - 1];

          if (!lastItem.category) {
            this.menuList.push({
              des: this.digit[this.menuList.length]
            });
          }
        } else {
          this.menuList.push({
            des: this.digit[this.menuList.length]
          });
        }

        this.totalLevels = this.menuList.length;
      } else if (this.menuList.length < this.totalLevels) {
        this.menuList.push({
          des: this.digit[this.menuList.length]
        });
      }

      this.calculateListStyle();
    }
  }
});

var __vue_script__$s = script$s;
/* template */

var __vue_render__$s = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('transition', {
    attrs: {
      "name": "bx-across-slide"
    },
    on: {
      "enter": _vm.enter,
      "before-leave": _vm.beforeLeave
    }
  }, [_vm.value ? _c('div', {
    staticClass: "bx-profession"
  }, [_c('div', {
    staticClass: "bx-container"
  }, [_c('div', {
    ref: "bxContainerHead",
    staticClass: "bx-container-head"
  }, [_c('div', {
    staticClass: "bx-container-title bx-hairline--bottom"
  }, [_c('div', {
    on: {
      "click": _vm.back
    }
  }, [_c('bxs-icon', {
    attrs: {
      "size": "24px",
      "color": "#ccc",
      "name": "arrow-left"
    }
  })], 1), _c('span', {
    staticClass: "bx-container-title-center"
  }, [_vm._v("\n            职业类别\n          ")]), _c('div', {
    on: {
      "click": _vm.closeMe
    }
  }, [_c('bxs-icon', {
    attrs: {
      "size": "24px",
      "color": "#ccc",
      "name": "close"
    }
  })], 1)]), _c('div', [_c('div', {
    on: {
      "click": _vm.searchShow
    }
  }, [_c('bxs-search', {
    attrs: {
      "placeholder": "请输入关键字",
      "disabled": "",
      "background": "#f2f2f2"
    }
  })], 1)]), _c('div', {
    staticClass: "bx-container-selected"
  }, [_c('div', {
    staticClass: "bx-container-selected-sel"
  }, [_vm._v("\n            已选：\n          ")]), _vm.selected && _vm.selected.length ? _c('div', {
    staticClass: "bx-container-selected-text"
  }, [_vm._v("\n            " + _vm._s(_vm.selectedStr) + "\n          ")]) : _vm._e(), _vm.isLeafLevel && _vm.isComplaint ? _c('div', {
    staticClass: "bx-container-right"
  }, [_vm._v("\n            类别：" + _vm._s(_vm.professionType) + "类（符合投保条件）\n          ")]) : _vm._e(), _vm.isLeafLevel && !_vm.isComplaint ? _c('div', {
    staticClass: "bx-container-err"
  }, [_vm._v("\n            类别：拒保" + _vm._s(_vm.professionType) + "类（不符合投保条件）\n          ")]) : _vm._e()]), _c('ul', {
    staticClass: "bx-container-menu bx-hairline--bottom"
  }, _vm._l(_vm.menuList, function (menu, index) {
    return _c('li', {
      key: 'menu' + index,
      staticClass: "bx-container-item",
      class: {
        'active': index + 1 === _vm.menuList.length
      },
      on: {
        "click": function click($event) {
          _vm.onClickMenu(index);
        }
      }
    }, [_vm._v("\n            " + _vm._s(menu.des) + "\n          ")]);
  }))]), _c('div', {
    staticClass: "bx-container-list",
    style: _vm.listStyle
  }, [_vm.professionObj && _vm.professionObj.length > 0 ? _c('ul', _vm._l(_vm.professionObj, function (item, index) {
    return _c('li', {
      key: index,
      staticClass: "bx-container-list-li bx-hairline--bottom",
      class: {
        'bx-container-highlight': _vm.selected && _vm.selected.length && _vm.selected[_vm.selected.length - 1].des !== undefined && _vm.selected[_vm.selected.length - 1].des === item.des
      },
      on: {
        "click": function click($event) {
          _vm.professionChoose(item);
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.des) + "\n            "), !item.code ? _c('div', [_c('bxs-icon', {
      attrs: {
        "size": "18px",
        "color": "#ccc",
        "name": "arrow-right"
      }
    })], 1) : _vm._e()]);
  })) : _vm._e()])]), _c('transition', {
    attrs: {
      "name": "bx-across-slide"
    },
    on: {
      "enter": _vm.enterSearchPage
    }
  }, [_vm.isShowSearch ? _c('div', {
    staticClass: "bx-search-container"
  }, [_c('div', {
    ref: "bxSearchBar",
    staticClass: "bx-search-bar bx-hairline--bottom"
  }, [_c('bxs-search', {
    attrs: {
      "placeholder": "请输入关键字",
      "show-action": ""
    },
    on: {
      "search": _vm.search,
      "cancel": _vm.searchCancel,
      "clear": _vm.searchClear
    },
    model: {
      value: _vm.searchValue,
      callback: function callback($$v) {
        _vm.searchValue = $$v;
      },
      expression: "searchValue"
    }
  })], 1), _c('div', {
    staticClass: "bx-search-content",
    style: _vm.searchListStyle
  }, [_vm.searchs.length > 0 ? _c('div', {
    staticClass: "bx-search-result"
  }, _vm._l(_vm.searchs, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "bx-search-item bx-hairline--bottom",
      on: {
        "click": function click($event) {
          _vm.searchAndChooseItem(item);
        }
      }
    }, [_c('div', {
      staticClass: "bx-search-name"
    }, [_vm._v("\n                " + _vm._s(item.name) + "\n              ")]), _c('div', {
      staticClass: "bx-search-job-type",
      class: {
        'bx-text-warn': !item.flag
      }
    }, [_vm._v("\n                " + _vm._s(item.val) + "类\n                " + _vm._s(item.flag ? '（符合投保条件）' : '（不符合投保条件）') + "\n              ")])]);
  })) : _c('div', [_c('bxs-default-page', {
    attrs: {
      "inline": false
    }
  })], 1)])]) : _vm._e()])], 1) : _vm._e()]);
};

var __vue_staticRenderFns__$s = [];
/* style */

var __vue_inject_styles__$s = undefined;
/* scoped */

var __vue_scope_id__$s = undefined;
/* module identifier */

var __vue_module_identifier__$s = undefined;
/* functional template */

var __vue_is_functional_template__$s = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$s =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$s,
  staticRenderFns: __vue_staticRenderFns__$s
}, __vue_inject_styles__$s, __vue_script__$s, __vue_scope_id__$s, __vue_is_functional_template__$s, __vue_module_identifier__$s, false, undefined, undefined, undefined);

var _components$e;

var onlyValues$5 = function onlyValues(values) {
  return function (str) {
    return indexOf$4(values).call(values, str) !== -1;
  };
};

var script$t = create({
  name: 'protocol',
  mixins: [Emitter],
  props: {
    // 协议列表
    protocolList: {
      type: Array,
      default: []
    },
    value: {
      type: Boolean,
      default: false
    },
    // 高亮颜色
    highlightColor: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'primary',
      validator: onlyValues$5(['primary', 'minor'])
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    color: function color() {
      return this.highlightColor;
    },
    colorClassName: function colorClassName() {
      return this.type === 'minor' ? 'bx-protocol-color-minor' : 'bx-protocol-color-primary';
    }
  },
  methods: {
    onClick: function onClick(item) {
      if (!item.url && item.onClick) {
        item.onClick();
      }
    },
    changeSelect: function changeSelect() {
      this.$emit('input', !this.value);
      this.dispatch('bxs-form-item', 'form.item.validate');
    }
  },
  components: (_components$e = {}, _components$e[__vue_component__$1.name] = __vue_component__$1, _components$e)
});

var __vue_script__$t = script$t;
/* template */

var __vue_render__$t = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "bx-protocol"
  }, [_c('span', {
    on: {
      "click": _vm.changeSelect
    }
  }, [_c('bxs-icon', {
    class: _vm.value ? _vm.colorClassName : '',
    attrs: {
      "name": _vm.value ? 'check-solid' : 'circle',
      "color": _vm.value ? _vm.color : '',
      "size": "18px"
    }
  })], 1), _c('span', {
    staticClass: "bx-protocol-primary"
  }, [_c('span', [_vm._v("我已认真阅读")]), _vm._l(_vm.protocolList, function (item, index) {
    return _c('a', {
      key: index,
      class: _vm.colorClassName,
      style: 'color:' + _vm.color,
      attrs: {
        "href": item.url,
        "target": item.target
      },
      on: {
        "click": function click($event) {
          _vm.onClick(item);
        }
      }
    }, [_vm._v("\n      " + _vm._s(item.name) + "\n    ")]);
  }), _c('span', [_vm._v(",并同意上述协议约定")])], 2), _c('div', {
    staticClass: "bx-protocol-sub"
  }, [_vm._t("subText")], 2)]);
};

var __vue_staticRenderFns__$t = [];
/* style */

var __vue_inject_styles__$t = undefined;
/* scoped */

var __vue_scope_id__$t = undefined;
/* module identifier */

var __vue_module_identifier__$t = undefined;
/* functional template */

var __vue_is_functional_template__$t = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$t =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$t,
  staticRenderFns: __vue_staticRenderFns__$t
}, __vue_inject_styles__$t, __vue_script__$t, __vue_scope_id__$t, __vue_is_functional_template__$t, __vue_module_identifier__$t, false, undefined, undefined, undefined);

var MIN_DISTANCE = 10;

function getDirection(x, y) {
  if (x > y && x > MIN_DISTANCE) {
    return 'horizontal';
  }

  if (y > x && y > MIN_DISTANCE) {
    return 'vertical';
  }

  return '';
}

var Touch = {
  data: function data() {
    return {
      direction: ''
    };
  },
  methods: {
    touchStart: function touchStart(event) {
      this.resetTouchStatus();
      this.startX = event.touches[0].clientX;
      this.startY = event.touches[0].clientY;
    },
    touchMove: function touchMove(event) {
      var touch = event.touches[0];
      this.deltaX = touch.clientX - this.startX;
      this.deltaY = touch.clientY - this.startY;
      this.offsetX = Math.abs(this.deltaX);
      this.offsetY = Math.abs(this.deltaY);
      this.direction = this.direction || getDirection(this.offsetX, this.offsetY);
    },
    resetTouchStatus: function resetTouchStatus() {
      this.direction = '';
      this.deltaX = 0;
      this.deltaY = 0;
      this.offsetX = 0;
      this.offsetY = 0;
    }
  }
};

var slice$4 = [].slice;
var factories = {};

var construct = function (C, argsLength, args) {
  if (!(argsLength in factories)) {
    for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[argsLength] = Function('C,a', 'return new C(' + list.join(',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.github.io/ecma262/#sec-function.prototype.bind
var functionBind = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = slice$4.call(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = partArgs.concat(slice$4.call(arguments));
    return this instanceof boundFunction ? construct(fn, args.length, args) : fn.apply(that, args);
  };
  if (isObject(fn.prototype)) boundFunction.prototype = fn.prototype;
  return boundFunction;
};

// `Function.prototype.bind` method
// https://tc39.github.io/ecma262/#sec-function.prototype.bind
_export({ target: 'Function', proto: true }, {
  bind: functionBind
});

var bind$2 = entryVirtual('Function').bind;

var FunctionPrototype$1 = Function.prototype;

var bind_1 = function (it) {
  var own = it.bind;
  return it === FunctionPrototype$1 || (it instanceof Function && own === FunctionPrototype$1.bind) ? bind$2 : own;
};

var bind$3 = bind_1;

var bind$4 = bind$3;

var _context$3;
var isServer = Vue.prototype.$isServer;
var scrollUtils = {
  getScrollEventTarget: function getScrollEventTarget(element, rootParent) {
    if (rootParent === void 0) {
      rootParent = window;
    }

    var currentNode = element;

    while (currentNode && currentNode.tagName !== 'HTML' && currentNode.tagName !== 'BODY' && currentNode.nodeType === 1 && currentNode !== rootParent) {
      var _this$getComputedStyl = this.getComputedStyle(currentNode),
          overflowY = _this$getComputedStyl.overflowY;

      if (overflowY === 'scroll' || overflowY === 'auto') {
        return currentNode;
      }

      currentNode = currentNode.parentNode;
    }

    return rootParent;
  },
  getScrollTop: function getScrollTop(element) {
    return 'scrollTop' in element ? element.scrollTop : element.pageYOffset;
  },
  getComputedStyle: !isServer && bind$4(_context$3 = document.defaultView.getComputedStyle).call(_context$3, document.defaultView)
};

var _components$f;
var script$u = create({
  name: 'pull-refresh',
  components: (_components$f = {}, _components$f[__vue_component__$l.name] = __vue_component__$l, _components$f),
  mixins: [Touch],
  props: {
    value: {
      type: Boolean,
      required: true
    },
    pullingText: {
      type: String,
      default: '下拉即可刷新…'
    },
    loosingText: {
      type: String,
      default: '释放即可刷新…'
    },
    loadingText: {
      type: String,
      default: '正在刷新…'
    },
    animationDuration: {
      type: Number,
      default: 300
    },
    headHeight: {
      type: Number,
      default: 49
    }
  },
  data: function data() {
    return {
      status: 'normal',
      height: 0,
      duration: 0
    };
  },
  computed: {
    style: function style() {
      return {
        transition: this.duration + "ms",
        transform: "translate3d(0," + this.height + "px, 0)"
      };
    },
    untouchable: function untouchable() {
      return this.status === 'loading';
    }
  },
  watch: {
    value: function value(val) {
      this.getStatus(val ? this.headHeight : 0, val);
    }
  },
  mounted: function mounted() {
    this.scrollEl = scrollUtils.getScrollEventTarget(this.$el);
  },
  methods: {
    onTouchStart: function onTouchStart(event) {
      if (this.untouchable) return;

      if (this.getCeiling()) {
        this.duration = 0;
        this.touchStart(event);
      }
    },
    onTouchMove: function onTouchMove(event) {
      if (this.untouchable) return;
      this.touchMove(event);

      if (!this.ceiling && this.getCeiling()) {
        this.duration = 0;
        this.startY = event.touches[0].clientY;
        this.deltaY = 0;
      }

      if (this.ceiling && this.deltaY >= 0) {
        if (this.direction === 'vertical') {
          this.getStatus(this.ease(this.deltaY));
          if (event.cancelable) event.preventDefault();
        }
      }
    },
    onTouchEnd: function onTouchEnd() {
      if (this.untouchable) return;

      if (this.ceiling && this.deltaY) {
        this.duration = this.animationDuration;

        if (this.status === 'loosing') {
          this.getStatus(this.headHeight, true);
          this.$emit('input', true);
          this.$emit('refresh');
        } else {
          this.getStatus(0);
        }
      }
    },
    getCeiling: function getCeiling() {
      this.ceiling = scrollUtils.getScrollTop(this.scrollEl) === 0;
      return this.ceiling;
    },
    ease: function ease(height) {
      var headHeight = this.headHeight;
      var realHeight;

      if (height < headHeight) {
        realHeight = height;
      } else if (height < headHeight * 2) {
        realHeight = Math.round(headHeight + (height - headHeight) / 2);
      } else {
        realHeight = Math.round(headHeight * 1.5 + (height - headHeight * 2) / 4);
      }

      return realHeight;
    },
    getStatus: function getStatus(height, isLoading) {
      this.height = height;
      var status;

      if (isLoading) {
        status = 'loading';
      } else if (height === 0) {
        status = 'normal';
      } else if (height < this.headHeight) {
        status = 'pulling';
      } else {
        status = 'loosing';
      }

      if (status !== this.status) {
        this.status = status;
      }
    }
  }
});

/* script */
var __vue_script__$u = script$u;
/* template */

var __vue_render__$u = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "bx-pull-refresh"
  }, [_c('div', {
    staticClass: "bx-pull-refresh-main",
    style: _vm.style,
    on: {
      "touchstart": _vm.onTouchStart,
      "touchmove": _vm.onTouchMove,
      "touchend": _vm.onTouchEnd,
      "touchcancel": _vm.onTouchEnd
    }
  }, [_c('div', {
    staticClass: "bx-pull-refresh-header"
  }, [_vm.status === 'pulling' ? [_c('span', {
    staticClass: "bx-pull-refresh-text"
  }, [_vm._v(_vm._s(_vm.pullingText))])] : _vm._e(), _vm.status === 'loosing' ? [_c('span', {
    staticClass: "bx-pull-refresh-text"
  }, [_vm._v(_vm._s(_vm.loosingText))])] : _vm._e(), _vm.status === 'loading' ? [_c('bxs-loading'), _c('span', {
    staticClass: "bx-pull-refresh-text"
  }, [_vm._v(_vm._s(_vm.loadingText))])] : _vm._e()], 2), _vm._t("default")], 2)]);
};

var __vue_staticRenderFns__$u = [];
/* style */

var __vue_inject_styles__$u = undefined;
/* scoped */

var __vue_scope_id__$u = undefined;
/* module identifier */

var __vue_module_identifier__$u = undefined;
/* functional template */

var __vue_is_functional_template__$u = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$u =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$u,
  staticRenderFns: __vue_staticRenderFns__$u
}, __vue_inject_styles__$u, __vue_script__$u, __vue_scope_id__$u, __vue_is_functional_template__$u, __vue_module_identifier__$u, false, undefined, undefined, undefined);

var _components$g;
var script$v = create({
  name: 'radio',
  components: (_components$g = {}, _components$g[__vue_component__$1.name] = __vue_component__$1, _components$g[__vue_component__$5.name] = __vue_component__$5, _components$g),
  props: {
    name: null,
    value: null,
    type: {
      type: String,
      default: 'icon',
      validator: function validator(str) {
        var _context;

        return indexOf$4(_context = ['icon', 'button']).call(_context, str) !== -1;
      }
    },
    selectColor: {
      type: String,
      default: 'primary'
    },
    disabled: Boolean,
    labelDisabled: Boolean,
    // 即将废弃
    labelPosition: String
  },
  data: function data() {
    return {
      parent: null,
      isCellParent: false
    };
  },
  computed: {
    currentValue: {
      get: function get() {
        return this.parent ? this.parent.value : this.value;
      },
      set: function set(val) {
        this.parent.$emit('input', val);
      }
    },
    isDisabled: function isDisabled() {
      return this.parent ? this.parent.disabled || this.disabled : this.disabled;
    },
    isLabelDisabled: function isLabelDisabled() {
      return this.parent ? this.parent.disabled || this.disabled || this.labelDisabled : this.disabled;
    },
    icon: function icon() {
      return this.name === this.currentValue ? "circle-dot bx-radio-color-" + this.bColor : 'circle';
    },
    cellIcon: function cellIcon() {
      return this.name === this.currentValue ? 'check' : '';
    },
    bColor: function bColor() {
      return this.parent ? this.parent.selectColor || this.selectColor : this.selectColor;
    },
    btnType: function btnType() {
      return this.name === this.currentValue ? this.bColor : 'assist';
    }
  },
  created: function created() {
    this.parent = this.findParent('bxs-radio-group');
    this.isCellParent = this.findParent('bxs-cell');
  },
  methods: {
    handleClick: function handleClick(label) {
      if (this.isDisabled || label === 'label' && this.isLabelDisabled) {
        return;
      }

      this.currentValue = this.name;
    },
    findParent: function findParent(name) {
      var parent = this.$parent;

      while (parent) {
        if (parent.$options.name === name) {
          break;
        }

        parent = parent.$parent;
      }

      return parent;
    }
  }
});

/* script */
var __vue_script__$v = script$v;
/* template */

var __vue_render__$v = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.type === 'icon' ? _c('div', {
    class: ['bx-radio-warp']
  }, [_c('span', {
    staticClass: "bx-radio-icon-warp",
    on: {
      "click": function click($event) {
        _vm.handleClick('radio');
      }
    }
  }, [_vm.isCellParent ? _c('bxs-icon', {
    attrs: {
      "color": _vm.isDisabled ? '#ccc' : '',
      "name": _vm.cellIcon
    }
  }) : _c('bxs-icon', {
    attrs: {
      "color": _vm.isDisabled ? '#ccc' : '',
      "name": _vm.icon
    }
  })], 1), _c('span', {
    staticClass: "bx-radio-text",
    class: [{
      'bx-radio-content--disable': _vm.isDisabled || _vm.isLabelDisabled
    }, _vm.labelPosition],
    on: {
      "click": function click($event) {
        _vm.handleClick('label');
      }
    }
  }, [_vm._t("default")], 2)]) : _vm.type === 'button' ? _c('div', {
    class: ['bx-radio-warp']
  }, [_c('bxs-button', {
    class: [{
      'bx-radio-content--disable': _vm.isDisabled
    }],
    attrs: {
      "plain": "",
      "size": "small",
      "type": _vm.btnType,
      "disabled": _vm.isDisabled
    },
    on: {
      "click": function click($event) {
        _vm.handleClick('radio');
      }
    }
  }, [_vm._t("default")], 2)], 1) : _vm._e();
};

var __vue_staticRenderFns__$v = [];
/* style */

var __vue_inject_styles__$v = undefined;
/* scoped */

var __vue_scope_id__$v = undefined;
/* module identifier */

var __vue_module_identifier__$v = undefined;
/* functional template */

var __vue_is_functional_template__$v = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$v =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$v,
  staticRenderFns: __vue_staticRenderFns__$v
}, __vue_inject_styles__$v, __vue_script__$v, __vue_scope_id__$v, __vue_is_functional_template__$v, __vue_module_identifier__$v, false, undefined, undefined, undefined);

//
var script$w = create({
  name: 'radio-group',
  mixins: [Emitter],
  props: {
    value: null,
    disabled: {
      type: Boolean,
      default: false
    },
    labelDisable: {
      type: Boolean,
      default: false
    },
    selectColor: {
      type: String,
      default: 'primary'
    }
  },
  watch: {
    value: function value(_value) {
      this.$emit('change', _value);
      this.dispatch('bxs-form-item', 'form.item.reset');
    }
  }
});

/* script */
var __vue_script__$w = script$w;
/* template */

var __vue_render__$w = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$w = [];
/* style */

var __vue_inject_styles__$w = undefined;
/* scoped */

var __vue_scope_id__$w = undefined;
/* module identifier */

var __vue_module_identifier__$w = undefined;
/* functional template */

var __vue_is_functional_template__$w = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$w =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$w,
  staticRenderFns: __vue_staticRenderFns__$w
}, __vue_inject_styles__$w, __vue_script__$w, __vue_scope_id__$w, __vue_is_functional_template__$w, __vue_module_identifier__$w, false, undefined, undefined, undefined);

var _components$h;
var count = 5;
var script$x = create({
  name: 'rate',
  data: function data() {
    var iconSize;

    if (this.size) {
      if (isNan$2(Number(this.size))) {
        iconSize = this.size;
      } else {
        iconSize = this.size + "px";
      }
    } else {
      iconSize = this.position === 'right' ? '18px' : '30px';
    }

    return {
      currentValue: this.value,
      iconSize: iconSize,
      count: count,
      beforeTouchValue: this.value,
      currentTag: this.tag,
      defaultTagList: ['服务好', '速度快', '效率高']
    };
  },
  props: {
    value: {
      type: Number,
      default: null,
      validator: function validator(value) {
        return value <= count;
      }
    },
    textList: {
      type: Array,
      default: function _default() {
        return ['非常差', '差', '一般', '好', '非常好'];
      }
    },
    size: {
      type: String,
      default: null
    },
    position: {
      type: String,
      default: 'bottom',
      validator: function validator(value) {
        var _context;

        // 这个值必须匹配下列字符串中的一个
        return indexOf$4(_context = ['bottom', 'right']).call(_context, value) !== -1;
      }
    },
    color: {
      type: String,
      default: '#FF9224'
    },
    voidColor: {
      type: String,
      default: '#E5E5E5'
    },
    readonly: {
      type: Boolean,
      default: false
    },
    tag: {
      type: Number,
      default: null
    },
    tagList: {
      type: [Boolean, Array]
    },
    starWidth: {
      type: String,
      default: '114px'
    },
    starSize: {
      type: String,
      required: false,
      default: ''
    },
    rateLabel: {
      type: String,
      required: ''
    },
    showRateNum: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  methods: {
    setCurrentValue: function setCurrentValue(value) {
      if (!this.readonly && this.currentValue !== value) {
        this.currentValue = value;
        this.$emit('change', this.currentValue, this.currentTag);
      }
    },
    setCurrentTag: function setCurrentTag(tag) {
      if (!this.readonly) {
        if (this.currentTag !== tag) {
          this.currentTag = tag;
        } else {
          this.currentTag = null;
        }

        this.$emit('change', this.currentValue, this.currentTag);
      }
    },
    touchstartRate: function touchstartRate() {
      this.beforeTouchValue = this.currentValue;
    },
    touchmoveRate: function touchmoveRate(event) {
      if (document.elementFromPoint) {
        var getTouchElement = document.elementFromPoint(event.touches[0].clientX, event.touches[0].clientY);

        if (getTouchElement && getTouchElement.dataset && getTouchElement.dataset.rateValue !== undefined) {
          if (!this.readonly && this.currentValue !== getTouchElement.dataset.rateValue) {
            this.currentValue = getTouchElement.dataset.rateValue;
          }
        }
      } else {
        var _getTouchElement = event.currentTarget;

        if (_getTouchElement && event.touches[0]) {
          var distanceX = event.touches[0].clientX - _getTouchElement.offsetLeft;
          var touchRateValue = Math.ceil(distanceX / (_getTouchElement.offsetWidth / this.count));

          if (touchRateValue < 1) {
            touchRateValue = 1;
          }

          if (touchRateValue > this.count) {
            touchRateValue = this.count;
          }

          if (!this.readonly && this.currentValue !== touchRateValue) {
            this.currentValue = touchRateValue;
          }
        }
      }
    },
    touchendRate: function touchendRate() {
      if (!this.readonly && this.currentValue !== this.beforeTouchValue) {
        this.$emit('change', this.currentValue, this.currentTag);
      }
    },
    // 星星裁切框的宽度
    getClipperWidth: function getClipperWidth(n) {
      return this.currentValue % 1 && n > this.currentValue ? this.currentValue % 1 * 100 + "%" : '100%';
    },
    // 评分文案
    getRateText: function getRateText() {
      return this.textList[_parseInt$3((this.currentValue > count ? count : this.currentValue) - 1, 10)] || '请选择评分';
    }
  },
  components: (_components$h = {}, _components$h[__vue_component__$1.name] = __vue_component__$1, _components$h),
  computed: {
    txFontSize: function txFontSize() {
      return _parseFloat$3(this.iconSize) * (13 / 30) + this.iconSize.replace(/(\d|\.)+/g, '');
    }
  }
});

var __vue_script__$x = script$x;
/* template */

var __vue_render__$x = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "bx-rate-wrapper",
    style: {
      display: _vm.position === 'right' ? 'inline-block' : 'block'
    }
  }, [_vm.position === 'right' ? _c('div', {
    staticClass: "bx-rate-content bx-rate-right"
  }, [_vm.rateLabel ? _c('label', {
    staticClass: "bx-rate-label"
  }, [_vm._v("\n      " + _vm._s(_vm.rateLabel) + "\n    ")]) : _vm._e(), _c('div', {
    staticClass: "bx-rate-star-wrapper"
  }, [_c('ul', {
    staticClass: "bx-rate-star",
    style: {
      width: _vm.starWidth
    },
    on: {
      "touchstart": _vm.touchstartRate,
      "touchmove": _vm.touchmoveRate,
      "touchend": _vm.touchendRate,
      "touchcancel": _vm.touchendRate
    }
  }, _vm._l(_vm.count, function (n) {
    return _c('li', {
      key: n,
      staticClass: "bx-rate-star-li",
      attrs: {
        "data-rate-value": n
      },
      on: {
        "click": function click($event) {
          _vm.setCurrentValue(n);
        }
      }
    }, [_c('span', {
      staticClass: "bx-rate-star-li-wrapper"
    }, [_c('bxs-icon', {
      staticClass: "bx-rate-star-li-icon",
      class: n < Math.ceil(_vm.currentValue) ? 'bx-rate-star-li-icon--opacity' : '',
      style: {
        fontSize: _vm.starSize || _vm.iconSize,
        color: _vm.voidColor
      },
      attrs: {
        "name": "star-solid"
      }
    }), n <= Math.ceil(_vm.currentValue) ? _c('span', {
      staticClass: "bx-rate-star-li-clipper",
      style: {
        width: _vm.getClipperWidth(n)
      }
    }, [_c('bxs-icon', {
      staticClass: "bx-rate-star-li-icon",
      style: {
        fontSize: _vm.starSize || _vm.iconSize,
        color: _vm.color
      },
      attrs: {
        "name": "star-solid"
      }
    })], 1) : _vm._e()], 1)]);
  }))]), _vm.showRateNum ? _c('span', {
    staticClass: "bx-rate-number",
    style: {
      color: _vm.currentValue === null ? '#ccc' : _vm.color
    }
  }, [_vm._v("\n      " + _vm._s(_vm.currentValue === null ? '0.0' : (_vm.currentValue * 1).toFixed(1)) + "\n    ")]) : _vm._e(), _vm.textList && _vm.textList.length && _vm.currentValue ? _c('span', {
    staticClass: "bx-rate-text"
  }, [_vm._v("\n      " + _vm._s(_vm.getRateText()) + "\n    ")]) : _vm._e()]) : _c('div', {
    staticClass: "bx-rate-content bx-rate-bottom"
  }, [_vm.showRateNum ? _c('header', {
    staticClass: "bx-rate-header",
    style: {
      color: _vm.currentValue === null ? '#ccc' : _vm.color
    }
  }, [_vm._v("\n      " + _vm._s(_vm.currentValue === null ? '0.0' : (_vm.currentValue * 1).toFixed(1)) + "分\n    ")]) : _vm._e(), _c('ul', {
    staticClass: "bx-rate-star",
    on: {
      "touchstart": _vm.touchstartRate,
      "touchmove": _vm.touchmoveRate,
      "touchend": _vm.touchendRate,
      "touchcancel": _vm.touchendRate
    }
  }, _vm._l(_vm.count, function (n) {
    return _c('li', {
      key: n,
      staticClass: "bx-rate-star-li",
      attrs: {
        "data-rate-value": n
      },
      on: {
        "click": function click($event) {
          _vm.setCurrentValue(n);
        }
      }
    }, [_c('bxs-icon', {
      staticClass: "bx-rate-star-li-icon",
      class: n < Math.ceil(_vm.currentValue) ? 'bx-rate-star-li-icon--opacity' : '',
      style: {
        fontSize: _vm.iconSize,
        color: _vm.voidColor
      },
      attrs: {
        "name": "star-solid"
      }
    }), n <= Math.ceil(_vm.currentValue) ? _c('span', {
      staticClass: "bx-rate-star-li-clipper",
      style: {
        width: _vm.getClipperWidth(n)
      }
    }, [_c('bxs-icon', {
      staticClass: "bx-rate-star-li-icon",
      style: {
        fontSize: _vm.iconSize,
        color: _vm.color
      },
      attrs: {
        "name": "star-solid"
      }
    })], 1) : _vm._e()], 1);
  })), _vm.textList && _vm.textList.length ? _c('p', {
    staticClass: "bx-rate-text",
    style: {
      color: _vm.currentValue === null ? '#999' : _vm.color,
      fontSize: _vm.txFontSize
    }
  }, [_vm._v("\n      " + _vm._s(_vm.getRateText()) + "\n    ")]) : _vm._e(), _vm.tagList ? _c('ul', {
    staticClass: "bx-rate-tag"
  }, _vm._l(_vm.tagList.constructor === Array ? _vm.tagList : _vm.defaultTagList, function (t, ti) {
    return _c('li', {
      key: t,
      staticClass: "bx-rate-tag-li",
      style: {
        'color': ti === _vm.currentTag ? _vm.color : '#333',
        'border-color': ti === _vm.currentTag ? _vm.color : '#ccc'
      },
      on: {
        "click": function click($event) {
          _vm.setCurrentTag(ti);
        }
      }
    }, [_vm._v("\n        " + _vm._s(t) + "\n      ")]);
  })) : _vm._e()])]);
};

var __vue_staticRenderFns__$x = [];
/* style */

var __vue_inject_styles__$x = undefined;
/* scoped */

var __vue_scope_id__$x = undefined;
/* module identifier */

var __vue_module_identifier__$x = undefined;
/* functional template */

var __vue_is_functional_template__$x = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$x =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$x,
  staticRenderFns: __vue_staticRenderFns__$x
}, __vue_inject_styles__$x, __vue_script__$x, __vue_scope_id__$x, __vue_is_functional_template__$x, __vue_module_identifier__$x, false, undefined, undefined, undefined);

var _components$i;

var onlyValues$6 = function onlyValues(values) {
  return function (str) {
    return indexOf$4(values).call(values, str) !== -1;
  };
};

var script$y = create({
  name: 'result-status',
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'wait',
      validator: onlyValues$6(['wait', 'success', 'fail'])
    }
  },
  computed: {
    iconName: function iconName() {
      return {
        wait: 'warning-solid',
        success: 'check-solid',
        fail: 'close-solid bx-red-font'
      }[this.type];
    }
  },
  components: (_components$i = {}, _components$i[__vue_component__$1.name] = __vue_component__$1, _components$i)
});

/* script */
var __vue_script__$y = script$y;
/* template */

var __vue_render__$y = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('div', {
    staticClass: "bx-result-status"
  }, [_c('div', {
    staticClass: "bx-result-status-body"
  }, [_c('div', {
    staticClass: "bx-result-content"
  }, [_c('bxs-icon', {
    attrs: {
      "name": _vm.iconName
    }
  }), _c('div', [_vm._v(_vm._s(_vm.title))])], 1), _c('div', {
    class: ['bx-img', "bx-result-status-chart--" + _vm.type]
  })]), _vm._t("footer")], 2)]);
};

var __vue_staticRenderFns__$y = [];
/* style */

var __vue_inject_styles__$y = undefined;
/* scoped */

var __vue_scope_id__$y = undefined;
/* module identifier */

var __vue_module_identifier__$y = undefined;
/* functional template */

var __vue_is_functional_template__$y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$y =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$y,
  staticRenderFns: __vue_staticRenderFns__$y
}, __vue_inject_styles__$y, __vue_script__$y, __vue_scope_id__$y, __vue_is_functional_template__$y, __vue_module_identifier__$y, false, undefined, undefined, undefined);

// `IsArray` abstract operation
// https://tc39.github.io/ecma262/#sec-isarray
var isArray$4 = Array.isArray || function isArray(arg) {
  return classofRaw$1(arg) == 'Array';
};

var nativeGetOwnPropertyNames = objectGetOwnPropertyNames.f;

var toString$2 = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return nativeGetOwnPropertyNames(it);
  } catch (error) {
    return windowNames.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var f$c = function getOwnPropertyNames(it) {
  return windowNames && toString$2.call(it) == '[object Window]'
    ? getWindowNames(it)
    : nativeGetOwnPropertyNames(toIndexedObject$1(it));
};

var objectGetOwnPropertyNamesExternal = {
	f: f$c
};

var SPECIES$a = wellKnownSymbol$1('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.github.io/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate$1 = function (originalArray, length) {
  var C;
  if (isArray$4(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray$4(C.prototype))) C = undefined;
    else if (isObject$1(C)) {
      C = C[SPECIES$a];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};

var push$1 = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation
var createMethod$9 = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject$1($this);
    var self = indexedObject$1(O);
    var boundFunction = bindContext$1(callbackfn, that, 3);
    var length = toLength$1(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate$1;
    var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push$1.call(target, value); // filter
        } else if (IS_EVERY) return false;  // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

var arrayIteration$1 = {
  // `Array.prototype.forEach` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
  forEach: createMethod$9(0),
  // `Array.prototype.map` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.map
  map: createMethod$9(1),
  // `Array.prototype.filter` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.filter
  filter: createMethod$9(2),
  // `Array.prototype.some` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.some
  some: createMethod$9(3),
  // `Array.prototype.every` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.every
  every: createMethod$9(4),
  // `Array.prototype.find` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.find
  find: createMethod$9(5),
  // `Array.prototype.findIndex` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod$9(6)
};

var $forEach$1 = arrayIteration$1.forEach;

var HIDDEN = sharedKey$1('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE$2 = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol$1('toPrimitive');
var setInternalState$4 = internalState$1.set;
var getInternalState$4 = internalState$1.getterFor(SYMBOL);
var ObjectPrototype$1 = Object[PROTOTYPE$2];
var $Symbol = global_1$1.Symbol;
var $stringify$1 = getBuiltIn$1('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor$1.f;
var nativeDefineProperty$2 = objectDefineProperty$1.f;
var nativeGetOwnPropertyNames$1 = objectGetOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable$2 = objectPropertyIsEnumerable$1.f;
var AllSymbols = shared$1('symbols');
var ObjectPrototypeSymbols = shared$1('op-symbols');
var StringToSymbolRegistry = shared$1('string-to-symbol-registry');
var SymbolToStringRegistry = shared$1('symbol-to-string-registry');
var WellKnownSymbolsStore$2 = shared$1('wks');
var QObject = global_1$1.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE$2] || !QObject[PROTOTYPE$2].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = descriptors$1 && fails$1(function () {
  return objectCreate$1(nativeDefineProperty$2({}, 'a', {
    get: function () { return nativeDefineProperty$2(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor$2(ObjectPrototype$1, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype$1[P];
  nativeDefineProperty$2(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype$1) {
    nativeDefineProperty$2(ObjectPrototype$1, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty$2;

var wrap$1 = function (tag, description) {
  var symbol = AllSymbols[tag] = objectCreate$1($Symbol[PROTOTYPE$2]);
  setInternalState$4(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!descriptors$1) symbol.description = description;
  return symbol;
};

var isSymbol$1 = nativeSymbol$1 && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return Object(it) instanceof $Symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype$1) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject$1(O);
  var key = toPrimitive$1(P, true);
  anObject$1(Attributes);
  if (has$2(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!has$2(O, HIDDEN)) nativeDefineProperty$2(O, HIDDEN, createPropertyDescriptor$1(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (has$2(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = objectCreate$1(Attributes, { enumerable: createPropertyDescriptor$1(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty$2(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject$1(O);
  var properties = toIndexedObject$1(Properties);
  var keys = objectKeys$1(properties).concat($getOwnPropertySymbols(properties));
  $forEach$1(keys, function (key) {
    if (!descriptors$1 || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? objectCreate$1(O) : $defineProperties(objectCreate$1(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPrimitive$1(V, true);
  var enumerable = nativePropertyIsEnumerable$2.call(this, P);
  if (this === ObjectPrototype$1 && has$2(AllSymbols, P) && !has$2(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !has$2(this, P) || !has$2(AllSymbols, P) || has$2(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject$1(O);
  var key = toPrimitive$1(P, true);
  if (it === ObjectPrototype$1 && has$2(AllSymbols, key) && !has$2(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor$2(it, key);
  if (descriptor && has$2(AllSymbols, key) && !(has$2(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames$1(toIndexedObject$1(O));
  var result = [];
  $forEach$1(names, function (key) {
    if (!has$2(AllSymbols, key) && !has$2(hiddenKeys$1, key)) result.push(key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype$1;
  var names = nativeGetOwnPropertyNames$1(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject$1(O));
  var result = [];
  $forEach$1(names, function (key) {
    if (has$2(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has$2(ObjectPrototype$1, key))) {
      result.push(AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.github.io/ecma262/#sec-symbol-constructor
if (!nativeSymbol$1) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
    var tag = uid$1(description);
    var setter = function (value) {
      if (this === ObjectPrototype$1) setter.call(ObjectPrototypeSymbols, value);
      if (has$2(this, HIDDEN) && has$2(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor$1(1, value));
    };
    if (descriptors$1 && USE_SETTER) setSymbolDescriptor(ObjectPrototype$1, tag, { configurable: true, set: setter });
    return wrap$1(tag, description);
  };

  redefine$1($Symbol[PROTOTYPE$2], 'toString', function toString() {
    return getInternalState$4(this).tag;
  });

  objectPropertyIsEnumerable$1.f = $propertyIsEnumerable;
  objectDefineProperty$1.f = $defineProperty;
  objectGetOwnPropertyDescriptor$1.f = $getOwnPropertyDescriptor;
  objectGetOwnPropertyNames.f = objectGetOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  objectGetOwnPropertySymbols.f = $getOwnPropertySymbols;

  if (descriptors$1) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty$2($Symbol[PROTOTYPE$2], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState$4(this).description;
      }
    });
    {
      redefine$1(ObjectPrototype$1, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

if (!useSymbolAsUid$1) {
  wrappedWellKnownSymbol.f = function (name) {
    return wrap$1(wellKnownSymbol$1(name), name);
  };
}

_export$1({ global: true, wrap: true, forced: !nativeSymbol$1, sham: !nativeSymbol$1 }, {
  Symbol: $Symbol
});

$forEach$1(objectKeys$1(WellKnownSymbolsStore$2), function (name) {
  defineWellKnownSymbol(name);
});

_export$1({ target: SYMBOL, stat: true, forced: !nativeSymbol$1 }, {
  // `Symbol.for` method
  // https://tc39.github.io/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = String(key);
    if (has$2(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.github.io/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol$1(sym)) throw TypeError(sym + ' is not a symbol');
    if (has$2(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

_export$1({ target: 'Object', stat: true, forced: !nativeSymbol$1, sham: !descriptors$1 }, {
  // `Object.create` method
  // https://tc39.github.io/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

_export$1({ target: 'Object', stat: true, forced: !nativeSymbol$1 }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
_export$1({ target: 'Object', stat: true, forced: fails$1(function () { objectGetOwnPropertySymbols.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return objectGetOwnPropertySymbols.f(toObject$1(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.github.io/ecma262/#sec-json.stringify
if ($stringify$1) {
  var FORCED_JSON_STRINGIFY = !nativeSymbol$1 || fails$1(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify$1([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify$1({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify$1(Object(symbol)) != '{}';
  });

  _export$1({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars
    stringify: function stringify(it, replacer, space) {
      var args = [it];
      var index = 1;
      var $replacer;
      while (arguments.length > index) args.push(arguments[index++]);
      $replacer = replacer;
      if (!isObject$1(replacer) && it === undefined || isSymbol$1(it)) return; // IE8 returns string on undefined
      if (!isArray$4(replacer)) replacer = function (key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol$1(value)) return value;
      };
      args[1] = replacer;
      return $stringify$1.apply(null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol[PROTOTYPE$2][TO_PRIMITIVE]) {
  createNonEnumerableProperty$1($Symbol[PROTOTYPE$2], TO_PRIMITIVE, $Symbol[PROTOTYPE$2].valueOf);
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag$1($Symbol, SYMBOL);

hiddenKeys$1[HIDDEN] = true;

var defineProperty$9 = objectDefineProperty$1.f;


var NativeSymbol = global_1$1.Symbol;

if (descriptors$1 && typeof NativeSymbol == 'function' && (!('description' in NativeSymbol.prototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
    var result = this instanceof SymbolWrapper
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
  symbolPrototype.constructor = SymbolWrapper;

  var symbolToString = symbolPrototype.toString;
  var native = String(NativeSymbol('test')) == 'Symbol(test)';
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  defineProperty$9(symbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = isObject$1(this) ? this.valueOf() : this;
      var string = symbolToString.call(symbol);
      if (has$2(EmptyStringDescriptionStore, symbol)) return '';
      var desc = native ? string.slice(7, -1) : string.replace(regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  _export$1({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}

var _components$j;
var script$z = create({
  name: 'step',
  props: {
    description: {
      type: String,
      default: ''
    },
    status: {
      type: String,
      default: '',
      validator: function validator(value) {
        var _context;

        // 值必须是这些字符串中的一个
        return indexOf$4(_context = ['', 'error']).call(_context, value) !== -1;
      }
    }
  },
  computed: {
    isHorizontalType: function isHorizontalType() {
      return this.$parent.type === 'horizontal';
    },
    index: function index() {
      var _context2;

      return indexOf$4(_context2 = this.$parent.$children).call(_context2, this);
    },
    stepStatus: function stepStatus() {
      var activeIdx = this.$parent.active;
      var isActive = this.index === activeIdx;
      var isInError = this.status === 'error';
      var isDone = this.index < activeIdx;
      var isHighlight = this.isHorizontalType ? isActive || isDone : isActive;
      return {
        isActive: isActive,
        isInError: isInError,
        isDone: isDone,
        isHighlight: isHighlight
      };
    },
    stepClsName: function stepClsName() {
      var _this$stepStatus = this.stepStatus,
          isActive = _this$stepStatus.isActive,
          isInError = _this$stepStatus.isInError,
          isHighlight = _this$stepStatus.isHighlight;
      var isJustBeforActive = this.index === this.$parent.active - 1;
      return {
        'bx-step-item--highlight': isHighlight,
        'bx-step-tail-no-border': !this.isHorizontalType && (isJustBeforActive || isActive),
        'bx-step-item--error': isInError
      };
    },
    customColor: function customColor() {
      return !this.stepStatus.isInError && this.stepStatus.isHighlight && this.$parent.activeColor || '';
    },
    customBgColor: function customBgColor() {
      var colorVal = this.isHorizontalType ? this.$parent.activeColor : this.$parent.activeBgColor;
      return !this.stepStatus.isInError && this.stepStatus.isHighlight && colorVal || '';
    }
  },
  components: (_components$j = {}, _components$j[__vue_component__$1.name] = __vue_component__$1, _components$j)
});

var __vue_script__$z = script$z;
/* template */

var __vue_render__$z = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "bx-step-wrapper"
  }, [_vm.isHorizontalType ? [_c('hr', {
    staticClass: "bx-steps-hr"
  }), _c('div', {
    class: ['bx-step-item-h', _vm.stepClsName]
  }, [_c('span', {
    staticClass: "bx-step-number",
    style: "background-color: " + _vm.customBgColor
  }, [!_vm.stepStatus.isDone || _vm.stepStatus.isActive ? [_vm._v("\n          " + _vm._s(_vm.index + 1) + "\n        ")] : _c('bxs-icon', {
    staticClass: "bx-step-check",
    attrs: {
      "name": "check"
    }
  })], 2), _c('p', {
    staticClass: "bx-step-item-title",
    style: "color: " + _vm.customColor
  }, [_vm._t("default"), _vm.description ? _c('span', {
    staticClass: "bx-step-item-desc"
  }, [_vm._v("\n          " + _vm._s(_vm.description) + "\n        ")]) : _vm._e()], 2)])] : _c('div', {
    class: ['bx-step-item-tail', _vm.stepClsName],
    style: "background-color: " + _vm.customBgColor
  }, [_c('em', {
    staticClass: "bx-step-tail-arrow1"
  }), _c('em', {
    staticClass: "bx-step-tail-arrow2"
  }), _c('p', {
    staticClass: "bx-step-item-title",
    style: "color: " + _vm.customColor
  }, [_vm._t("default")], 2)])], 2);
};

var __vue_staticRenderFns__$z = [];
/* style */

var __vue_inject_styles__$z = undefined;
/* scoped */

var __vue_scope_id__$z = undefined;
/* module identifier */

var __vue_module_identifier__$z = undefined;
/* functional template */

var __vue_is_functional_template__$z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$z =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$z,
  staticRenderFns: __vue_staticRenderFns__$z
}, __vue_inject_styles__$z, __vue_script__$z, __vue_scope_id__$z, __vue_is_functional_template__$z, __vue_module_identifier__$z, false, undefined, undefined, undefined);

function washNumFn(num, precision) {
  var value = "" + num;

  if (precision) {
    value = _parseFloat$3(num).toFixed(precision);
  } else {
    value = "" + Math.round(_parseFloat$3(num));
  }

  return value;
}

var script$A = create({
  name: 'stepper',
  mixins: [Emitter],
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    disableInput: {
      type: Boolean,
      default: false
    },
    value: {
      type: Number,
      default: 0
    },
    min: {
      type: Number,
      default: -Infinity
    },
    max: {
      type: Number,
      default: Infinity
    },
    step: {
      type: Number,
      default: 1
    },
    precision: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      num: this.value,
      // 绑定值
      oldNum: this.value // 绑定老值

    };
  },
  computed: {
    disabledAddClass: {
      get: function get() {
        if (this.disabled) {
          return 'bx-number-disabled';
        }

        if (this.max && Number(this.num) >= this.max) {
          return 'bx-number-disabled';
        }

        return '';
      }
    },
    disabledMinusClass: {
      get: function get() {
        if (this.disabled) {
          return 'bx-number-disabled';
        }

        if (this.min && Number(this.num) <= this.min) {
          return 'bx-number-disabled';
        }

        return '';
      }
    },
    disableInputClass: {
      get: function get() {
        if (this.disableInput) {
          return 'bx-input-disabled';
        }

        if (this.disabled) {
          return 'bx-input-disabled';
        }

        return '';
      }
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  watch: {
    value: {
      handler: function handler() {
        var washedValue = washNumFn(this.value, this.precision);

        if (washedValue !== this.num) {
          if (_parseFloat$3(this.value) > this.max) {
            this.$emit('change', this.max);
            this.num = this.max;
          } else if (_parseFloat$3(this.value) < this.min) {
            this.$emit('change', this.min);
            this.num = this.min;
          } else {
            this.num = washedValue;
          }
        }

        if (this.value !== this.num - 0) {
          this.$emit('change', this.num - 0);
        }
      },
      immediate: true
    }
  },
  methods: {
    // 输入框失去焦点时
    onblurFn: function onblurFn() {
      var number = _parseFloat$3(this.num);

      if (this.num === '') {
        Toast('请输入数字');
        this.num = this.oldNum;
        return;
      }

      if (isNan$2(Number(this.num))) {
        Toast('请输入数字');
        this.num = this.oldNum;
        return;
      }

      if (number > this.max) {
        Toast("\u8BF7\u8F93\u4E0D\u5927\u4E8E" + this.max + "\u7684\u6570\u503C");
        this.num = this.max;
        return;
      }

      if (number < this.min) {
        Toast("\u8BF7\u8F93\u4E0D\u5C0F\u4E8E" + this.min + "\u7684\u6570\u503C");
        this.num = this.min;
        return;
      }

      if (!this.num || this.step.toString().split('.').length - 1 > this.precision) {
        this.num = this.oldNum;
      } else {
        this.num = number.toFixed(this.precision);
      }

      this.oldNum = this.num;

      if (this.num !== this.oldNum) {
        this.$emit('change', _parseFloat$3(this.num));
        this.dispatch('bxs-form-item', 'form.item.validate');
      }

      this.$emit('blur', _parseFloat$3(this.num));
    },
    // 输入框获取焦点时
    onfocusFn: function onfocusFn() {
      if (isNan$2(Number(this.num))) {
        this.num = this.oldNum;
      }

      if (this.num) {
        if (this.precision > 0) {
          this.num = _parseFloat$3(this.num).toFixed(this.precision);
        } else {
          this.num = "" + this.num;
        }
      }

      this.oldNum = this.num;
      this.$emit('focus', _parseFloat$3(this.num));
      this.dispatch('bxs-form-item', 'form.item.reset');
    },
    // 加减操作
    changeNum: function changeNum(type) {
      var fixNum = this.precision;

      var num = _parseFloat$3(this.num);

      var tmpNum = _parseFloat$3(this.num);

      if (this.disabled) {
        return false;
      }

      var n = type === 'up' ? num + _parseFloat$3(this.step) : num - _parseFloat$3(this.step);

      if (fixNum === 0) {
        tmpNum = _parseFloat$3(n).toFixed(fixNum);
      } else {
        tmpNum = n;
        tmpNum = washNumFn(tmpNum, this.precision);
      }

      if (tmpNum > this.max) {
        tmpNum = this.max;
      }

      if (tmpNum < this.min) {
        tmpNum = this.min;
      }

      this.num = tmpNum;
      this.num = "" + this.num;
      this.oldNum = this.num;
      this.$emit(type === 'up' ? 'plus' : 'minus', _parseFloat$3(this.num));
      this.$emit('change', _parseFloat$3(this.num));
      this.dispatch('bxs-form-item', 'form.item.validate');
      return true;
    }
  }
});

/* script */
var __vue_script__$A = script$A;
/* template */

var __vue_render__$A = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "bx-stepper-control"
  }, [_c('div', {
    staticClass: "bx-stepper-minus",
    class: _vm.disabledMinusClass,
    on: {
      "click": function click($event) {
        _vm.changeNum('down');
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.num,
      expression: "num"
    }],
    staticClass: "bx-stepper-input",
    class: _vm.disableInputClass,
    attrs: {
      "type": "number",
      "disabled": _vm.disableInput || _vm.disabled
    },
    domProps: {
      "value": _vm.num
    },
    on: {
      "blur": _vm.onblurFn,
      "focus": _vm.onfocusFn,
      "input": function input($event) {
        if ($event.target.composing) {
          return;
        }

        _vm.num = $event.target.value;
      }
    }
  }), _c('div', {
    staticClass: "bx-stepper-plus",
    class: _vm.disabledAddClass,
    on: {
      "click": function click($event) {
        _vm.changeNum('up');
      }
    }
  })]);
};

var __vue_staticRenderFns__$A = [];
/* style */

var __vue_inject_styles__$A = undefined;
/* scoped */

var __vue_scope_id__$A = undefined;
/* module identifier */

var __vue_module_identifier__$A = undefined;
/* functional template */

var __vue_is_functional_template__$A = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$A =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$A,
  staticRenderFns: __vue_staticRenderFns__$A
}, __vue_inject_styles__$A, __vue_script__$A, __vue_scope_id__$A, __vue_is_functional_template__$A, __vue_module_identifier__$A, false, undefined, undefined, undefined);

var script$B = create({
  name: 'steps',
  created: function created() {
    if (this.stepCount) {
      var _context;

      if (some$2(_context = this.$slots.default).call(_context, function (step) {
        var _context2;

        return !(step.componentOptions === undefined && step.text && trim$5(_context2 = step.text).call(_context2) === '' || step.componentOptions && step.componentOptions.tag === 'bxs-step');
      })) {
        throw new Error("<bxs-steps>\u7684slot\u5143\u7D20\u53EA\u80FD\u4E3A<bxs-step>");
      }

      if (this.active > this.stepCount) {
        throw new Error("\u6B65\u9AA4\u503C\u4E0D\u80FD\u5927\u4E8E\u6B65\u9AA4\u6700\u5927\u503C: " + this.stepCount);
      }
    } else {
      throw new Error("\u7EC4\u4EF6\u6B65\u9AA4\u4E0D\u80FD\u4E3A\u7A7A");
    }
  },
  props: {
    type: {
      // 步骤类型
      type: String,
      default: 'horizontal',
      validator: function validator(value) {
        var _context3;

        // 值必须是这些字符串中的一个
        return indexOf$4(_context3 = ['horizontal', 'tail']).call(_context3, value) !== -1;
      }
    },
    active: {
      // 当前步骤
      type: Number,
      default: 0
    },
    activeColor: {
      // 激活状态颜色
      type: String,
      default: null
    },
    activeBgColor: {
      // tail类型。背景色
      type: String,
      default: null
    }
  },
  computed: {
    stepCount: function stepCount() {
      var _context4;

      return this.$slots.default && filter$2(_context4 = this.$slots.default).call(_context4, function (step) {
        return step.componentOptions && step.componentOptions.tag === 'bxs-step';
      }).length;
    }
  }
});

/* script */
var __vue_script__$B = script$B;
/* template */

var __vue_render__$B = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "bx-steps-wrapper"
  }, [_c('div', {
    class: "bx-steps-group bx-steps-group--" + _vm.type
  }, [_vm._t("default")], 2)]);
};

var __vue_staticRenderFns__$B = [];
/* style */

var __vue_inject_styles__$B = undefined;
/* scoped */

var __vue_scope_id__$B = undefined;
/* module identifier */

var __vue_module_identifier__$B = undefined;
/* functional template */

var __vue_is_functional_template__$B = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$B =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$B,
  staticRenderFns: __vue_staticRenderFns__$B
}, __vue_inject_styles__$B, __vue_script__$B, __vue_scope_id__$B, __vue_is_functional_template__$B, __vue_module_identifier__$B, false, undefined, undefined, undefined);

// `Date.now` method
// https://tc39.github.io/ecma262/#sec-date.now
_export({ target: 'Date', stat: true }, {
  now: function now() {
    return new Date().getTime();
  }
});

var now$1 = path.Date.now;

var now$2 = now$1;

var now$3 = now$2;

// 嗅探transform可支持的前缀
var elementStyle = document.createElement('div').style;

var vendor = function getVendor() {
  var vendors = ['t', 'webkitT', 'MozT', 'msT', 'OT'];
  var transform;
  var i = 0;
  var l = vendors.length;

  for (; i < l; i += 1) {
    transform = vendors[i] + "ransform";
    if (transform in elementStyle) return vendors[i].substr(0, vendors[i].length - 1);
  }

  return false;
}();

var prefixStyle = function prefixStyle(style) {
  if (vendor === false) return false;
  if (vendor === '') return style;
  return vendor + style.charAt(0).toUpperCase() + style.substr(1);
};

var transition = {
  prefixStyle: prefixStyle,
  transform: prefixStyle('transform'),
  transformProperty: prefixStyle('transitionProperty'),
  transitionDuration: prefixStyle('transitionDuration'),
  transitionTimingFunction: prefixStyle('transitionTimingFunction'),

  /* eslint no-param-reassign: ["error", { "props": false }] */
  // 设置transition属性
  setProperty: function setProperty(obj, property) {
    obj.style[prefixStyle('transitionProperty')] = property;
  },
  // 页面滑动到指定位置
  setTransform: function setTransform(obj, x, y) {
    obj.style[prefixStyle('transform')] = "translate3d(" + x + "px," + y + "px, 0px)";
  },
  // 设置transition间隔时间
  setDuration: function setDuration(obj, time) {
    obj.style[prefixStyle('transitionDuration')] = time + "ms";
  },
  // 设置scale
  setScale: function setScale(obj, scale) {
    obj.style[prefixStyle('transform')] = "scale(" + scale + ")";
  },
  // 设置transition的动画贝塞尔曲线
  setTimingFunction: function setTimingFunction(obj, easing) {
    obj.style[prefixStyle('transitionTimingFunction')] = easing;
  }
};

// @@match logic
fixRegexpWellKnownSymbolLogic('match', 1, function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible$1(this);
      var matcher = regexp == undefined ? undefined : regexp[MATCH];
      return matcher !== undefined ? matcher.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative(nativeMatch, regexp, this);
      if (res.done) return res.value;

      var rx = anObject$1(regexp);
      var S = String(this);

      if (!rx.global) return regexpExecAbstract(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regexpExecAbstract(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength$1(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});

var dom = {
  hasClass: function hasClass($dom, className) {
    return $dom.className.match(new RegExp(className));
  },

  /* eslint no-param-reassign: ["error", { "props": false }] */
  addClass: function addClass($dom, className) {
    if (!this.hasClass($dom, className)) {
      $dom.className += " " + className;
    }
  },
  removeClass: function removeClass($dom, className) {
    if (this.hasClass($dom, className)) {
      var reg = new RegExp("(\\s|^)" + className);
      $dom.className = $dom.className.replace(reg, '');
    }
  }
};

var props = {
  // 轮播间隔时间
  speed: {
    type: Number,
    default: 5000
  },
  // 轮播动画时间
  transitionSpeed: {
    type: Number,
    default: 300
  },
  // 是否循环轮播
  loop: {
    type: Boolean,
    default: true
  },
  // 是否自动轮播
  autoplay: {
    type: Boolean,
    default: true
  },
  // 是否展示指示器/分页器
  pagination: {
    type: Boolean,
    default: true
  },
  // 页数大于当前值时,才展示分页器
  paginationLimit: {
    type: Number,
    default: 1
  },
  // 覆盖默认指示器/分页器样式
  paginationClass: {
    type: String,
    default: null
  },
  // 页数大于当前值时,才展示分页器
  angle: {
    type: Number,
    default: 45
  },
  // 滑动结束后,时间小于{duration}毫秒并且距离大于{distance},即判定为滑动到上一个/下一个
  duration: {
    type: Number,
    default: 300
  },
  distance: {
    type: Number,
    default: 30
  },
  // 是否开启回弹
  bounce: {
    type: Boolean,
    default: true
  }
};

var touchEvents = {
  start: env.supportTouch ? 'touchstart' : 'mousedown',
  move: env.supportTouch ? 'touchmove' : 'mousemove',
  end: env.supportTouch ? 'touchend' : 'mouseup'
};
var timer = null;
var script$C = create({
  name: 'swiper',
  props: props,
  data: function data() {
    return {
      width: 0,
      currentIndex: 0,
      // 当前活动项
      count: 0,
      // 子元素个数
      touches: {
        startX: 0,
        // touch前一个点
        startY: 0,
        // touch前一个点
        currentX: 0,
        // touch后一个点
        currentY: 0,
        // touch后一个点
        distanceX: 0,
        // 两个touch之间的距离
        distanceY: 0 // 两个touch之间的距离

      },
      offset: {
        x: 0,
        // 横向滑动距离
        y: 0,
        // 纵向滑动距离
        distance: 0 // 滑动的距离

      },
      direction: null,
      // 滑动的方向
      startTime: null,
      // 控制滑动的时间不能太长
      endTime: null,
      // 控制滑动的时间不能太长
      isPagination: this.pagination,
      // 是否展示分页指示器
      isLoop: this.loop,
      // 是否循环滚动
      isBounce: this.bounce,
      // 是否回弹
      isTouch: false,
      // 是否点击
      isSliding: false,
      isTouchStart: false,
      isTouchEnd: false
    };
  },
  methods: {
    init: function init() {
      this.element = this.$el;
      this.scroller = this.$el.firstChild;
      this.width = this.element.clientWidth; // 防止swiper元素上设置了小数点宽度，而clientWidth取出来是整数

      this.scroller.style.width = this.width + "px";
      this.count = this.$children.length; // 当设置了分页指示器，并且数量大于指定数量，才展示指示器

      this.isPagination = this.pagination && this.count > this.paginationLimit; // 当数量为1时，自动取消循环

      this.isLoop = this.loop && this.count > 1;
      this.setIndex();

      if (this.isLoop) {
        // 循环滚动的数量
        this.loopCount = this.count + 2;
        this.createLoop();
      }

      if (this.autoplay && this.count > 1) {
        this.startAutoPlay();
      }
    },
    // 是否可以回弹
    canBounce: function canBounce() {
      var result = false;

      if (this.bounce && !this.isLoop) {
        if (this.currentIndex === 0 && this.direction === 'right') {
          result = true;
        }

        if (this.currentIndex === this.count - 1 && this.direction === 'left') {
          result = true;
        }
      }

      return result;
    },
    // 动态为每个项设置index
    setIndex: function setIndex() {
      var _context;

      forEach$2(_context = this.$children).call(_context, function (item, index) {
        /* eslint no-param-reassign: ["error", { "props": false }] */
        item.$data.index = index;
      });
    },
    // 更新index位置
    updateIndex: function updateIndex() {
      if (this.isLoop) {
        this.slideTo(-1 * (this.currentIndex + 1) * this.width, 0, 0);
      } else {
        this.slideTo(-1 * this.currentIndex * this.width, 0, 0);
      }
    },
    // 创建无限循环
    createLoop: function createLoop() {
      var firstNode = this.$children[0].$el.cloneNode(true);
      var lastNode = this.$children[this.count - 1].$el.cloneNode(true);
      dom.removeClass(firstNode, 'bx-swiper-item--active');
      dom.removeClass(lastNode, 'bx-swiper-item--active');
      this.scroller.insertBefore(lastNode, this.$children[0].$el);
      this.scroller.appendChild(firstNode); // 定位到第一个slideitem

      this.translate(-1 * this.width, 0);
    },
    // 处理循环滚动位置
    handleLoop: function handleLoop() {
      if (this.offset.x === 0) {
        this.slideTo(-1 * this.count * this.width, 0, 0);
      }

      if (this.offset.x === -1 * (this.loopCount - 1) * this.width) {
        this.slideTo(-1 * this.width, 0, 0);
      }
    },

    /* eslint-disable consistent-return */
    // 开启自动播放
    startAutoPlay: function startAutoPlay() {
      var _this = this;

      timer = window.setInterval(function () {
        if (_this.isTouchStart) {
          if (_this.isTouchEnd) {
            _this.isTouchStart = false;
            _this.isTouchEnd = false;
          }

          return false;
        }

        _this.next();
      }, this.speed);
    },
    addEvent: function addEvent() {
      var $element = this.element;
      var $scroller = this.scroller; // touchStart、touchMove、touchEnd事件

      $element.addEventListener(touchEvents.start, this.handleEvent, false);
      $element.addEventListener(touchEvents.move, this.handleEvent, false);
      $element.addEventListener(touchEvents.end, this.handleEvent, false); // 兼容PC
      // if (Env.supportTouch && !Env.isIos && !Env.isAndroid) {
      //   this.wrapper['addEventListener']('mousedown', this.handleEvent, false);
      //   this.wrapper['addEventListener']('mousemove', this.handleEvent, false);
      //   this.wrapper['addEventListener']('mouseup', this.handleEvent, false);
      // }
      // 动画结束事件

      $scroller.addEventListener('transitionend', this.handleEvent, false);
      $scroller.addEventListener('webkitTransitionEnd', this.handleEvent, false); // 窗口resize事件

      window.addEventListener('resize', this.handleEvent, false);
    },
    handleEvent: function handleEvent(e) {
      // if (e.originalEvent) e = e.originalEvent;
      switch (e.type) {
        case 'touchstart':
          this.onTouchStart(e);
          break;

        case 'touchmove':
          this.onTouchMove(e);
          break;

        case 'touchend':
          this.onTouchEnd(e);
          break;

        case 'mousedown':
          this.onTouchStart(e);
          break;

        case 'mousemove':
          this.onTouchMove(e);
          break;

        case 'mouseup':
          this.onTouchEnd(e);
          break;

        case 'transitionend':
          this.transitionEnd(e);
          break;

        case 'webkitTransitionEnd':
          this.transitionEnd(e);
          break;

        case 'resize':
          this.onResize(e);
          break;
      }
    },
    onTouchStart: function onTouchStart(e) {
      // 大于一个touch点,不做处理
      if (e.touches && e.touches.length > 1) {
        e.preventDefault();
        return false;
      }

      this.touches.startX = e.type === 'touchstart' ? e.touches[0].pageX : e.pageX;
      this.touches.startY = e.type === 'touchstart' ? e.touches[0].pageY : e.pageY;
      this.isTouch = true;
      this.isSliding = false;
      this.offset.distance = 0;
      this.startTime = now$3();
      this.isTouchStart = true;
      transition.setDuration(this.scroller, 0);
      this.$emit('touch-start', e);
    },
    onTouchMove: function onTouchMove(e) {
      // 大于一个touch点,不做处理
      if (!this.isTouch && e.type === 'mousemove' || e.touches && e.touches.length > 1) {
        e.preventDefault();
        return false;
      } // this.isLoop && this.handleLoop();


      this.touches.currentX = e.type === 'touchmove' ? e.touches[0].pageX : e.pageX;
      this.touches.currentY = e.type === 'touchmove' ? e.touches[0].pageY : e.pageY;
      var touchAngle = Math.atan2(Math.abs(this.touches.currentY - this.touches.startY), Math.abs(this.touches.currentX - this.touches.startX)) * 180 / Math.PI; // 滑动的角度小于{angle}才能正常滑动

      if (!this.isSliding) {
        this.isSliding = touchAngle <= this.angle;
      }

      if (!this.isSliding) {
        return false;
      }

      this.touches.distanceX = this.touches.currentX - this.touches.startX;
      this.touches.distanceY = this.touches.currentY - this.touches.startY;
      this.direction = this.touches.distanceX >= 0 ? 'right' : 'left';
      this.isBounce = this.canBounce();
      this.touches.distanceX = this.isBounce ? this.touches.distanceX / 2 : this.touches.distanceX;
      this.offset.x += this.touches.distanceX;
      this.offset.distance += this.touches.distanceX;
      this.translate(this.offset.x, 0);
      this.touches.startX = this.touches.currentX;
      this.touches.startY = this.touches.currentY;
      e.preventDefault();
      this.$emit('touch-move', e);
    },

    /* eslint-enable consistent-return */
    onTouchEnd: function onTouchEnd(e) {
      this.endTime = now$3();
      var duration = this.endTime - this.startTime;

      if (!this.isBounce && (duration <= this.duration && Math.abs(this.offset.distance) > this.distance || Math.abs(this.offset.distance) > this.width / 2)) {
        if (this.offset.distance > 0) {
          this.prev();
        } else {
          this.next();
        }
      } else {
        this.slideTo(this.offset.x - this.offset.distance, 0);
      }

      this.isTouch = false;
      this.isTouchEnd = true;
      this.$emit('touch-end', e);
    },
    transitionEnd: function transitionEnd(e) {
      if (this.isLoop) {
        this.handleLoop();
      }

      this.$emit('transition-end', e);
    },
    onResize: function onResize() {
      this.width = this.element.clientWidth;
      this.scroller.style.width = this.width + "px";
      this.updateIndex();
    },
    // 滚动到指定的x轴/y轴位置, time为动画时间
    slideTo: function slideTo(x, y, time) {
      /* eslint-disable no-param-reassign */
      if (time !== 0) {
        time = this.transitionSpeed;
      }

      transition.setProperty(this.scroller, transition.prefixStyle('transform'));
      transition.setDuration(this.scroller, time);
      this.translate(x, y);
    },
    // 滚动到指定的index
    slideToIndex: function slideToIndex(index, type) {
      if (this.loop) {
        if (type === 'prev') {
          if (index === this.count - 1) {
            this.slideTo(0, 0);
          } else {
            this.slideTo(-1 * (index + 1) * this.width, 0);
          }
        } else if (index === 0) {
          this.slideTo(-1 * (this.loopCount - 1) * this.width, 0);
        } else {
          this.slideTo(-1 * (index + 1) * this.width, 0);
        }
      } else {
        this.slideTo(-1 * index * this.width, 0);
      }

      this.$emit('slide', index);
    },
    // 滑动到上一个
    prev: function prev() {
      this.currentIndex -= 1;

      if (this.currentIndex < 0) {
        this.currentIndex = this.count - 1;
      }

      this.slideToIndex(this.currentIndex, 'prev');
      this.$emit('slide-prev', this.currentIndex);
    },
    // 滑动到下一个
    next: function next() {
      this.currentIndex += 1;

      if (this.currentIndex >= this.count) {
        this.currentIndex = 0;
      }

      this.slideToIndex(this.currentIndex, 'next');
      this.$emit('slide-next', this.currentIndex);
    },
    // 页面滑动到指定位置

    /* eslint-disable no-param-reassign */
    translate: function translate(x, y) {
      if (!this.bounce) {
        if (x > 0) {
          x = 0;
        }

        var total = this.loop ? this.loopCount : this.count;
        var totalDistance = (total - 1) * this.width;

        if (Math.abs(x) > totalDistance) {
          x = -1 * totalDistance;
        }
      }

      this.offset.x = x;
      transition.setTransform(this.scroller, x, y);
    }
  },
  mounted: function mounted() {
    this.init();
    this.addEvent();
  },
  destroyed: function destroyed() {
    if (timer) {
      window.clearInterval(timer);
    }
  }
});

/* script */
var __vue_script__$C = script$C;
/* template */

var __vue_render__$C = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "bx-swiper"
  }, [_c('div', {
    staticClass: "bx-swiper-scroller"
  }, [_vm._t("default")], 2), _vm.isPagination ? _c('div', {
    staticClass: "bx-swiper-paginations",
    class: _vm.paginationClass
  }, _vm._l(_vm.count, function (key) {
    return _c('div', {
      key: key,
      staticClass: "bx-swiper-pagination bx-swiper-pagination--translation",
      class: key - 1 == _vm.currentIndex && 'bx-swiper-pagination--active'
    });
  })) : _vm._e()]);
};

var __vue_staticRenderFns__$C = [];
/* style */

var __vue_inject_styles__$C = undefined;
/* scoped */

var __vue_scope_id__$C = undefined;
/* module identifier */

var __vue_module_identifier__$C = undefined;
/* functional template */

var __vue_is_functional_template__$C = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$C =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$C,
  staticRenderFns: __vue_staticRenderFns__$C
}, __vue_inject_styles__$C, __vue_script__$C, __vue_scope_id__$C, __vue_is_functional_template__$C, __vue_module_identifier__$C, false, undefined, undefined, undefined);

//
var script$D = create({
  name: 'swiper-item',
  data: function data() {
    return {
      index: 0
    };
  }
});

/* script */
var __vue_script__$D = script$D;
/* template */

var __vue_render__$D = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "bx-swiper-item",
    class: {
      'bx-swiper-item--active': _vm.$parent.currentIndex == _vm.index
    }
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$D = [];
/* style */

var __vue_inject_styles__$D = undefined;
/* scoped */

var __vue_scope_id__$D = undefined;
/* module identifier */

var __vue_module_identifier__$D = undefined;
/* functional template */

var __vue_is_functional_template__$D = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$D =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$D,
  staticRenderFns: __vue_staticRenderFns__$D
}, __vue_inject_styles__$D, __vue_script__$D, __vue_scope_id__$D, __vue_is_functional_template__$D, __vue_module_identifier__$D, false, undefined, undefined, undefined);

//
var script$E = create({
  name: 'switch',
  mixins: [Emitter],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    activeColor: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    style: function style() {
      var style = {};

      if (this.activeColor && this.selected) {
        style.backgroundColor = this.activeColor;
      }

      return style;
    },
    selected: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    onClick: function onClick() {
      this.selected = !this.selected;
    }
  },
  watch: {
    selected: function selected() {
      this.$emit('change', this.selected);
      this.dispatch('bxs-form-item', 'form.item.validate');
    }
  }
});

var __vue_script__$E = script$E;
/* template */

var __vue_render__$E = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "bx-switch-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.selected,
      expression: "selected"
    }],
    staticClass: "bx-switch",
    style: _vm.style,
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": isArray$3(_vm.selected) ? _vm._i(_vm.selected, null) > -1 : _vm.selected
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.selected,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;

        if (isArray$3($$a)) {
          var $$v = null,
              $$i = _vm._i($$a, $$v);

          if ($$el.checked) {
            $$i < 0 && (_vm.selected = concat$2($$a).call($$a, [$$v]));
          } else {
            var _context;

            $$i > -1 && (_vm.selected = concat$2(_context = slice$2($$a).call($$a, 0, $$i)).call(_context, slice$2($$a).call($$a, $$i + 1)));
          }
        } else {
          _vm.selected = $$c;
        }
      }
    }
  }), _c('span', {
    staticClass: "bx-switch-circle",
    on: {
      "click": _vm.onClick
    }
  })]);
};

var __vue_staticRenderFns__$E = [];
/* style */

var __vue_inject_styles__$E = undefined;
/* scoped */

var __vue_scope_id__$E = undefined;
/* module identifier */

var __vue_module_identifier__$E = undefined;
/* functional template */

var __vue_is_functional_template__$E = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$E =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$E,
  staticRenderFns: __vue_staticRenderFns__$E
}, __vue_inject_styles__$E, __vue_script__$E, __vue_scope_id__$E, __vue_is_functional_template__$E, __vue_module_identifier__$E, false, undefined, undefined, undefined);

var script$F = create({
  name: 'tab',
  props: {
    index: {
      type: Number,
      default: 0
    }
  },
  model: {
    prop: 'index',
    event: 'change'
  },
  data: function data() {
    return {
      currentIndex: this.index,
      isAdaptive: false,
      itemWidth: 0,
      lineWidth: 0,
      style: {}
    };
  },
  watch: {
    index: function index(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.safeSetCurrentIndex(newVal);
      }
    }
  },
  methods: {
    init: function init(currentIndex) {
      var _context,
          _context2,
          _this = this;

      // 如果宽度小于屏幕宽度，则自适应
      var totalWidth = 0;

      forEach$2(_context = this.$children).call(_context, function (item) {
        totalWidth += item.$el.clientWidth;
      });

      if (totalWidth < this.$el.clientWidth) {
        this.isAdaptive = true;
      } // 动态为每个项设置index


      forEach$2(_context2 = this.$children).call(_context2, function (item, index) {
        /* eslint no-param-reassign: ["error", { "props": false }] */
        item.$data.index = index;
      }); // 线条宽度


      this.lineWidth = this.$el.childNodes[0].lastChild.clientWidth; // 渲染结束后，再动态设置line的样式

      this.$nextTick(function () {
        // （额外）调用一次 calculateLineStyle 是必要的，因为 currentIndex 在 children 变少时可能无需改变（如果未越界），但标线因为 tab-item 宽度改变需要重算。
        _this.safeSetCurrentIndex(currentIndex);

        _this.calculateLineStyle();
      });
    },
    safeSetCurrentIndex: function safeSetCurrentIndex(currentIndex) {
      var newIndex = Math.max(Math.min(currentIndex, this.$children.length - 1), 0);

      if (newIndex === this.currentIndex) {
        return;
      }

      this.currentIndex = newIndex;
      this.calculateLineStyle();
      this.$emit('change', newIndex);
    },
    // 计算style
    calculateLineStyle: function calculateLineStyle() {
      // tab项宽度
      this.itemWidth = this.$children[this.currentIndex].$el.clientWidth;
      var left = this.$children[this.currentIndex].$el.offsetLeft + (this.itemWidth - this.lineWidth) / 2;
      left = this.toFixed(left, 1);
      this.style = {
        left: left + "px",
        transitionProperty: 'left'
      };
    },
    // 重写toFixed函数
    toFixed: function toFixed(value, decimal) {
      var times = Math.pow(10, decimal);
      var des = value * times + 0.5;
      des = _parseInt$3(des, 10) / times;
      des = des.toFixed(decimal);
      return "" + des;
    },
    // tab项改变监听
    itemListener: function itemListener() {
      var _this2 = this;

      this.$on('change-item', function (currentIndex) {
        _this2.safeSetCurrentIndex(currentIndex);
      });
    },
    childrenListener: function childrenListener() {
      var _this3 = this;

      this.$on('child-mutate', function () {
        _this3.init(_this3.currentIndex);
      });
    },
    // resize监听
    resizeListener: function resizeListener() {
      var _this4 = this;

      window.addEventListener('resize', function () {
        _this4.calculateLineStyle();
      }, false);
    }
  },
  mounted: function mounted() {
    this.init(this.index);
    this.itemListener();
    this.resizeListener();
    this.childrenListener();
  }
});

/* script */
var __vue_script__$F = script$F;
/* template */

var __vue_render__$F = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "bx-tab"
  }, [_c('div', {
    staticClass: "bx-tab-scroller"
  }, [_c('div', {
    staticClass: "bx-tab-wrap",
    class: _vm.isAdaptive && 'bx-tab-adaptive'
  }, [_vm._t("default")], 2), _c('div', {
    staticClass: "bx-tab-line",
    style: _vm.style
  })])]);
};

var __vue_staticRenderFns__$F = [];
/* style */

var __vue_inject_styles__$F = undefined;
/* scoped */

var __vue_scope_id__$F = undefined;
/* module identifier */

var __vue_module_identifier__$F = undefined;
/* functional template */

var __vue_is_functional_template__$F = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$F =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$F,
  staticRenderFns: __vue_staticRenderFns__$F
}, __vue_inject_styles__$F, __vue_script__$F, __vue_scope_id__$F, __vue_is_functional_template__$F, __vue_module_identifier__$F, false, undefined, undefined, undefined);

//
var script$G = create({
  name: 'tab-item',
  data: function data() {
    return {
      index: 0
    };
  },
  methods: {
    changeItem: function changeItem() {
      this.$parent.$emit('change-item', this.index);
    }
  },
  mounted: function mounted() {
    this.$parent.$emit('child-mutate');
  },
  destroyed: function destroyed() {
    this.$parent.$emit('child-mutate');
  }
});

/* script */
var __vue_script__$G = script$G;
/* template */

var __vue_render__$G = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "bx-tab-item",
    class: {
      'bx-tab-item--active': _vm.$parent.currentIndex == _vm.index
    },
    on: {
      "click": _vm.changeItem
    }
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$G = [];
/* style */

var __vue_inject_styles__$G = undefined;
/* scoped */

var __vue_scope_id__$G = undefined;
/* module identifier */

var __vue_module_identifier__$G = undefined;
/* functional template */

var __vue_is_functional_template__$G = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$G =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$G,
  staticRenderFns: __vue_staticRenderFns__$G
}, __vue_inject_styles__$G, __vue_script__$G, __vue_scope_id__$G, __vue_is_functional_template__$G, __vue_module_identifier__$G, false, undefined, undefined, undefined);

var typeList = ['default', 'primary', 'success', 'info', 'warning', 'danger', 'caution'];

var onlyValues$7 = function onlyValues(values) {
  return function (str) {
    return indexOf$4(values).call(values, str) !== -1;
  };
};

var script$H = create({
  name: 'tag',
  props: {
    plain: {
      type: Boolean,
      default: false
    },
    loose: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'default',
      validator: onlyValues$7(typeList)
    }
  },
  computed: {
    tagClass: function tagClass() {
      var obj = {
        'bx-tag--android': env.isAndroid,
        'bx-tag': true,
        'bx-tag--plain': this.plain,
        'bx-hairline--surround': this.plain,
        'bx-tag--loose': this.loose,
        'bx-tag-type--default': false
      };

      if (this.type && this.type !== 'default') {
        obj["bx-tag-type--" + this.type] = true;
      } else {
        obj["bx-tag-type--default"] = true;
      }

      return obj;
    }
  }
});

/* script */
var __vue_script__$H = script$H;
/* template */

var __vue_render__$H = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('span', {
    class: _vm.tagClass
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$H = [];
/* style */

var __vue_inject_styles__$H = undefined;
/* scoped */

var __vue_scope_id__$H = undefined;
/* module identifier */

var __vue_module_identifier__$H = undefined;
/* functional template */

var __vue_is_functional_template__$H = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$H =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$H,
  staticRenderFns: __vue_staticRenderFns__$H
}, __vue_inject_styles__$H, __vue_script__$H, __vue_scope_id__$H, __vue_is_functional_template__$H, __vue_module_identifier__$H, false, undefined, undefined, undefined);

var UNSCOPABLES = wellKnownSymbol$1('unscopables');
var ArrayPrototype$f = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype$f[UNSCOPABLES] == undefined) {
  createNonEnumerableProperty$1(ArrayPrototype$f, UNSCOPABLES, objectCreate$1(null));
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables = function (key) {
  ArrayPrototype$f[UNSCOPABLES][key] = true;
};

var correctPrototypeGetter$1 = !fails$1(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var IE_PROTO$3 = sharedKey$1('IE_PROTO');
var ObjectPrototype$2 = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.getprototypeof
var objectGetPrototypeOf$1 = correctPrototypeGetter$1 ? Object.getPrototypeOf : function (O) {
  O = toObject$1(O);
  if (has$2(O, IE_PROTO$3)) return O[IE_PROTO$3];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype$2 : null;
};

var ITERATOR$8 = wellKnownSymbol$1('iterator');
var BUGGY_SAFARI_ITERATORS$2 = false;

var returnThis$2 = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$3, PrototypeOfArrayIteratorPrototype$1, arrayIterator$1;

if ([].keys) {
  arrayIterator$1 = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator$1)) BUGGY_SAFARI_ITERATORS$2 = true;
  else {
    PrototypeOfArrayIteratorPrototype$1 = objectGetPrototypeOf$1(objectGetPrototypeOf$1(arrayIterator$1));
    if (PrototypeOfArrayIteratorPrototype$1 !== Object.prototype) IteratorPrototype$3 = PrototypeOfArrayIteratorPrototype$1;
  }
}

if (IteratorPrototype$3 == undefined) IteratorPrototype$3 = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if ( !has$2(IteratorPrototype$3, ITERATOR$8)) {
  createNonEnumerableProperty$1(IteratorPrototype$3, ITERATOR$8, returnThis$2);
}

var iteratorsCore$1 = {
  IteratorPrototype: IteratorPrototype$3,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$2
};

var IteratorPrototype$4 = iteratorsCore$1.IteratorPrototype;





var returnThis$3 = function () { return this; };

var createIteratorConstructor$1 = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = objectCreate$1(IteratorPrototype$4, { next: createPropertyDescriptor$1(1, next) });
  setToStringTag$1(IteratorConstructor, TO_STRING_TAG, false);
  iterators$1[TO_STRING_TAG] = returnThis$3;
  return IteratorConstructor;
};

var IteratorPrototype$5 = iteratorsCore$1.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS$3 = iteratorsCore$1.BUGGY_SAFARI_ITERATORS;
var ITERATOR$9 = wellKnownSymbol$1('iterator');
var KEYS$1 = 'keys';
var VALUES$1 = 'values';
var ENTRIES$1 = 'entries';

var returnThis$4 = function () { return this; };

var defineIterator$1 = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor$1(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS$3 && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS$1: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES$1: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES$1: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$9]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS$3 && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = objectGetPrototypeOf$1(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype$5 !== Object.prototype && CurrentIteratorPrototype.next) {
      if ( objectGetPrototypeOf$1(CurrentIteratorPrototype) !== IteratorPrototype$5) {
        if (objectSetPrototypeOf$1) {
          objectSetPrototypeOf$1(CurrentIteratorPrototype, IteratorPrototype$5);
        } else if (typeof CurrentIteratorPrototype[ITERATOR$9] != 'function') {
          createNonEnumerableProperty$1(CurrentIteratorPrototype, ITERATOR$9, returnThis$4);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag$1(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES$1 && nativeIterator && nativeIterator.name !== VALUES$1) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ( IterablePrototype[ITERATOR$9] !== defaultIterator) {
    createNonEnumerableProperty$1(IterablePrototype, ITERATOR$9, defaultIterator);
  }
  iterators$1[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES$1),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS$1),
      entries: getIterationMethod(ENTRIES$1)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS$3 || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine$1(IterablePrototype, KEY, methods[KEY]);
      }
    } else _export$1({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS$3 || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};

var ARRAY_ITERATOR$1 = 'Array Iterator';
var setInternalState$5 = internalState$1.set;
var getInternalState$5 = internalState$1.getterFor(ARRAY_ITERATOR$1);

// `Array.prototype.entries` method
// https://tc39.github.io/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.github.io/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.github.io/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.github.io/ecma262/#sec-createarrayiterator
var es_array_iterator$1 = defineIterator$1(Array, 'Array', function (iterated, kind) {
  setInternalState$5(this, {
    type: ARRAY_ITERATOR$1,
    target: toIndexedObject$1(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$5(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
// https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
iterators$1.Arguments = iterators$1.Array;

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

var defineProperty$a = objectDefineProperty$1.f;





var DataView$1 = global_1$1.DataView;
var DataViewPrototype = DataView$1 && DataView$1.prototype;
var Int8Array$1 = global_1$1.Int8Array;
var Int8ArrayPrototype = Int8Array$1 && Int8Array$1.prototype;
var Uint8ClampedArray = global_1$1.Uint8ClampedArray;
var Uint8ClampedArrayPrototype = Uint8ClampedArray && Uint8ClampedArray.prototype;
var TypedArray = Int8Array$1 && objectGetPrototypeOf$1(Int8Array$1);
var TypedArrayPrototype = Int8ArrayPrototype && objectGetPrototypeOf$1(Int8ArrayPrototype);
var ObjectPrototype$3 = Object.prototype;
var isPrototypeOf = ObjectPrototype$3.isPrototypeOf;

var TO_STRING_TAG$7 = wellKnownSymbol$1('toStringTag');
var TYPED_ARRAY_TAG = uid$1('TYPED_ARRAY_TAG');
var NATIVE_ARRAY_BUFFER = !!(global_1$1.ArrayBuffer && DataView$1);
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var NATIVE_ARRAY_BUFFER_VIEWS = NATIVE_ARRAY_BUFFER && !!objectSetPrototypeOf$1 && classof$1(global_1$1.opera) !== 'Opera';
var TYPED_ARRAY_TAG_REQIRED = false;
var NAME$1;

var TypedArrayConstructorsList = {
  Int8Array: 1,
  Uint8Array: 1,
  Uint8ClampedArray: 1,
  Int16Array: 2,
  Uint16Array: 2,
  Int32Array: 4,
  Uint32Array: 4,
  Float32Array: 4,
  Float64Array: 8
};

var isView = function isView(it) {
  var klass = classof$1(it);
  return klass === 'DataView' || has$2(TypedArrayConstructorsList, klass);
};

var isTypedArray = function (it) {
  return isObject$1(it) && has$2(TypedArrayConstructorsList, classof$1(it));
};

var aTypedArray = function (it) {
  if (isTypedArray(it)) return it;
  throw TypeError('Target is not a typed array');
};

var aTypedArrayConstructor = function (C) {
  if (objectSetPrototypeOf$1) {
    if (isPrototypeOf.call(TypedArray, C)) return C;
  } else for (var ARRAY in TypedArrayConstructorsList) if (has$2(TypedArrayConstructorsList, NAME$1)) {
    var TypedArrayConstructor = global_1$1[ARRAY];
    if (TypedArrayConstructor && (C === TypedArrayConstructor || isPrototypeOf.call(TypedArrayConstructor, C))) {
      return C;
    }
  } throw TypeError('Target is not a typed array constructor');
};

var exportTypedArrayMethod = function (KEY, property, forced) {
  if (!descriptors$1) return;
  if (forced) for (var ARRAY in TypedArrayConstructorsList) {
    var TypedArrayConstructor = global_1$1[ARRAY];
    if (TypedArrayConstructor && has$2(TypedArrayConstructor.prototype, KEY)) {
      delete TypedArrayConstructor.prototype[KEY];
    }
  }
  if (!TypedArrayPrototype[KEY] || forced) {
    redefine$1(TypedArrayPrototype, KEY, forced ? property
      : NATIVE_ARRAY_BUFFER_VIEWS && Int8ArrayPrototype[KEY] || property);
  }
};

var exportTypedArrayStaticMethod = function (KEY, property, forced) {
  var ARRAY, TypedArrayConstructor;
  if (!descriptors$1) return;
  if (objectSetPrototypeOf$1) {
    if (forced) for (ARRAY in TypedArrayConstructorsList) {
      TypedArrayConstructor = global_1$1[ARRAY];
      if (TypedArrayConstructor && has$2(TypedArrayConstructor, KEY)) {
        delete TypedArrayConstructor[KEY];
      }
    }
    if (!TypedArray[KEY] || forced) {
      // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
      try {
        return redefine$1(TypedArray, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS && Int8Array$1[KEY] || property);
      } catch (error) { /* empty */ }
    } else return;
  }
  for (ARRAY in TypedArrayConstructorsList) {
    TypedArrayConstructor = global_1$1[ARRAY];
    if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) {
      redefine$1(TypedArrayConstructor, KEY, property);
    }
  }
};

for (NAME$1 in TypedArrayConstructorsList) {
  if (!global_1$1[NAME$1]) NATIVE_ARRAY_BUFFER_VIEWS = false;
}

// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!NATIVE_ARRAY_BUFFER_VIEWS || typeof TypedArray != 'function' || TypedArray === Function.prototype) {
  // eslint-disable-next-line no-shadow
  TypedArray = function TypedArray() {
    throw TypeError('Incorrect invocation');
  };
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME$1 in TypedArrayConstructorsList) {
    if (global_1$1[NAME$1]) objectSetPrototypeOf$1(global_1$1[NAME$1], TypedArray);
  }
}

if (!NATIVE_ARRAY_BUFFER_VIEWS || !TypedArrayPrototype || TypedArrayPrototype === ObjectPrototype$3) {
  TypedArrayPrototype = TypedArray.prototype;
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME$1 in TypedArrayConstructorsList) {
    if (global_1$1[NAME$1]) objectSetPrototypeOf$1(global_1$1[NAME$1].prototype, TypedArrayPrototype);
  }
}

// WebKit bug - one more object in Uint8ClampedArray prototype chain
if (NATIVE_ARRAY_BUFFER_VIEWS && objectGetPrototypeOf$1(Uint8ClampedArrayPrototype) !== TypedArrayPrototype) {
  objectSetPrototypeOf$1(Uint8ClampedArrayPrototype, TypedArrayPrototype);
}

if (descriptors$1 && !has$2(TypedArrayPrototype, TO_STRING_TAG$7)) {
  TYPED_ARRAY_TAG_REQIRED = true;
  defineProperty$a(TypedArrayPrototype, TO_STRING_TAG$7, { get: function () {
    return isObject$1(this) ? this[TYPED_ARRAY_TAG] : undefined;
  } });
  for (NAME$1 in TypedArrayConstructorsList) if (global_1$1[NAME$1]) {
    createNonEnumerableProperty$1(global_1$1[NAME$1], TYPED_ARRAY_TAG, NAME$1);
  }
}

// WebKit bug - the same parent prototype for typed arrays and data view
if (NATIVE_ARRAY_BUFFER && objectSetPrototypeOf$1 && objectGetPrototypeOf$1(DataViewPrototype) !== ObjectPrototype$3) {
  objectSetPrototypeOf$1(DataViewPrototype, ObjectPrototype$3);
}

var arrayBufferViewCore = {
  NATIVE_ARRAY_BUFFER: NATIVE_ARRAY_BUFFER,
  NATIVE_ARRAY_BUFFER_VIEWS: NATIVE_ARRAY_BUFFER_VIEWS,
  TYPED_ARRAY_TAG: TYPED_ARRAY_TAG_REQIRED && TYPED_ARRAY_TAG,
  aTypedArray: aTypedArray,
  aTypedArrayConstructor: aTypedArrayConstructor,
  exportTypedArrayMethod: exportTypedArrayMethod,
  exportTypedArrayStaticMethod: exportTypedArrayStaticMethod,
  isView: isView,
  isTypedArray: isTypedArray,
  TypedArray: TypedArray,
  TypedArrayPrototype: TypedArrayPrototype
};

// `ToIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-toindex
var toIndex = function (it) {
  if (it === undefined) return 0;
  var number = toInteger$1(it);
  var length = toLength$1(number);
  if (number !== length) throw RangeError('Wrong length or index');
  return length;
};

// IEEE754 conversions based on https://github.com/feross/ieee754
// eslint-disable-next-line no-shadow-restricted-names
var Infinity$1 = 1 / 0;
var abs = Math.abs;
var pow$1 = Math.pow;
var floor$4 = Math.floor;
var log$1 = Math.log;
var LN2 = Math.LN2;

var pack = function (number, mantissaLength, bytes) {
  var buffer = new Array(bytes);
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var rt = mantissaLength === 23 ? pow$1(2, -24) - pow$1(2, -77) : 0;
  var sign = number < 0 || number === 0 && 1 / number < 0 ? 1 : 0;
  var index = 0;
  var exponent, mantissa, c;
  number = abs(number);
  // eslint-disable-next-line no-self-compare
  if (number != number || number === Infinity$1) {
    // eslint-disable-next-line no-self-compare
    mantissa = number != number ? 1 : 0;
    exponent = eMax;
  } else {
    exponent = floor$4(log$1(number) / LN2);
    if (number * (c = pow$1(2, -exponent)) < 1) {
      exponent--;
      c *= 2;
    }
    if (exponent + eBias >= 1) {
      number += rt / c;
    } else {
      number += rt * pow$1(2, 1 - eBias);
    }
    if (number * c >= 2) {
      exponent++;
      c /= 2;
    }
    if (exponent + eBias >= eMax) {
      mantissa = 0;
      exponent = eMax;
    } else if (exponent + eBias >= 1) {
      mantissa = (number * c - 1) * pow$1(2, mantissaLength);
      exponent = exponent + eBias;
    } else {
      mantissa = number * pow$1(2, eBias - 1) * pow$1(2, mantissaLength);
      exponent = 0;
    }
  }
  for (; mantissaLength >= 8; buffer[index++] = mantissa & 255, mantissa /= 256, mantissaLength -= 8);
  exponent = exponent << mantissaLength | mantissa;
  exponentLength += mantissaLength;
  for (; exponentLength > 0; buffer[index++] = exponent & 255, exponent /= 256, exponentLength -= 8);
  buffer[--index] |= sign * 128;
  return buffer;
};

var unpack = function (buffer, mantissaLength) {
  var bytes = buffer.length;
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var nBits = exponentLength - 7;
  var index = bytes - 1;
  var sign = buffer[index--];
  var exponent = sign & 127;
  var mantissa;
  sign >>= 7;
  for (; nBits > 0; exponent = exponent * 256 + buffer[index], index--, nBits -= 8);
  mantissa = exponent & (1 << -nBits) - 1;
  exponent >>= -nBits;
  nBits += mantissaLength;
  for (; nBits > 0; mantissa = mantissa * 256 + buffer[index], index--, nBits -= 8);
  if (exponent === 0) {
    exponent = 1 - eBias;
  } else if (exponent === eMax) {
    return mantissa ? NaN : sign ? -Infinity$1 : Infinity$1;
  } else {
    mantissa = mantissa + pow$1(2, mantissaLength);
    exponent = exponent - eBias;
  } return (sign ? -1 : 1) * mantissa * pow$1(2, exponent - mantissaLength);
};

var ieee754 = {
  pack: pack,
  unpack: unpack
};

// `Array.prototype.fill` method implementation
// https://tc39.github.io/ecma262/#sec-array.prototype.fill
var arrayFill = function fill(value /* , start = 0, end = @length */) {
  var O = toObject$1(this);
  var length = toLength$1(O.length);
  var argumentsLength = arguments.length;
  var index = toAbsoluteIndex$1(argumentsLength > 1 ? arguments[1] : undefined, length);
  var end = argumentsLength > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex$1(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};

var NATIVE_ARRAY_BUFFER$1 = arrayBufferViewCore.NATIVE_ARRAY_BUFFER;








var getOwnPropertyNames$2 = objectGetOwnPropertyNames.f;
var defineProperty$b = objectDefineProperty$1.f;




var getInternalState$6 = internalState$1.get;
var setInternalState$6 = internalState$1.set;
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE$3 = 'prototype';
var WRONG_LENGTH = 'Wrong length';
var WRONG_INDEX = 'Wrong index';
var NativeArrayBuffer = global_1$1[ARRAY_BUFFER];
var $ArrayBuffer = NativeArrayBuffer;
var $DataView = global_1$1[DATA_VIEW];
var RangeError$1 = global_1$1.RangeError;

var packIEEE754 = ieee754.pack;
var unpackIEEE754 = ieee754.unpack;

var packInt8 = function (number) {
  return [number & 0xFF];
};

var packInt16 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF];
};

var packInt32 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF, number >> 16 & 0xFF, number >> 24 & 0xFF];
};

var unpackInt32 = function (buffer) {
  return buffer[3] << 24 | buffer[2] << 16 | buffer[1] << 8 | buffer[0];
};

var packFloat32 = function (number) {
  return packIEEE754(number, 23, 4);
};

var packFloat64 = function (number) {
  return packIEEE754(number, 52, 8);
};

var addGetter = function (Constructor, key) {
  defineProperty$b(Constructor[PROTOTYPE$3], key, { get: function () { return getInternalState$6(this)[key]; } });
};

var get$2 = function (view, count, index, isLittleEndian) {
  var intIndex = toIndex(index);
  var store = getInternalState$6(view);
  if (intIndex + count > store.byteLength) throw RangeError$1(WRONG_INDEX);
  var bytes = getInternalState$6(store.buffer).bytes;
  var start = intIndex + store.byteOffset;
  var pack = bytes.slice(start, start + count);
  return isLittleEndian ? pack : pack.reverse();
};

var set$4 = function (view, count, index, conversion, value, isLittleEndian) {
  var intIndex = toIndex(index);
  var store = getInternalState$6(view);
  if (intIndex + count > store.byteLength) throw RangeError$1(WRONG_INDEX);
  var bytes = getInternalState$6(store.buffer).bytes;
  var start = intIndex + store.byteOffset;
  var pack = conversion(+value);
  for (var i = 0; i < count; i++) bytes[start + i] = pack[isLittleEndian ? i : count - i - 1];
};

if (!NATIVE_ARRAY_BUFFER$1) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance$1(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    setInternalState$6(this, {
      bytes: arrayFill.call(new Array(byteLength), 0),
      byteLength: byteLength
    });
    if (!descriptors$1) this.byteLength = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance$1(this, $DataView, DATA_VIEW);
    anInstance$1(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = getInternalState$6(buffer).byteLength;
    var offset = toInteger$1(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError$1('Wrong offset');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength$1(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError$1(WRONG_LENGTH);
    setInternalState$6(this, {
      buffer: buffer,
      byteLength: byteLength,
      byteOffset: offset
    });
    if (!descriptors$1) {
      this.buffer = buffer;
      this.byteLength = byteLength;
      this.byteOffset = offset;
    }
  };

  if (descriptors$1) {
    addGetter($ArrayBuffer, 'byteLength');
    addGetter($DataView, 'buffer');
    addGetter($DataView, 'byteLength');
    addGetter($DataView, 'byteOffset');
  }

  redefineAll$1($DataView[PROTOTYPE$3], {
    getInt8: function getInt8(byteOffset) {
      return get$2(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get$2(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get$2(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get$2(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackInt32(get$2(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackInt32(get$2(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined)) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get$2(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 23);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get$2(this, 8, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 52);
    },
    setInt8: function setInt8(byteOffset, value) {
      set$4(this, 1, byteOffset, packInt8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set$4(this, 1, byteOffset, packInt8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set$4(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set$4(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set$4(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set$4(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set$4(this, 4, byteOffset, packFloat32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set$4(this, 8, byteOffset, packFloat64, value, arguments.length > 2 ? arguments[2] : undefined);
    }
  });
} else {
  if (!fails$1(function () {
    NativeArrayBuffer(1);
  }) || !fails$1(function () {
    new NativeArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails$1(function () {
    new NativeArrayBuffer(); // eslint-disable-line no-new
    new NativeArrayBuffer(1.5); // eslint-disable-line no-new
    new NativeArrayBuffer(NaN); // eslint-disable-line no-new
    return NativeArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance$1(this, $ArrayBuffer);
      return new NativeArrayBuffer(toIndex(length));
    };
    var ArrayBufferPrototype = $ArrayBuffer[PROTOTYPE$3] = NativeArrayBuffer[PROTOTYPE$3];
    for (var keys$7 = getOwnPropertyNames$2(NativeArrayBuffer), j$1 = 0, key$1; keys$7.length > j$1;) {
      if (!((key$1 = keys$7[j$1++]) in $ArrayBuffer)) {
        createNonEnumerableProperty$1($ArrayBuffer, key$1, NativeArrayBuffer[key$1]);
      }
    }
    ArrayBufferPrototype.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var testView = new $DataView(new $ArrayBuffer(2));
  var nativeSetInt8 = $DataView[PROTOTYPE$3].setInt8;
  testView.setInt8(0, 2147483648);
  testView.setInt8(1, 2147483649);
  if (testView.getInt8(0) || !testView.getInt8(1)) redefineAll$1($DataView[PROTOTYPE$3], {
    setInt8: function setInt8(byteOffset, value) {
      nativeSetInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      nativeSetInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, { unsafe: true });
}

setToStringTag$1($ArrayBuffer, ARRAY_BUFFER);
setToStringTag$1($DataView, DATA_VIEW);

var arrayBuffer = {
  ArrayBuffer: $ArrayBuffer,
  DataView: $DataView
};

var ArrayBuffer = arrayBuffer.ArrayBuffer;
var DataView$2 = arrayBuffer.DataView;
var nativeArrayBufferSlice = ArrayBuffer.prototype.slice;

var INCORRECT_SLICE = fails$1(function () {
  return !new ArrayBuffer(2).slice(1, undefined).byteLength;
});

// `ArrayBuffer.prototype.slice` method
// https://tc39.github.io/ecma262/#sec-arraybuffer.prototype.slice
_export$1({ target: 'ArrayBuffer', proto: true, unsafe: true, forced: INCORRECT_SLICE }, {
  slice: function slice(start, end) {
    if (nativeArrayBufferSlice !== undefined && end === undefined) {
      return nativeArrayBufferSlice.call(anObject$1(this), start); // FF fix
    }
    var length = anObject$1(this).byteLength;
    var first = toAbsoluteIndex$1(start, length);
    var fin = toAbsoluteIndex$1(end === undefined ? length : end, length);
    var result = new (speciesConstructor(this, ArrayBuffer))(toLength$1(fin - first));
    var viewSource = new DataView$2(this);
    var viewTarget = new DataView$2(result);
    var index = 0;
    while (first < fin) {
      viewTarget.setUint8(index++, viewSource.getUint8(first++));
    } return result;
  }
});

var NATIVE_ARRAY_BUFFER$2 = arrayBufferViewCore.NATIVE_ARRAY_BUFFER;

// `DataView` constructor
// https://tc39.github.io/ecma262/#sec-dataview-constructor
_export$1({ global: true, forced: !NATIVE_ARRAY_BUFFER$2 }, {
  DataView: arrayBuffer.DataView
});

var charAt$2 = stringMultibyte.charAt;



var STRING_ITERATOR$1 = 'String Iterator';
var setInternalState$7 = internalState$1.set;
var getInternalState$7 = internalState$1.getterFor(STRING_ITERATOR$1);

// `String.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
defineIterator$1(String, 'String', function (iterated) {
  setInternalState$7(this, {
    type: STRING_ITERATOR$1,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState$7(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt$2(string, index);
  state.index += point.length;
  return { value: point, done: false };
});

/* eslint-disable no-new */



var NATIVE_ARRAY_BUFFER_VIEWS$1 = arrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;

var ArrayBuffer$1 = global_1$1.ArrayBuffer;
var Int8Array$2 = global_1$1.Int8Array;

var typedArraysConstructorsRequiresWrappers = !NATIVE_ARRAY_BUFFER_VIEWS$1 || !fails$1(function () {
  Int8Array$2(1);
}) || !fails$1(function () {
  new Int8Array$2(-1);
}) || !checkCorrectnessOfIteration$1(function (iterable) {
  new Int8Array$2();
  new Int8Array$2(null);
  new Int8Array$2(1.5);
  new Int8Array$2(iterable);
}, true) || fails$1(function () {
  // Safari (11+) bug - a reason why even Safari 13 should load a typed array polyfill
  return new Int8Array$2(new ArrayBuffer$1(2), 1, undefined).length !== 1;
});

var toPositiveInteger = function (it) {
  var result = toInteger$1(it);
  if (result < 0) throw RangeError("The argument can't be less than 0");
  return result;
};

var toOffset = function (it, BYTES) {
  var offset = toPositiveInteger(it);
  if (offset % BYTES) throw RangeError('Wrong offset');
  return offset;
};

var aTypedArrayConstructor$1 = arrayBufferViewCore.aTypedArrayConstructor;

var typedArrayFrom = function from(source /* , mapfn, thisArg */) {
  var O = toObject$1(source);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod$1(O);
  var i, length, result, step, iterator, next;
  if (iteratorMethod != undefined && !isArrayIteratorMethod$1(iteratorMethod)) {
    iterator = iteratorMethod.call(O);
    next = iterator.next;
    O = [];
    while (!(step = next.call(iterator)).done) {
      O.push(step.value);
    }
  }
  if (mapping && argumentsLength > 2) {
    mapfn = bindContext$1(mapfn, arguments[2], 2);
  }
  length = toLength$1(O.length);
  result = new (aTypedArrayConstructor$1(this))(length);
  for (i = 0; length > i; i++) {
    result[i] = mapping ? mapfn(O[i], i) : O[i];
  }
  return result;
};

var typedArrayConstructor = createCommonjsModule(function (module) {


















var getOwnPropertyNames = objectGetOwnPropertyNames.f;

var forEach = arrayIteration$1.forEach;






var getInternalState = internalState$1.get;
var setInternalState = internalState$1.set;
var nativeDefineProperty = objectDefineProperty$1.f;
var nativeGetOwnPropertyDescriptor = objectGetOwnPropertyDescriptor$1.f;
var round = Math.round;
var RangeError = global_1$1.RangeError;
var ArrayBuffer = arrayBuffer.ArrayBuffer;
var DataView = arrayBuffer.DataView;
var NATIVE_ARRAY_BUFFER_VIEWS = arrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;
var TYPED_ARRAY_TAG = arrayBufferViewCore.TYPED_ARRAY_TAG;
var TypedArray = arrayBufferViewCore.TypedArray;
var TypedArrayPrototype = arrayBufferViewCore.TypedArrayPrototype;
var aTypedArrayConstructor = arrayBufferViewCore.aTypedArrayConstructor;
var isTypedArray = arrayBufferViewCore.isTypedArray;
var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
var WRONG_LENGTH = 'Wrong length';

var fromList = function (C, list) {
  var index = 0;
  var length = list.length;
  var result = new (aTypedArrayConstructor(C))(length);
  while (length > index) result[index] = list[index++];
  return result;
};

var addGetter = function (it, key) {
  nativeDefineProperty(it, key, { get: function () {
    return getInternalState(this)[key];
  } });
};

var isArrayBuffer = function (it) {
  var klass;
  return it instanceof ArrayBuffer || (klass = classof$1(it)) == 'ArrayBuffer' || klass == 'SharedArrayBuffer';
};

var isTypedArrayIndex = function (target, key) {
  return isTypedArray(target)
    && typeof key != 'symbol'
    && key in target
    && String(+key) == String(key);
};

var wrappedGetOwnPropertyDescriptor = function getOwnPropertyDescriptor(target, key) {
  return isTypedArrayIndex(target, key = toPrimitive$1(key, true))
    ? createPropertyDescriptor$1(2, target[key])
    : nativeGetOwnPropertyDescriptor(target, key);
};

var wrappedDefineProperty = function defineProperty(target, key, descriptor) {
  if (isTypedArrayIndex(target, key = toPrimitive$1(key, true))
    && isObject$1(descriptor)
    && has$2(descriptor, 'value')
    && !has$2(descriptor, 'get')
    && !has$2(descriptor, 'set')
    // TODO: add validation descriptor w/o calling accessors
    && !descriptor.configurable
    && (!has$2(descriptor, 'writable') || descriptor.writable)
    && (!has$2(descriptor, 'enumerable') || descriptor.enumerable)
  ) {
    target[key] = descriptor.value;
    return target;
  } return nativeDefineProperty(target, key, descriptor);
};

if (descriptors$1) {
  if (!NATIVE_ARRAY_BUFFER_VIEWS) {
    objectGetOwnPropertyDescriptor$1.f = wrappedGetOwnPropertyDescriptor;
    objectDefineProperty$1.f = wrappedDefineProperty;
    addGetter(TypedArrayPrototype, 'buffer');
    addGetter(TypedArrayPrototype, 'byteOffset');
    addGetter(TypedArrayPrototype, 'byteLength');
    addGetter(TypedArrayPrototype, 'length');
  }

  _export$1({ target: 'Object', stat: true, forced: !NATIVE_ARRAY_BUFFER_VIEWS }, {
    getOwnPropertyDescriptor: wrappedGetOwnPropertyDescriptor,
    defineProperty: wrappedDefineProperty
  });

  module.exports = function (TYPE, wrapper, CLAMPED) {
    var BYTES = TYPE.match(/\d+$/)[0] / 8;
    var CONSTRUCTOR_NAME = TYPE + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + TYPE;
    var SETTER = 'set' + TYPE;
    var NativeTypedArrayConstructor = global_1$1[CONSTRUCTOR_NAME];
    var TypedArrayConstructor = NativeTypedArrayConstructor;
    var TypedArrayConstructorPrototype = TypedArrayConstructor && TypedArrayConstructor.prototype;
    var exported = {};

    var getter = function (that, index) {
      var data = getInternalState(that);
      return data.view[GETTER](index * BYTES + data.byteOffset, true);
    };

    var setter = function (that, index, value) {
      var data = getInternalState(that);
      if (CLAMPED) value = (value = round(value)) < 0 ? 0 : value > 0xFF ? 0xFF : value & 0xFF;
      data.view[SETTER](index * BYTES + data.byteOffset, value, true);
    };

    var addElement = function (that, index) {
      nativeDefineProperty(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };

    if (!NATIVE_ARRAY_BUFFER_VIEWS) {
      TypedArrayConstructor = wrapper(function (that, data, offset, $length) {
        anInstance$1(that, TypedArrayConstructor, CONSTRUCTOR_NAME);
        var index = 0;
        var byteOffset = 0;
        var buffer, byteLength, length;
        if (!isObject$1(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new ArrayBuffer(byteLength);
        } else if (isArrayBuffer(data)) {
          buffer = data;
          byteOffset = toOffset(offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - byteOffset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength$1($length) * BYTES;
            if (byteLength + byteOffset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (isTypedArray(data)) {
          return fromList(TypedArrayConstructor, data);
        } else {
          return typedArrayFrom.call(TypedArrayConstructor, data);
        }
        setInternalState(that, {
          buffer: buffer,
          byteOffset: byteOffset,
          byteLength: byteLength,
          length: length,
          view: new DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });

      if (objectSetPrototypeOf$1) objectSetPrototypeOf$1(TypedArrayConstructor, TypedArray);
      TypedArrayConstructorPrototype = TypedArrayConstructor.prototype = objectCreate$1(TypedArrayPrototype);
    } else if (typedArraysConstructorsRequiresWrappers) {
      TypedArrayConstructor = wrapper(function (dummy, data, typedArrayOffset, $length) {
        anInstance$1(dummy, TypedArrayConstructor, CONSTRUCTOR_NAME);
        return inheritIfRequired(function () {
          if (!isObject$1(data)) return new NativeTypedArrayConstructor(toIndex(data));
          if (isArrayBuffer(data)) return $length !== undefined
            ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES), $length)
            : typedArrayOffset !== undefined
              ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES))
              : new NativeTypedArrayConstructor(data);
          if (isTypedArray(data)) return fromList(TypedArrayConstructor, data);
          return typedArrayFrom.call(TypedArrayConstructor, data);
        }(), dummy, TypedArrayConstructor);
      });

      if (objectSetPrototypeOf$1) objectSetPrototypeOf$1(TypedArrayConstructor, TypedArray);
      forEach(getOwnPropertyNames(NativeTypedArrayConstructor), function (key) {
        if (!(key in TypedArrayConstructor)) {
          createNonEnumerableProperty$1(TypedArrayConstructor, key, NativeTypedArrayConstructor[key]);
        }
      });
      TypedArrayConstructor.prototype = TypedArrayConstructorPrototype;
    }

    if (TypedArrayConstructorPrototype.constructor !== TypedArrayConstructor) {
      createNonEnumerableProperty$1(TypedArrayConstructorPrototype, 'constructor', TypedArrayConstructor);
    }

    if (TYPED_ARRAY_TAG) {
      createNonEnumerableProperty$1(TypedArrayConstructorPrototype, TYPED_ARRAY_TAG, CONSTRUCTOR_NAME);
    }

    exported[CONSTRUCTOR_NAME] = TypedArrayConstructor;

    _export$1({
      global: true, forced: TypedArrayConstructor != NativeTypedArrayConstructor, sham: !NATIVE_ARRAY_BUFFER_VIEWS
    }, exported);

    if (!(BYTES_PER_ELEMENT in TypedArrayConstructor)) {
      createNonEnumerableProperty$1(TypedArrayConstructor, BYTES_PER_ELEMENT, BYTES);
    }

    if (!(BYTES_PER_ELEMENT in TypedArrayConstructorPrototype)) {
      createNonEnumerableProperty$1(TypedArrayConstructorPrototype, BYTES_PER_ELEMENT, BYTES);
    }

    setSpecies(CONSTRUCTOR_NAME);
  };
} else module.exports = function () { /* empty */ };
});

// `Uint8Array` constructor
// https://tc39.github.io/ecma262/#sec-typedarray-objects
typedArrayConstructor('Uint8', function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

var min$7 = Math.min;

// `Array.prototype.copyWithin` method implementation
// https://tc39.github.io/ecma262/#sec-array.prototype.copywithin
var arrayCopyWithin = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject$1(this);
  var len = toLength$1(O.length);
  var to = toAbsoluteIndex$1(target, len);
  var from = toAbsoluteIndex$1(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = min$7((end === undefined ? len : toAbsoluteIndex$1(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};

var aTypedArray$1 = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$1 = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.copyWithin` method
// https://tc39.github.io/ecma262/#sec-%typedarray%.prototype.copywithin
exportTypedArrayMethod$1('copyWithin', function copyWithin(target, start /* , end */) {
  return arrayCopyWithin.call(aTypedArray$1(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
});

var $every$1 = arrayIteration$1.every;

var aTypedArray$2 = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$2 = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.every` method
// https://tc39.github.io/ecma262/#sec-%typedarray%.prototype.every
exportTypedArrayMethod$2('every', function every(callbackfn /* , thisArg */) {
  return $every$1(aTypedArray$2(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});

var aTypedArray$3 = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$3 = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.fill` method
// https://tc39.github.io/ecma262/#sec-%typedarray%.prototype.fill
// eslint-disable-next-line no-unused-vars
exportTypedArrayMethod$3('fill', function fill(value /* , start, end */) {
  return arrayFill.apply(aTypedArray$3(this), arguments);
});

var $filter$1 = arrayIteration$1.filter;


var aTypedArray$4 = arrayBufferViewCore.aTypedArray;
var aTypedArrayConstructor$2 = arrayBufferViewCore.aTypedArrayConstructor;
var exportTypedArrayMethod$4 = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.filter` method
// https://tc39.github.io/ecma262/#sec-%typedarray%.prototype.filter
exportTypedArrayMethod$4('filter', function filter(callbackfn /* , thisArg */) {
  var list = $filter$1(aTypedArray$4(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  var C = speciesConstructor(this, this.constructor);
  var index = 0;
  var length = list.length;
  var result = new (aTypedArrayConstructor$2(C))(length);
  while (length > index) result[index] = list[index++];
  return result;
});

var $find$1 = arrayIteration$1.find;

var aTypedArray$5 = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$5 = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.find` method
// https://tc39.github.io/ecma262/#sec-%typedarray%.prototype.find
exportTypedArrayMethod$5('find', function find(predicate /* , thisArg */) {
  return $find$1(aTypedArray$5(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});

var $findIndex = arrayIteration$1.findIndex;

var aTypedArray$6 = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$6 = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.findIndex` method
// https://tc39.github.io/ecma262/#sec-%typedarray%.prototype.findindex
exportTypedArrayMethod$6('findIndex', function findIndex(predicate /* , thisArg */) {
  return $findIndex(aTypedArray$6(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});

var $forEach$2 = arrayIteration$1.forEach;

var aTypedArray$7 = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$7 = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.forEach` method
// https://tc39.github.io/ecma262/#sec-%typedarray%.prototype.foreach
exportTypedArrayMethod$7('forEach', function forEach(callbackfn /* , thisArg */) {
  $forEach$2(aTypedArray$7(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});

var $includes$1 = arrayIncludes$1.includes;

var aTypedArray$8 = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$8 = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-%typedarray%.prototype.includes
exportTypedArrayMethod$8('includes', function includes(searchElement /* , fromIndex */) {
  return $includes$1(aTypedArray$8(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});

var $indexOf$1 = arrayIncludes$1.indexOf;

var aTypedArray$9 = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$9 = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.indexOf` method
// https://tc39.github.io/ecma262/#sec-%typedarray%.prototype.indexof
exportTypedArrayMethod$9('indexOf', function indexOf(searchElement /* , fromIndex */) {
  return $indexOf$1(aTypedArray$9(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});

var ITERATOR$a = wellKnownSymbol$1('iterator');
var Uint8Array$1 = global_1$1.Uint8Array;
var arrayValues = es_array_iterator$1.values;
var arrayKeys = es_array_iterator$1.keys;
var arrayEntries = es_array_iterator$1.entries;
var aTypedArray$a = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$a = arrayBufferViewCore.exportTypedArrayMethod;
var nativeTypedArrayIterator = Uint8Array$1 && Uint8Array$1.prototype[ITERATOR$a];

var CORRECT_ITER_NAME = !!nativeTypedArrayIterator
  && (nativeTypedArrayIterator.name == 'values' || nativeTypedArrayIterator.name == undefined);

var typedArrayValues = function values() {
  return arrayValues.call(aTypedArray$a(this));
};

// `%TypedArray%.prototype.entries` method
// https://tc39.github.io/ecma262/#sec-%typedarray%.prototype.entries
exportTypedArrayMethod$a('entries', function entries() {
  return arrayEntries.call(aTypedArray$a(this));
});
// `%TypedArray%.prototype.keys` method
// https://tc39.github.io/ecma262/#sec-%typedarray%.prototype.keys
exportTypedArrayMethod$a('keys', function keys() {
  return arrayKeys.call(aTypedArray$a(this));
});
// `%TypedArray%.prototype.values` method
// https://tc39.github.io/ecma262/#sec-%typedarray%.prototype.values
exportTypedArrayMethod$a('values', typedArrayValues, !CORRECT_ITER_NAME);
// `%TypedArray%.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-%typedarray%.prototype-@@iterator
exportTypedArrayMethod$a(ITERATOR$a, typedArrayValues, !CORRECT_ITER_NAME);

var aTypedArray$b = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$b = arrayBufferViewCore.exportTypedArrayMethod;
var $join = [].join;

// `%TypedArray%.prototype.join` method
// https://tc39.github.io/ecma262/#sec-%typedarray%.prototype.join
// eslint-disable-next-line no-unused-vars
exportTypedArrayMethod$b('join', function join(separator) {
  return $join.apply(aTypedArray$b(this), arguments);
});

var min$8 = Math.min;
var nativeLastIndexOf = [].lastIndexOf;
var NEGATIVE_ZERO$1 = !!nativeLastIndexOf && 1 / [1].lastIndexOf(1, -0) < 0;
var SLOPPY_METHOD$2 = sloppyArrayMethod$1('lastIndexOf');

// `Array.prototype.lastIndexOf` method implementation
// https://tc39.github.io/ecma262/#sec-array.prototype.lastindexof
var arrayLastIndexOf = (NEGATIVE_ZERO$1 || SLOPPY_METHOD$2) ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
  // convert -0 to +0
  if (NEGATIVE_ZERO$1) return nativeLastIndexOf.apply(this, arguments) || 0;
  var O = toIndexedObject$1(this);
  var length = toLength$1(O.length);
  var index = length - 1;
  if (arguments.length > 1) index = min$8(index, toInteger$1(arguments[1]));
  if (index < 0) index = length + index;
  for (;index >= 0; index--) if (index in O && O[index] === searchElement) return index || 0;
  return -1;
} : nativeLastIndexOf;

var aTypedArray$c = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$c = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.lastIndexOf` method
// https://tc39.github.io/ecma262/#sec-%typedarray%.prototype.lastindexof
// eslint-disable-next-line no-unused-vars
exportTypedArrayMethod$c('lastIndexOf', function lastIndexOf(searchElement /* , fromIndex */) {
  return arrayLastIndexOf.apply(aTypedArray$c(this), arguments);
});

var $map$1 = arrayIteration$1.map;


var aTypedArray$d = arrayBufferViewCore.aTypedArray;
var aTypedArrayConstructor$3 = arrayBufferViewCore.aTypedArrayConstructor;
var exportTypedArrayMethod$d = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.map` method
// https://tc39.github.io/ecma262/#sec-%typedarray%.prototype.map
exportTypedArrayMethod$d('map', function map(mapfn /* , thisArg */) {
  return $map$1(aTypedArray$d(this), mapfn, arguments.length > 1 ? arguments[1] : undefined, function (O, length) {
    return new (aTypedArrayConstructor$3(speciesConstructor(O, O.constructor)))(length);
  });
});

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod$a = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aFunction$3(callbackfn);
    var O = toObject$1(that);
    var self = indexedObject$1(O);
    var length = toLength$1(O.length);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

var arrayReduce$1 = {
  // `Array.prototype.reduce` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.reduce
  left: createMethod$a(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.reduceright
  right: createMethod$a(true)
};

var $reduce$1 = arrayReduce$1.left;

var aTypedArray$e = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$e = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.reduce` method
// https://tc39.github.io/ecma262/#sec-%typedarray%.prototype.reduce
exportTypedArrayMethod$e('reduce', function reduce(callbackfn /* , initialValue */) {
  return $reduce$1(aTypedArray$e(this), callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
});

var $reduceRight = arrayReduce$1.right;

var aTypedArray$f = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$f = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.reduceRicht` method
// https://tc39.github.io/ecma262/#sec-%typedarray%.prototype.reduceright
exportTypedArrayMethod$f('reduceRight', function reduceRight(callbackfn /* , initialValue */) {
  return $reduceRight(aTypedArray$f(this), callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
});

var aTypedArray$g = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$g = arrayBufferViewCore.exportTypedArrayMethod;
var floor$5 = Math.floor;

// `%TypedArray%.prototype.reverse` method
// https://tc39.github.io/ecma262/#sec-%typedarray%.prototype.reverse
exportTypedArrayMethod$g('reverse', function reverse() {
  var that = this;
  var length = aTypedArray$g(that).length;
  var middle = floor$5(length / 2);
  var index = 0;
  var value;
  while (index < middle) {
    value = that[index];
    that[index++] = that[--length];
    that[length] = value;
  } return that;
});

var aTypedArray$h = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$h = arrayBufferViewCore.exportTypedArrayMethod;

var FORCED$8 = fails$1(function () {
  // eslint-disable-next-line no-undef
  new Int8Array(1).set({});
});

// `%TypedArray%.prototype.set` method
// https://tc39.github.io/ecma262/#sec-%typedarray%.prototype.set
exportTypedArrayMethod$h('set', function set(arrayLike /* , offset */) {
  aTypedArray$h(this);
  var offset = toOffset(arguments.length > 1 ? arguments[1] : undefined, 1);
  var length = this.length;
  var src = toObject$1(arrayLike);
  var len = toLength$1(src.length);
  var index = 0;
  if (len + offset > length) throw RangeError('Wrong length');
  while (index < len) this[offset + index] = src[index++];
}, FORCED$8);

var aTypedArray$i = arrayBufferViewCore.aTypedArray;
var aTypedArrayConstructor$4 = arrayBufferViewCore.aTypedArrayConstructor;
var exportTypedArrayMethod$i = arrayBufferViewCore.exportTypedArrayMethod;
var $slice = [].slice;

var FORCED$9 = fails$1(function () {
  // eslint-disable-next-line no-undef
  new Int8Array(1).slice();
});

// `%TypedArray%.prototype.slice` method
// https://tc39.github.io/ecma262/#sec-%typedarray%.prototype.slice
exportTypedArrayMethod$i('slice', function slice(start, end) {
  var list = $slice.call(aTypedArray$i(this), start, end);
  var C = speciesConstructor(this, this.constructor);
  var index = 0;
  var length = list.length;
  var result = new (aTypedArrayConstructor$4(C))(length);
  while (length > index) result[index] = list[index++];
  return result;
}, FORCED$9);

var $some$1 = arrayIteration$1.some;

var aTypedArray$j = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$j = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.some` method
// https://tc39.github.io/ecma262/#sec-%typedarray%.prototype.some
exportTypedArrayMethod$j('some', function some(callbackfn /* , thisArg */) {
  return $some$1(aTypedArray$j(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});

var aTypedArray$k = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$k = arrayBufferViewCore.exportTypedArrayMethod;
var $sort = [].sort;

// `%TypedArray%.prototype.sort` method
// https://tc39.github.io/ecma262/#sec-%typedarray%.prototype.sort
exportTypedArrayMethod$k('sort', function sort(comparefn) {
  return $sort.call(aTypedArray$k(this), comparefn);
});

var aTypedArray$l = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$l = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.subarray` method
// https://tc39.github.io/ecma262/#sec-%typedarray%.prototype.subarray
exportTypedArrayMethod$l('subarray', function subarray(begin, end) {
  var O = aTypedArray$l(this);
  var length = O.length;
  var beginIndex = toAbsoluteIndex$1(begin, length);
  return new (speciesConstructor(O, O.constructor))(
    O.buffer,
    O.byteOffset + beginIndex * O.BYTES_PER_ELEMENT,
    toLength$1((end === undefined ? length : toAbsoluteIndex$1(end, length)) - beginIndex)
  );
});

var Int8Array$3 = global_1$1.Int8Array;
var aTypedArray$m = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$m = arrayBufferViewCore.exportTypedArrayMethod;
var $toLocaleString = [].toLocaleString;
var $slice$1 = [].slice;

// iOS Safari 6.x fails here
var TO_LOCALE_STRING_BUG = !!Int8Array$3 && fails$1(function () {
  $toLocaleString.call(new Int8Array$3(1));
});

var FORCED$a = fails$1(function () {
  return [1, 2].toLocaleString() != new Int8Array$3([1, 2]).toLocaleString();
}) || !fails$1(function () {
  Int8Array$3.prototype.toLocaleString.call([1, 2]);
});

// `%TypedArray%.prototype.toLocaleString` method
// https://tc39.github.io/ecma262/#sec-%typedarray%.prototype.tolocalestring
exportTypedArrayMethod$m('toLocaleString', function toLocaleString() {
  return $toLocaleString.apply(TO_LOCALE_STRING_BUG ? $slice$1.call(aTypedArray$m(this)) : aTypedArray$m(this), arguments);
}, FORCED$a);

var exportTypedArrayMethod$n = arrayBufferViewCore.exportTypedArrayMethod;



var Uint8Array$2 = global_1$1.Uint8Array;
var Uint8ArrayPrototype = Uint8Array$2 && Uint8Array$2.prototype || {};
var arrayToString = [].toString;
var arrayJoin = [].join;

if (fails$1(function () { arrayToString.call({}); })) {
  arrayToString = function toString() {
    return arrayJoin.call(this);
  };
}

var IS_NOT_ARRAY_METHOD = Uint8ArrayPrototype.toString != arrayToString;

// `%TypedArray%.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-%typedarray%.prototype.tostring
exportTypedArrayMethod$n('toString', arrayToString, IS_NOT_ARRAY_METHOD);

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables$1 = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

var ITERATOR$b = wellKnownSymbol$1('iterator');
var TO_STRING_TAG$8 = wellKnownSymbol$1('toStringTag');
var ArrayValues = es_array_iterator$1.values;

for (var COLLECTION_NAME$1 in domIterables$1) {
  var Collection$1 = global_1$1[COLLECTION_NAME$1];
  var CollectionPrototype$1 = Collection$1 && Collection$1.prototype;
  if (CollectionPrototype$1) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype$1[ITERATOR$b] !== ArrayValues) try {
      createNonEnumerableProperty$1(CollectionPrototype$1, ITERATOR$b, ArrayValues);
    } catch (error) {
      CollectionPrototype$1[ITERATOR$b] = ArrayValues;
    }
    if (!CollectionPrototype$1[TO_STRING_TAG$8]) {
      createNonEnumerableProperty$1(CollectionPrototype$1, TO_STRING_TAG$8, COLLECTION_NAME$1);
    }
    if (domIterables$1[COLLECTION_NAME$1]) for (var METHOD_NAME in es_array_iterator$1) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype$1[METHOD_NAME] !== es_array_iterator$1[METHOD_NAME]) try {
        createNonEnumerableProperty$1(CollectionPrototype$1, METHOD_NAME, es_array_iterator$1[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype$1[METHOD_NAME] = es_array_iterator$1[METHOD_NAME];
      }
    }
  }
}

var ITERATOR$c = wellKnownSymbol$1('iterator');

var nativeUrl = !fails$1(function () {
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var searchParams = url.searchParams;
  var result = '';
  url.pathname = 'c%20d';
  searchParams.forEach(function (value, key) {
    searchParams['delete']('b');
    result += key + value;
  });
  return (isPure$1 && !url.toJSON)
    || !searchParams.sort
    || url.href !== 'http://a/c%20d?a=1&c=3'
    || searchParams.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !searchParams[ITERATOR$c]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('http://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('http://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('http://x', undefined).host !== 'x';
});

var nativeAssign$1 = Object.assign;
var defineProperty$c = Object.defineProperty;

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
var objectAssign$1 = !nativeAssign$1 || fails$1(function () {
  // should have correct order of operations (Edge bug)
  if (descriptors$1 && nativeAssign$1({ b: 1 }, nativeAssign$1(defineProperty$c({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$c(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return nativeAssign$1({}, A)[symbol] != 7 || objectKeys$1(nativeAssign$1({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject$1(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
  var propertyIsEnumerable = objectPropertyIsEnumerable$1.f;
  while (argumentsLength > index) {
    var S = indexedObject$1(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys$1(S).concat(getOwnPropertySymbols(S)) : objectKeys$1(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!descriptors$1 || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : nativeAssign$1;

var createProperty$1 = function (object, key, value) {
  var propertyKey = toPrimitive$1(key);
  if (propertyKey in object) objectDefineProperty$1.f(object, propertyKey, createPropertyDescriptor$1(0, value));
  else object[propertyKey] = value;
};

// `Array.from` method implementation
// https://tc39.github.io/ecma262/#sec-array.from
var arrayFrom = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject$1(arrayLike);
  var C = typeof this == 'function' ? this : Array;
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var index = 0;
  var iteratorMethod = getIteratorMethod$1(O);
  var length, result, step, iterator, next;
  if (mapping) mapfn = bindContext$1(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod$1(iteratorMethod))) {
    iterator = iteratorMethod.call(O);
    next = iterator.next;
    result = new C();
    for (;!(step = next.call(iterator)).done; index++) {
      createProperty$1(result, index, mapping
        ? callWithSafeIterationClosing$1(iterator, mapfn, [step.value, index], true)
        : step.value
      );
    }
  } else {
    length = toLength$1(O.length);
    result = new C(length);
    for (;length > index; index++) {
      createProperty$1(result, index, mapping ? mapfn(O[index], index) : O[index]);
    }
  }
  result.length = index;
  return result;
};

// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js
var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = '-'; // '\x2D'
var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
var baseMinusTMin = base - tMin;
var floor$6 = Math.floor;
var stringFromCharCode = String.fromCharCode;

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */
var ucs2decode = function (string) {
  var output = [];
  var counter = 0;
  var length = string.length;
  while (counter < length) {
    var value = string.charCodeAt(counter++);
    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // It's a high surrogate, and there is a next character.
      var extra = string.charCodeAt(counter++);
      if ((extra & 0xFC00) == 0xDC00) { // Low surrogate.
        output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // It's an unmatched surrogate; only append this code unit, in case the
        // next code unit is the high surrogate of a surrogate pair.
        output.push(value);
        counter--;
      }
    } else {
      output.push(value);
    }
  }
  return output;
};

/**
 * Converts a digit/integer into a basic code point.
 */
var digitToBasic = function (digit) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */
var adapt = function (delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor$6(delta / damp) : delta >> 1;
  delta += floor$6(delta / numPoints);
  for (; delta > baseMinusTMin * tMax >> 1; k += base) {
    delta = floor$6(delta / baseMinusTMin);
  }
  return floor$6(k + (baseMinusTMin + 1) * delta / (delta + skew));
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */
// eslint-disable-next-line  max-statements
var encode = function (input) {
  var output = [];

  // Convert the input in UCS-2 to an array of Unicode code points.
  input = ucs2decode(input);

  // Cache the length.
  var inputLength = input.length;

  // Initialize the state.
  var n = initialN;
  var delta = 0;
  var bias = initialBias;
  var i, currentValue;

  // Handle the basic code points.
  for (i = 0; i < input.length; i++) {
    currentValue = input[i];
    if (currentValue < 0x80) {
      output.push(stringFromCharCode(currentValue));
    }
  }

  var basicLength = output.length; // number of basic code points.
  var handledCPCount = basicLength; // number of code points that have been handled;

  // Finish the basic string with a delimiter unless it's empty.
  if (basicLength) {
    output.push(delimiter);
  }

  // Main encoding loop:
  while (handledCPCount < inputLength) {
    // All non-basic code points < n have been handled already. Find the next larger one:
    var m = maxInt;
    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    }

    // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
    var handledCPCountPlusOne = handledCPCount + 1;
    if (m - n > floor$6((maxInt - delta) / handledCPCountPlusOne)) {
      throw RangeError(OVERFLOW_ERROR);
    }

    delta += (m - n) * handledCPCountPlusOne;
    n = m;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue < n && ++delta > maxInt) {
        throw RangeError(OVERFLOW_ERROR);
      }
      if (currentValue == n) {
        // Represent delta as a generalized variable-length integer.
        var q = delta;
        for (var k = base; /* no condition */; k += base) {
          var t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
          if (q < t) break;
          var qMinusT = q - t;
          var baseMinusT = base - t;
          output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
          q = floor$6(qMinusT / baseMinusT);
        }

        output.push(stringFromCharCode(digitToBasic(q)));
        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
        delta = 0;
        ++handledCPCount;
      }
    }

    ++delta;
    ++n;
  }
  return output.join('');
};

var punycodeToAscii = function (input) {
  var encoded = [];
  var labels = input.toLowerCase().replace(regexSeparators, '\u002E').split('.');
  var i, label;
  for (i = 0; i < labels.length; i++) {
    label = labels[i];
    encoded.push(regexNonASCII.test(label) ? 'xn--' + encode(label) : label);
  }
  return encoded.join('.');
};

var getIterator = function (it) {
  var iteratorMethod = getIteratorMethod$1(it);
  if (typeof iteratorMethod != 'function') {
    throw TypeError(String(it) + ' is not iterable');
  } return anObject$1(iteratorMethod.call(it));
};

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`





















var $fetch$2 = getBuiltIn$1('fetch');
var Headers = getBuiltIn$1('Headers');
var ITERATOR$d = wellKnownSymbol$1('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState$8 = internalState$1.set;
var getInternalParamsState = internalState$1.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = internalState$1.getterFor(URL_SEARCH_PARAMS_ITERATOR);

var plus = /\+/g;
var sequences = Array(4);

var percentSequence = function (bytes) {
  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode = function (sequence) {
  try {
    return decodeURIComponent(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize = function (it) {
  var result = it.replace(plus, ' ');
  var bytes = 4;
  try {
    return decodeURIComponent(result);
  } catch (error) {
    while (bytes) {
      result = result.replace(percentSequence(bytes--), percentDecode);
    }
    return result;
  }
};

var find$3 = /[!'()~]|%20/g;

var replace = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replace[match];
};

var serialize = function (it) {
  return encodeURIComponent(it).replace(find$3, replacer);
};

var parseSearchParams = function (result, query) {
  if (query) {
    var attributes = query.split('&');
    var index = 0;
    var attribute, entry;
    while (index < attributes.length) {
      attribute = attributes[index++];
      if (attribute.length) {
        entry = attribute.split('=');
        result.push({
          key: deserialize(entry.shift()),
          value: deserialize(entry.join('='))
        });
      }
    }
  }
};

var updateSearchParams = function (query) {
  this.entries.length = 0;
  parseSearchParams(this.entries, query);
};

var validateArgumentsLength = function (passed, required) {
  if (passed < required) throw TypeError('Not enough arguments');
};

var URLSearchParamsIterator = createIteratorConstructor$1(function Iterator(params, kind) {
  setInternalState$8(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    iterator: getIterator(getInternalParamsState(params).entries),
    kind: kind
  });
}, 'Iterator', function next() {
  var state = getInternalIteratorState(this);
  var kind = state.kind;
  var step = state.iterator.next();
  var entry = step.value;
  if (!step.done) {
    step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [entry.key, entry.value];
  } return step;
});

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance$1(this, URLSearchParamsConstructor, URL_SEARCH_PARAMS);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  var that = this;
  var entries = [];
  var iteratorMethod, iterator, next, step, entryIterator, entryNext, first, second, key;

  setInternalState$8(that, {
    type: URL_SEARCH_PARAMS,
    entries: entries,
    updateURL: function () { /* empty */ },
    updateSearchParams: updateSearchParams
  });

  if (init !== undefined) {
    if (isObject$1(init)) {
      iteratorMethod = getIteratorMethod$1(init);
      if (typeof iteratorMethod === 'function') {
        iterator = iteratorMethod.call(init);
        next = iterator.next;
        while (!(step = next.call(iterator)).done) {
          entryIterator = getIterator(anObject$1(step.value));
          entryNext = entryIterator.next;
          if (
            (first = entryNext.call(entryIterator)).done ||
            (second = entryNext.call(entryIterator)).done ||
            !entryNext.call(entryIterator).done
          ) throw TypeError('Expected sequence with length 2');
          entries.push({ key: first.value + '', value: second.value + '' });
        }
      } else for (key in init) if (has$2(init, key)) entries.push({ key: key, value: init[key] + '' });
    } else {
      parseSearchParams(entries, typeof init === 'string' ? init.charAt(0) === '?' ? init.slice(1) : init : init + '');
    }
  }
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

redefineAll$1(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.appent` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    validateArgumentsLength(arguments.length, 2);
    var state = getInternalParamsState(this);
    state.entries.push({ key: name + '', value: value + '' });
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var key = name + '';
    var index = 0;
    while (index < entries.length) {
      if (entries[index].key === key) entries.splice(index, 1);
      else index++;
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = name + '';
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = name + '';
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) result.push(entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = name + '';
    var index = 0;
    while (index < entries.length) {
      if (entries[index++].key === key) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var found = false;
    var key = name + '';
    var val = value + '';
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) entries.splice(index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) entries.push({ key: key, value: val });
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    var entries = state.entries;
    // Array#sort is not stable in some engines
    var slice = entries.slice();
    var entry, entriesIndex, sliceIndex;
    entries.length = 0;
    for (sliceIndex = 0; sliceIndex < slice.length; sliceIndex++) {
      entry = slice[sliceIndex];
      for (entriesIndex = 0; entriesIndex < sliceIndex; entriesIndex++) {
        if (entries[entriesIndex].key > entry.key) {
          entries.splice(entriesIndex, 0, entry);
          break;
        }
      }
      if (entriesIndex === sliceIndex) entries.push(entry);
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = bindContext$1(callback, arguments.length > 1 ? arguments[1] : undefined, 3);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
redefine$1(URLSearchParamsPrototype, ITERATOR$d, URLSearchParamsPrototype.entries);

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
redefine$1(URLSearchParamsPrototype, 'toString', function toString() {
  var entries = getInternalParamsState(this).entries;
  var result = [];
  var index = 0;
  var entry;
  while (index < entries.length) {
    entry = entries[index++];
    result.push(serialize(entry.key) + '=' + serialize(entry.value));
  } return result.join('&');
}, { enumerable: true });

setToStringTag$1(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

_export$1({ global: true, forced: !nativeUrl }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` for correct work with polyfilled `URLSearchParams`
// https://github.com/zloirock/core-js/issues/674
if (!nativeUrl && typeof $fetch$2 == 'function' && typeof Headers == 'function') {
  _export$1({ global: true, enumerable: true, forced: true }, {
    fetch: function fetch(input /* , init */) {
      var args = [input];
      var init, body, headers;
      if (arguments.length > 1) {
        init = arguments[1];
        if (isObject$1(init)) {
          body = init.body;
          if (classof$1(body) === URL_SEARCH_PARAMS) {
            headers = init.headers ? new Headers(init.headers) : new Headers();
            if (!headers.has('content-type')) {
              headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
            }
            init = objectCreate$1(init, {
              body: createPropertyDescriptor$1(0, String(body)),
              headers: createPropertyDescriptor$1(0, headers)
            });
          }
        }
        args.push(init);
      } return $fetch$2.apply(this, args);
    }
  });
}

var web_urlSearchParams = {
  URLSearchParams: URLSearchParamsConstructor,
  getState: getInternalParamsState
};

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`











var codeAt = stringMultibyte.codeAt;





var NativeURL = global_1$1.URL;
var URLSearchParams$1 = web_urlSearchParams.URLSearchParams;
var getInternalSearchParamsState = web_urlSearchParams.getState;
var setInternalState$9 = internalState$1.set;
var getInternalURLState = internalState$1.getterFor('URL');
var floor$7 = Math.floor;
var pow$2 = Math.pow;

var INVALID_AUTHORITY = 'Invalid authority';
var INVALID_SCHEME = 'Invalid scheme';
var INVALID_HOST = 'Invalid host';
var INVALID_PORT = 'Invalid port';

var ALPHA = /[A-Za-z]/;
var ALPHANUMERIC = /[\d+\-.A-Za-z]/;
var DIGIT = /\d/;
var HEX_START = /^(0x|0X)/;
var OCT = /^[0-7]+$/;
var DEC = /^\d+$/;
var HEX = /^[\dA-Fa-f]+$/;
// eslint-disable-next-line no-control-regex
var FORBIDDEN_HOST_CODE_POINT = /[\u0000\u0009\u000A\u000D #%/:?@[\\]]/;
// eslint-disable-next-line no-control-regex
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\u0000\u0009\u000A\u000D #/:?@[\\]]/;
// eslint-disable-next-line no-control-regex
var LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE = /^[\u0000-\u001F ]+|[\u0000-\u001F ]+$/g;
// eslint-disable-next-line no-control-regex
var TAB_AND_NEW_LINE = /[\u0009\u000A\u000D]/g;
var EOF;

var parseHost = function (url, input) {
  var result, codePoints, index;
  if (input.charAt(0) == '[') {
    if (input.charAt(input.length - 1) != ']') return INVALID_HOST;
    result = parseIPv6(input.slice(1, -1));
    if (!result) return INVALID_HOST;
    url.host = result;
  // opaque host
  } else if (!isSpecial(url)) {
    if (FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT.test(input)) return INVALID_HOST;
    result = '';
    codePoints = arrayFrom(input);
    for (index = 0; index < codePoints.length; index++) {
      result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
    }
    url.host = result;
  } else {
    input = punycodeToAscii(input);
    if (FORBIDDEN_HOST_CODE_POINT.test(input)) return INVALID_HOST;
    result = parseIPv4(input);
    if (result === null) return INVALID_HOST;
    url.host = result;
  }
};

var parseIPv4 = function (input) {
  var parts = input.split('.');
  var partsLength, numbers, index, part, radix, number, ipv4;
  if (parts.length && parts[parts.length - 1] == '') {
    parts.pop();
  }
  partsLength = parts.length;
  if (partsLength > 4) return input;
  numbers = [];
  for (index = 0; index < partsLength; index++) {
    part = parts[index];
    if (part == '') return input;
    radix = 10;
    if (part.length > 1 && part.charAt(0) == '0') {
      radix = HEX_START.test(part) ? 16 : 8;
      part = part.slice(radix == 8 ? 1 : 2);
    }
    if (part === '') {
      number = 0;
    } else {
      if (!(radix == 10 ? DEC : radix == 8 ? OCT : HEX).test(part)) return input;
      number = parseInt(part, radix);
    }
    numbers.push(number);
  }
  for (index = 0; index < partsLength; index++) {
    number = numbers[index];
    if (index == partsLength - 1) {
      if (number >= pow$2(256, 5 - partsLength)) return null;
    } else if (number > 255) return null;
  }
  ipv4 = numbers.pop();
  for (index = 0; index < numbers.length; index++) {
    ipv4 += numbers[index] * pow$2(256, 3 - index);
  }
  return ipv4;
};

// eslint-disable-next-line max-statements
var parseIPv6 = function (input) {
  var address = [0, 0, 0, 0, 0, 0, 0, 0];
  var pieceIndex = 0;
  var compress = null;
  var pointer = 0;
  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;

  var char = function () {
    return input.charAt(pointer);
  };

  if (char() == ':') {
    if (input.charAt(1) != ':') return;
    pointer += 2;
    pieceIndex++;
    compress = pieceIndex;
  }
  while (char()) {
    if (pieceIndex == 8) return;
    if (char() == ':') {
      if (compress !== null) return;
      pointer++;
      pieceIndex++;
      compress = pieceIndex;
      continue;
    }
    value = length = 0;
    while (length < 4 && HEX.test(char())) {
      value = value * 16 + parseInt(char(), 16);
      pointer++;
      length++;
    }
    if (char() == '.') {
      if (length == 0) return;
      pointer -= length;
      if (pieceIndex > 6) return;
      numbersSeen = 0;
      while (char()) {
        ipv4Piece = null;
        if (numbersSeen > 0) {
          if (char() == '.' && numbersSeen < 4) pointer++;
          else return;
        }
        if (!DIGIT.test(char())) return;
        while (DIGIT.test(char())) {
          number = parseInt(char(), 10);
          if (ipv4Piece === null) ipv4Piece = number;
          else if (ipv4Piece == 0) return;
          else ipv4Piece = ipv4Piece * 10 + number;
          if (ipv4Piece > 255) return;
          pointer++;
        }
        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
        numbersSeen++;
        if (numbersSeen == 2 || numbersSeen == 4) pieceIndex++;
      }
      if (numbersSeen != 4) return;
      break;
    } else if (char() == ':') {
      pointer++;
      if (!char()) return;
    } else if (char()) return;
    address[pieceIndex++] = value;
  }
  if (compress !== null) {
    swaps = pieceIndex - compress;
    pieceIndex = 7;
    while (pieceIndex != 0 && swaps > 0) {
      swap = address[pieceIndex];
      address[pieceIndex--] = address[compress + swaps - 1];
      address[compress + --swaps] = swap;
    }
  } else if (pieceIndex != 8) return;
  return address;
};

var findLongestZeroSequence = function (ipv6) {
  var maxIndex = null;
  var maxLength = 1;
  var currStart = null;
  var currLength = 0;
  var index = 0;
  for (; index < 8; index++) {
    if (ipv6[index] !== 0) {
      if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
      }
      currStart = null;
      currLength = 0;
    } else {
      if (currStart === null) currStart = index;
      ++currLength;
    }
  }
  if (currLength > maxLength) {
    maxIndex = currStart;
    maxLength = currLength;
  }
  return maxIndex;
};

var serializeHost = function (host) {
  var result, index, compress, ignore0;
  // ipv4
  if (typeof host == 'number') {
    result = [];
    for (index = 0; index < 4; index++) {
      result.unshift(host % 256);
      host = floor$7(host / 256);
    } return result.join('.');
  // ipv6
  } else if (typeof host == 'object') {
    result = '';
    compress = findLongestZeroSequence(host);
    for (index = 0; index < 8; index++) {
      if (ignore0 && host[index] === 0) continue;
      if (ignore0) ignore0 = false;
      if (compress === index) {
        result += index ? ':' : '::';
        ignore0 = true;
      } else {
        result += host[index].toString(16);
        if (index < 7) result += ':';
      }
    }
    return '[' + result + ']';
  } return host;
};

var C0ControlPercentEncodeSet = {};
var fragmentPercentEncodeSet = objectAssign$1({}, C0ControlPercentEncodeSet, {
  ' ': 1, '"': 1, '<': 1, '>': 1, '`': 1
});
var pathPercentEncodeSet = objectAssign$1({}, fragmentPercentEncodeSet, {
  '#': 1, '?': 1, '{': 1, '}': 1
});
var userinfoPercentEncodeSet = objectAssign$1({}, pathPercentEncodeSet, {
  '/': 1, ':': 1, ';': 1, '=': 1, '@': 1, '[': 1, '\\': 1, ']': 1, '^': 1, '|': 1
});

var percentEncode = function (char, set) {
  var code = codeAt(char, 0);
  return code > 0x20 && code < 0x7F && !has$2(set, char) ? char : encodeURIComponent(char);
};

var specialSchemes = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
};

var isSpecial = function (url) {
  return has$2(specialSchemes, url.scheme);
};

var includesCredentials = function (url) {
  return url.username != '' || url.password != '';
};

var cannotHaveUsernamePasswordPort = function (url) {
  return !url.host || url.cannotBeABaseURL || url.scheme == 'file';
};

var isWindowsDriveLetter = function (string, normalized) {
  var second;
  return string.length == 2 && ALPHA.test(string.charAt(0))
    && ((second = string.charAt(1)) == ':' || (!normalized && second == '|'));
};

var startsWithWindowsDriveLetter = function (string) {
  var third;
  return string.length > 1 && isWindowsDriveLetter(string.slice(0, 2)) && (
    string.length == 2 ||
    ((third = string.charAt(2)) === '/' || third === '\\' || third === '?' || third === '#')
  );
};

var shortenURLsPath = function (url) {
  var path = url.path;
  var pathSize = path.length;
  if (pathSize && (url.scheme != 'file' || pathSize != 1 || !isWindowsDriveLetter(path[0], true))) {
    path.pop();
  }
};

var isSingleDot = function (segment) {
  return segment === '.' || segment.toLowerCase() === '%2e';
};

var isDoubleDot = function (segment) {
  segment = segment.toLowerCase();
  return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
};

// States:
var SCHEME_START = {};
var SCHEME = {};
var NO_SCHEME = {};
var SPECIAL_RELATIVE_OR_AUTHORITY = {};
var PATH_OR_AUTHORITY = {};
var RELATIVE = {};
var RELATIVE_SLASH = {};
var SPECIAL_AUTHORITY_SLASHES = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var AUTHORITY = {};
var HOST = {};
var HOSTNAME = {};
var PORT = {};
var FILE = {};
var FILE_SLASH = {};
var FILE_HOST = {};
var PATH_START = {};
var PATH = {};
var CANNOT_BE_A_BASE_URL_PATH = {};
var QUERY = {};
var FRAGMENT = {};

// eslint-disable-next-line max-statements
var parseURL = function (url, input, stateOverride, base) {
  var state = stateOverride || SCHEME_START;
  var pointer = 0;
  var buffer = '';
  var seenAt = false;
  var seenBracket = false;
  var seenPasswordToken = false;
  var codePoints, char, bufferCodePoints, failure;

  if (!stateOverride) {
    url.scheme = '';
    url.username = '';
    url.password = '';
    url.host = null;
    url.port = null;
    url.path = [];
    url.query = null;
    url.fragment = null;
    url.cannotBeABaseURL = false;
    input = input.replace(LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE, '');
  }

  input = input.replace(TAB_AND_NEW_LINE, '');

  codePoints = arrayFrom(input);

  while (pointer <= codePoints.length) {
    char = codePoints[pointer];
    switch (state) {
      case SCHEME_START:
        if (char && ALPHA.test(char)) {
          buffer += char.toLowerCase();
          state = SCHEME;
        } else if (!stateOverride) {
          state = NO_SCHEME;
          continue;
        } else return INVALID_SCHEME;
        break;

      case SCHEME:
        if (char && (ALPHANUMERIC.test(char) || char == '+' || char == '-' || char == '.')) {
          buffer += char.toLowerCase();
        } else if (char == ':') {
          if (stateOverride && (
            (isSpecial(url) != has$2(specialSchemes, buffer)) ||
            (buffer == 'file' && (includesCredentials(url) || url.port !== null)) ||
            (url.scheme == 'file' && !url.host)
          )) return;
          url.scheme = buffer;
          if (stateOverride) {
            if (isSpecial(url) && specialSchemes[url.scheme] == url.port) url.port = null;
            return;
          }
          buffer = '';
          if (url.scheme == 'file') {
            state = FILE;
          } else if (isSpecial(url) && base && base.scheme == url.scheme) {
            state = SPECIAL_RELATIVE_OR_AUTHORITY;
          } else if (isSpecial(url)) {
            state = SPECIAL_AUTHORITY_SLASHES;
          } else if (codePoints[pointer + 1] == '/') {
            state = PATH_OR_AUTHORITY;
            pointer++;
          } else {
            url.cannotBeABaseURL = true;
            url.path.push('');
            state = CANNOT_BE_A_BASE_URL_PATH;
          }
        } else if (!stateOverride) {
          buffer = '';
          state = NO_SCHEME;
          pointer = 0;
          continue;
        } else return INVALID_SCHEME;
        break;

      case NO_SCHEME:
        if (!base || (base.cannotBeABaseURL && char != '#')) return INVALID_SCHEME;
        if (base.cannotBeABaseURL && char == '#') {
          url.scheme = base.scheme;
          url.path = base.path.slice();
          url.query = base.query;
          url.fragment = '';
          url.cannotBeABaseURL = true;
          state = FRAGMENT;
          break;
        }
        state = base.scheme == 'file' ? FILE : RELATIVE;
        continue;

      case SPECIAL_RELATIVE_OR_AUTHORITY:
        if (char == '/' && codePoints[pointer + 1] == '/') {
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          pointer++;
        } else {
          state = RELATIVE;
          continue;
        } break;

      case PATH_OR_AUTHORITY:
        if (char == '/') {
          state = AUTHORITY;
          break;
        } else {
          state = PATH;
          continue;
        }

      case RELATIVE:
        url.scheme = base.scheme;
        if (char == EOF) {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.query = base.query;
        } else if (char == '/' || (char == '\\' && isSpecial(url))) {
          state = RELATIVE_SLASH;
        } else if (char == '?') {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.query = '';
          state = QUERY;
        } else if (char == '#') {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.query = base.query;
          url.fragment = '';
          state = FRAGMENT;
        } else {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.path.pop();
          state = PATH;
          continue;
        } break;

      case RELATIVE_SLASH:
        if (isSpecial(url) && (char == '/' || char == '\\')) {
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
        } else if (char == '/') {
          state = AUTHORITY;
        } else {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          state = PATH;
          continue;
        } break;

      case SPECIAL_AUTHORITY_SLASHES:
        state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
        if (char != '/' || buffer.charAt(pointer + 1) != '/') continue;
        pointer++;
        break;

      case SPECIAL_AUTHORITY_IGNORE_SLASHES:
        if (char != '/' && char != '\\') {
          state = AUTHORITY;
          continue;
        } break;

      case AUTHORITY:
        if (char == '@') {
          if (seenAt) buffer = '%40' + buffer;
          seenAt = true;
          bufferCodePoints = arrayFrom(buffer);
          for (var i = 0; i < bufferCodePoints.length; i++) {
            var codePoint = bufferCodePoints[i];
            if (codePoint == ':' && !seenPasswordToken) {
              seenPasswordToken = true;
              continue;
            }
            var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
            if (seenPasswordToken) url.password += encodedCodePoints;
            else url.username += encodedCodePoints;
          }
          buffer = '';
        } else if (
          char == EOF || char == '/' || char == '?' || char == '#' ||
          (char == '\\' && isSpecial(url))
        ) {
          if (seenAt && buffer == '') return INVALID_AUTHORITY;
          pointer -= arrayFrom(buffer).length + 1;
          buffer = '';
          state = HOST;
        } else buffer += char;
        break;

      case HOST:
      case HOSTNAME:
        if (stateOverride && url.scheme == 'file') {
          state = FILE_HOST;
          continue;
        } else if (char == ':' && !seenBracket) {
          if (buffer == '') return INVALID_HOST;
          failure = parseHost(url, buffer);
          if (failure) return failure;
          buffer = '';
          state = PORT;
          if (stateOverride == HOSTNAME) return;
        } else if (
          char == EOF || char == '/' || char == '?' || char == '#' ||
          (char == '\\' && isSpecial(url))
        ) {
          if (isSpecial(url) && buffer == '') return INVALID_HOST;
          if (stateOverride && buffer == '' && (includesCredentials(url) || url.port !== null)) return;
          failure = parseHost(url, buffer);
          if (failure) return failure;
          buffer = '';
          state = PATH_START;
          if (stateOverride) return;
          continue;
        } else {
          if (char == '[') seenBracket = true;
          else if (char == ']') seenBracket = false;
          buffer += char;
        } break;

      case PORT:
        if (DIGIT.test(char)) {
          buffer += char;
        } else if (
          char == EOF || char == '/' || char == '?' || char == '#' ||
          (char == '\\' && isSpecial(url)) ||
          stateOverride
        ) {
          if (buffer != '') {
            var port = parseInt(buffer, 10);
            if (port > 0xFFFF) return INVALID_PORT;
            url.port = (isSpecial(url) && port === specialSchemes[url.scheme]) ? null : port;
            buffer = '';
          }
          if (stateOverride) return;
          state = PATH_START;
          continue;
        } else return INVALID_PORT;
        break;

      case FILE:
        url.scheme = 'file';
        if (char == '/' || char == '\\') state = FILE_SLASH;
        else if (base && base.scheme == 'file') {
          if (char == EOF) {
            url.host = base.host;
            url.path = base.path.slice();
            url.query = base.query;
          } else if (char == '?') {
            url.host = base.host;
            url.path = base.path.slice();
            url.query = '';
            state = QUERY;
          } else if (char == '#') {
            url.host = base.host;
            url.path = base.path.slice();
            url.query = base.query;
            url.fragment = '';
            state = FRAGMENT;
          } else {
            if (!startsWithWindowsDriveLetter(codePoints.slice(pointer).join(''))) {
              url.host = base.host;
              url.path = base.path.slice();
              shortenURLsPath(url);
            }
            state = PATH;
            continue;
          }
        } else {
          state = PATH;
          continue;
        } break;

      case FILE_SLASH:
        if (char == '/' || char == '\\') {
          state = FILE_HOST;
          break;
        }
        if (base && base.scheme == 'file' && !startsWithWindowsDriveLetter(codePoints.slice(pointer).join(''))) {
          if (isWindowsDriveLetter(base.path[0], true)) url.path.push(base.path[0]);
          else url.host = base.host;
        }
        state = PATH;
        continue;

      case FILE_HOST:
        if (char == EOF || char == '/' || char == '\\' || char == '?' || char == '#') {
          if (!stateOverride && isWindowsDriveLetter(buffer)) {
            state = PATH;
          } else if (buffer == '') {
            url.host = '';
            if (stateOverride) return;
            state = PATH_START;
          } else {
            failure = parseHost(url, buffer);
            if (failure) return failure;
            if (url.host == 'localhost') url.host = '';
            if (stateOverride) return;
            buffer = '';
            state = PATH_START;
          } continue;
        } else buffer += char;
        break;

      case PATH_START:
        if (isSpecial(url)) {
          state = PATH;
          if (char != '/' && char != '\\') continue;
        } else if (!stateOverride && char == '?') {
          url.query = '';
          state = QUERY;
        } else if (!stateOverride && char == '#') {
          url.fragment = '';
          state = FRAGMENT;
        } else if (char != EOF) {
          state = PATH;
          if (char != '/') continue;
        } break;

      case PATH:
        if (
          char == EOF || char == '/' ||
          (char == '\\' && isSpecial(url)) ||
          (!stateOverride && (char == '?' || char == '#'))
        ) {
          if (isDoubleDot(buffer)) {
            shortenURLsPath(url);
            if (char != '/' && !(char == '\\' && isSpecial(url))) {
              url.path.push('');
            }
          } else if (isSingleDot(buffer)) {
            if (char != '/' && !(char == '\\' && isSpecial(url))) {
              url.path.push('');
            }
          } else {
            if (url.scheme == 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
              if (url.host) url.host = '';
              buffer = buffer.charAt(0) + ':'; // normalize windows drive letter
            }
            url.path.push(buffer);
          }
          buffer = '';
          if (url.scheme == 'file' && (char == EOF || char == '?' || char == '#')) {
            while (url.path.length > 1 && url.path[0] === '') {
              url.path.shift();
            }
          }
          if (char == '?') {
            url.query = '';
            state = QUERY;
          } else if (char == '#') {
            url.fragment = '';
            state = FRAGMENT;
          }
        } else {
          buffer += percentEncode(char, pathPercentEncodeSet);
        } break;

      case CANNOT_BE_A_BASE_URL_PATH:
        if (char == '?') {
          url.query = '';
          state = QUERY;
        } else if (char == '#') {
          url.fragment = '';
          state = FRAGMENT;
        } else if (char != EOF) {
          url.path[0] += percentEncode(char, C0ControlPercentEncodeSet);
        } break;

      case QUERY:
        if (!stateOverride && char == '#') {
          url.fragment = '';
          state = FRAGMENT;
        } else if (char != EOF) {
          if (char == "'" && isSpecial(url)) url.query += '%27';
          else if (char == '#') url.query += '%23';
          else url.query += percentEncode(char, C0ControlPercentEncodeSet);
        } break;

      case FRAGMENT:
        if (char != EOF) url.fragment += percentEncode(char, fragmentPercentEncodeSet);
        break;
    }

    pointer++;
  }
};

// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var URLConstructor = function URL(url /* , base */) {
  var that = anInstance$1(this, URLConstructor, 'URL');
  var base = arguments.length > 1 ? arguments[1] : undefined;
  var urlString = String(url);
  var state = setInternalState$9(that, { type: 'URL' });
  var baseState, failure;
  if (base !== undefined) {
    if (base instanceof URLConstructor) baseState = getInternalURLState(base);
    else {
      failure = parseURL(baseState = {}, String(base));
      if (failure) throw TypeError(failure);
    }
  }
  failure = parseURL(state, urlString, null, baseState);
  if (failure) throw TypeError(failure);
  var searchParams = state.searchParams = new URLSearchParams$1();
  var searchParamsState = getInternalSearchParamsState(searchParams);
  searchParamsState.updateSearchParams(state.query);
  searchParamsState.updateURL = function () {
    state.query = String(searchParams) || null;
  };
  if (!descriptors$1) {
    that.href = serializeURL.call(that);
    that.origin = getOrigin.call(that);
    that.protocol = getProtocol.call(that);
    that.username = getUsername.call(that);
    that.password = getPassword.call(that);
    that.host = getHost.call(that);
    that.hostname = getHostname.call(that);
    that.port = getPort.call(that);
    that.pathname = getPathname.call(that);
    that.search = getSearch.call(that);
    that.searchParams = getSearchParams.call(that);
    that.hash = getHash.call(that);
  }
};

var URLPrototype = URLConstructor.prototype;

var serializeURL = function () {
  var url = getInternalURLState(this);
  var scheme = url.scheme;
  var username = url.username;
  var password = url.password;
  var host = url.host;
  var port = url.port;
  var path = url.path;
  var query = url.query;
  var fragment = url.fragment;
  var output = scheme + ':';
  if (host !== null) {
    output += '//';
    if (includesCredentials(url)) {
      output += username + (password ? ':' + password : '') + '@';
    }
    output += serializeHost(host);
    if (port !== null) output += ':' + port;
  } else if (scheme == 'file') output += '//';
  output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + path.join('/') : '';
  if (query !== null) output += '?' + query;
  if (fragment !== null) output += '#' + fragment;
  return output;
};

var getOrigin = function () {
  var url = getInternalURLState(this);
  var scheme = url.scheme;
  var port = url.port;
  if (scheme == 'blob') try {
    return new URL(scheme.path[0]).origin;
  } catch (error) {
    return 'null';
  }
  if (scheme == 'file' || !isSpecial(url)) return 'null';
  return scheme + '://' + serializeHost(url.host) + (port !== null ? ':' + port : '');
};

var getProtocol = function () {
  return getInternalURLState(this).scheme + ':';
};

var getUsername = function () {
  return getInternalURLState(this).username;
};

var getPassword = function () {
  return getInternalURLState(this).password;
};

var getHost = function () {
  var url = getInternalURLState(this);
  var host = url.host;
  var port = url.port;
  return host === null ? ''
    : port === null ? serializeHost(host)
    : serializeHost(host) + ':' + port;
};

var getHostname = function () {
  var host = getInternalURLState(this).host;
  return host === null ? '' : serializeHost(host);
};

var getPort = function () {
  var port = getInternalURLState(this).port;
  return port === null ? '' : String(port);
};

var getPathname = function () {
  var url = getInternalURLState(this);
  var path = url.path;
  return url.cannotBeABaseURL ? path[0] : path.length ? '/' + path.join('/') : '';
};

var getSearch = function () {
  var query = getInternalURLState(this).query;
  return query ? '?' + query : '';
};

var getSearchParams = function () {
  return getInternalURLState(this).searchParams;
};

var getHash = function () {
  var fragment = getInternalURLState(this).fragment;
  return fragment ? '#' + fragment : '';
};

var accessorDescriptor = function (getter, setter) {
  return { get: getter, set: setter, configurable: true, enumerable: true };
};

if (descriptors$1) {
  objectDefineProperties$1(URLPrototype, {
    // `URL.prototype.href` accessors pair
    // https://url.spec.whatwg.org/#dom-url-href
    href: accessorDescriptor(serializeURL, function (href) {
      var url = getInternalURLState(this);
      var urlString = String(href);
      var failure = parseURL(url, urlString);
      if (failure) throw TypeError(failure);
      getInternalSearchParamsState(url.searchParams).updateSearchParams(url.query);
    }),
    // `URL.prototype.origin` getter
    // https://url.spec.whatwg.org/#dom-url-origin
    origin: accessorDescriptor(getOrigin),
    // `URL.prototype.protocol` accessors pair
    // https://url.spec.whatwg.org/#dom-url-protocol
    protocol: accessorDescriptor(getProtocol, function (protocol) {
      var url = getInternalURLState(this);
      parseURL(url, String(protocol) + ':', SCHEME_START);
    }),
    // `URL.prototype.username` accessors pair
    // https://url.spec.whatwg.org/#dom-url-username
    username: accessorDescriptor(getUsername, function (username) {
      var url = getInternalURLState(this);
      var codePoints = arrayFrom(String(username));
      if (cannotHaveUsernamePasswordPort(url)) return;
      url.username = '';
      for (var i = 0; i < codePoints.length; i++) {
        url.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
      }
    }),
    // `URL.prototype.password` accessors pair
    // https://url.spec.whatwg.org/#dom-url-password
    password: accessorDescriptor(getPassword, function (password) {
      var url = getInternalURLState(this);
      var codePoints = arrayFrom(String(password));
      if (cannotHaveUsernamePasswordPort(url)) return;
      url.password = '';
      for (var i = 0; i < codePoints.length; i++) {
        url.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
      }
    }),
    // `URL.prototype.host` accessors pair
    // https://url.spec.whatwg.org/#dom-url-host
    host: accessorDescriptor(getHost, function (host) {
      var url = getInternalURLState(this);
      if (url.cannotBeABaseURL) return;
      parseURL(url, String(host), HOST);
    }),
    // `URL.prototype.hostname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hostname
    hostname: accessorDescriptor(getHostname, function (hostname) {
      var url = getInternalURLState(this);
      if (url.cannotBeABaseURL) return;
      parseURL(url, String(hostname), HOSTNAME);
    }),
    // `URL.prototype.port` accessors pair
    // https://url.spec.whatwg.org/#dom-url-port
    port: accessorDescriptor(getPort, function (port) {
      var url = getInternalURLState(this);
      if (cannotHaveUsernamePasswordPort(url)) return;
      port = String(port);
      if (port == '') url.port = null;
      else parseURL(url, port, PORT);
    }),
    // `URL.prototype.pathname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-pathname
    pathname: accessorDescriptor(getPathname, function (pathname) {
      var url = getInternalURLState(this);
      if (url.cannotBeABaseURL) return;
      url.path = [];
      parseURL(url, pathname + '', PATH_START);
    }),
    // `URL.prototype.search` accessors pair
    // https://url.spec.whatwg.org/#dom-url-search
    search: accessorDescriptor(getSearch, function (search) {
      var url = getInternalURLState(this);
      search = String(search);
      if (search == '') {
        url.query = null;
      } else {
        if ('?' == search.charAt(0)) search = search.slice(1);
        url.query = '';
        parseURL(url, search, QUERY);
      }
      getInternalSearchParamsState(url.searchParams).updateSearchParams(url.query);
    }),
    // `URL.prototype.searchParams` getter
    // https://url.spec.whatwg.org/#dom-url-searchparams
    searchParams: accessorDescriptor(getSearchParams),
    // `URL.prototype.hash` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hash
    hash: accessorDescriptor(getHash, function (hash) {
      var url = getInternalURLState(this);
      hash = String(hash);
      if (hash == '') {
        url.fragment = null;
        return;
      }
      if ('#' == hash.charAt(0)) hash = hash.slice(1);
      url.fragment = '';
      parseURL(url, hash, FRAGMENT);
    })
  });
}

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
redefine$1(URLPrototype, 'toJSON', function toJSON() {
  return serializeURL.call(this);
}, { enumerable: true });

// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
redefine$1(URLPrototype, 'toString', function toString() {
  return serializeURL.call(this);
}, { enumerable: true });

if (NativeURL) {
  var nativeCreateObjectURL = NativeURL.createObjectURL;
  var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
  // `URL.createObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
  // eslint-disable-next-line no-unused-vars
  if (nativeCreateObjectURL) redefine$1(URLConstructor, 'createObjectURL', function createObjectURL(blob) {
    return nativeCreateObjectURL.apply(NativeURL, arguments);
  });
  // `URL.revokeObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
  // eslint-disable-next-line no-unused-vars
  if (nativeRevokeObjectURL) redefine$1(URLConstructor, 'revokeObjectURL', function revokeObjectURL(url) {
    return nativeRevokeObjectURL.apply(NativeURL, arguments);
  });
}

setToStringTag$1(URLConstructor, 'URL');

_export$1({ global: true, forced: !nativeUrl, sham: !descriptors$1 }, {
  URL: URLConstructor
});

var min$9 = Math.min;
var nativeLastIndexOf$1 = [].lastIndexOf;
var NEGATIVE_ZERO$2 = !!nativeLastIndexOf$1 && 1 / [1].lastIndexOf(1, -0) < 0;
var SLOPPY_METHOD$3 = sloppyArrayMethod('lastIndexOf');

// `Array.prototype.lastIndexOf` method implementation
// https://tc39.github.io/ecma262/#sec-array.prototype.lastindexof
var arrayLastIndexOf$1 = (NEGATIVE_ZERO$2 || SLOPPY_METHOD$3) ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
  // convert -0 to +0
  if (NEGATIVE_ZERO$2) return nativeLastIndexOf$1.apply(this, arguments) || 0;
  var O = toIndexedObject(this);
  var length = toLength(O.length);
  var index = length - 1;
  if (arguments.length > 1) index = min$9(index, toInteger(arguments[1]));
  if (index < 0) index = length + index;
  for (;index >= 0; index--) if (index in O && O[index] === searchElement) return index || 0;
  return -1;
} : nativeLastIndexOf$1;

// `Array.prototype.lastIndexOf` method
// https://tc39.github.io/ecma262/#sec-array.prototype.lastindexof
_export({ target: 'Array', proto: true, forced: arrayLastIndexOf$1 !== [].lastIndexOf }, {
  lastIndexOf: arrayLastIndexOf$1
});

var lastIndexOf = entryVirtual('Array').lastIndexOf;

var ArrayPrototype$g = Array.prototype;

var lastIndexOf_1 = function (it) {
  var own = it.lastIndexOf;
  return it === ArrayPrototype$g || (it instanceof Array && own === ArrayPrototype$g.lastIndexOf) ? lastIndexOf : own;
};

var lastIndexOf$1 = lastIndexOf_1;

var lastIndexOf$2 = lastIndexOf$1;

// 证件型单列
var SINGLE = 'single'; // 证件型双列

var DOUBLE = 'double'; // 宫格型

var LATTICE = 'lattice'; // 滑动型 多行

var ROWS = 'rows'; // 滑动型 单行

var ROW = 'row';
var STYLE_LIST = [SINGLE, DOUBLE, LATTICE, ROWS, ROW];
var TASK_STATUS = {
  READY: '准备上传',
  UPLOADING: '上传中',
  SUCCESS: '上传成功',
  FAILED: '上传失败'
}; // 本地开发环境上传代理

var PROXY_URL = 'http://192.168.180.194:9673/oss/upload';
var OSS_INFO_LIST = [{
  type: 1,
  // 微易科技
  authUrlTest: 'https://test.winbaoxian.com/management/oss/getAuthInfo',
  authUrlProd: 'https://management.winbaoxian.com/oss/getAuthInfo'
}, {
  type: 2,
  // 微易保险经纪
  authUrlTest: 'https://third-api.wyins.net.cn/oss/getAuthInfo',
  authUrlProd: 'https://third-api.wyins.net/oss/getAuthInfo'
}];

var props$1 = {
  // 是否禁用
  disabled: Boolean,
  // 自定义上传
  customUpload: Function,
  // 读取图片之前
  beforeRead: Function,
  // 上传图片之前
  beforeUpload: Function,
  // 图片体积超过设定大小
  oversize: Function,
  // 图片张数超过设定大小
  overAmount: Function,
  // 手动处理文件
  handleFile: Function,
  // 上传图片的接受类型
  accept: {
    type: String,
    default: 'image/*'
  },
  // input 的 capture 属性
  capture: {
    type: String,
    default: null
  },
  // 图片的最大尺寸
  maxSize: {
    type: Number,
    default: Number.MAX_VALUE
  },
  // 图片最多张数
  maxAmount: {
    type: Number,
    default: 9
  },
  // 上传后oss后，图片的保存路径
  fileDir: {
    type: String,
    default: 'bxs_ui_uploader'
  },
  // 图片列表
  images: {
    type: Array,
    default: function _default() {
      return [];
    },
    validator: function validator(images) {
      var flag = true;

      forEach$2(images).call(images, function (image) {
        if (typeof image !== 'object') {
          flag = false;
        }
      });

      return flag;
    }
  },
  listStyle: {
    type: String,
    default: null,
    validator: function validator(value) {
      var style = find$2(STYLE_LIST).call(STYLE_LIST, function (item) {
        return item === value;
      });

      return !(value && !style);
    }
  },
  errorMessage: {
    type: String,
    default: null
  },
  isDev: {
    type: Boolean,
    default: null
  },
  timeout: {
    type: Number,
    default: 0
  },
  ossType: {
    type: Number,
    default: 1,
    validator: function validator(value) {
      if (!value) {
        return false;
      }

      var info = find$2(OSS_INFO_LIST).call(OSS_INFO_LIST, function (item) {
        return item.type === value;
      });

      return !!info;
    }
  },
  useFileContentForThumbnail: {
    type: Boolean,
    default: true
  }
};

/* eslint-disable no-param-reassign */
var styleListMixins = {
  computed: {
    isSingle: function isSingle() {
      return this.listStyle === SINGLE;
    },
    isDouble: function isDouble() {
      return this.listStyle === DOUBLE;
    },
    isLattice: function isLattice() {
      return this.listStyle === LATTICE;
    },
    isRows: function isRows() {
      return this.listStyle === ROWS;
    },
    isRow: function isRow() {
      return this.listStyle === ROW;
    },
    staticKey: function staticKey() {
      return this.isSingle || this.isDouble;
    }
  }
};

var _components$k;
/* eslint-disable vue/no-unused-components */

var script$I = {
  name: 'uploader-list',
  mixins: [styleListMixins],
  props: {
    disabled: Boolean,
    customUpload: Function,
    listStyle: {
      type: String,
      default: null
    },
    message: {
      type: String,
      default: null
    },
    maxAmount: {
      type: Number,
      default: 9
    },
    images: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    accept: {
      type: String,
      default: 'image/*'
    },
    capture: {
      type: String,
      default: null
    },
    isBadAndroid: Boolean,
    useFileContentForThumbnail: {
      type: Boolean,
      default: true
    }
  },
  components: (_components$k = {}, _components$k[__vue_component__$1.name] = __vue_component__$1, _components$k),
  computed: {
    bgImgList: function bgImgList() {
      return this.$myThemeProps;
    },
    defaultBgImg: function defaultBgImg() {
      return this.addOssParams(this.bgImgList.file);
    },
    ossParams: function ossParams() {
      var ossParams = '?x-oss-process=image/resize,w_250';

      if (this.isSingle) {
        ossParams = '?x-oss-process=image/resize,w_500';
      } else if (this.isDouble) {
        ossParams = '?x-oss-process=image/resize,w_330';
      } else if (this.isLattice) {
        ossParams = '?x-oss-process=image/resize,w_210';
      } else if (this.isRows || this.isRow) {
        ossParams = '?x-oss-process=image/resize,w_250';
      }

      return ossParams;
    }
  },
  created: function created() {},
  methods: {
    clearInput: function clearInput() {
      var formList = this.$refs.babAndroidForm;

      if (formList && formList instanceof Array) {
        forEach$2(formList).call(formList, function (form) {
          form.reset();
        });
      } else if (formList) {
        formList.reset();
      }
    },
    clickImage: function clickImage(index) {
      this.$emit('click-image', index);
    },
    triggerInput: function triggerInput(index) {
      this.$emit('trigger', index);
    },
    deleteImage: function deleteImage(index) {
      this.$emit('delete', index);
    },
    onChange: function onChange(event) {
      this.$emit('bad-android-input-change', event);
    },
    addOssParams: function addOssParams(url) {
      if (indexOf$4(url).call(url, '?') === -1 && (/winbaoxian\.com/.test(url) || /wyins\.net/.test(url))) {
        return url + this.ossParams;
      }

      return url;
    },
    getStyle: function getStyle(image) {
      if (this.staticKey) {
        var url;

        if (this.useFileContentForThumbnail && image.content) {
          url = image.content; // 优先使用base64格式
        } else if (image.url) {
          url = this.addOssParams(image.url); // 图片链接
        } else if (image.bgImg) {
          if (this.bgImgList[image.bgImg]) {
            url = this.addOssParams(this.bgImgList[image.bgImg]); // 内置的背景图
          } else {
            url = this.addOssParams(image.bgImg); // 自定义背景图
          }
        } else {
          url = this.defaultBgImg; // 默认背景图
        }

        return {
          backgroundImage: "url(" + url + ")"
        };
      }

      return {
        'background-image': "url(" + (image.content || (image.url ? this.addOssParams(image.url) : '')) + ")"
      };
    }
  }
};

var __vue_script__$I = script$I;
/* template */

var __vue_render__$I = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_vm.isSingle ? _c('div', {
    staticClass: "bx-uploader-single"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.message && !_vm.disabled,
      expression: "message && !disabled"
    }],
    staticClass: "bx-uploader-single-error"
  }, [_vm._v("\n      " + _vm._s(_vm.message) + "\n    ")]), _c('div', {
    staticClass: "bx-uploader-single-list"
  }, _vm._l(_vm.images, function (image, index) {
    return _c('div', {
      key: image.key
    }, [_c('div', {
      staticClass: "bx-uploader-single-item",
      style: _vm.getStyle(image),
      on: {
        "click": function click($event) {
          $event.stopPropagation();

          _vm.clickImage(index);
        }
      }
    }, [!_vm.disabled ? _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: image.url || image.content,
        expression: "image.url || image.content"
      }],
      staticClass: "bx-uploader-delete",
      on: {
        "click": function click($event) {
          $event.stopPropagation();

          _vm.deleteImage(index);
        }
      }
    }) : _vm._e(), image.status ? _c('div', {
      staticClass: "bx-uploader-single-status"
    }, [_c('div', {
      staticClass: "bx-uploader-single-info"
    }, [_vm._v("\n              " + _vm._s(image.status) + "\n            ")])]) : _vm._e(), !image.url && !image.content ? _c('form', {
      ref: "babAndroidForm",
      refInFor: true,
      staticClass: "bx-uploader-form"
    }, [!_vm.customUpload ? _c('input', {
      staticClass: "bx-uploader-input",
      attrs: {
        "type": "file",
        "accept": _vm.accept,
        "capture": _vm.capture,
        "disabled": _vm.disabled
      },
      on: {
        "change": _vm.onChange
      }
    }) : _c('div', {
      staticClass: "bx-uploader-input",
      on: {
        "click": function click($event) {
          $event.stopPropagation();

          _vm.triggerInput(index);
        }
      }
    })]) : _vm._e()]), _c('div', {
      staticClass: "bx-uploader-single-title"
    }, [_vm._v("\n          " + _vm._s(image.title) + "\n        ")])]);
  }))]) : _vm._e(), _vm.isDouble ? _c('div', {
    staticClass: "bx-uploader-double"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.message && !_vm.disabled,
      expression: "message && !disabled"
    }],
    staticClass: "bx-uploader-double-error"
  }, [_vm._v("\n      " + _vm._s(_vm.message) + "\n    ")]), _c('div', {
    staticClass: "bx-uploader-double-list"
  }, _vm._l(_vm.images, function (image, index) {
    return _c('div', {
      key: image.key,
      staticClass: "bx-uploader-double-outer"
    }, [_c('div', {
      staticClass: "bx-uploader-double-item",
      style: _vm.getStyle(image),
      on: {
        "click": function click($event) {
          _vm.clickImage(index);
        }
      }
    }, [image.status ? _c('div', {
      staticClass: "bx-uploader-double-status"
    }, [_c('div', {
      staticClass: "bx-uploader-double-info"
    }, [_vm._v("\n              " + _vm._s(image.status) + "\n            ")])]) : _vm._e(), !_vm.disabled ? _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: image.url || image.content,
        expression: "image.url || image.content"
      }],
      staticClass: "bx-uploader-delete",
      on: {
        "click": function click($event) {
          $event.stopPropagation();

          _vm.deleteImage(index);
        }
      }
    }) : _vm._e(), !image.url && !image.content ? _c('form', {
      ref: "babAndroidForm",
      refInFor: true,
      staticClass: "bx-uploader-form"
    }, [!_vm.customUpload ? _c('input', {
      staticClass: "bx-uploader-input",
      attrs: {
        "type": "file",
        "accept": _vm.accept,
        "capture": _vm.capture,
        "disabled": _vm.disabled
      },
      on: {
        "change": _vm.onChange
      }
    }) : _c('div', {
      staticClass: "bx-uploader-input",
      on: {
        "click": function click($event) {
          $event.stopPropagation();

          _vm.triggerInput(index);
        }
      }
    })]) : _vm._e()]), _c('div', {
      staticClass: "bx-uploader-double-title"
    }, [_vm._v("\n          " + _vm._s(image.title) + "\n        ")])]);
  }))]) : _vm._e(), _vm.isLattice ? _c('div', {
    staticClass: "bx-uploader-lattice"
  }, [_c('div', {
    staticClass: "bx-uploader-lattice-list"
  }, [_vm._l(_vm.images, function (image, index) {
    return _c('div', {
      key: image.key,
      staticClass: "bx-uploader-lattice-item",
      class: image.status && _vm.isBadAndroid ? 'bx-hairline--surround' : '',
      style: _vm.getStyle(image),
      on: {
        "click": function click($event) {
          _vm.clickImage(index);
        }
      }
    }, [image.status ? _c('div', {
      staticClass: "bx-uploader-lattice-status"
    }, [_c('div', {
      staticClass: "bx-uploader-lattice-info"
    }, [_vm._v("\n            " + _vm._s(image.status) + "\n          ")])]) : _vm._e(), !_vm.disabled ? _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: image.url || image.content,
        expression: "image.url || image.content"
      }],
      staticClass: "bx-uploader-delete",
      on: {
        "click": function click($event) {
          $event.stopPropagation();

          _vm.deleteImage(index);
        }
      }
    }) : _vm._e()]);
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.disabled && _vm.maxAmount > _vm.images.length,
      expression: "!disabled && maxAmount > images.length"
    }],
    staticClass: "bx-uploader-lattice-item bx-hairline--surround",
    on: {
      "click": function click($event) {
        _vm.triggerInput();
      }
    }
  }, [_c('bxs-icon', {
    staticClass: "bx-uploader-lattice-add",
    class: {
      'bx-uploader-lattice--limit': _vm.maxAmount !== Number.MAX_VALUE
    },
    attrs: {
      "name": "add"
    }
  }), _vm.maxAmount !== Number.MAX_VALUE ? _c('span', {
    staticClass: "bx-uploader-lattice-maxinfo"
  }, [_vm._v("\n          " + _vm._s('最多' + _vm.maxAmount + '张图') + "\n        ")]) : _vm._e(), _c('form', {
    ref: "babAndroidForm",
    staticClass: "bx-uploader-form"
  }, [!_vm.customUpload ? _c('input', {
    staticClass: "bx-uploader-input",
    attrs: {
      "type": "file",
      "accept": _vm.accept,
      "capture": _vm.capture,
      "disabled": _vm.disabled,
      "multiple": "multiple"
    },
    on: {
      "change": _vm.onChange
    }
  }) : _vm._e()])], 1)], 2)]) : _vm._e(), _vm.isRows ? _c('div', {
    staticClass: "bx-uploader-rows"
  }, [_c('div', {
    staticClass: "bx-uploader-rows-list"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.message && !_vm.disabled,
      expression: "message && !disabled"
    }],
    staticClass: "bx-uploader-rows-error"
  }, [_vm._v("\n        " + _vm._s(_vm.message) + "\n      ")]), _vm._l(_vm.images, function (image, index) {
    return _c('div', {
      key: image.key,
      staticClass: "bx-uploader-rows-item",
      class: image.status && _vm.isBadAndroid ? 'bx-hairline--surround' : '',
      style: _vm.getStyle(image),
      on: {
        "click": function click($event) {
          _vm.clickImage(index);
        }
      }
    }, [image.status ? _c('div', {
      staticClass: "bx-uploader-rows-status"
    }, [_c('div', {
      staticClass: "bx-uploader-rows-info"
    }, [_vm._v("\n            " + _vm._s(image.status) + "\n          ")])]) : _vm._e(), !_vm.disabled ? _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: image.url || image.content,
        expression: "image.url || image.content"
      }],
      staticClass: "bx-uploader-delete",
      on: {
        "click": function click($event) {
          $event.stopPropagation();

          _vm.deleteImage(index);
        }
      }
    }) : _vm._e()]);
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.disabled && _vm.maxAmount > _vm.images.length,
      expression: "!disabled && maxAmount > images.length"
    }],
    staticClass: "bx-uploader-rows-item bx-hairline--surround",
    on: {
      "click": function click($event) {
        _vm.triggerInput();
      }
    }
  }, [_c('bxs-icon', {
    staticClass: "bx-uploader-rows-add",
    attrs: {
      "name": "add"
    }
  }), _c('form', {
    ref: "babAndroidForm",
    staticClass: "bx-uploader-form"
  }, [!_vm.customUpload ? _c('input', {
    staticClass: "bx-uploader-input",
    attrs: {
      "type": "file",
      "accept": _vm.accept,
      "capture": _vm.capture,
      "disabled": _vm.disabled,
      "multiple": "multiple"
    },
    on: {
      "change": _vm.onChange
    }
  }) : _vm._e()])], 1)], 2)]) : _vm._e(), _vm.isRow ? _c('div', {
    staticClass: "bx-uploader-row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.message && !_vm.disabled,
      expression: "message && !disabled"
    }],
    staticClass: "bx-uploader-row-error"
  }, [_vm._v("\n      " + _vm._s(_vm.message) + "\n    ")]), _c('div', {
    staticClass: "bx-uploader-row-wrapper"
  }, [_c('div', {
    staticClass: "bx-uploader-row-list"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.disabled && _vm.maxAmount > _vm.images.length,
      expression: "!disabled && maxAmount > images.length"
    }],
    staticClass: "bx-uploader-row-item bx-hairline--surround",
    on: {
      "click": function click($event) {
        _vm.triggerInput();
      }
    }
  }, [_c('bxs-icon', {
    staticClass: "bx-uploader-row-add",
    attrs: {
      "name": "add"
    }
  }), _c('form', {
    ref: "babAndroidForm",
    staticClass: "bx-uploader-form"
  }, [!_vm.customUpload ? _c('input', {
    staticClass: "bx-uploader-input",
    attrs: {
      "type": "file",
      "accept": _vm.accept,
      "capture": _vm.capture,
      "disabled": _vm.disabled,
      "multiple": "multiple"
    },
    on: {
      "change": _vm.onChange
    }
  }) : _vm._e()])], 1), _vm._l(_vm.images, function (image, index) {
    return _c('div', {
      key: image.key,
      staticClass: "bx-uploader-row-item",
      class: image.status && _vm.isBadAndroid ? 'bx-hairline--surround' : '',
      style: _vm.getStyle(image),
      on: {
        "click": function click($event) {
          _vm.clickImage(index);
        }
      }
    }, [image.status ? _c('div', {
      staticClass: "bx-uploader-row-status"
    }, [_c('div', {
      staticClass: "bx-uploader-row-info"
    }, [_vm._v("\n              " + _vm._s(image.status) + "\n            ")])]) : _vm._e(), !_vm.disabled ? _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: image.url || image.content,
        expression: "image.url || image.content"
      }],
      staticClass: "bx-uploader-delete",
      on: {
        "click": function click($event) {
          $event.stopPropagation();

          _vm.deleteImage(index);
        }
      }
    }) : _vm._e()]);
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.images.length,
      expression: "images.length"
    }],
    staticClass: "bx-uploader-row-item"
  }, [_c('div', {
    staticClass: "bx-uploader-row-last"
  }, [_vm._v("\n            已到最后一张\n          ")])])], 2)])]) : _vm._e()]);
};

var __vue_staticRenderFns__$I = [];
/* style */

var __vue_inject_styles__$I = undefined;
/* scoped */

var __vue_scope_id__$I = undefined;
/* module identifier */

var __vue_module_identifier__$I = undefined;
/* functional template */

var __vue_is_functional_template__$I = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$I =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$I,
  staticRenderFns: __vue_staticRenderFns__$I
}, __vue_inject_styles__$I, __vue_script__$I, __vue_scope_id__$I, __vue_is_functional_template__$I, __vue_module_identifier__$I, false, undefined, undefined, undefined);

var $findIndex$1 = arrayIteration.findIndex;


var FIND_INDEX = 'findIndex';
var SKIPS_HOLES$1 = true;

// Shouldn't skip holes
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES$1 = false; });

// `Array.prototype.findIndex` method
// https://tc39.github.io/ecma262/#sec-array.prototype.findindex
_export({ target: 'Array', proto: true, forced: SKIPS_HOLES$1 }, {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $findIndex$1(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var findIndex = entryVirtual('Array').findIndex;

var ArrayPrototype$h = Array.prototype;

var findIndex_1 = function (it) {
  var own = it.findIndex;
  return it === ArrayPrototype$h || (it instanceof Array && own === ArrayPrototype$h.findIndex) ? findIndex : own;
};

var findIndex$1 = findIndex_1;

var findIndex$2 = findIndex$1;

var taskMixins = {
  data: function data() {
    return {
      tasks: []
    };
  },
  methods: {
    findImage: function findImage(key) {
      var _context;

      return find$2(_context = this.images).call(_context, function (item) {
        return item.key === key;
      });
    },
    randomString: function randomString(len) {
      var length = len || 32;
      var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
      var maxPos = chars.length;
      var pwd = '';

      for (var i = 0; i < length; i += 1) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }

      return pwd;
    },
    addTasks: function addTasks(files) {
      var _this = this,
          _this$tasks;

      var tasks = map$2(files).call(files, function (file) {
        var obj = file;
        obj.key = obj.key || _this.randomString(15);
        obj.xhr = new XMLHttpRequest();

        var image = _this.findImage(obj.key);

        if (image) {
          image.orientation = obj.orientation;
          image.naturalWidth = obj.naturalWidth;
          image.naturalHeight = obj.naturalHeight;
          image.content = obj.content;
          image.status = TASK_STATUS.UPLOADING;
        } else {
          var newImage = {
            key: obj.key,
            orientation: obj.orientation,
            naturalWidth: obj.naturalWidth,
            naturalHeight: obj.naturalHeight,
            content: obj.content,
            status: TASK_STATUS.UPLOADING
          };

          if (_this.isRow) {
            _this.images.unshift(newImage);
          } else {
            _this.images.push(newImage);
          }
        }

        _this.emitChange(image);

        obj.status = TASK_STATUS.READY;
        return obj;
      });

      (_this$tasks = this.tasks).push.apply(_this$tasks, tasks);
    },
    addSuccessImage: function addSuccessImage(res) {
      var list = typeof res === 'string' ? [res] : res;

      if (res.length) {
        if (this.staticKey) {
          var image = this.findImage(this.currentKey);
          var url = list[0];

          if (!url) {
            return;
          }

          image.url = url;
          this.$emit('upload-success', {
            image: image,
            images: this.images
          });
          this.dispatch('bxs-form-item', 'form.item.validate');
          this.emitChange(image);
        } else {
          if (list.length + this.images.length > this.maxAmount) {
            if (this.overAmount) {
              this.overAmount(this.maxAmount, list.length);
            } else {
              Toast("\u6700\u591A\u53EF\u4F20" + this.maxAmount + "\u5F20");
            }

            return;
          }

          for (var i = 0; i < list.length; i += 1) {
            var _url = list[i];

            if (_url) {
              var _image = {
                url: list[i],
                key: this.randomString(15)
              };

              if (this.isRow) {
                this.images.unshift(_image);
              } else {
                this.images.push(_image);
              }

              this.$emit('upload-success', {
                image: _image,
                images: this.images
              });
              this.dispatch('bxs-form-item', 'form.item.validate');
              this.emitChange(_image);
            }
          }
        }
      }
    },
    taskStart: function taskStart(task) {
      task.status = TASK_STATUS.UPLOADING;
      var image = this.findImage(task.key);

      if (image) {
        image.status = TASK_STATUS.UPLOADING;
      }

      this.emitChange(image);
    },
    taskSuccess: function taskSuccess(task) {
      var image = this.findImage(task.key);

      if (image) {
        image.status = null;
        image.url = task.imageUrl;
        this.$emit('upload-success', {
          image: image,
          images: this.images
        });
        this.dispatch('bxs-form-item', 'form.item.validate');
      }

      this.emitChange(image);
      this.removeTask(task.key);
    },
    taskFailed: function taskFailed(task) {
      var _this2 = this;

      if (!task) {
        var _context2, _context3;

        forEach$2(_context2 = this.tasks).call(_context2, function (item) {
          if (item.status === TASK_STATUS.READY) {
            var img = _this2.findImage(item.key);

            if (img) {
              img.status = TASK_STATUS.FAILED;

              _this2.emitChange(img);

              _this2.$emit('upload-failed', {
                img: img,
                images: _this2.images
              });

              _this2.dispatch('bxs-form-item', 'form.item.validate');
            }
          }
        });

        forEach$2(_context3 = this.tasks).call(_context3, function (item) {
          if (item.status === TASK_STATUS.READY) {
            _this2.removeTask(item.key);
          }
        });
      } else {
        var image = this.findImage(task.key);

        if (image) {
          image.status = TASK_STATUS.FAILED;
          this.emitChange(image);
          this.$emit('upload-failed', {
            image: image,
            images: this.images
          });
          this.dispatch('bxs-form-item', 'form.item.validate');
        }

        this.removeTask(task.key);
      }
    },
    removeTask: function removeTask(key) {
      for (var i = 0; i < this.tasks.length; i += 1) {
        var task = this.tasks[i];

        if (task.key === key) {
          var _context4;

          if (task.xhr.readyState < 4) {
            task.xhr.abort();
          }

          splice$2(_context4 = this.tasks).call(_context4, i, 1);

          return true;
        }
      }

      return false;
    },
    emitChange: function emitChange(image) {
      if (image) {
        var _context5;

        var index = findIndex$2(_context5 = this.images).call(_context5, function (item) {
          return item.key === image.key;
        });

        if (index > -1) {
          this.$set(this.images, index, this.images[index]);
        }
      }

      this.$emit('change', this.images);
    }
  }
};

var script$J = create({
  name: 'uploader',
  mixins: [taskMixins, styleListMixins, Emitter],
  components: {
    UploaderList: __vue_component__$I
  },
  props: props$1,
  data: function data() {
    return {
      currentKey: null,
      reading: false,
      isBadIos: false,
      // ios8及以下 canvas不支持旋转，做降级处理
      isBadAndroid: false,
      // 安卓4.4以下判定为true（不包括4.4）；
      isDevelop: null,
      // 是否是本地开发环境
      isCustomUploading: false // 是否正在自定义上传

    };
  },
  model: {
    prop: 'images',
    event: 'change'
  },
  computed: {
    ossInfo: function ossInfo() {
      var _this = this;

      return find$2(OSS_INFO_LIST).call(OSS_INFO_LIST, function (item) {
        return item.type === _this.ossType;
      }) || {};
    },
    authUrl: function authUrl() {
      var hostName = window.location.hostname;

      if (/^.*\.com$/.test(hostName) && hostName !== 'test.winbaoxian.com' || /^.*\.net$/.test(hostName)) {
        return this.ossInfo.authUrlProd;
      }

      return this.ossInfo.authUrlTest;
    },
    message: function message() {
      var _context;

      if (this.errorMessage) {
        return this.errorMessage;
      }

      var failedImages = filter$2(_context = this.images).call(_context, function (item) {
        return item.status === TASK_STATUS.FAILED;
      });

      var message = failedImages.length ? "\u4E0A\u4F20\u5931\u8D25" + failedImages.length + "\u5F20" : null;

      if (message && (this.isRows || this.isRow)) {
        message += '，滑动查看更多';
      }

      return message;
    },
    maxSizeText: function maxSizeText() {
      if (this.maxSize !== Number.MAX_VALUE) {
        if (this.maxSize < 1024) {
          return this.maxSize + "b";
        }

        if (this.maxSize < 1024 * 1024) {
          return Math.floor(this.maxSize / 1024) + "kb";
        }

        if (this.maxSize < 1024 * 1024 * 1024) {
          return Math.floor(this.maxSize / (1024 * 1024)) + "M";
        }

        return Math.floor(this.maxSize / (1024 * 1024 * 1024)) + "G";
      }

      return null;
    }
  },
  created: function created() {
    this.getUserAgentInfo();
    this.setIsDevelop();
  },
  methods: {
    setIsDevelop: function setIsDevelop() {
      if (window.location.port) {
        this.isDevelop = true;
      } else {
        this.isDevelop = false;
      }

      if (this.isDev === true || this.isDev === false) {
        this.isDevelop = this.isDev;
      }
    },
    getUserAgentInfo: function getUserAgentInfo() {
      var str = navigator.userAgent.toLowerCase();
      var ver = str.match(/cpu iphone os (.*?) like mac os/);

      if (ver && ver[1]) {
        var version = ver[1];

        if (version && Number(version.split('_')[0]) <= 8) {
          this.isBadIos = true;
        } else {
          this.isBadIos = false;
        }
      }

      if (indexOf$4(str).call(str, 'android') > 0) {
        var reg = /android [\d._]+/gi;
        var vInfo = str.match(reg);
        var versionAndr = vInfo.toString().replace(/[^0-9|_.]/gi, '').split('.');

        if (versionAndr && versionAndr.length) {
          if (versionAndr[0] && Number(versionAndr[0]) < 4) {
            this.isBadAndroid = true;
          } else if (Number(versionAndr[0]) === 4 && Number(versionAndr[1]) < 4) {
            this.isBadAndroid = true;
          }
        }
      }
    },
    getSuffix: function getSuffix(filename) {
      var pos = lastIndexOf$2(filename).call(filename, '.');

      var suffix = '';

      if (pos !== -1) {
        suffix = filename.substring(pos);
      }

      return suffix;
    },
    onChange: function onChange(event) {
      var _this2 = this;

      var files = event.target.files;

      if (this.disabled || !files.length) {
        this.clearInput();
        return;
      }

      files = slice$2([]).call(files, 0);

      if (!files || this.beforeRead && !this.beforeRead(files)) {
        this.clearInput();
        return;
      }

      var oversize = false;

      forEach$2(files).call(files, function (file) {
        if (file.size > _this2.maxSize) {
          oversize = true;
        }
      });

      if (oversize) {
        if (this.oversize) {
          this.oversize(files, this.maxSize);
        } else {
          Toast("\u56FE\u7247\u4E0D\u5F97\u5927\u4E8E" + this.maxSizeText);
        }

        this.clearInput();
        return;
      }

      if (!this.staticKey && files.length + this.images.length > this.maxAmount) {
        if (this.overAmount) {
          this.overAmount(this.maxAmount, files.length);
        } else {
          Toast("\u6700\u591A\u53EF\u4F20" + this.maxAmount + "\u5F20");
        }

        this.clearInput();
        return;
      }

      this.reading = true;

      promise$3.all(map$2(files).call(files, this.handleFile ? this.customReadFile : this.readFile)).then(function (result) {
        _this2.reading = false;

        var payload = map$2(files).call(files, function (file, index) {
          var _result$index = result[index],
              fileInfo = _result$index.fileInfo,
              _result$index$orienta = _result$index.orientation,
              orientation = _result$index$orienta === void 0 ? null : _result$index$orienta;

          if (orientation === -1 || orientation === -2 || orientation === 1) {
            // 如果不用旋转，则把orientation设置为null
            fileInfo.orientation = null;
          } else {
            fileInfo.orientation = orientation;
          }

          return {
            file: files[index],
            newFile: _this2.handleFile ? fileInfo.file : null,
            content: _this2.handleFile ? fileInfo.content : _this2.getCanvasDataUrl(fileInfo),
            currentKey: fileInfo.currentKey,
            naturalWidth: fileInfo.naturalWidth,
            naturalHeight: fileInfo.naturalHeight,
            orientation: orientation
          };
        });

        _this2.onAfterRead(payload);
      }).catch(function () {
        _this2.reading = false;
      });

      this.dispatch('bxs-form-item', 'form.item.reset');
    },
    readFile: function readFile(file) {
      return promise$3.all([this.getFileInfo(file), this.getOrientation(file)]).then(function (_ref) {
        var fileInfo = _ref[0],
            orientation = _ref[1];
        return {
          fileInfo: fileInfo,
          orientation: orientation
        };
      });
    },
    customReadFile: function customReadFile(file) {
      var _this3 = this;

      return new promise$3(function (resolve, reject) {
        _this3.handleFile(file).then(function (res) {
          var reader = new FileReader();

          reader.onload = function (event) {
            resolve({
              fileInfo: {
                file: res,
                currentKey: _this3.currentKey,
                content: event.target.result
              }
            });
          };

          reader.onerror = function (event) {
            reject(event);
          };

          reader.readAsDataURL(res);
        });
      });
    },
    getOrientation: function getOrientation(file) {
      var _this4 = this;

      return new promise$3(function (resolve, reject) {
        if (_this4.isBadIos || _this4.isBadAndroid) {
          resolve(null);
        }

        try {
          var reader = new FileReader();

          reader.onload = function (e) {
            var view = new DataView(e.target.result);

            if (view.getUint16(0, false) !== 0xffd8) {
              resolve(null); // 不是jpeg
            }

            var length = view.byteLength;
            var offset = 2;

            while (offset < length) {
              if (view.getUint16(offset + 2, false) <= 8) {
                resolve(-1); // 不包含旋转信息
              }

              var marker = view.getUint16(offset, false);
              offset += 2;

              if (marker === 0xffe1) {
                offset += 2;

                if (view.getUint32(offset, false) !== 0x45786966) {
                  resolve(null); // 不包含旋转信息
                }

                var little = view.getUint16(offset += 6, false) === 0x4949;
                offset += view.getUint32(offset + 4, little);
                var tags = view.getUint16(offset, little);
                offset += 2;

                for (var i = 0; i < tags; i += 1) {
                  if (view.getUint16(offset + i * 12, little) === 0x0112) {
                    resolve(view.getUint16(offset + i * 12 + 8, little));
                  }
                }
              } else if ((marker & 0xff00) !== 0xff00) {
                break;
              } else {
                offset += view.getUint16(offset, false);
              }
            }

            resolve(null); // 不包含旋转信息
          };

          reader.readAsArrayBuffer(file);
        } catch (e) {
          reject(e);
        }
      });
    },
    getFileInfo: function getFileInfo(file) {
      var _this5 = this;

      return new promise$3(function (resolve, reject) {
        var self = _this5;

        if (window.URL && (_this5.isBadIos || _this5.isBadAndroid)) {
          var url = window.URL.createObjectURL(file);
          resolve({
            file: file,
            currentKey: self.currentKey,
            content: url
          });
        } else {
          var reader = new FileReader();

          reader.onload = function (event) {
            if (_this5.isBadIos || _this5.isBadAndroid) {
              resolve({
                file: file,
                currentKey: self.currentKey
              });
            } else {
              var img = new Image();

              img.onload = function () {
                var naturalWidth = this.naturalWidth,
                    naturalHeight = this.naturalHeight;
                resolve({
                  file: file,
                  img: img,
                  currentKey: self.currentKey,
                  content: event.target.result,
                  naturalWidth: naturalWidth,
                  naturalHeight: naturalHeight
                });
              };

              img.src = event.target.result;
            }
          };

          reader.onerror = function (event) {
            reject(event);
          };

          reader.readAsDataURL(file);
        }
      });
    },
    onAfterRead: function onAfterRead(files) {
      var _this6 = this;

      if (this.beforeUpload) {
        var result = this.beforeUpload(files);

        if (!result) {
          this.clearInput();
          return;
        }
      }

      if (this.staticKey) {
        files[0].key = this.currentKey;
      }

      this.addTasks(files);
      this.getAuthInfo().then(function (authInfo) {
        var _context2;

        forEach$2(_context2 = _this6.tasks).call(_context2, function (task) {
          if (task.status === TASK_STATUS.READY) {
            _this6.taskStart(task);

            _this6.submit(task, authInfo);
          }
        });
      }).catch(function () {
        _this6.taskFailed();
      });
      this.clearInput();
    },
    clearInput: function clearInput() {
      if (this.$refs.form) {
        this.$refs.form.reset();
      }

      if (this.$refs.uploaderList) {
        this.$refs.uploaderList.clearInput();
      }
    },
    getAuthInfo: function getAuthInfo() {
      var _this7 = this;

      var promise = new promise$3(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.timeout = _this7.timeout;
        xhr.open('GET', _this7.authUrl + "?fileDir=" + _this7.fileDir, true);

        xhr.onload = function (e) {
          if (e.currentTarget.status === 200) {
            try {
              var data = JSON.parse(xhr.responseText); // Fix https://jira2.winbaoxian.cn/browse/GZSG-102, 兼容经纪与科技相同 API signature 差异。

              var result = data.data;

              if (!result.fileName) {
                result.fileName = generateFileName();
              }

              resolve(result);
            } catch (error) {
              reject(error);
            }
          } else {
            reject(e);
          }
        };

        xhr.onerror = function (event) {
          reject(event);
        };

        xhr.onabort = function (event) {
          reject(event);
        };

        xhr.ontimeout = function (event) {
          reject(event);
        };

        xhr.send();
      });
      return promise;
    },
    submit: function submit(task, authInfo) {
      var _context3;

      task.host = authInfo.host;
      var key = "" + authInfo.dir + new Date().getTime() + "_" + this.randomString(15) + this.getSuffix(task.file.name);
      var formData = new FormData();
      formData.append('success_action_status', 200);
      formData.append('signature', authInfo.signature);
      formData.append('policy', authInfo.policy);
      formData.append('OSSAccessKeyId', authInfo.accessid);
      formData.append('key', key);
      var protocol = indexOf$4(_context3 = authInfo.cdnMediaHost).call(_context3, '//') === 0 ? 'https:' : '';
      task.imageUrl = protocol + authInfo.cdnMediaHost + key;
      formData.append('file', this.handleFile ? task.newFile : this.getBlobByDataURI(task));
      task.formData = formData;
      this.upload(task);
    },
    upload: function upload(task) {
      var _this8 = this;

      var xhr = task.xhr || new XMLHttpRequest();
      xhr.timeout = this.timeout;

      xhr.onload = function (e) {
        if (e.currentTarget.status === 200) {
          _this8.taskSuccess(task, xhr);
        } else {
          _this8.taskFailed(task);
        }
      };

      xhr.onerror = function () {
        _this8.taskFailed(task);
      };

      xhr.ontimeout = function () {
        _this8.taskFailed(task);
      };

      var uploadUrl = this.isDevelop ? PROXY_URL + "?host=" + encodeURI(task.host) : task.host;

      try {
        xhr.open('POST', uploadUrl, true);
        xhr.send(task.formData);
      } catch (e) {
        this.taskFailed(task);
      }
    },
    getCanvasDataUrl: function getCanvasDataUrl(_ref2) {
      var file = _ref2.file,
          img = _ref2.img,
          orientation = _ref2.orientation,
          naturalWidth = _ref2.naturalWidth,
          naturalHeight = _ref2.naturalHeight,
          content = _ref2.content;

      if (!orientation || this.isBadIos || this.isBadAndroid) {
        return content;
      }

      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      canvas.width = naturalWidth;
      canvas.height = naturalHeight;
      var drawWidth = naturalWidth;
      var drawHeight = naturalHeight;
      var degree = 0;

      switch (orientation) {
        case 3:
          degree = 180;
          drawWidth = -naturalWidth;
          drawHeight = -naturalHeight;
          break;

        case 6:
          canvas.width = naturalHeight;
          canvas.height = naturalWidth;
          degree = 90;
          drawWidth = naturalWidth;
          drawHeight = -naturalHeight;
          break;

        case 8:
          canvas.width = naturalHeight;
          canvas.height = naturalWidth;
          degree = 270;
          drawWidth = -naturalWidth;
          drawHeight = naturalHeight;
          break;
      }

      context.rotate(degree * Math.PI / 180);
      context.drawImage(img, 0, 0, drawWidth, drawHeight);
      return canvas.toDataURL(file.type, 0.92);
    },
    getBlobByDataURI: function getBlobByDataURI(_ref3) {
      var content = _ref3.content,
          file = _ref3.file;

      if (this.isBadIos || this.isBadAndroid) {
        return file;
      }

      var binary = atob(content.split(',')[1]);
      var array = [];

      for (var i = 0; i < binary.length; i += 1) {
        array.push(binary.charCodeAt(i));
      }

      return new Blob([new Uint8Array(array)], {
        type: file.type
      });
    },
    clickInput: function clickInput(index) {
      var _this9 = this;

      if (this.reading) {
        return;
      }

      if (this.staticKey) {
        var image = this.images[index];

        if (!image.key) {
          image.key = this.randomString(15);
        }

        this.currentKey = image.key;
      } else {
        this.currentKey = null;
      }

      if (this.customUpload && !this.disabled && !this.isCustomUploading) {
        this.isCustomUploading = true;

        setTimeout$2(function () {
          _this9.isCustomUploading = false;
        }, 1000);

        var cu = this.customUpload();

        if (cu) {
          if (typeof cu.then === 'function') {
            cu.then(function (res) {
              _this9.addSuccessImage(res);
            });
          } else {
            this.addSuccessImage(cu);
          }
        }
      }
    },
    clickImage: function clickImage(index) {
      var image = this.images[index];

      if (image.url) {
        this.preview(index);
      } else if (!image.status) {
        this.clickInput(index);
      }
    },
    deleteImage: function deleteImage(index) {
      var image = this.images[index];
      this.removeTask(image.key);

      if (this.staticKey) {
        image.url = '';
        image.status = null;
        image.orientation = null;
        image.naturalWidth = null;
        image.naturalHeight = null;
        image.content = null;
        this.$set(this.images, index, image);
      } else {
        var _context4;

        splice$2(_context4 = this.images).call(_context4, index, 1);
      }

      this.$emit('delete', {
        image: image,
        images: this.images
      });
      this.dispatch('bxs-form-item', 'form.item.validate');
    },
    preview: function preview(index) {
      if (this.images[index].status) {
        return;
      }

      this.$emit('preview', {
        url: this.images[index].url,
        index: index,
        images: this.images
      });
    }
  }
});

/* script */
var __vue_script__$J = script$J;
/* template */

var __vue_render__$J = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [!_vm.listStyle ? _c('div', {
    staticClass: "bx-uploader-btn"
  }, [_vm._t("button"), _c('form', {
    ref: "form",
    staticClass: "bx-uploader-btn-form"
  }, [_c('input', {
    ref: "input",
    staticClass: "bx-uploader-btn-input",
    attrs: {
      "type": "file",
      "accept": _vm.accept,
      "capture": _vm.capture,
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.onChange
    }
  })])], 2) : _vm._e(), _c('uploader-list', {
    ref: "uploaderList",
    attrs: {
      "disabled": _vm.disabled,
      "custom-upload": _vm.customUpload,
      "images": _vm.images,
      "list-style": _vm.listStyle,
      "message": _vm.message,
      "max-amount": _vm.maxAmount,
      "accept": _vm.accept,
      "capture": _vm.capture,
      "is-bad-android": _vm.isBadAndroid,
      "use-file-content-for-thumbnail": _vm.useFileContentForThumbnail
    },
    on: {
      "bad-android-input-change": _vm.onChange,
      "click-image": _vm.clickImage,
      "trigger": _vm.clickInput,
      "delete": _vm.deleteImage,
      "preview": _vm.preview
    }
  })], 1);
};

var __vue_staticRenderFns__$J = [];
/* style */

var __vue_inject_styles__$J = undefined;
/* scoped */

var __vue_scope_id__$J = undefined;
/* module identifier */

var __vue_module_identifier__$J = undefined;
/* functional template */

var __vue_is_functional_template__$J = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$J =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$J,
  staticRenderFns: __vue_staticRenderFns__$J
}, __vue_inject_styles__$J, __vue_script__$J, __vue_scope_id__$J, __vue_is_functional_template__$J, __vue_module_identifier__$J, false, undefined, undefined, undefined);

var trim$6 = stringTrim.trim;


var nativeParseFloat$1 = global_1$1.parseFloat;
var FORCED$b = 1 / nativeParseFloat$1(whitespaces + '-0') !== -Infinity;

// `parseFloat` method
// https://tc39.github.io/ecma262/#sec-parsefloat-string
var _parseFloat$4 = FORCED$b ? function parseFloat(string) {
  var trimmedString = trim$6(String(string));
  var result = nativeParseFloat$1(trimmedString);
  return result === 0 && trimmedString.charAt(0) == '-' ? -0 : result;
} : nativeParseFloat$1;

// `parseFloat` method
// https://tc39.github.io/ecma262/#sec-parsefloat-string
_export$1({ global: true, forced: parseFloat != _parseFloat$4 }, {
  parseFloat: _parseFloat$4
});

var ITERATOR$e = wellKnownSymbol('iterator');

var nativeUrl$1 = !fails(function () {
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var searchParams = url.searchParams;
  var result = '';
  url.pathname = 'c%20d';
  searchParams.forEach(function (value, key) {
    searchParams['delete']('b');
    result += key + value;
  });
  return (isPure && !url.toJSON)
    || !searchParams.sort
    || url.href !== 'http://a/c%20d?a=1&c=3'
    || searchParams.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !searchParams[ITERATOR$e]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('http://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('http://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('http://x', undefined).host !== 'x';
});

// `Array.from` method implementation
// https://tc39.github.io/ecma262/#sec-array.from
var arrayFrom$1 = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var C = typeof this == 'function' ? this : Array;
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var index = 0;
  var iteratorMethod = getIteratorMethod(O);
  var length, result, step, iterator, next;
  if (mapping) mapfn = bindContext(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = iteratorMethod.call(O);
    next = iterator.next;
    result = new C();
    for (;!(step = next.call(iterator)).done; index++) {
      createProperty(result, index, mapping
        ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true)
        : step.value
      );
    }
  } else {
    length = toLength(O.length);
    result = new C(length);
    for (;length > index; index++) {
      createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
    }
  }
  result.length = index;
  return result;
};

// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js
var maxInt$1 = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var base$1 = 36;
var tMin$1 = 1;
var tMax$1 = 26;
var skew$1 = 38;
var damp$1 = 700;
var initialBias$1 = 72;
var initialN$1 = 128; // 0x80
var delimiter$1 = '-'; // '\x2D'
var regexNonASCII$1 = /[^\0-\u007E]/; // non-ASCII chars
var regexSeparators$1 = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var OVERFLOW_ERROR$1 = 'Overflow: input needs wider integers to process';
var baseMinusTMin$1 = base$1 - tMin$1;
var floor$8 = Math.floor;
var stringFromCharCode$1 = String.fromCharCode;

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */
var ucs2decode$1 = function (string) {
  var output = [];
  var counter = 0;
  var length = string.length;
  while (counter < length) {
    var value = string.charCodeAt(counter++);
    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // It's a high surrogate, and there is a next character.
      var extra = string.charCodeAt(counter++);
      if ((extra & 0xFC00) == 0xDC00) { // Low surrogate.
        output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // It's an unmatched surrogate; only append this code unit, in case the
        // next code unit is the high surrogate of a surrogate pair.
        output.push(value);
        counter--;
      }
    } else {
      output.push(value);
    }
  }
  return output;
};

/**
 * Converts a digit/integer into a basic code point.
 */
var digitToBasic$1 = function (digit) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */
var adapt$1 = function (delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor$8(delta / damp$1) : delta >> 1;
  delta += floor$8(delta / numPoints);
  for (; delta > baseMinusTMin$1 * tMax$1 >> 1; k += base$1) {
    delta = floor$8(delta / baseMinusTMin$1);
  }
  return floor$8(k + (baseMinusTMin$1 + 1) * delta / (delta + skew$1));
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */
// eslint-disable-next-line  max-statements
var encode$1 = function (input) {
  var output = [];

  // Convert the input in UCS-2 to an array of Unicode code points.
  input = ucs2decode$1(input);

  // Cache the length.
  var inputLength = input.length;

  // Initialize the state.
  var n = initialN$1;
  var delta = 0;
  var bias = initialBias$1;
  var i, currentValue;

  // Handle the basic code points.
  for (i = 0; i < input.length; i++) {
    currentValue = input[i];
    if (currentValue < 0x80) {
      output.push(stringFromCharCode$1(currentValue));
    }
  }

  var basicLength = output.length; // number of basic code points.
  var handledCPCount = basicLength; // number of code points that have been handled;

  // Finish the basic string with a delimiter unless it's empty.
  if (basicLength) {
    output.push(delimiter$1);
  }

  // Main encoding loop:
  while (handledCPCount < inputLength) {
    // All non-basic code points < n have been handled already. Find the next larger one:
    var m = maxInt$1;
    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    }

    // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
    var handledCPCountPlusOne = handledCPCount + 1;
    if (m - n > floor$8((maxInt$1 - delta) / handledCPCountPlusOne)) {
      throw RangeError(OVERFLOW_ERROR$1);
    }

    delta += (m - n) * handledCPCountPlusOne;
    n = m;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue < n && ++delta > maxInt$1) {
        throw RangeError(OVERFLOW_ERROR$1);
      }
      if (currentValue == n) {
        // Represent delta as a generalized variable-length integer.
        var q = delta;
        for (var k = base$1; /* no condition */; k += base$1) {
          var t = k <= bias ? tMin$1 : (k >= bias + tMax$1 ? tMax$1 : k - bias);
          if (q < t) break;
          var qMinusT = q - t;
          var baseMinusT = base$1 - t;
          output.push(stringFromCharCode$1(digitToBasic$1(t + qMinusT % baseMinusT)));
          q = floor$8(qMinusT / baseMinusT);
        }

        output.push(stringFromCharCode$1(digitToBasic$1(q)));
        bias = adapt$1(delta, handledCPCountPlusOne, handledCPCount == basicLength);
        delta = 0;
        ++handledCPCount;
      }
    }

    ++delta;
    ++n;
  }
  return output.join('');
};

var punycodeToAscii$1 = function (input) {
  var encoded = [];
  var labels = input.toLowerCase().replace(regexSeparators$1, '\u002E').split('.');
  var i, label;
  for (i = 0; i < labels.length; i++) {
    label = labels[i];
    encoded.push(regexNonASCII$1.test(label) ? 'xn--' + encode$1(label) : label);
  }
  return encoded.join('.');
};

var getIterator$1 = function (it) {
  var iteratorMethod = getIteratorMethod(it);
  if (typeof iteratorMethod != 'function') {
    throw TypeError(String(it) + ' is not iterable');
  } return anObject(iteratorMethod.call(it));
};

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`





















var $fetch$3 = getBuiltIn('fetch');
var Headers$1 = getBuiltIn('Headers');
var ITERATOR$f = wellKnownSymbol('iterator');
var URL_SEARCH_PARAMS$1 = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR$1 = URL_SEARCH_PARAMS$1 + 'Iterator';
var setInternalState$a = internalState.set;
var getInternalParamsState$1 = internalState.getterFor(URL_SEARCH_PARAMS$1);
var getInternalIteratorState$1 = internalState.getterFor(URL_SEARCH_PARAMS_ITERATOR$1);

var plus$1 = /\+/g;
var sequences$1 = Array(4);

var percentSequence$1 = function (bytes) {
  return sequences$1[bytes - 1] || (sequences$1[bytes - 1] = RegExp('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode$1 = function (sequence) {
  try {
    return decodeURIComponent(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize$1 = function (it) {
  var result = it.replace(plus$1, ' ');
  var bytes = 4;
  try {
    return decodeURIComponent(result);
  } catch (error) {
    while (bytes) {
      result = result.replace(percentSequence$1(bytes--), percentDecode$1);
    }
    return result;
  }
};

var find$4 = /[!'()~]|%20/g;

var replace$1 = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer$1 = function (match) {
  return replace$1[match];
};

var serialize$1 = function (it) {
  return encodeURIComponent(it).replace(find$4, replacer$1);
};

var parseSearchParams$1 = function (result, query) {
  if (query) {
    var attributes = query.split('&');
    var index = 0;
    var attribute, entry;
    while (index < attributes.length) {
      attribute = attributes[index++];
      if (attribute.length) {
        entry = attribute.split('=');
        result.push({
          key: deserialize$1(entry.shift()),
          value: deserialize$1(entry.join('='))
        });
      }
    }
  }
};

var updateSearchParams$1 = function (query) {
  this.entries.length = 0;
  parseSearchParams$1(this.entries, query);
};

var validateArgumentsLength$1 = function (passed, required) {
  if (passed < required) throw TypeError('Not enough arguments');
};

var URLSearchParamsIterator$1 = createIteratorConstructor(function Iterator(params, kind) {
  setInternalState$a(this, {
    type: URL_SEARCH_PARAMS_ITERATOR$1,
    iterator: getIterator$1(getInternalParamsState$1(params).entries),
    kind: kind
  });
}, 'Iterator', function next() {
  var state = getInternalIteratorState$1(this);
  var kind = state.kind;
  var step = state.iterator.next();
  var entry = step.value;
  if (!step.done) {
    step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [entry.key, entry.value];
  } return step;
});

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor$1 = function URLSearchParams(/* init */) {
  anInstance(this, URLSearchParamsConstructor$1, URL_SEARCH_PARAMS$1);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  var that = this;
  var entries = [];
  var iteratorMethod, iterator, next, step, entryIterator, entryNext, first, second, key;

  setInternalState$a(that, {
    type: URL_SEARCH_PARAMS$1,
    entries: entries,
    updateURL: function () { /* empty */ },
    updateSearchParams: updateSearchParams$1
  });

  if (init !== undefined) {
    if (isObject(init)) {
      iteratorMethod = getIteratorMethod(init);
      if (typeof iteratorMethod === 'function') {
        iterator = iteratorMethod.call(init);
        next = iterator.next;
        while (!(step = next.call(iterator)).done) {
          entryIterator = getIterator$1(anObject(step.value));
          entryNext = entryIterator.next;
          if (
            (first = entryNext.call(entryIterator)).done ||
            (second = entryNext.call(entryIterator)).done ||
            !entryNext.call(entryIterator).done
          ) throw TypeError('Expected sequence with length 2');
          entries.push({ key: first.value + '', value: second.value + '' });
        }
      } else for (key in init) if (has(init, key)) entries.push({ key: key, value: init[key] + '' });
    } else {
      parseSearchParams$1(entries, typeof init === 'string' ? init.charAt(0) === '?' ? init.slice(1) : init : init + '');
    }
  }
};

var URLSearchParamsPrototype$1 = URLSearchParamsConstructor$1.prototype;

redefineAll(URLSearchParamsPrototype$1, {
  // `URLSearchParams.prototype.appent` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    validateArgumentsLength$1(arguments.length, 2);
    var state = getInternalParamsState$1(this);
    state.entries.push({ key: name + '', value: value + '' });
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name) {
    validateArgumentsLength$1(arguments.length, 1);
    var state = getInternalParamsState$1(this);
    var entries = state.entries;
    var key = name + '';
    var index = 0;
    while (index < entries.length) {
      if (entries[index].key === key) entries.splice(index, 1);
      else index++;
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    validateArgumentsLength$1(arguments.length, 1);
    var entries = getInternalParamsState$1(this).entries;
    var key = name + '';
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    validateArgumentsLength$1(arguments.length, 1);
    var entries = getInternalParamsState$1(this).entries;
    var key = name + '';
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) result.push(entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name) {
    validateArgumentsLength$1(arguments.length, 1);
    var entries = getInternalParamsState$1(this).entries;
    var key = name + '';
    var index = 0;
    while (index < entries.length) {
      if (entries[index++].key === key) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    validateArgumentsLength$1(arguments.length, 1);
    var state = getInternalParamsState$1(this);
    var entries = state.entries;
    var found = false;
    var key = name + '';
    var val = value + '';
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) entries.splice(index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) entries.push({ key: key, value: val });
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState$1(this);
    var entries = state.entries;
    // Array#sort is not stable in some engines
    var slice = entries.slice();
    var entry, entriesIndex, sliceIndex;
    entries.length = 0;
    for (sliceIndex = 0; sliceIndex < slice.length; sliceIndex++) {
      entry = slice[sliceIndex];
      for (entriesIndex = 0; entriesIndex < sliceIndex; entriesIndex++) {
        if (entries[entriesIndex].key > entry.key) {
          entries.splice(entriesIndex, 0, entry);
          break;
        }
      }
      if (entriesIndex === sliceIndex) entries.push(entry);
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState$1(this).entries;
    var boundFunction = bindContext(callback, arguments.length > 1 ? arguments[1] : undefined, 3);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator$1(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator$1(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator$1(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
redefine(URLSearchParamsPrototype$1, ITERATOR$f, URLSearchParamsPrototype$1.entries);

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
redefine(URLSearchParamsPrototype$1, 'toString', function toString() {
  var entries = getInternalParamsState$1(this).entries;
  var result = [];
  var index = 0;
  var entry;
  while (index < entries.length) {
    entry = entries[index++];
    result.push(serialize$1(entry.key) + '=' + serialize$1(entry.value));
  } return result.join('&');
}, { enumerable: true });

setToStringTag(URLSearchParamsConstructor$1, URL_SEARCH_PARAMS$1);

_export({ global: true, forced: !nativeUrl$1 }, {
  URLSearchParams: URLSearchParamsConstructor$1
});

// Wrap `fetch` for correct work with polyfilled `URLSearchParams`
// https://github.com/zloirock/core-js/issues/674
if (!nativeUrl$1 && typeof $fetch$3 == 'function' && typeof Headers$1 == 'function') {
  _export({ global: true, enumerable: true, forced: true }, {
    fetch: function fetch(input /* , init */) {
      var args = [input];
      var init, body, headers;
      if (arguments.length > 1) {
        init = arguments[1];
        if (isObject(init)) {
          body = init.body;
          if (classof(body) === URL_SEARCH_PARAMS$1) {
            headers = init.headers ? new Headers$1(init.headers) : new Headers$1();
            if (!headers.has('content-type')) {
              headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
            }
            init = objectCreate(init, {
              body: createPropertyDescriptor(0, String(body)),
              headers: createPropertyDescriptor(0, headers)
            });
          }
        }
        args.push(init);
      } return $fetch$3.apply(this, args);
    }
  });
}

var web_urlSearchParams$1 = {
  URLSearchParams: URLSearchParamsConstructor$1,
  getState: getInternalParamsState$1
};

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`











var codeAt$1 = stringMultibyte$1.codeAt;





var NativeURL$1 = global_1.URL;
var URLSearchParams$2 = web_urlSearchParams$1.URLSearchParams;
var getInternalSearchParamsState$1 = web_urlSearchParams$1.getState;
var setInternalState$b = internalState.set;
var getInternalURLState$1 = internalState.getterFor('URL');
var floor$9 = Math.floor;
var pow$3 = Math.pow;

var INVALID_AUTHORITY$1 = 'Invalid authority';
var INVALID_SCHEME$1 = 'Invalid scheme';
var INVALID_HOST$1 = 'Invalid host';
var INVALID_PORT$1 = 'Invalid port';

var ALPHA$1 = /[A-Za-z]/;
var ALPHANUMERIC$1 = /[\d+\-.A-Za-z]/;
var DIGIT$1 = /\d/;
var HEX_START$1 = /^(0x|0X)/;
var OCT$1 = /^[0-7]+$/;
var DEC$1 = /^\d+$/;
var HEX$1 = /^[\dA-Fa-f]+$/;
// eslint-disable-next-line no-control-regex
var FORBIDDEN_HOST_CODE_POINT$1 = /[\u0000\u0009\u000A\u000D #%/:?@[\\]]/;
// eslint-disable-next-line no-control-regex
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT$1 = /[\u0000\u0009\u000A\u000D #/:?@[\\]]/;
// eslint-disable-next-line no-control-regex
var LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE$1 = /^[\u0000-\u001F ]+|[\u0000-\u001F ]+$/g;
// eslint-disable-next-line no-control-regex
var TAB_AND_NEW_LINE$1 = /[\u0009\u000A\u000D]/g;
var EOF$1;

var parseHost$1 = function (url, input) {
  var result, codePoints, index;
  if (input.charAt(0) == '[') {
    if (input.charAt(input.length - 1) != ']') return INVALID_HOST$1;
    result = parseIPv6$1(input.slice(1, -1));
    if (!result) return INVALID_HOST$1;
    url.host = result;
  // opaque host
  } else if (!isSpecial$1(url)) {
    if (FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT$1.test(input)) return INVALID_HOST$1;
    result = '';
    codePoints = arrayFrom$1(input);
    for (index = 0; index < codePoints.length; index++) {
      result += percentEncode$1(codePoints[index], C0ControlPercentEncodeSet$1);
    }
    url.host = result;
  } else {
    input = punycodeToAscii$1(input);
    if (FORBIDDEN_HOST_CODE_POINT$1.test(input)) return INVALID_HOST$1;
    result = parseIPv4$1(input);
    if (result === null) return INVALID_HOST$1;
    url.host = result;
  }
};

var parseIPv4$1 = function (input) {
  var parts = input.split('.');
  var partsLength, numbers, index, part, radix, number, ipv4;
  if (parts.length && parts[parts.length - 1] == '') {
    parts.pop();
  }
  partsLength = parts.length;
  if (partsLength > 4) return input;
  numbers = [];
  for (index = 0; index < partsLength; index++) {
    part = parts[index];
    if (part == '') return input;
    radix = 10;
    if (part.length > 1 && part.charAt(0) == '0') {
      radix = HEX_START$1.test(part) ? 16 : 8;
      part = part.slice(radix == 8 ? 1 : 2);
    }
    if (part === '') {
      number = 0;
    } else {
      if (!(radix == 10 ? DEC$1 : radix == 8 ? OCT$1 : HEX$1).test(part)) return input;
      number = parseInt(part, radix);
    }
    numbers.push(number);
  }
  for (index = 0; index < partsLength; index++) {
    number = numbers[index];
    if (index == partsLength - 1) {
      if (number >= pow$3(256, 5 - partsLength)) return null;
    } else if (number > 255) return null;
  }
  ipv4 = numbers.pop();
  for (index = 0; index < numbers.length; index++) {
    ipv4 += numbers[index] * pow$3(256, 3 - index);
  }
  return ipv4;
};

// eslint-disable-next-line max-statements
var parseIPv6$1 = function (input) {
  var address = [0, 0, 0, 0, 0, 0, 0, 0];
  var pieceIndex = 0;
  var compress = null;
  var pointer = 0;
  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;

  var char = function () {
    return input.charAt(pointer);
  };

  if (char() == ':') {
    if (input.charAt(1) != ':') return;
    pointer += 2;
    pieceIndex++;
    compress = pieceIndex;
  }
  while (char()) {
    if (pieceIndex == 8) return;
    if (char() == ':') {
      if (compress !== null) return;
      pointer++;
      pieceIndex++;
      compress = pieceIndex;
      continue;
    }
    value = length = 0;
    while (length < 4 && HEX$1.test(char())) {
      value = value * 16 + parseInt(char(), 16);
      pointer++;
      length++;
    }
    if (char() == '.') {
      if (length == 0) return;
      pointer -= length;
      if (pieceIndex > 6) return;
      numbersSeen = 0;
      while (char()) {
        ipv4Piece = null;
        if (numbersSeen > 0) {
          if (char() == '.' && numbersSeen < 4) pointer++;
          else return;
        }
        if (!DIGIT$1.test(char())) return;
        while (DIGIT$1.test(char())) {
          number = parseInt(char(), 10);
          if (ipv4Piece === null) ipv4Piece = number;
          else if (ipv4Piece == 0) return;
          else ipv4Piece = ipv4Piece * 10 + number;
          if (ipv4Piece > 255) return;
          pointer++;
        }
        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
        numbersSeen++;
        if (numbersSeen == 2 || numbersSeen == 4) pieceIndex++;
      }
      if (numbersSeen != 4) return;
      break;
    } else if (char() == ':') {
      pointer++;
      if (!char()) return;
    } else if (char()) return;
    address[pieceIndex++] = value;
  }
  if (compress !== null) {
    swaps = pieceIndex - compress;
    pieceIndex = 7;
    while (pieceIndex != 0 && swaps > 0) {
      swap = address[pieceIndex];
      address[pieceIndex--] = address[compress + swaps - 1];
      address[compress + --swaps] = swap;
    }
  } else if (pieceIndex != 8) return;
  return address;
};

var findLongestZeroSequence$1 = function (ipv6) {
  var maxIndex = null;
  var maxLength = 1;
  var currStart = null;
  var currLength = 0;
  var index = 0;
  for (; index < 8; index++) {
    if (ipv6[index] !== 0) {
      if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
      }
      currStart = null;
      currLength = 0;
    } else {
      if (currStart === null) currStart = index;
      ++currLength;
    }
  }
  if (currLength > maxLength) {
    maxIndex = currStart;
    maxLength = currLength;
  }
  return maxIndex;
};

var serializeHost$1 = function (host) {
  var result, index, compress, ignore0;
  // ipv4
  if (typeof host == 'number') {
    result = [];
    for (index = 0; index < 4; index++) {
      result.unshift(host % 256);
      host = floor$9(host / 256);
    } return result.join('.');
  // ipv6
  } else if (typeof host == 'object') {
    result = '';
    compress = findLongestZeroSequence$1(host);
    for (index = 0; index < 8; index++) {
      if (ignore0 && host[index] === 0) continue;
      if (ignore0) ignore0 = false;
      if (compress === index) {
        result += index ? ':' : '::';
        ignore0 = true;
      } else {
        result += host[index].toString(16);
        if (index < 7) result += ':';
      }
    }
    return '[' + result + ']';
  } return host;
};

var C0ControlPercentEncodeSet$1 = {};
var fragmentPercentEncodeSet$1 = objectAssign({}, C0ControlPercentEncodeSet$1, {
  ' ': 1, '"': 1, '<': 1, '>': 1, '`': 1
});
var pathPercentEncodeSet$1 = objectAssign({}, fragmentPercentEncodeSet$1, {
  '#': 1, '?': 1, '{': 1, '}': 1
});
var userinfoPercentEncodeSet$1 = objectAssign({}, pathPercentEncodeSet$1, {
  '/': 1, ':': 1, ';': 1, '=': 1, '@': 1, '[': 1, '\\': 1, ']': 1, '^': 1, '|': 1
});

var percentEncode$1 = function (char, set) {
  var code = codeAt$1(char, 0);
  return code > 0x20 && code < 0x7F && !has(set, char) ? char : encodeURIComponent(char);
};

var specialSchemes$1 = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
};

var isSpecial$1 = function (url) {
  return has(specialSchemes$1, url.scheme);
};

var includesCredentials$1 = function (url) {
  return url.username != '' || url.password != '';
};

var cannotHaveUsernamePasswordPort$1 = function (url) {
  return !url.host || url.cannotBeABaseURL || url.scheme == 'file';
};

var isWindowsDriveLetter$1 = function (string, normalized) {
  var second;
  return string.length == 2 && ALPHA$1.test(string.charAt(0))
    && ((second = string.charAt(1)) == ':' || (!normalized && second == '|'));
};

var startsWithWindowsDriveLetter$1 = function (string) {
  var third;
  return string.length > 1 && isWindowsDriveLetter$1(string.slice(0, 2)) && (
    string.length == 2 ||
    ((third = string.charAt(2)) === '/' || third === '\\' || third === '?' || third === '#')
  );
};

var shortenURLsPath$1 = function (url) {
  var path = url.path;
  var pathSize = path.length;
  if (pathSize && (url.scheme != 'file' || pathSize != 1 || !isWindowsDriveLetter$1(path[0], true))) {
    path.pop();
  }
};

var isSingleDot$1 = function (segment) {
  return segment === '.' || segment.toLowerCase() === '%2e';
};

var isDoubleDot$1 = function (segment) {
  segment = segment.toLowerCase();
  return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
};

// States:
var SCHEME_START$1 = {};
var SCHEME$1 = {};
var NO_SCHEME$1 = {};
var SPECIAL_RELATIVE_OR_AUTHORITY$1 = {};
var PATH_OR_AUTHORITY$1 = {};
var RELATIVE$1 = {};
var RELATIVE_SLASH$1 = {};
var SPECIAL_AUTHORITY_SLASHES$1 = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES$1 = {};
var AUTHORITY$1 = {};
var HOST$1 = {};
var HOSTNAME$1 = {};
var PORT$1 = {};
var FILE$1 = {};
var FILE_SLASH$1 = {};
var FILE_HOST$1 = {};
var PATH_START$1 = {};
var PATH$1 = {};
var CANNOT_BE_A_BASE_URL_PATH$1 = {};
var QUERY$1 = {};
var FRAGMENT$1 = {};

// eslint-disable-next-line max-statements
var parseURL$1 = function (url, input, stateOverride, base) {
  var state = stateOverride || SCHEME_START$1;
  var pointer = 0;
  var buffer = '';
  var seenAt = false;
  var seenBracket = false;
  var seenPasswordToken = false;
  var codePoints, char, bufferCodePoints, failure;

  if (!stateOverride) {
    url.scheme = '';
    url.username = '';
    url.password = '';
    url.host = null;
    url.port = null;
    url.path = [];
    url.query = null;
    url.fragment = null;
    url.cannotBeABaseURL = false;
    input = input.replace(LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE$1, '');
  }

  input = input.replace(TAB_AND_NEW_LINE$1, '');

  codePoints = arrayFrom$1(input);

  while (pointer <= codePoints.length) {
    char = codePoints[pointer];
    switch (state) {
      case SCHEME_START$1:
        if (char && ALPHA$1.test(char)) {
          buffer += char.toLowerCase();
          state = SCHEME$1;
        } else if (!stateOverride) {
          state = NO_SCHEME$1;
          continue;
        } else return INVALID_SCHEME$1;
        break;

      case SCHEME$1:
        if (char && (ALPHANUMERIC$1.test(char) || char == '+' || char == '-' || char == '.')) {
          buffer += char.toLowerCase();
        } else if (char == ':') {
          if (stateOverride && (
            (isSpecial$1(url) != has(specialSchemes$1, buffer)) ||
            (buffer == 'file' && (includesCredentials$1(url) || url.port !== null)) ||
            (url.scheme == 'file' && !url.host)
          )) return;
          url.scheme = buffer;
          if (stateOverride) {
            if (isSpecial$1(url) && specialSchemes$1[url.scheme] == url.port) url.port = null;
            return;
          }
          buffer = '';
          if (url.scheme == 'file') {
            state = FILE$1;
          } else if (isSpecial$1(url) && base && base.scheme == url.scheme) {
            state = SPECIAL_RELATIVE_OR_AUTHORITY$1;
          } else if (isSpecial$1(url)) {
            state = SPECIAL_AUTHORITY_SLASHES$1;
          } else if (codePoints[pointer + 1] == '/') {
            state = PATH_OR_AUTHORITY$1;
            pointer++;
          } else {
            url.cannotBeABaseURL = true;
            url.path.push('');
            state = CANNOT_BE_A_BASE_URL_PATH$1;
          }
        } else if (!stateOverride) {
          buffer = '';
          state = NO_SCHEME$1;
          pointer = 0;
          continue;
        } else return INVALID_SCHEME$1;
        break;

      case NO_SCHEME$1:
        if (!base || (base.cannotBeABaseURL && char != '#')) return INVALID_SCHEME$1;
        if (base.cannotBeABaseURL && char == '#') {
          url.scheme = base.scheme;
          url.path = base.path.slice();
          url.query = base.query;
          url.fragment = '';
          url.cannotBeABaseURL = true;
          state = FRAGMENT$1;
          break;
        }
        state = base.scheme == 'file' ? FILE$1 : RELATIVE$1;
        continue;

      case SPECIAL_RELATIVE_OR_AUTHORITY$1:
        if (char == '/' && codePoints[pointer + 1] == '/') {
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES$1;
          pointer++;
        } else {
          state = RELATIVE$1;
          continue;
        } break;

      case PATH_OR_AUTHORITY$1:
        if (char == '/') {
          state = AUTHORITY$1;
          break;
        } else {
          state = PATH$1;
          continue;
        }

      case RELATIVE$1:
        url.scheme = base.scheme;
        if (char == EOF$1) {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.query = base.query;
        } else if (char == '/' || (char == '\\' && isSpecial$1(url))) {
          state = RELATIVE_SLASH$1;
        } else if (char == '?') {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.query = '';
          state = QUERY$1;
        } else if (char == '#') {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.query = base.query;
          url.fragment = '';
          state = FRAGMENT$1;
        } else {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.path.pop();
          state = PATH$1;
          continue;
        } break;

      case RELATIVE_SLASH$1:
        if (isSpecial$1(url) && (char == '/' || char == '\\')) {
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES$1;
        } else if (char == '/') {
          state = AUTHORITY$1;
        } else {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          state = PATH$1;
          continue;
        } break;

      case SPECIAL_AUTHORITY_SLASHES$1:
        state = SPECIAL_AUTHORITY_IGNORE_SLASHES$1;
        if (char != '/' || buffer.charAt(pointer + 1) != '/') continue;
        pointer++;
        break;

      case SPECIAL_AUTHORITY_IGNORE_SLASHES$1:
        if (char != '/' && char != '\\') {
          state = AUTHORITY$1;
          continue;
        } break;

      case AUTHORITY$1:
        if (char == '@') {
          if (seenAt) buffer = '%40' + buffer;
          seenAt = true;
          bufferCodePoints = arrayFrom$1(buffer);
          for (var i = 0; i < bufferCodePoints.length; i++) {
            var codePoint = bufferCodePoints[i];
            if (codePoint == ':' && !seenPasswordToken) {
              seenPasswordToken = true;
              continue;
            }
            var encodedCodePoints = percentEncode$1(codePoint, userinfoPercentEncodeSet$1);
            if (seenPasswordToken) url.password += encodedCodePoints;
            else url.username += encodedCodePoints;
          }
          buffer = '';
        } else if (
          char == EOF$1 || char == '/' || char == '?' || char == '#' ||
          (char == '\\' && isSpecial$1(url))
        ) {
          if (seenAt && buffer == '') return INVALID_AUTHORITY$1;
          pointer -= arrayFrom$1(buffer).length + 1;
          buffer = '';
          state = HOST$1;
        } else buffer += char;
        break;

      case HOST$1:
      case HOSTNAME$1:
        if (stateOverride && url.scheme == 'file') {
          state = FILE_HOST$1;
          continue;
        } else if (char == ':' && !seenBracket) {
          if (buffer == '') return INVALID_HOST$1;
          failure = parseHost$1(url, buffer);
          if (failure) return failure;
          buffer = '';
          state = PORT$1;
          if (stateOverride == HOSTNAME$1) return;
        } else if (
          char == EOF$1 || char == '/' || char == '?' || char == '#' ||
          (char == '\\' && isSpecial$1(url))
        ) {
          if (isSpecial$1(url) && buffer == '') return INVALID_HOST$1;
          if (stateOverride && buffer == '' && (includesCredentials$1(url) || url.port !== null)) return;
          failure = parseHost$1(url, buffer);
          if (failure) return failure;
          buffer = '';
          state = PATH_START$1;
          if (stateOverride) return;
          continue;
        } else {
          if (char == '[') seenBracket = true;
          else if (char == ']') seenBracket = false;
          buffer += char;
        } break;

      case PORT$1:
        if (DIGIT$1.test(char)) {
          buffer += char;
        } else if (
          char == EOF$1 || char == '/' || char == '?' || char == '#' ||
          (char == '\\' && isSpecial$1(url)) ||
          stateOverride
        ) {
          if (buffer != '') {
            var port = parseInt(buffer, 10);
            if (port > 0xFFFF) return INVALID_PORT$1;
            url.port = (isSpecial$1(url) && port === specialSchemes$1[url.scheme]) ? null : port;
            buffer = '';
          }
          if (stateOverride) return;
          state = PATH_START$1;
          continue;
        } else return INVALID_PORT$1;
        break;

      case FILE$1:
        url.scheme = 'file';
        if (char == '/' || char == '\\') state = FILE_SLASH$1;
        else if (base && base.scheme == 'file') {
          if (char == EOF$1) {
            url.host = base.host;
            url.path = base.path.slice();
            url.query = base.query;
          } else if (char == '?') {
            url.host = base.host;
            url.path = base.path.slice();
            url.query = '';
            state = QUERY$1;
          } else if (char == '#') {
            url.host = base.host;
            url.path = base.path.slice();
            url.query = base.query;
            url.fragment = '';
            state = FRAGMENT$1;
          } else {
            if (!startsWithWindowsDriveLetter$1(codePoints.slice(pointer).join(''))) {
              url.host = base.host;
              url.path = base.path.slice();
              shortenURLsPath$1(url);
            }
            state = PATH$1;
            continue;
          }
        } else {
          state = PATH$1;
          continue;
        } break;

      case FILE_SLASH$1:
        if (char == '/' || char == '\\') {
          state = FILE_HOST$1;
          break;
        }
        if (base && base.scheme == 'file' && !startsWithWindowsDriveLetter$1(codePoints.slice(pointer).join(''))) {
          if (isWindowsDriveLetter$1(base.path[0], true)) url.path.push(base.path[0]);
          else url.host = base.host;
        }
        state = PATH$1;
        continue;

      case FILE_HOST$1:
        if (char == EOF$1 || char == '/' || char == '\\' || char == '?' || char == '#') {
          if (!stateOverride && isWindowsDriveLetter$1(buffer)) {
            state = PATH$1;
          } else if (buffer == '') {
            url.host = '';
            if (stateOverride) return;
            state = PATH_START$1;
          } else {
            failure = parseHost$1(url, buffer);
            if (failure) return failure;
            if (url.host == 'localhost') url.host = '';
            if (stateOverride) return;
            buffer = '';
            state = PATH_START$1;
          } continue;
        } else buffer += char;
        break;

      case PATH_START$1:
        if (isSpecial$1(url)) {
          state = PATH$1;
          if (char != '/' && char != '\\') continue;
        } else if (!stateOverride && char == '?') {
          url.query = '';
          state = QUERY$1;
        } else if (!stateOverride && char == '#') {
          url.fragment = '';
          state = FRAGMENT$1;
        } else if (char != EOF$1) {
          state = PATH$1;
          if (char != '/') continue;
        } break;

      case PATH$1:
        if (
          char == EOF$1 || char == '/' ||
          (char == '\\' && isSpecial$1(url)) ||
          (!stateOverride && (char == '?' || char == '#'))
        ) {
          if (isDoubleDot$1(buffer)) {
            shortenURLsPath$1(url);
            if (char != '/' && !(char == '\\' && isSpecial$1(url))) {
              url.path.push('');
            }
          } else if (isSingleDot$1(buffer)) {
            if (char != '/' && !(char == '\\' && isSpecial$1(url))) {
              url.path.push('');
            }
          } else {
            if (url.scheme == 'file' && !url.path.length && isWindowsDriveLetter$1(buffer)) {
              if (url.host) url.host = '';
              buffer = buffer.charAt(0) + ':'; // normalize windows drive letter
            }
            url.path.push(buffer);
          }
          buffer = '';
          if (url.scheme == 'file' && (char == EOF$1 || char == '?' || char == '#')) {
            while (url.path.length > 1 && url.path[0] === '') {
              url.path.shift();
            }
          }
          if (char == '?') {
            url.query = '';
            state = QUERY$1;
          } else if (char == '#') {
            url.fragment = '';
            state = FRAGMENT$1;
          }
        } else {
          buffer += percentEncode$1(char, pathPercentEncodeSet$1);
        } break;

      case CANNOT_BE_A_BASE_URL_PATH$1:
        if (char == '?') {
          url.query = '';
          state = QUERY$1;
        } else if (char == '#') {
          url.fragment = '';
          state = FRAGMENT$1;
        } else if (char != EOF$1) {
          url.path[0] += percentEncode$1(char, C0ControlPercentEncodeSet$1);
        } break;

      case QUERY$1:
        if (!stateOverride && char == '#') {
          url.fragment = '';
          state = FRAGMENT$1;
        } else if (char != EOF$1) {
          if (char == "'" && isSpecial$1(url)) url.query += '%27';
          else if (char == '#') url.query += '%23';
          else url.query += percentEncode$1(char, C0ControlPercentEncodeSet$1);
        } break;

      case FRAGMENT$1:
        if (char != EOF$1) url.fragment += percentEncode$1(char, fragmentPercentEncodeSet$1);
        break;
    }

    pointer++;
  }
};

// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var URLConstructor$1 = function URL(url /* , base */) {
  var that = anInstance(this, URLConstructor$1, 'URL');
  var base = arguments.length > 1 ? arguments[1] : undefined;
  var urlString = String(url);
  var state = setInternalState$b(that, { type: 'URL' });
  var baseState, failure;
  if (base !== undefined) {
    if (base instanceof URLConstructor$1) baseState = getInternalURLState$1(base);
    else {
      failure = parseURL$1(baseState = {}, String(base));
      if (failure) throw TypeError(failure);
    }
  }
  failure = parseURL$1(state, urlString, null, baseState);
  if (failure) throw TypeError(failure);
  var searchParams = state.searchParams = new URLSearchParams$2();
  var searchParamsState = getInternalSearchParamsState$1(searchParams);
  searchParamsState.updateSearchParams(state.query);
  searchParamsState.updateURL = function () {
    state.query = String(searchParams) || null;
  };
  if (!descriptors) {
    that.href = serializeURL$1.call(that);
    that.origin = getOrigin$1.call(that);
    that.protocol = getProtocol$1.call(that);
    that.username = getUsername$1.call(that);
    that.password = getPassword$1.call(that);
    that.host = getHost$1.call(that);
    that.hostname = getHostname$1.call(that);
    that.port = getPort$1.call(that);
    that.pathname = getPathname$1.call(that);
    that.search = getSearch$1.call(that);
    that.searchParams = getSearchParams$1.call(that);
    that.hash = getHash$1.call(that);
  }
};

var URLPrototype$1 = URLConstructor$1.prototype;

var serializeURL$1 = function () {
  var url = getInternalURLState$1(this);
  var scheme = url.scheme;
  var username = url.username;
  var password = url.password;
  var host = url.host;
  var port = url.port;
  var path = url.path;
  var query = url.query;
  var fragment = url.fragment;
  var output = scheme + ':';
  if (host !== null) {
    output += '//';
    if (includesCredentials$1(url)) {
      output += username + (password ? ':' + password : '') + '@';
    }
    output += serializeHost$1(host);
    if (port !== null) output += ':' + port;
  } else if (scheme == 'file') output += '//';
  output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + path.join('/') : '';
  if (query !== null) output += '?' + query;
  if (fragment !== null) output += '#' + fragment;
  return output;
};

var getOrigin$1 = function () {
  var url = getInternalURLState$1(this);
  var scheme = url.scheme;
  var port = url.port;
  if (scheme == 'blob') try {
    return new URL(scheme.path[0]).origin;
  } catch (error) {
    return 'null';
  }
  if (scheme == 'file' || !isSpecial$1(url)) return 'null';
  return scheme + '://' + serializeHost$1(url.host) + (port !== null ? ':' + port : '');
};

var getProtocol$1 = function () {
  return getInternalURLState$1(this).scheme + ':';
};

var getUsername$1 = function () {
  return getInternalURLState$1(this).username;
};

var getPassword$1 = function () {
  return getInternalURLState$1(this).password;
};

var getHost$1 = function () {
  var url = getInternalURLState$1(this);
  var host = url.host;
  var port = url.port;
  return host === null ? ''
    : port === null ? serializeHost$1(host)
    : serializeHost$1(host) + ':' + port;
};

var getHostname$1 = function () {
  var host = getInternalURLState$1(this).host;
  return host === null ? '' : serializeHost$1(host);
};

var getPort$1 = function () {
  var port = getInternalURLState$1(this).port;
  return port === null ? '' : String(port);
};

var getPathname$1 = function () {
  var url = getInternalURLState$1(this);
  var path = url.path;
  return url.cannotBeABaseURL ? path[0] : path.length ? '/' + path.join('/') : '';
};

var getSearch$1 = function () {
  var query = getInternalURLState$1(this).query;
  return query ? '?' + query : '';
};

var getSearchParams$1 = function () {
  return getInternalURLState$1(this).searchParams;
};

var getHash$1 = function () {
  var fragment = getInternalURLState$1(this).fragment;
  return fragment ? '#' + fragment : '';
};

var accessorDescriptor$1 = function (getter, setter) {
  return { get: getter, set: setter, configurable: true, enumerable: true };
};

if (descriptors) {
  objectDefineProperties(URLPrototype$1, {
    // `URL.prototype.href` accessors pair
    // https://url.spec.whatwg.org/#dom-url-href
    href: accessorDescriptor$1(serializeURL$1, function (href) {
      var url = getInternalURLState$1(this);
      var urlString = String(href);
      var failure = parseURL$1(url, urlString);
      if (failure) throw TypeError(failure);
      getInternalSearchParamsState$1(url.searchParams).updateSearchParams(url.query);
    }),
    // `URL.prototype.origin` getter
    // https://url.spec.whatwg.org/#dom-url-origin
    origin: accessorDescriptor$1(getOrigin$1),
    // `URL.prototype.protocol` accessors pair
    // https://url.spec.whatwg.org/#dom-url-protocol
    protocol: accessorDescriptor$1(getProtocol$1, function (protocol) {
      var url = getInternalURLState$1(this);
      parseURL$1(url, String(protocol) + ':', SCHEME_START$1);
    }),
    // `URL.prototype.username` accessors pair
    // https://url.spec.whatwg.org/#dom-url-username
    username: accessorDescriptor$1(getUsername$1, function (username) {
      var url = getInternalURLState$1(this);
      var codePoints = arrayFrom$1(String(username));
      if (cannotHaveUsernamePasswordPort$1(url)) return;
      url.username = '';
      for (var i = 0; i < codePoints.length; i++) {
        url.username += percentEncode$1(codePoints[i], userinfoPercentEncodeSet$1);
      }
    }),
    // `URL.prototype.password` accessors pair
    // https://url.spec.whatwg.org/#dom-url-password
    password: accessorDescriptor$1(getPassword$1, function (password) {
      var url = getInternalURLState$1(this);
      var codePoints = arrayFrom$1(String(password));
      if (cannotHaveUsernamePasswordPort$1(url)) return;
      url.password = '';
      for (var i = 0; i < codePoints.length; i++) {
        url.password += percentEncode$1(codePoints[i], userinfoPercentEncodeSet$1);
      }
    }),
    // `URL.prototype.host` accessors pair
    // https://url.spec.whatwg.org/#dom-url-host
    host: accessorDescriptor$1(getHost$1, function (host) {
      var url = getInternalURLState$1(this);
      if (url.cannotBeABaseURL) return;
      parseURL$1(url, String(host), HOST$1);
    }),
    // `URL.prototype.hostname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hostname
    hostname: accessorDescriptor$1(getHostname$1, function (hostname) {
      var url = getInternalURLState$1(this);
      if (url.cannotBeABaseURL) return;
      parseURL$1(url, String(hostname), HOSTNAME$1);
    }),
    // `URL.prototype.port` accessors pair
    // https://url.spec.whatwg.org/#dom-url-port
    port: accessorDescriptor$1(getPort$1, function (port) {
      var url = getInternalURLState$1(this);
      if (cannotHaveUsernamePasswordPort$1(url)) return;
      port = String(port);
      if (port == '') url.port = null;
      else parseURL$1(url, port, PORT$1);
    }),
    // `URL.prototype.pathname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-pathname
    pathname: accessorDescriptor$1(getPathname$1, function (pathname) {
      var url = getInternalURLState$1(this);
      if (url.cannotBeABaseURL) return;
      url.path = [];
      parseURL$1(url, pathname + '', PATH_START$1);
    }),
    // `URL.prototype.search` accessors pair
    // https://url.spec.whatwg.org/#dom-url-search
    search: accessorDescriptor$1(getSearch$1, function (search) {
      var url = getInternalURLState$1(this);
      search = String(search);
      if (search == '') {
        url.query = null;
      } else {
        if ('?' == search.charAt(0)) search = search.slice(1);
        url.query = '';
        parseURL$1(url, search, QUERY$1);
      }
      getInternalSearchParamsState$1(url.searchParams).updateSearchParams(url.query);
    }),
    // `URL.prototype.searchParams` getter
    // https://url.spec.whatwg.org/#dom-url-searchparams
    searchParams: accessorDescriptor$1(getSearchParams$1),
    // `URL.prototype.hash` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hash
    hash: accessorDescriptor$1(getHash$1, function (hash) {
      var url = getInternalURLState$1(this);
      hash = String(hash);
      if (hash == '') {
        url.fragment = null;
        return;
      }
      if ('#' == hash.charAt(0)) hash = hash.slice(1);
      url.fragment = '';
      parseURL$1(url, hash, FRAGMENT$1);
    })
  });
}

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
redefine(URLPrototype$1, 'toJSON', function toJSON() {
  return serializeURL$1.call(this);
}, { enumerable: true });

// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
redefine(URLPrototype$1, 'toString', function toString() {
  return serializeURL$1.call(this);
}, { enumerable: true });

if (NativeURL$1) {
  var nativeCreateObjectURL$1 = NativeURL$1.createObjectURL;
  var nativeRevokeObjectURL$1 = NativeURL$1.revokeObjectURL;
  // `URL.createObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
  // eslint-disable-next-line no-unused-vars
  if (nativeCreateObjectURL$1) redefine(URLConstructor$1, 'createObjectURL', function createObjectURL(blob) {
    return nativeCreateObjectURL$1.apply(NativeURL$1, arguments);
  });
  // `URL.revokeObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
  // eslint-disable-next-line no-unused-vars
  if (nativeRevokeObjectURL$1) redefine(URLConstructor$1, 'revokeObjectURL', function revokeObjectURL(url) {
    return nativeRevokeObjectURL$1.apply(NativeURL$1, arguments);
  });
}

setToStringTag(URLConstructor$1, 'URL');

_export({ global: true, forced: !nativeUrl$1, sham: !descriptors }, {
  URL: URLConstructor$1
});

var url = path.URL;

var url$1 = url;

var url$2 = url$1;

var sdkInitingKey = 'weiyi_alinvc_unique_initing';
var sdkInitedKey = 'weiyi_alinvc_unique_inited'; // 标识滑动验证是否成功

var sdkSlidingVerificationKey = 'weiyi_alinvc_sliding_verification'; // 默认滑动验证组件会放到 该 id 的 div 中

var renderToElementId = 'weiyi_alinvc_render_to_element_id';
if (window[sdkInitingKey] === undefined) window[sdkInitingKey] = false;
if (window[sdkInitingKey] === undefined) window[sdkInitingKey] = false;
if (window[sdkSlidingVerificationKey] === undefined) window[sdkSlidingVerificationKey] = false;

function startObserverDom(buttonEle, trackEle) {
  var observer = new MutationObserver(function (eles) {
    if (eles[0].attributeName === 'style') {
      var left = window.parseFloat(buttonEle.style.left);

      if (left <= 3) {
        trackEle.style.width = '0px'; // eslint-disable-line no-param-reassign

        buttonEle.style.left = "3px"; // eslint-disable-line no-param-reassign

        addClass$1(trackEle, 'force-width-zero');
      } else {
        trackEle.style.width = left + 46 + "px"; // eslint-disable-line no-param-reassign

        removeClass$1(trackEle, 'force-width-zero');
      }
    }
  });
  observer.observe(buttonEle, {
    attributes: true,
    subtree: false,
    characterData: true,
    attributeFilter: ['style']
  });
}

function getHourString() {
  var d = new Date();
  return "" + d.getFullYear() + (d.getMonth() + 1) + d.getDate() + d.getHours();
} // 用于检测 SDK 是否已加载, 且初始化完成


function heartCheckSureReady() {
  var _context;

  return typeof window.getNVCVal === 'function' && // eslint-disable-next-line no-underscore-dangle
  indexOf$4(_context = window.__nvc__umid).call(_context, 'defaultToken') < 0;
} // 加载 SDK 并确保 SDK 相关初始化已完成


function loadJSScriptAndCheck(jsUrl) {
  return new promise$3(function (resolve, reject) {
    var existEl = document.querySelector('script#bxs-ali-sdk-nvc');

    if (existEl) {
      // 包含 3 种情况: 文件已经加载完成、文件正在加载、文件加载完成但sdk未初始化完成
      heartCheck(heartCheckSureReady).then(function () {
        return resolve();
      }).catch(function (err) {
        return reject(err);
      });
    } else {
      var el = document.createElement('script');
      el.setAttribute('id', 'bxs-ali-sdk-nvc');

      el.onload = function () {
        heartCheck(heartCheckSureReady).then(function () {
          return resolve();
        }).catch(function (err) {
          return reject(err);
        });
      };

      el.onerror = function (err) {
        return typeof el.remove === 'function' && el.remove() && reject(err);
      };

      el.src = jsUrl;
      document.head.appendChild(el);
    }
  });
}

var cacheData = {};
function resetNvc(requestId) {
  window.nvcReset && window.nvcReset(); // eslint-disable-line

  window._nvc_nc && window._nvc_nc.reset(); // eslint-disable-line

  window._nvc_nc && window._nvc_nc.hide(); // eslint-disable-line

  if (requestId && cacheData[requestId].renderToWrapperId) {
    var wrapperEle = document.querySelector(cacheData[requestId].renderToWrapperId);

    if (wrapperEle) {
      var wrapperBox = wrapperEle.parentElement;
      wrapperBox.setAttribute('style', 'display: none');
    }
  }
}
function safeRequest(requestId, url, renderToWrapperId, nvcVal, sliderStartCb) {
  return new promise$3(function (resolve, reject) {
    if (!requestId) reject(new Error('requestId 参数缺失'));
    if (!cacheData[requestId]) reject(new Error('请确保 requestId 初始化方法 initSdk 中的一致'));
    if (!window[sdkInitedKey]) reject(new Error('请先初始化人机验证 SDK: initSdk'));
    cacheData[requestId].url = url;
    cacheData[requestId].renderToWrapperId = renderToWrapperId;
    cacheData[requestId].nvcVal = nvcVal;
    var urlObj = new url$2(indexOf$4(url).call(url, 'http') !== 0 ? "" + window.location.protocol + url : url);
    urlObj.searchParams.append('nvcValue', nvcVal || window.getNVCVal());
    requestAjax(urlObj.toString()).then(function (res) {
      var nvcCode = res.nvcCode;
      var code = +nvcCode;
      delete res.nvcCode;

      var resolveWrapper = function resolveWrapper(resResolve) {
        resolve(resResolve);
      };

      if (code === 200) {
        // 无痕校验 - 成功通过
        resetNvc();
        resolveWrapper(res);
      } else if (code === 100) {
        // 二次验证 - 成功通过
        resetNvc();
        window[sdkSlidingVerificationKey] = true;
        resolveWrapper(res);
        var wrapperEle = document.querySelector(renderToWrapperId);
        var wrapperBox = wrapperEle.parentElement;
        wrapperBox.setAttribute('style', 'display: none');
      } else if (code === 400 || code === 600 || code === 700) {
        // 唤醒二次验证
        if (typeof sliderStartCb === 'function') sliderStartCb(); // 将真实的 renderTo DIV 元素移至 renderToWrapperId 内

        if (renderToWrapperId) {
          var _wrapperEle = document.querySelector(renderToWrapperId);

          if (_wrapperEle) {
            var _wrapperBox = _wrapperEle.parentElement;

            if (!_wrapperEle.querySelector("#" + renderToElementId)) {
              var ele = document.querySelector("#" + renderToElementId);

              _wrapperEle.appendChild(ele);

              _wrapperBox.setAttribute('style', 'display: block');

              heartCheck(function () {
                var _context2;

                var tempButtonEle = ele.querySelector('.button');
                return tempButtonEle && tempButtonEle.innerHTML && trim$5(_context2 = tempButtonEle.innerHTML).call(_context2);
              }, 100, 1000 * 60 * 5).then(function () {
                setTimeout$2(function () {
                  // TODO: why 为什么还需要延迟 500ms
                  startObserverDom(ele.querySelector('.stage1 .button'), ele.querySelector('.stage1 .track'));
                }, 500);
              }).catch(function (err) {
                console.error(err); // eslint-disable-line
              });
            }
          }
        } // TODO: 心跳检测二次验证的结果


        window.getNC().then(function () {
          window.NoCaptcha.setEnabled(true);
          window.NoCaptcha.upLang('cn', {
            LOADING: '加载中...',
            // 加载状态提示
            SLIDER_LABEL: '请向右滑动验证',
            // 等待滑动状态提示
            CHECK_Y: '验证通过',
            // 验证通过状态提示
            ERROR_TITLE: '验证未通过' // 验证失败触发拦截状态提示

          });

          window._nvc_nc.reset(); // eslint-disable-line


          setTimeout$2(function () {
            window._nvc_nc.reset(); // eslint-disable-line

          }, 100); // TODO: why 需要延迟 100ms

        }); // 5分钟内如果未通过, 则被认为是机器人

        heartCheck(function () {
          return window[sdkSlidingVerificationKey];
        }, 1000, 1000 * 60 * 5).then(function () {
          return resolveWrapper(res);
        }).catch(function (err) {
          return reject(err);
        });
      } else if (code === 800 || code === 900) {
        reject(new Error('系统检测为机器人操作'));
      }
    }).catch(function (err) {
      reject(err);
    });
  });
} // 获取人机验证配置对象: 无痕配置 && 滑动验证

function getConfig(requestId, appkey, scene, debugTrans) {
  if (!document.querySelector("#" + renderToElementId)) {
    var ele = document.createElement('div');
    ele.setAttribute('id', renderToElementId);
    document.body.appendChild(ele);
  }

  var opts = {
    appkey: appkey,
    scene: scene,
    isH5: true,
    popUp: false,
    renderTo: "#" + renderToElementId,
    nvcCallback: function nvcCallback(data) {
      safeRequest(requestId, cacheData[requestId].url, cacheData[requestId].renderToWrapperId, data);
    },
    language: 'cn',
    retryTimes: 5,
    // 允许服务器超时重复次数，默认5次。
    customWidth: 200,
    // 当唤醒滑动验证作为二次验证时，配置滑动验证组件的宽度
    token: new Date().getTime() + String(Math.random()).substring(2)
  };

  if (debugTrans) {
    opts.trans = debugTrans;
    opts.appkey = 'CF_APP_1';
    opts.scene = 'nvc_register_h5';
  }

  return opts;
}
/**
 * 人机认证 SDK 初始化入口, 步骤如下:
 *  1、请求配置信息: appkey、scene、sdk-url
 *  2、加载 sdk-url (确保 SDK 完全可用后再 resolve)
 * 额外说明: 支持重复调用
 */


function initSdk(requestId, debugTrans) {
  return new promise$3(function (resolve, reject) {
    if (!requestId) reject(new Error('requestId 参数缺失'));
    if (cacheData[requestId]) reject(new Error("requestId (" + requestId + ") \u5DF2\u5B58\u5728"));

    function customResolve() {
      cacheData[requestId] = {
        debugTrans: debugTrans
      };
      resolve();
    }

    if (window[sdkInitedKey]) {
      // SDK 已初始化完成
      customResolve();
      return;
    }

    if (window[sdkInitingKey]) {
      // SDK 正在初始化的
      heartCheck(heartCheckSureReady).then(function () {
        return customResolve();
      }).catch(function (err) {
        return reject(err);
      });
      return;
    }

    window[sdkInitingKey] = true; // 开始初始化 SDK

    var url = '//third-api.winbaoxian.cn/afs/getAfsConfig';
    requestAjax(url).then(function (_ref) {
      var cfg = _ref.data;
      window.NVC_Opt = getConfig(requestId, cfg.appkey, cfg.scene, debugTrans);
      return loadJSScriptAndCheck(cfg.sdk + "?t=" + getHourString());
    }).then(function () {
      window[sdkInitingKey] = false;
      window[sdkInitedKey] = true;
      customResolve();
    }).catch(function (err) {
      window[sdkInitingKey] = false;
      window[sdkInitedKey] = false;
      reject(err);
    });
  });
}
function nvcRequest(requestId, url, renderId, debugTrans, sliderStartCb) {
  return initSdk(requestId, debugTrans).then(function () {
    return safeRequest(requestId, url, renderId, null, sliderStartCb);
  });
}

var _components$l;
var captchaSendUrl;
var captchaSendVoiceUrl;
var host = window.location.hostname;

if (/^.*\.wyins\.net$/.test(host)) {
  captchaSendUrl = '//third-api.wyins.net/captcha/send?mobile=';
  captchaSendVoiceUrl = '//third-api.wyins.net/captcha/sendVoice?mobile=';
} else if (/^.*\.wyins\.net.cn$/.test(host)) {
  captchaSendUrl = '//third-api.wyins.net.cn/captcha/send?mobile=';
  captchaSendVoiceUrl = '//third-api.wyins.net.cn/captcha/sendVoice?mobile=';
} else if (/git-page\.winbaoxian\.com$/.test(host)) {
  captchaSendUrl = '//third-api.winbaoxian.cn/captcha/send?mobile=';
  captchaSendVoiceUrl = '//third-api.winbaoxian.cn/captcha/sendVoice?mobile=';
} else if (/^.*\.com$/.test(host) && host !== 'test.winbaoxian.com') {
  captchaSendUrl = '//third-api.winbaoxian.com/captcha/send?mobile=';
  captchaSendVoiceUrl = '//third-api.winbaoxian.com/captcha/sendVoice?mobile=';
} else {
  captchaSendUrl = '//third-api.winbaoxian.cn/captcha/send?mobile=';
  captchaSendVoiceUrl = '//third-api.winbaoxian.cn/captcha/sendVoice?mobile=';
}

var script$K = create({
  name: 'verify-code-input',
  model: {
    prop: 'cellphone',
    event: 'input'
  },
  props: {
    debugVoice: {
      type: Boolean,
      default: false
    },
    debugNvc: {
      type: Object,
      required: false
    },
    cellphone: {
      type: [String, Number],
      required: true
    },
    errorMessage: {
      type: String,
      default: ''
    }
  },
  components: (_components$l = {}, _components$l[__vue_component__$a.name] = __vue_component__$a, _components$l),
  data: function data() {
    return {
      requestId: '',
      // nvc 的请求 ID
      sliderId: '',
      // 随机生成的元素 id, 验证滑块会显示在该元素内
      errorCellphoneMsg: '',
      currentVerifyCode: '',
      // 用户输入的验证码
      sliderOpening: false,
      // 验证滑块是否正在显示
      btnText: '',
      btnTextClickable: true,
      gettingTimes: 0,
      // 验证码的请求次数
      idGettingCode: null,
      // 计时器
      texts: {
        initial: '获取验证码',
        noTraceVerify: '验证获取中',
        // 无痕验证中的文案
        again: '重新获取'
      },
      countDown: 59,
      // 倒计时数字
      voiceText: '语音验证',
      btnVoiceTextClickable: true,
      voiceSliderOpening: false,
      // 验证滑块是否正在显示
      voiceSendSuccess: false // 语音验证码是否成功发送

    };
  },
  computed: {
    currentCellphone: {
      get: function get() {
        return this.cellphone;
      },
      set: function set(val) {
        this.$emit('input', val);
      }
    },
    codeAttrs: function codeAttrs() {
      var attrs = {}; // eslint-disable-next-line no-restricted-syntax

      for (var key in this.$attrs) {
        if (indexOf$4(key).call(key, 'cellphone-') !== 0 && indexOf$4(key).call(key, 'debug-') !== 0) {
          attrs[key] = this.$attrs[key];
        }
      }

      return attrs;
    },
    cellphoneAttrs: function cellphoneAttrs() {
      var attrs = {}; // eslint-disable-next-line no-restricted-syntax

      for (var key in this.$attrs) {
        if (indexOf$4(key).call(key, 'cellphone-') === 0 && key !== 'cellphone-') {
          attrs[key.replace(/^cellphone-/, '')] = this.$attrs[key];
        }
      }

      return attrs;
    }
  },
  created: function created() {
    this.sliderId = "slider-" + new Date().getTime() + Math.random().toString(32).substring(2);
    this.btnText = this.texts.initial;
  },
  methods: {
    emitEvent: function emitEvent(eventType) {
      if (eventType === 'cellphone-clear') {
        this.cellphoneChange();
      }

      if (eventType === 'code-change') {
        this.$emit(eventType, this.getVerifyCode());
      } else {
        this.$emit(eventType);
      }
    },
    getVerifyCode: function getVerifyCode() {
      return this.currentVerifyCode;
    },
    // 重置组件状态
    resetCountDown: function resetCountDown(resetTimesAndCode) {
      this.sliderOpening = false;

      if (resetTimesAndCode) {
        this.currentVerifyCode = '';
        this.errorCellphoneMsg = '';
        this.gettingTimes = 0;
        this.btnText = this.texts.initial;
      } else {
        this.btnText = this.texts.again;
      }

      this.countDown = 59;
      window.clearInterval(this.idGettingCode);
      this.idGettingCode = null;
      this.btnTextClickable = true; // 语音验证码相关

      this.btnVoiceTextClickable = true;
      this.voiceSendSuccess = false;
      this.voiceSliderOpening = false;
      this.voiceText = '语音验证';
    },
    validCellphone: function validCellphone() {
      // 手机号非空校验
      if (!this.currentCellphone) {
        this.errorCellphoneMsg = '请输入手机号';
        return false;
      } // 手机号 11 位数字校验


      if (!/^[0-9]{11}$/.test(String(this.currentCellphone))) {
        this.errorCellphoneMsg = '手机号必须为11位数字';
        return false;
      }

      this.errorCellphoneMsg = '';
      return true;
    },
    // 如果手机号改变了, 则重置组件状态
    cellphoneChange: function cellphoneChange() {
      this.validCellphone();
      this.resetCountDown(true);
      resetNvc(this.requestId);
    },
    startCountDown: function startCountDown() {
      var _this = this;

      this.btnTextClickable = false;
      this.btnText = "\u91CD\u53D1 (" + this.countDown + "s)";
      this.idGettingCode = window.setInterval(function () {
        if (_this.countDown <= 0) {
          _this.resetCountDown(false);

          return;
        }

        _this.countDown = _this.countDown - 1;
        _this.btnText = "\u91CD\u53D1 (" + _this.countDown + "s)";
      }, 1000);
    },
    // 获取短信验证码
    handlerGetVerifyCode: function handlerGetVerifyCode() {
      var _this2 = this;

      if (!this.btnTextClickable) return;
      if (!this.validCellphone()) return;
      if (window.appBridge) window.appBridge.showLoading(true);
      this.btnTextClickable = false;
      this.btnText = '验证获取中';
      this.gettingTimes = this.gettingTimes + 1;
      this.requestId = new Date().getTime() + Math.random().toString(32).substring(2);

      var sliderStartCb = function sliderStartCb() {
        _this2.sliderOpening = true;
        if (window.appBridge) window.appBridge.hideLoading();
      };

      nvcRequest(this.requestId, "" + captchaSendUrl + this.currentCellphone, "#" + this.sliderId, this.debugNvc, // { nvcCode: 400, key1: "code300" },
      sliderStartCb).then(function (res) {
        if (res.success === false) throw new Error(res.info);
        if (window.appBridge) window.appBridge.hideLoading();
        _this2.sliderOpening = false; // 手机号校验通过, 倒计时开始

        Toast(res.info || '验证码发送成功');

        _this2.startCountDown();

        _this2.$refs.inputVerifyCode.$el.querySelector('input').focus();
      }).catch(function (err) {
        if (window.appBridge) window.appBridge.hideLoading();
        Toast(err.message || '发送验证码失败，请稍后再试');

        _this2.startCountDown();

        _this2.sliderOpening = false;
      });
    },
    // 获取语音验证码
    handlerGetVerifyVoice: function handlerGetVerifyVoice() {
      var _this3 = this;

      if (!this.btnVoiceTextClickable) return;
      if (!this.validCellphone()) return;
      if (window.appBridge) window.appBridge.showLoading(true);
      this.btnVoiceTextClickable = false;
      this.voiceText = '验证获取中';
      this.requestId = new Date().getTime() + Math.random().toString(32).substring(2);

      var sliderStartCb = function sliderStartCb() {
        _this3.voiceSliderOpening = true;
        if (window.appBridge) window.appBridge.hideLoading();
      };

      nvcRequest(this.requestId, "" + captchaSendVoiceUrl + this.currentCellphone, "#" + this.sliderId, this.debugNvc, sliderStartCb).then(function (res) {
        if (res.success === false) throw new Error(res.info);
        if (window.appBridge) window.appBridge.hideLoading();
        _this3.voiceSliderOpening = false;
        _this3.voiceSendSuccess = true; // 手机号校验通过, 倒计时开始

        Toast(res.info || '请留意接听语音验证码');

        _this3.safeFocusInput();
      }).catch(function (err) {
        if (window.appBridge) window.appBridge.hideLoading();
        Toast(err.message || '发送验证码失败，请稍后再试');
        _this3.voiceText = '语音验证';
        _this3.btnVoiceTextClickable = true;
        _this3.voiceSliderOpening = false;
      });
    }
  },
  safeFocusInput: function safeFocusInput() {
    var inputEle = this.$refs.inputVerifyCode.$el.querySelector('input');

    if (inputEle) {
      inputEle.focus();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.clearInterval(this.idGettingCode);
  }
});

var __vue_script__$K = script$K;
/* template */

var __vue_render__$K = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "bx-verify-code-input"
  }, [_c('div', {
    staticClass: "bx-hairline--bottom"
  }, [_c('bxs-input', _vm._b({
    attrs: {
      "placeholder": _vm.cellphoneAttrs.placeholder || '请输入手机号',
      "label": _vm.cellphoneAttrs.label || '手机号',
      "type": _vm.cellphoneAttrs.type || 'number',
      "error-message": _vm.errorCellphoneMsg
    },
    on: {
      "change": _vm.cellphoneChange,
      "clear": function clear($event) {
        _vm.emitEvent('cellphone-clear');
      },
      "click-icon": function clickIcon($event) {
        _vm.emitEvent('cellphone-click-icon');
      }
    },
    model: {
      value: _vm.currentCellphone,
      callback: function callback($$v) {
        _vm.currentCellphone = typeof $$v === 'string' ? trim$5($$v).call($$v) : $$v;
      },
      expression: "currentCellphone"
    }
  }, 'bxs-input', _vm.cellphoneAttrs, false))], 1), _c('div', {
    staticClass: "bx-hairline--bottom"
  }, [_c('bxs-input', _vm._b({
    ref: "inputVerifyCode",
    class: {
      'has-error': _vm.errorMessage
    },
    attrs: {
      "placeholder": _vm.codeAttrs.placeholder || '请输入验证码',
      "error-message": _vm.errorMessage,
      "label": _vm.codeAttrs.label || '验证码',
      "type": _vm.codeAttrs.type || 'text',
      "autocomplete": "one-time-code"
    },
    on: {
      "change": function change($event) {
        _vm.emitEvent('code-change');
      }
    },
    model: {
      value: _vm.currentVerifyCode,
      callback: function callback($$v) {
        _vm.currentVerifyCode = typeof $$v === 'string' ? trim$5($$v).call($$v) : $$v;
      },
      expression: "currentVerifyCode"
    }
  }, 'bxs-input', _vm.codeAttrs, false), [!_vm.sliderOpening ? _c('span', {
    staticClass: "bx-verify-code-input-button",
    class: {
      'bx-verify-code-input-button--getting': !this.btnTextClickable
    },
    attrs: {
      "slot": "button"
    },
    on: {
      "click": _vm.handlerGetVerifyCode
    },
    slot: "button"
  }, [_vm._v("\n        " + _vm._s(_vm.btnText) + "\n      ")]) : _vm._e()])], 1), _c('div', {
    staticClass: "bx-verify-code-input-slider"
  }, [_c('div', {
    staticClass: "bx-verify-code-input-tip"
  }, [_vm._v("\n      请滑动验证，获取验证码\n    ")]), _c('div', {
    attrs: {
      "id": _vm.sliderId
    }
  })]), (_vm.debugVoice || _vm.gettingTimes >= 2) && !_vm.voiceSliderOpening && !_vm.voiceSendSuccess ? _c('div', {
    staticClass: "bx-verify-code-input-voice",
    class: {
      'bx-verify-code-input-button--getting': !this.btnVoiceTextClickable
    }
  }, [_c('span', {
    on: {
      "click": _vm.handlerGetVerifyVoice
    }
  }, [_vm._v("\n      " + _vm._s(_vm.voiceText) + "\n    ")])]) : _vm._e()]);
};

var __vue_staticRenderFns__$K = [];
/* style */

var __vue_inject_styles__$K = undefined;
/* scoped */

var __vue_scope_id__$K = undefined;
/* module identifier */

var __vue_module_identifier__$K = undefined;
/* functional template */

var __vue_is_functional_template__$K = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$K =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__$K,
  staticRenderFns: __vue_staticRenderFns__$K
}, __vue_inject_styles__$K, __vue_script__$K, __vue_scope_id__$K, __vue_is_functional_template__$K, __vue_module_identifier__$K, false, undefined, undefined, undefined);

var version$2 = '4.1.0';
var components = [__vue_component__$3, __vue_component__$4, __vue_component__$2, __vue_component__$5, __vue_component__$6, __vue_component__$7, __vue_component__$8, __vue_component__$9, __vue_component__$b, DatePicker, DefaultPage, __vue_component__$i, __vue_component__$j, __vue_component__$1, __vue_component__$a, __vue_component__$k, __vue_component__$l, __vue_component__$m, MessageBox, Picker, __vue_component__$p, __vue_component__$q, __vue_component__$s, __vue_component__$t, __vue_component__$u, __vue_component__$v, __vue_component__$w, __vue_component__$x, __vue_component__$y, SafeAreaPatch, __vue_component__$r, __vue_component__$z, __vue_component__$A, __vue_component__$B, __vue_component__$C, __vue_component__$D, __vue_component__$E, __vue_component__$F, __vue_component__$G, __vue_component__$H, ThemeSwitcher, Toast, __vue_component__$J, __vue_component__$K];

var install$1 = function install(Vue) {
  forEach$2(components).call(components, function (Component) {
    Vue.use(Component);
  });
};
/* istanbul ignore if */


if (typeof window !== 'undefined' && window.Vue) {
  install$1(window.Vue);
}
var index$1 = {
  install: install$1,
  version: version$2
};

export default index$1;
export { __vue_component__$3 as Area, __vue_component__$4 as Badge, __vue_component__$2 as BottomSheets, __vue_component__$5 as Button, __vue_component__$6 as Cell, __vue_component__$7 as CellGroup, __vue_component__$8 as Checkbox, __vue_component__$9 as CheckboxGroup, __vue_component__$b as CrmInput, DatePicker as DatetimePicker, DefaultPage, __vue_component__$i as Form, __vue_component__$j as FormItem, __vue_component__$1 as Icon, __vue_component__$a as Input, __vue_component__$k as LoadMore, __vue_component__$l as Loading, __vue_component__$m as MailInput, MessageBox, Picker, __vue_component__$p as Popup, __vue_component__$q as Price, __vue_component__$s as ProfessionList, __vue_component__$t as Protocol, __vue_component__$u as PullRefresh, __vue_component__$v as Radio, __vue_component__$w as RadioGroup, __vue_component__$x as Rate, __vue_component__$y as ResultStatus, SafeAreaPatch, __vue_component__$r as Search, __vue_component__$z as Step, __vue_component__$A as Stepper, __vue_component__$B as Steps, __vue_component__$C as Swiper, __vue_component__$D as SwiperItem, __vue_component__$E as Switch, __vue_component__$F as Tab, __vue_component__$G as TabItem, __vue_component__$H as Tag, ThemeSwitcher, Toast, __vue_component__$J as Uploader, __vue_component__$K as VerifyCodeInput, install$1 as install, version$2 as version };
